/*(function(){const e=document.createElement("link").relList;if(e&&e.supports&&e.supports("modulepreload"))return;for(const n of document.querySelectorAll('link[rel="modulepreload"]'))i(n);new MutationObserver(n=>{for(const r of n)if(r.type==="childList")for(const d of r.addedNodes)d.tagName==="LINK"&&d.rel==="modulepreload"&&i(d)}).observe(document,{childList:!0,subtree:!0});function t(n){const r={};return n.integrity&&(r.integrity=n.integrity),n.referrerPolicy&&(r.referrerPolicy=n.referrerPolicy),n.crossOrigin==="use-credentials"?r.credentials="include":n.crossOrigin==="anonymous"?r.credentials="omit":r.credentials="same-origin",r}function i(n){if(n.ep)return;n.ep=!0;const r=t(n);fetch(n.href,r)}})();function lt(){const s=document.querySelector(".faq__accordion-container");if(!s)return;const e=s.querySelectorAll(".faq__accordion-node");e.forEach(t=>{t.querySelector(".faq__accordion-toggle").addEventListener("click",n=>{n.preventDefault(),e.forEach(d=>{if(d!==t){d.classList.remove("is-active");const c=d.querySelector(".faq__accordion-content");c&&(c.style.maxHeight=null)}});const r=t.querySelector(".faq__accordion-content");r&&(t.classList.contains("is-active")?(t.classList.remove("is-active"),r.style.maxHeight=null):(t.classList.add("is-active"),r.style.maxHeight=`${r.scrollHeight}px`))})})}function ot(){const s=document.querySelectorAll(".c-card");for(const t of s){let u=function(){a>0?(i.style.display="none",n.style.display="flex",c.textContent=a):(i.style.display="flex",n.style.display="none")};var e=u;if(!t.querySelector(".add-to-cart-btn"))continue;const i=t.querySelector(".add-to-cart-btn"),n=t.querySelector(".quantity-actions"),r=t.querySelector(".increment-btn"),d=t.querySelector(".decrement-btn"),c=t.querySelector(".quantity-count");let a=0;i.addEventListener("click",f=>{f.preventDefault(),a=1,u()}),r.addEventListener("click",f=>{f.preventDefault(),a++,u()}),d.addEventListener("click",f=>{f.preventDefault(),a>1?a--:a=0,u()})}}function Ue(s){return s!==null&&typeof s=="object"&&"constructor"in s&&s.constructor===Object}function Fe(s,e){s===void 0&&(s={}),e===void 0&&(e={}),Object.keys(e).forEach(t=>{typeof s[t]>"u"?s[t]=e[t]:Ue(e[t])&&Ue(s[t])&&Object.keys(e[t]).length>0&&Fe(s[t],e[t])})}const tt={body:{},addEventListener(){},removeEventListener(){},activeElement:{blur(){},nodeName:""},querySelector(){return null},querySelectorAll(){return[]},getElementById(){return null},createEvent(){return{initEvent(){}}},createElement(){return{children:[],childNodes:[],style:{},setAttribute(){},getElementsByTagName(){return[]}}},createElementNS(){return{}},importNode(){return null},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""}};function N(){const s=typeof document<"u"?document:{};return Fe(s,tt),s}const dt={document:tt,navigator:{userAgent:""},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""},history:{replaceState(){},pushState(){},go(){},back(){}},CustomEvent:function(){return this},addEventListener(){},removeEventListener(){},getComputedStyle(){return{getPropertyValue(){return""}}},Image(){},Date(){},screen:{},setTimeout(){},clearTimeout(){},matchMedia(){return{}},requestAnimationFrame(s){return typeof setTimeout>"u"?(s(),null):setTimeout(s,0)},cancelAnimationFrame(s){typeof setTimeout>"u"||clearTimeout(s)}};function R(){const s=typeof window<"u"?window:{};return Fe(s,dt),s}function ae(s){return s===void 0&&(s=""),s.trim().split(" ").filter(e=>!!e.trim())}function ct(s){const e=s;Object.keys(e).forEach(t=>{try{e[t]=null}catch{}try{delete e[t]}catch{}})}function de(s,e){return e===void 0&&(e=0),setTimeout(s,e)}function Q(){return Date.now()}function ft(s){const e=R();let t;return e.getComputedStyle&&(t=e.getComputedStyle(s,null)),!t&&s.currentStyle&&(t=s.currentStyle),t||(t=s.style),t}function Xe(s,e){e===void 0&&(e="x");const t=R();let i,n,r;const d=ft(s);return t.WebKitCSSMatrix?(n=d.transform||d.webkitTransform,n.split(",").length>6&&(n=n.split(", ").map(c=>c.replace(",",".")).join(", ")),r=new t.WebKitCSSMatrix(n==="none"?"":n)):(r=d.MozTransform||d.OTransform||d.MsTransform||d.msTransform||d.transform||d.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,"),i=r.toString().split(",")),e==="x"&&(t.WebKitCSSMatrix?n=r.m41:i.length===16?n=parseFloat(i[12]):n=parseFloat(i[4])),e==="y"&&(t.WebKitCSSMatrix?n=r.m42:i.length===16?n=parseFloat(i[13]):n=parseFloat(i[5])),n||0}function ye(s){return typeof s=="object"&&s!==null&&s.constructor&&Object.prototype.toString.call(s).slice(8,-1)==="Object"}function ut(s){return typeof window<"u"&&typeof window.HTMLElement<"u"?s instanceof HTMLElement:s&&(s.nodeType===1||s.nodeType===11)}function K(){const s=Object(arguments.length<=0?void 0:arguments[0]),e=["__proto__","constructor","prototype"];for(let t=1;t<arguments.length;t+=1){const i=t<0||arguments.length<=t?void 0:arguments[t];if(i!=null&&!ut(i)){const n=Object.keys(Object(i)).filter(r=>e.indexOf(r)<0);for(let r=0,d=n.length;r<d;r+=1){const c=n[r],a=Object.getOwnPropertyDescriptor(i,c);a!==void 0&&a.enumerable&&(ye(s[c])&&ye(i[c])?i[c].__swiper__?s[c]=i[c]:K(s[c],i[c]):!ye(s[c])&&ye(i[c])?(s[c]={},i[c].__swiper__?s[c]=i[c]:K(s[c],i[c])):s[c]=i[c])}}}return s}function Se(s,e,t){s.style.setProperty(e,t)}function st(s){let{swiper:e,targetPosition:t,side:i}=s;const n=R(),r=-e.translate;let d=null,c;const a=e.params.speed;e.wrapperEl.style.scrollSnapType="none",n.cancelAnimationFrame(e.cssModeFrameID);const u=t>r?"next":"prev",f=(v,m)=>u==="next"&&v>=m||u==="prev"&&v<=m,p=()=>{c=new Date().getTime(),d===null&&(d=c);const v=Math.max(Math.min((c-d)/a,1),0),m=.5-Math.cos(v*Math.PI)/2;let l=r+m*(t-r);if(f(l,t)&&(l=t),e.wrapperEl.scrollTo({[i]:l}),f(l,t)){e.wrapperEl.style.overflow="hidden",e.wrapperEl.style.scrollSnapType="",setTimeout(()=>{e.wrapperEl.style.overflow="",e.wrapperEl.scrollTo({[i]:l})}),n.cancelAnimationFrame(e.cssModeFrameID);return}e.cssModeFrameID=n.requestAnimationFrame(p)};p()}function ce(s){return s.querySelector(".swiper-slide-transform")||s.shadowRoot&&s.shadowRoot.querySelector(".swiper-slide-transform")||s}function W(s,e){e===void 0&&(e="");const t=R(),i=[...s.children];return t.HTMLSlotElement&&s instanceof HTMLSlotElement&&i.push(...s.assignedElements()),e?i.filter(n=>n.matches(e)):i}function pt(s,e){var i,n;const t=[e];for(;t.length>0;){const r=t.shift();if(s===r)return!0;t.push(...r.children,...((i=r.shadowRoot)==null?void 0:i.children)||[],...((n=r.assignedElements)==null?void 0:n.call(r))||[])}}function mt(s,e){const t=R();let i=e.contains(s);return!i&&t.HTMLSlotElement&&e instanceof HTMLSlotElement&&(i=[...e.assignedElements()].includes(s),i||(i=pt(s,e))),i}function Le(s){try{console.warn(s);return}catch{}}function Z(s,e){e===void 0&&(e=[]);const t=document.createElement(s);return t.classList.add(...Array.isArray(e)?e:ae(e)),t}function Ie(s){const e=R(),t=N(),i=s.getBoundingClientRect(),n=t.body,r=s.clientTop||n.clientTop||0,d=s.clientLeft||n.clientLeft||0,c=s===e?e.scrollY:s.scrollTop,a=s===e?e.scrollX:s.scrollLeft;return{top:i.top+c-r,left:i.left+a-d}}function ht(s,e){const t=[];for(;s.previousElementSibling;){const i=s.previousElementSibling;e?i.matches(e)&&t.push(i):t.push(i),s=i}return t}function gt(s,e){const t=[];for(;s.nextElementSibling;){const i=s.nextElementSibling;e?i.matches(e)&&t.push(i):t.push(i),s=i}return t}function le(s,e){return R().getComputedStyle(s,null).getPropertyValue(e)}function Ee(s){let e=s,t;if(e){for(t=0;(e=e.previousSibling)!==null;)e.nodeType===1&&(t+=1);return t}}function oe(s,e){const t=[];let i=s.parentElement;for(;i;)e?i.matches(e)&&t.push(i):t.push(i),i=i.parentElement;return t}function be(s,e){function t(i){i.target===s&&(e.call(s,i),s.removeEventListener("transitionend",t))}e&&s.addEventListener("transitionend",t)}function Ye(s,e,t){const i=R();return s[e==="width"?"offsetWidth":"offsetHeight"]+parseFloat(i.getComputedStyle(s,null).getPropertyValue(e==="width"?"margin-right":"margin-top"))+parseFloat(i.getComputedStyle(s,null).getPropertyValue(e==="width"?"margin-left":"margin-bottom"))}function G(s){return(Array.isArray(s)?s:[s]).filter(e=>!!e)}function Ae(s){return e=>Math.abs(e)>0&&s.browser&&s.browser.need3dFix&&Math.abs(e)%90===0?e+.001:e}let Be;function vt(){const s=R(),e=N();return{smoothScroll:e.documentElement&&e.documentElement.style&&"scrollBehavior"in e.documentElement.style,touch:!!("ontouchstart"in s||s.DocumentTouch&&e instanceof s.DocumentTouch)}}function it(){return Be||(Be=vt()),Be}let He;function wt(s){let{userAgent:e}=s===void 0?{}:s;const t=it(),i=R(),n=i.navigator.platform,r=e||i.navigator.userAgent,d={ios:!1,android:!1},c=i.screen.width,a=i.screen.height,u=r.match(/(Android);?[\s\/]+([\d.]+)?/);let f=r.match(/(iPad).*OS\s([\d_]+)/);const p=r.match(/(iPod)(.*OS\s([\d_]+))?/),v=!f&&r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),m=n==="Win32";let l=n==="MacIntel";const o=["1024x1366","1366x1024","834x1194","1194x834","834x1112","1112x834","768x1024","1024x768","820x1180","1180x820","810x1080","1080x810"];return!f&&l&&t.touch&&o.indexOf(`${c}x${a}`)>=0&&(f=r.match(/(Version)\/([\d.]+)/),f||(f=[0,1,"13_0_0"]),l=!1),u&&!m&&(d.os="android",d.android=!0),(f||v||p)&&(d.os="ios",d.ios=!0),d}function rt(s){return s===void 0&&(s={}),He||(He=wt(s)),He}let qe;function yt(){const s=R(),e=rt();let t=!1;function i(){const c=s.navigator.userAgent.toLowerCase();return c.indexOf("safari")>=0&&c.indexOf("chrome")<0&&c.indexOf("android")<0}if(i()){const c=String(s.navigator.userAgent);if(c.includes("Version/")){const[a,u]=c.split("Version/")[1].split(" ")[0].split(".").map(f=>Number(f));t=a<16||a===16&&u<2}}const n=/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(s.navigator.userAgent),r=i(),d=r||n&&e.ios;return{isSafari:t||r,needPerspectiveFix:t,need3dFix:d,isWebView:n}}function St(){return qe||(qe=yt()),qe}function bt(s){let{swiper:e,on:t,emit:i}=s;const n=R();let r=null,d=null;const c=()=>{!e||e.destroyed||!e.initialized||(i("beforeResize"),i("resize"))},a=()=>{!e||e.destroyed||!e.initialized||(r=new ResizeObserver(p=>{d=n.requestAnimationFrame(()=>{const{width:v,height:m}=e;let l=v,o=m;p.forEach(w=>{let{contentBoxSize:y,contentRect:g,target:h}=w;h&&h!==e.el||(l=g?g.width:(y[0]||y).inlineSize,o=g?g.height:(y[0]||y).blockSize)}),(l!==v||o!==m)&&c()})}),r.observe(e.el))},u=()=>{d&&n.cancelAnimationFrame(d),r&&r.unobserve&&e.el&&(r.unobserve(e.el),r=null)},f=()=>{!e||e.destroyed||!e.initialized||i("orientationchange")};t("init",()=>{if(e.params.resizeObserver&&typeof n.ResizeObserver<"u"){a();return}n.addEventListener("resize",c),n.addEventListener("orientationchange",f)}),t("destroy",()=>{u(),n.removeEventListener("resize",c),n.removeEventListener("orientationchange",f)})}function Et(s){let{swiper:e,extendParams:t,on:i,emit:n}=s;const r=[],d=R(),c=function(f,p){p===void 0&&(p={});const v=d.MutationObserver||d.WebkitMutationObserver,m=new v(l=>{if(e.__preventObserver__)return;if(l.length===1){n("observerUpdate",l[0]);return}const o=function(){n("observerUpdate",l[0])};d.requestAnimationFrame?d.requestAnimationFrame(o):d.setTimeout(o,0)});m.observe(f,{attributes:typeof p.attributes>"u"?!0:p.attributes,childList:e.isElement||(typeof p.childList>"u"?!0:p).childList,characterData:typeof p.characterData>"u"?!0:p.characterData}),r.push(m)},a=()=>{if(e.params.observer){if(e.params.observeParents){const f=oe(e.hostEl);for(let p=0;p<f.length;p+=1)c(f[p])}c(e.hostEl,{childList:e.params.observeSlideChildren}),c(e.wrapperEl,{attributes:!1})}},u=()=>{r.forEach(f=>{f.disconnect()}),r.splice(0,r.length)};t({observer:!1,observeParents:!1,observeSlideChildren:!1}),i("init",a),i("destroy",u)}var xt={on(s,e,t){const i=this;if(!i.eventsListeners||i.destroyed||typeof e!="function")return i;const n=t?"unshift":"push";return s.split(" ").forEach(r=>{i.eventsListeners[r]||(i.eventsListeners[r]=[]),i.eventsListeners[r][n](e)}),i},once(s,e,t){const i=this;if(!i.eventsListeners||i.destroyed||typeof e!="function")return i;function n(){i.off(s,n),n.__emitterProxy&&delete n.__emitterProxy;for(var r=arguments.length,d=new Array(r),c=0;c<r;c++)d[c]=arguments[c];e.apply(i,d)}return n.__emitterProxy=e,i.on(s,n,t)},onAny(s,e){const t=this;if(!t.eventsListeners||t.destroyed||typeof s!="function")return t;const i=e?"unshift":"push";return t.eventsAnyListeners.indexOf(s)<0&&t.eventsAnyListeners[i](s),t},offAny(s){const e=this;if(!e.eventsListeners||e.destroyed||!e.eventsAnyListeners)return e;const t=e.eventsAnyListeners.indexOf(s);return t>=0&&e.eventsAnyListeners.splice(t,1),e},off(s,e){const t=this;return!t.eventsListeners||t.destroyed||!t.eventsListeners||s.split(" ").forEach(i=>{typeof e>"u"?t.eventsListeners[i]=[]:t.eventsListeners[i]&&t.eventsListeners[i].forEach((n,r)=>{(n===e||n.__emitterProxy&&n.__emitterProxy===e)&&t.eventsListeners[i].splice(r,1)})}),t},emit(){const s=this;if(!s.eventsListeners||s.destroyed||!s.eventsListeners)return s;let e,t,i;for(var n=arguments.length,r=new Array(n),d=0;d<n;d++)r[d]=arguments[d];return typeof r[0]=="string"||Array.isArray(r[0])?(e=r[0],t=r.slice(1,r.length),i=s):(e=r[0].events,t=r[0].data,i=r[0].context||s),t.unshift(i),(Array.isArray(e)?e:e.split(" ")).forEach(a=>{s.eventsAnyListeners&&s.eventsAnyListeners.length&&s.eventsAnyListeners.forEach(u=>{u.apply(i,[a,...t])}),s.eventsListeners&&s.eventsListeners[a]&&s.eventsListeners[a].forEach(u=>{u.apply(i,t)})}),s}};function Tt(){const s=this;let e,t;const i=s.el;typeof s.params.width<"u"&&s.params.width!==null?e=s.params.width:e=i.clientWidth,typeof s.params.height<"u"&&s.params.height!==null?t=s.params.height:t=i.clientHeight,!(e===0&&s.isHorizontal()||t===0&&s.isVertical())&&(e=e-parseInt(le(i,"padding-left")||0,10)-parseInt(le(i,"padding-right")||0,10),t=t-parseInt(le(i,"padding-top")||0,10)-parseInt(le(i,"padding-bottom")||0,10),Number.isNaN(e)&&(e=0),Number.isNaN(t)&&(t=0),Object.assign(s,{width:e,height:t,size:s.isHorizontal()?e:t}))}function Mt(){const s=this;function e(L,A){return parseFloat(L.getPropertyValue(s.getDirectionLabel(A))||0)}const t=s.params,{wrapperEl:i,slidesEl:n,size:r,rtlTranslate:d,wrongRTL:c}=s,a=s.virtual&&t.virtual.enabled,u=a?s.virtual.slides.length:s.slides.length,f=W(n,`.${s.params.slideClass}, swiper-slide`),p=a?s.virtual.slides.length:f.length;let v=[];const m=[],l=[];let o=t.slidesOffsetBefore;typeof o=="function"&&(o=t.slidesOffsetBefore.call(s));let w=t.slidesOffsetAfter;typeof w=="function"&&(w=t.slidesOffsetAfter.call(s));const y=s.snapGrid.length,g=s.slidesGrid.length;let h=t.spaceBetween,S=-o,b=0,z=0;if(typeof r>"u")return;typeof h=="string"&&h.indexOf("%")>=0?h=parseFloat(h.replace("%",""))/100*r:typeof h=="string"&&(h=parseFloat(h)),s.virtualSize=-h,f.forEach(L=>{d?L.style.marginLeft="":L.style.marginRight="",L.style.marginBottom="",L.style.marginTop=""}),t.centeredSlides&&t.cssMode&&(Se(i,"--swiper-centered-offset-before",""),Se(i,"--swiper-centered-offset-after",""));const $=t.grid&&t.grid.rows>1&&s.grid;$?s.grid.initSlides(f):s.grid&&s.grid.unsetSlides();let O;const P=t.slidesPerView==="auto"&&t.breakpoints&&Object.keys(t.breakpoints).filter(L=>typeof t.breakpoints[L].slidesPerView<"u").length>0;for(let L=0;L<p;L+=1){O=0;let A;if(f[L]&&(A=f[L]),$&&s.grid.updateSlide(L,A,f),!(f[L]&&le(A,"display")==="none")){if(t.slidesPerView==="auto"){P&&(f[L].style[s.getDirectionLabel("width")]="");const M=getComputedStyle(A),E=A.style.transform,x=A.style.webkitTransform;if(E&&(A.style.transform="none"),x&&(A.style.webkitTransform="none"),t.roundLengths)O=s.isHorizontal()?Ye(A,"width"):Ye(A,"height");else{const D=e(M,"width"),q=e(M,"padding-left"),C=e(M,"padding-right"),I=e(M,"margin-left"),H=e(M,"margin-right"),_=M.getPropertyValue("box-sizing");if(_&&_==="border-box")O=D+I+H;else{const{clientWidth:X,offsetWidth:F}=A;O=D+q+C+I+H+(F-X)}}E&&(A.style.transform=E),x&&(A.style.webkitTransform=x),t.roundLengths&&(O=Math.floor(O))}else O=(r-(t.slidesPerView-1)*h)/t.slidesPerView,t.roundLengths&&(O=Math.floor(O)),f[L]&&(f[L].style[s.getDirectionLabel("width")]=`${O}px`);f[L]&&(f[L].swiperSlideSize=O),l.push(O),t.centeredSlides?(S=S+O/2+b/2+h,b===0&&L!==0&&(S=S-r/2-h),L===0&&(S=S-r/2-h),Math.abs(S)<1/1e3&&(S=0),t.roundLengths&&(S=Math.floor(S)),z%t.slidesPerGroup===0&&v.push(S),m.push(S)):(t.roundLengths&&(S=Math.floor(S)),(z-Math.min(s.params.slidesPerGroupSkip,z))%s.params.slidesPerGroup===0&&v.push(S),m.push(S),S=S+O+h),s.virtualSize+=O+h,b=O,z+=1}}if(s.virtualSize=Math.max(s.virtualSize,r)+w,d&&c&&(t.effect==="slide"||t.effect==="coverflow")&&(i.style.width=`${s.virtualSize+h}px`),t.setWrapperSize&&(i.style[s.getDirectionLabel("width")]=`${s.virtualSize+h}px`),$&&s.grid.updateWrapperSize(O,v),!t.centeredSlides){const L=[];for(let A=0;A<v.length;A+=1){let M=v[A];t.roundLengths&&(M=Math.floor(M)),v[A]<=s.virtualSize-r&&L.push(M)}v=L,Math.floor(s.virtualSize-r)-Math.floor(v[v.length-1])>1&&v.push(s.virtualSize-r)}if(a&&t.loop){const L=l[0]+h;if(t.slidesPerGroup>1){const A=Math.ceil((s.virtual.slidesBefore+s.virtual.slidesAfter)/t.slidesPerGroup),M=L*t.slidesPerGroup;for(let E=0;E<A;E+=1)v.push(v[v.length-1]+M)}for(let A=0;A<s.virtual.slidesBefore+s.virtual.slidesAfter;A+=1)t.slidesPerGroup===1&&v.push(v[v.length-1]+L),m.push(m[m.length-1]+L),s.virtualSize+=L}if(v.length===0&&(v=[0]),h!==0){const L=s.isHorizontal()&&d?"marginLeft":s.getDirectionLabel("marginRight");f.filter((A,M)=>!t.cssMode||t.loop?!0:M!==f.length-1).forEach(A=>{A.style[L]=`${h}px`})}if(t.centeredSlides&&t.centeredSlidesBounds){let L=0;l.forEach(M=>{L+=M+(h||0)}),L-=h;const A=L>r?L-r:0;v=v.map(M=>M<=0?-o:M>A?A+w:M)}if(t.centerInsufficientSlides){let L=0;l.forEach(M=>{L+=M+(h||0)}),L-=h;const A=(t.slidesOffsetBefore||0)+(t.slidesOffsetAfter||0);if(L+A<r){const M=(r-L-A)/2;v.forEach((E,x)=>{v[x]=E-M}),m.forEach((E,x)=>{m[x]=E+M})}}if(Object.assign(s,{slides:f,snapGrid:v,slidesGrid:m,slidesSizesGrid:l}),t.centeredSlides&&t.cssMode&&!t.centeredSlidesBounds){Se(i,"--swiper-centered-offset-before",`${-v[0]}px`),Se(i,"--swiper-centered-offset-after",`${s.size/2-l[l.length-1]/2}px`);const L=-s.snapGrid[0],A=-s.slidesGrid[0];s.snapGrid=s.snapGrid.map(M=>M+L),s.slidesGrid=s.slidesGrid.map(M=>M+A)}if(p!==u&&s.emit("slidesLengthChange"),v.length!==y&&(s.params.watchOverflow&&s.checkOverflow(),s.emit("snapGridLengthChange")),m.length!==g&&s.emit("slidesGridLengthChange"),t.watchSlidesProgress&&s.updateSlidesOffset(),s.emit("slidesUpdated"),!a&&!t.cssMode&&(t.effect==="slide"||t.effect==="fade")){const L=`${t.containerModifierClass}backface-hidden`,A=s.el.classList.contains(L);p<=t.maxBackfaceHiddenSlides?A||s.el.classList.add(L):A&&s.el.classList.remove(L)}}function Ct(s){const e=this,t=[],i=e.virtual&&e.params.virtual.enabled;let n=0,r;typeof s=="number"?e.setTransition(s):s===!0&&e.setTransition(e.params.speed);const d=c=>i?e.slides[e.getSlideIndexByData(c)]:e.slides[c];if(e.params.slidesPerView!=="auto"&&e.params.slidesPerView>1)if(e.params.centeredSlides)(e.visibleSlides||[]).forEach(c=>{t.push(c)});else for(r=0;r<Math.ceil(e.params.slidesPerView);r+=1){const c=e.activeIndex+r;if(c>e.slides.length&&!i)break;t.push(d(c))}else t.push(d(e.activeIndex));for(r=0;r<t.length;r+=1)if(typeof t[r]<"u"){const c=t[r].offsetHeight;n=c>n?c:n}(n||n===0)&&(e.wrapperEl.style.height=`${n}px`)}function Pt(){const s=this,e=s.slides,t=s.isElement?s.isHorizontal()?s.wrapperEl.offsetLeft:s.wrapperEl.offsetTop:0;for(let i=0;i<e.length;i+=1)e[i].swiperSlideOffset=(s.isHorizontal()?e[i].offsetLeft:e[i].offsetTop)-t-s.cssOverflowAdjustment()}const Ke=(s,e,t)=>{e&&!s.classList.contains(t)?s.classList.add(t):!e&&s.classList.contains(t)&&s.classList.remove(t)};function Lt(s){s===void 0&&(s=this&&this.translate||0);const e=this,t=e.params,{slides:i,rtlTranslate:n,snapGrid:r}=e;if(i.length===0)return;typeof i[0].swiperSlideOffset>"u"&&e.updateSlidesOffset();let d=-s;n&&(d=s),e.visibleSlidesIndexes=[],e.visibleSlides=[];let c=t.spaceBetween;typeof c=="string"&&c.indexOf("%")>=0?c=parseFloat(c.replace("%",""))/100*e.size:typeof c=="string"&&(c=parseFloat(c));for(let a=0;a<i.length;a+=1){const u=i[a];let f=u.swiperSlideOffset;t.cssMode&&t.centeredSlides&&(f-=i[0].swiperSlideOffset);const p=(d+(t.centeredSlides?e.minTranslate():0)-f)/(u.swiperSlideSize+c),v=(d-r[0]+(t.centeredSlides?e.minTranslate():0)-f)/(u.swiperSlideSize+c),m=-(d-f),l=m+e.slidesSizesGrid[a],o=m>=0&&m<=e.size-e.slidesSizesGrid[a],w=m>=0&&m<e.size-1||l>1&&l<=e.size||m<=0&&l>=e.size;w&&(e.visibleSlides.push(u),e.visibleSlidesIndexes.push(a)),Ke(u,w,t.slideVisibleClass),Ke(u,o,t.slideFullyVisibleClass),u.progress=n?-p:p,u.originalProgress=n?-v:v}}function It(s){const e=this;if(typeof s>"u"){const f=e.rtlTranslate?-1:1;s=e&&e.translate&&e.translate*f||0}const t=e.params,i=e.maxTranslate()-e.minTranslate();let{progress:n,isBeginning:r,isEnd:d,progressLoop:c}=e;const a=r,u=d;if(i===0)n=0,r=!0,d=!0;else{n=(s-e.minTranslate())/i;const f=Math.abs(s-e.minTranslate())<1,p=Math.abs(s-e.maxTranslate())<1;r=f||n<=0,d=p||n>=1,f&&(n=0),p&&(n=1)}if(t.loop){const f=e.getSlideIndexByData(0),p=e.getSlideIndexByData(e.slides.length-1),v=e.slidesGrid[f],m=e.slidesGrid[p],l=e.slidesGrid[e.slidesGrid.length-1],o=Math.abs(s);o>=v?c=(o-v)/l:c=(o+l-m)/l,c>1&&(c-=1)}Object.assign(e,{progress:n,progressLoop:c,isBeginning:r,isEnd:d}),(t.watchSlidesProgress||t.centeredSlides&&t.autoHeight)&&e.updateSlidesProgress(s),r&&!a&&e.emit("reachBeginning toEdge"),d&&!u&&e.emit("reachEnd toEdge"),(a&&!r||u&&!d)&&e.emit("fromEdge"),e.emit("progress",n)}const _e=(s,e,t)=>{e&&!s.classList.contains(t)?s.classList.add(t):!e&&s.classList.contains(t)&&s.classList.remove(t)};function At(){const s=this,{slides:e,params:t,slidesEl:i,activeIndex:n}=s,r=s.virtual&&t.virtual.enabled,d=s.grid&&t.grid&&t.grid.rows>1,c=p=>W(i,`.${t.slideClass}${p}, swiper-slide${p}`)[0];let a,u,f;if(r)if(t.loop){let p=n-s.virtual.slidesBefore;p<0&&(p=s.virtual.slides.length+p),p>=s.virtual.slides.length&&(p-=s.virtual.slides.length),a=c(`[data-swiper-slide-index="${p}"]`)}else a=c(`[data-swiper-slide-index="${n}"]`);else d?(a=e.find(p=>p.column===n),f=e.find(p=>p.column===n+1),u=e.find(p=>p.column===n-1)):a=e[n];a&&(d||(f=gt(a,`.${t.slideClass}, swiper-slide`)[0],t.loop&&!f&&(f=e[0]),u=ht(a,`.${t.slideClass}, swiper-slide`)[0],t.loop&&!u===0&&(u=e[e.length-1]))),e.forEach(p=>{_e(p,p===a,t.slideActiveClass),_e(p,p===f,t.slideNextClass),_e(p,p===u,t.slidePrevClass)}),s.emitSlidesClasses()}const Pe=(s,e)=>{if(!s||s.destroyed||!s.params)return;const t=()=>s.isElement?"swiper-slide":`.${s.params.slideClass}`,i=e.closest(t());if(i){let n=i.querySelector(`.${s.params.lazyPreloaderClass}`);!n&&s.isElement&&(i.shadowRoot?n=i.shadowRoot.querySelector(`.${s.params.lazyPreloaderClass}`):requestAnimationFrame(()=>{i.shadowRoot&&(n=i.shadowRoot.querySelector(`.${s.params.lazyPreloaderClass}`),n&&n.remove())})),n&&n.remove()}},Ge=(s,e)=>{if(!s.slides[e])return;const t=s.slides[e].querySelector('[loading="lazy"]');t&&t.removeAttribute("loading")},Ne=s=>{if(!s||s.destroyed||!s.params)return;let e=s.params.lazyPreloadPrevNext;const t=s.slides.length;if(!t||!e||e<0)return;e=Math.min(e,t);const i=s.params.slidesPerView==="auto"?s.slidesPerViewDynamic():Math.ceil(s.params.slidesPerView),n=s.activeIndex;if(s.params.grid&&s.params.grid.rows>1){const d=n,c=[d-e];c.push(...Array.from({length:e}).map((a,u)=>d+i+u)),s.slides.forEach((a,u)=>{c.includes(a.column)&&Ge(s,u)});return}const r=n+i-1;if(s.params.rewind||s.params.loop)for(let d=n-e;d<=r+e;d+=1){const c=(d%t+t)%t;(c<n||c>r)&&Ge(s,c)}else for(let d=Math.max(n-e,0);d<=Math.min(r+e,t-1);d+=1)d!==n&&(d>r||d<n)&&Ge(s,d)};function zt(s){const{slidesGrid:e,params:t}=s,i=s.rtlTranslate?s.translate:-s.translate;let n;for(let r=0;r<e.length;r+=1)typeof e[r+1]<"u"?i>=e[r]&&i<e[r+1]-(e[r+1]-e[r])/2?n=r:i>=e[r]&&i<e[r+1]&&(n=r+1):i>=e[r]&&(n=r);return t.normalizeSlideIndex&&(n<0||typeof n>"u")&&(n=0),n}function Ot(s){const e=this,t=e.rtlTranslate?e.translate:-e.translate,{snapGrid:i,params:n,activeIndex:r,realIndex:d,snapIndex:c}=e;let a=s,u;const f=m=>{let l=m-e.virtual.slidesBefore;return l<0&&(l=e.virtual.slides.length+l),l>=e.virtual.slides.length&&(l-=e.virtual.slides.length),l};if(typeof a>"u"&&(a=zt(e)),i.indexOf(t)>=0)u=i.indexOf(t);else{const m=Math.min(n.slidesPerGroupSkip,a);u=m+Math.floor((a-m)/n.slidesPerGroup)}if(u>=i.length&&(u=i.length-1),a===r&&!e.params.loop){u!==c&&(e.snapIndex=u,e.emit("snapIndexChange"));return}if(a===r&&e.params.loop&&e.virtual&&e.params.virtual.enabled){e.realIndex=f(a);return}const p=e.grid&&n.grid&&n.grid.rows>1;let v;if(e.virtual&&n.virtual.enabled&&n.loop)v=f(a);else if(p){const m=e.slides.find(o=>o.column===a);let l=parseInt(m.getAttribute("data-swiper-slide-index"),10);Number.isNaN(l)&&(l=Math.max(e.slides.indexOf(m),0)),v=Math.floor(l/n.grid.rows)}else if(e.slides[a]){const m=e.slides[a].getAttribute("data-swiper-slide-index");m?v=parseInt(m,10):v=a}else v=a;Object.assign(e,{previousSnapIndex:c,snapIndex:u,previousRealIndex:d,realIndex:v,previousIndex:r,activeIndex:a}),e.initialized&&Ne(e),e.emit("activeIndexChange"),e.emit("snapIndexChange"),(e.initialized||e.params.runCallbacksOnInit)&&(d!==v&&e.emit("realIndexChange"),e.emit("slideChange"))}function Dt(s,e){const t=this,i=t.params;let n=s.closest(`.${i.slideClass}, swiper-slide`);!n&&t.isElement&&e&&e.length>1&&e.includes(s)&&[...e.slice(e.indexOf(s)+1,e.length)].forEach(c=>{!n&&c.matches&&c.matches(`.${i.slideClass}, swiper-slide`)&&(n=c)});let r=!1,d;if(n){for(let c=0;c<t.slides.length;c+=1)if(t.slides[c]===n){r=!0,d=c;break}}if(n&&r)t.clickedSlide=n,t.virtual&&t.params.virtual.enabled?t.clickedIndex=parseInt(n.getAttribute("data-swiper-slide-index"),10):t.clickedIndex=d;else{t.clickedSlide=void 0,t.clickedIndex=void 0;return}i.slideToClickedSlide&&t.clickedIndex!==void 0&&t.clickedIndex!==t.activeIndex&&t.slideToClickedSlide()}var $t={updateSize:Tt,updateSlides:Mt,updateAutoHeight:Ct,updateSlidesOffset:Pt,updateSlidesProgress:Lt,updateProgress:It,updateSlidesClasses:At,updateActiveIndex:Ot,updateClickedSlide:Dt};function kt(s){s===void 0&&(s=this.isHorizontal()?"x":"y");const e=this,{params:t,rtlTranslate:i,translate:n,wrapperEl:r}=e;if(t.virtualTranslate)return i?-n:n;if(t.cssMode)return n;let d=Xe(r,s);return d+=e.cssOverflowAdjustment(),i&&(d=-d),d||0}function Bt(s,e){const t=this,{rtlTranslate:i,params:n,wrapperEl:r,progress:d}=t;let c=0,a=0;const u=0;t.isHorizontal()?c=i?-s:s:a=s,n.roundLengths&&(c=Math.floor(c),a=Math.floor(a)),t.previousTranslate=t.translate,t.translate=t.isHorizontal()?c:a,n.cssMode?r[t.isHorizontal()?"scrollLeft":"scrollTop"]=t.isHorizontal()?-c:-a:n.virtualTranslate||(t.isHorizontal()?c-=t.cssOverflowAdjustment():a-=t.cssOverflowAdjustment(),r.style.transform=`translate3d(${c}px, ${a}px, ${u}px)`);let f;const p=t.maxTranslate()-t.minTranslate();p===0?f=0:f=(s-t.minTranslate())/p,f!==d&&t.updateProgress(s),t.emit("setTranslate",t.translate,e)}function Ht(){return-this.snapGrid[0]}function qt(){return-this.snapGrid[this.snapGrid.length-1]}function _t(s,e,t,i,n){s===void 0&&(s=0),e===void 0&&(e=this.params.speed),t===void 0&&(t=!0),i===void 0&&(i=!0);const r=this,{params:d,wrapperEl:c}=r;if(r.animating&&d.preventInteractionOnTransition)return!1;const a=r.minTranslate(),u=r.maxTranslate();let f;if(i&&s>a?f=a:i&&s<u?f=u:f=s,r.updateProgress(f),d.cssMode){const p=r.isHorizontal();if(e===0)c[p?"scrollLeft":"scrollTop"]=-f;else{if(!r.support.smoothScroll)return st({swiper:r,targetPosition:-f,side:p?"left":"top"}),!0;c.scrollTo({[p?"left":"top"]:-f,behavior:"smooth"})}return!0}return e===0?(r.setTransition(0),r.setTranslate(f),t&&(r.emit("beforeTransitionStart",e,n),r.emit("transitionEnd"))):(r.setTransition(e),r.setTranslate(f),t&&(r.emit("beforeTransitionStart",e,n),r.emit("transitionStart")),r.animating||(r.animating=!0,r.onTranslateToWrapperTransitionEnd||(r.onTranslateToWrapperTransitionEnd=function(v){!r||r.destroyed||v.target===this&&(r.wrapperEl.removeEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.onTranslateToWrapperTransitionEnd=null,delete r.onTranslateToWrapperTransitionEnd,r.animating=!1,t&&r.emit("transitionEnd"))}),r.wrapperEl.addEventListener("transitionend",r.onTranslateToWrapperTransitionEnd))),!0}var Gt={getTranslate:kt,setTranslate:Bt,minTranslate:Ht,maxTranslate:qt,translateTo:_t};function Vt(s,e){const t=this;t.params.cssMode||(t.wrapperEl.style.transitionDuration=`${s}ms`,t.wrapperEl.style.transitionDelay=s===0?"0ms":""),t.emit("setTransition",s,e)}function nt(s){let{swiper:e,runCallbacks:t,direction:i,step:n}=s;const{activeIndex:r,previousIndex:d}=e;let c=i;if(c||(r>d?c="next":r<d?c="prev":c="reset"),e.emit(`transition${n}`),t&&r!==d){if(c==="reset"){e.emit(`slideResetTransition${n}`);return}e.emit(`slideChangeTransition${n}`),c==="next"?e.emit(`slideNextTransition${n}`):e.emit(`slidePrevTransition${n}`)}}function Rt(s,e){s===void 0&&(s=!0);const t=this,{params:i}=t;i.cssMode||(i.autoHeight&&t.updateAutoHeight(),nt({swiper:t,runCallbacks:s,direction:e,step:"Start"}))}function Xt(s,e){s===void 0&&(s=!0);const t=this,{params:i}=t;t.animating=!1,!i.cssMode&&(t.setTransition(0),nt({swiper:t,runCallbacks:s,direction:e,step:"End"}))}var Yt={setTransition:Vt,transitionStart:Rt,transitionEnd:Xt};function Nt(s,e,t,i,n){s===void 0&&(s=0),t===void 0&&(t=!0),typeof s=="string"&&(s=parseInt(s,10));const r=this;let d=s;d<0&&(d=0);const{params:c,snapGrid:a,slidesGrid:u,previousIndex:f,activeIndex:p,rtlTranslate:v,wrapperEl:m,enabled:l}=r;if(!l&&!i&&!n||r.destroyed||r.animating&&c.preventInteractionOnTransition)return!1;typeof e>"u"&&(e=r.params.speed);const o=Math.min(r.params.slidesPerGroupSkip,d);let w=o+Math.floor((d-o)/r.params.slidesPerGroup);w>=a.length&&(w=a.length-1);const y=-a[w];if(c.normalizeSlideIndex)for(let b=0;b<u.length;b+=1){const z=-Math.floor(y*100),$=Math.floor(u[b]*100),O=Math.floor(u[b+1]*100);typeof u[b+1]<"u"?z>=$&&z<O-(O-$)/2?d=b:z>=$&&z<O&&(d=b+1):z>=$&&(d=b)}if(r.initialized&&d!==p&&(!r.allowSlideNext&&(v?y>r.translate&&y>r.minTranslate():y<r.translate&&y<r.minTranslate())||!r.allowSlidePrev&&y>r.translate&&y>r.maxTranslate()&&(p||0)!==d))return!1;d!==(f||0)&&t&&r.emit("beforeSlideChangeStart"),r.updateProgress(y);let g;d>p?g="next":d<p?g="prev":g="reset";const h=r.virtual&&r.params.virtual.enabled;if(!(h&&n)&&(v&&-y===r.translate||!v&&y===r.translate))return r.updateActiveIndex(d),c.autoHeight&&r.updateAutoHeight(),r.updateSlidesClasses(),c.effect!=="slide"&&r.setTranslate(y),g!=="reset"&&(r.transitionStart(t,g),r.transitionEnd(t,g)),!1;if(c.cssMode){const b=r.isHorizontal(),z=v?y:-y;if(e===0)h&&(r.wrapperEl.style.scrollSnapType="none",r._immediateVirtual=!0),h&&!r._cssModeVirtualInitialSet&&r.params.initialSlide>0?(r._cssModeVirtualInitialSet=!0,requestAnimationFrame(()=>{m[b?"scrollLeft":"scrollTop"]=z})):m[b?"scrollLeft":"scrollTop"]=z,h&&requestAnimationFrame(()=>{r.wrapperEl.style.scrollSnapType="",r._immediateVirtual=!1});else{if(!r.support.smoothScroll)return st({swiper:r,targetPosition:z,side:b?"left":"top"}),!0;m.scrollTo({[b?"left":"top"]:z,behavior:"smooth"})}return!0}return r.setTransition(e),r.setTranslate(y),r.updateActiveIndex(d),r.updateSlidesClasses(),r.emit("beforeTransitionStart",e,i),r.transitionStart(t,g),e===0?r.transitionEnd(t,g):r.animating||(r.animating=!0,r.onSlideToWrapperTransitionEnd||(r.onSlideToWrapperTransitionEnd=function(z){!r||r.destroyed||z.target===this&&(r.wrapperEl.removeEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.onSlideToWrapperTransitionEnd=null,delete r.onSlideToWrapperTransitionEnd,r.transitionEnd(t,g))}),r.wrapperEl.addEventListener("transitionend",r.onSlideToWrapperTransitionEnd)),!0}function Ft(s,e,t,i){s===void 0&&(s=0),t===void 0&&(t=!0),typeof s=="string"&&(s=parseInt(s,10));const n=this;if(n.destroyed)return;typeof e>"u"&&(e=n.params.speed);const r=n.grid&&n.params.grid&&n.params.grid.rows>1;let d=s;if(n.params.loop)if(n.virtual&&n.params.virtual.enabled)d=d+n.virtual.slidesBefore;else{let c;if(r){const v=d*n.params.grid.rows;c=n.slides.find(m=>m.getAttribute("data-swiper-slide-index")*1===v).column}else c=n.getSlideIndexByData(d);const a=r?Math.ceil(n.slides.length/n.params.grid.rows):n.slides.length,{centeredSlides:u}=n.params;let f=n.params.slidesPerView;f==="auto"?f=n.slidesPerViewDynamic():(f=Math.ceil(parseFloat(n.params.slidesPerView,10)),u&&f%2===0&&(f=f+1));let p=a-c<f;if(u&&(p=p||c<Math.ceil(f/2)),i&&u&&n.params.slidesPerView!=="auto"&&!r&&(p=!1),p){const v=u?c<n.activeIndex?"prev":"next":c-n.activeIndex-1<n.params.slidesPerView?"next":"prev";n.loopFix({direction:v,slideTo:!0,activeSlideIndex:v==="next"?c+1:c-a+1,slideRealIndex:v==="next"?n.realIndex:void 0})}if(r){const v=d*n.params.grid.rows;d=n.slides.find(m=>m.getAttribute("data-swiper-slide-index")*1===v).column}else d=n.getSlideIndexByData(d)}return requestAnimationFrame(()=>{n.slideTo(d,e,t,i)}),n}function Wt(s,e,t){e===void 0&&(e=!0);const i=this,{enabled:n,params:r,animating:d}=i;if(!n||i.destroyed)return i;typeof s>"u"&&(s=i.params.speed);let c=r.slidesPerGroup;r.slidesPerView==="auto"&&r.slidesPerGroup===1&&r.slidesPerGroupAuto&&(c=Math.max(i.slidesPerViewDynamic("current",!0),1));const a=i.activeIndex<r.slidesPerGroupSkip?1:c,u=i.virtual&&r.virtual.enabled;if(r.loop){if(d&&!u&&r.loopPreventsSliding)return!1;if(i.loopFix({direction:"next"}),i._clientLeft=i.wrapperEl.clientLeft,i.activeIndex===i.slides.length-1&&r.cssMode)return requestAnimationFrame(()=>{i.slideTo(i.activeIndex+a,s,e,t)}),!0}return r.rewind&&i.isEnd?i.slideTo(0,s,e,t):i.slideTo(i.activeIndex+a,s,e,t)}function jt(s,e,t){e===void 0&&(e=!0);const i=this,{params:n,snapGrid:r,slidesGrid:d,rtlTranslate:c,enabled:a,animating:u}=i;if(!a||i.destroyed)return i;typeof s>"u"&&(s=i.params.speed);const f=i.virtual&&n.virtual.enabled;if(n.loop){if(u&&!f&&n.loopPreventsSliding)return!1;i.loopFix({direction:"prev"}),i._clientLeft=i.wrapperEl.clientLeft}const p=c?i.translate:-i.translate;function v(y){return y<0?-Math.floor(Math.abs(y)):Math.floor(y)}const m=v(p),l=r.map(y=>v(y));let o=r[l.indexOf(m)-1];if(typeof o>"u"&&n.cssMode){let y;r.forEach((g,h)=>{m>=g&&(y=h)}),typeof y<"u"&&(o=r[y>0?y-1:y])}let w=0;if(typeof o<"u"&&(w=d.indexOf(o),w<0&&(w=i.activeIndex-1),n.slidesPerView==="auto"&&n.slidesPerGroup===1&&n.slidesPerGroupAuto&&(w=w-i.slidesPerViewDynamic("previous",!0)+1,w=Math.max(w,0))),n.rewind&&i.isBeginning){const y=i.params.virtual&&i.params.virtual.enabled&&i.virtual?i.virtual.slides.length-1:i.slides.length-1;return i.slideTo(y,s,e,t)}else if(n.loop&&i.activeIndex===0&&n.cssMode)return requestAnimationFrame(()=>{i.slideTo(w,s,e,t)}),!0;return i.slideTo(w,s,e,t)}function Ut(s,e,t){e===void 0&&(e=!0);const i=this;if(!i.destroyed)return typeof s>"u"&&(s=i.params.speed),i.slideTo(i.activeIndex,s,e,t)}function Kt(s,e,t,i){e===void 0&&(e=!0),i===void 0&&(i=.5);const n=this;if(n.destroyed)return;typeof s>"u"&&(s=n.params.speed);let r=n.activeIndex;const d=Math.min(n.params.slidesPerGroupSkip,r),c=d+Math.floor((r-d)/n.params.slidesPerGroup),a=n.rtlTranslate?n.translate:-n.translate;if(a>=n.snapGrid[c]){const u=n.snapGrid[c],f=n.snapGrid[c+1];a-u>(f-u)*i&&(r+=n.params.slidesPerGroup)}else{const u=n.snapGrid[c-1],f=n.snapGrid[c];a-u<=(f-u)*i&&(r-=n.params.slidesPerGroup)}return r=Math.max(r,0),r=Math.min(r,n.slidesGrid.length-1),n.slideTo(r,s,e,t)}function Zt(){const s=this;if(s.destroyed)return;const{params:e,slidesEl:t}=s,i=e.slidesPerView==="auto"?s.slidesPerViewDynamic():e.slidesPerView;let n=s.clickedIndex,r;const d=s.isElement?"swiper-slide":`.${e.slideClass}`;if(e.loop){if(s.animating)return;r=parseInt(s.clickedSlide.getAttribute("data-swiper-slide-index"),10),e.centeredSlides?n<s.loopedSlides-i/2||n>s.slides.length-s.loopedSlides+i/2?(s.loopFix(),n=s.getSlideIndex(W(t,`${d}[data-swiper-slide-index="${r}"]`)[0]),de(()=>{s.slideTo(n)})):s.slideTo(n):n>s.slides.length-i?(s.loopFix(),n=s.getSlideIndex(W(t,`${d}[data-swiper-slide-index="${r}"]`)[0]),de(()=>{s.slideTo(n)})):s.slideTo(n)}else s.slideTo(n)}var Qt={slideTo:Nt,slideToLoop:Ft,slideNext:Wt,slidePrev:jt,slideReset:Ut,slideToClosest:Kt,slideToClickedSlide:Zt};function Jt(s){const e=this,{params:t,slidesEl:i}=e;if(!t.loop||e.virtual&&e.params.virtual.enabled)return;const n=()=>{W(i,`.${t.slideClass}, swiper-slide`).forEach((p,v)=>{p.setAttribute("data-swiper-slide-index",v)})},r=e.grid&&t.grid&&t.grid.rows>1,d=t.slidesPerGroup*(r?t.grid.rows:1),c=e.slides.length%d!==0,a=r&&e.slides.length%t.grid.rows!==0,u=f=>{for(let p=0;p<f;p+=1){const v=e.isElement?Z("swiper-slide",[t.slideBlankClass]):Z("div",[t.slideClass,t.slideBlankClass]);e.slidesEl.append(v)}};if(c){if(t.loopAddBlankSlides){const f=d-e.slides.length%d;u(f),e.recalcSlides(),e.updateSlides()}else Le("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");n()}else if(a){if(t.loopAddBlankSlides){const f=t.grid.rows-e.slides.length%t.grid.rows;u(f),e.recalcSlides(),e.updateSlides()}else Le("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");n()}else n();e.loopFix({slideRealIndex:s,direction:t.centeredSlides?void 0:"next"})}function es(s){let{slideRealIndex:e,slideTo:t=!0,direction:i,setTranslate:n,activeSlideIndex:r,byController:d,byMousewheel:c}=s===void 0?{}:s;const a=this;if(!a.params.loop)return;a.emit("beforeLoopFix");const{slides:u,allowSlidePrev:f,allowSlideNext:p,slidesEl:v,params:m}=a,{centeredSlides:l}=m;if(a.allowSlidePrev=!0,a.allowSlideNext=!0,a.virtual&&m.virtual.enabled){t&&(!m.centeredSlides&&a.snapIndex===0?a.slideTo(a.virtual.slides.length,0,!1,!0):m.centeredSlides&&a.snapIndex<m.slidesPerView?a.slideTo(a.virtual.slides.length+a.snapIndex,0,!1,!0):a.snapIndex===a.snapGrid.length-1&&a.slideTo(a.virtual.slidesBefore,0,!1,!0)),a.allowSlidePrev=f,a.allowSlideNext=p,a.emit("loopFix");return}let o=m.slidesPerView;o==="auto"?o=a.slidesPerViewDynamic():(o=Math.ceil(parseFloat(m.slidesPerView,10)),l&&o%2===0&&(o=o+1));const w=m.slidesPerGroupAuto?o:m.slidesPerGroup;let y=w;y%w!==0&&(y+=w-y%w),y+=m.loopAdditionalSlides,a.loopedSlides=y;const g=a.grid&&m.grid&&m.grid.rows>1;u.length<o+y?Le("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters"):g&&m.grid.fill==="row"&&Le("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");const h=[],S=[];let b=a.activeIndex;typeof r>"u"?r=a.getSlideIndex(u.find(E=>E.classList.contains(m.slideActiveClass))):b=r;const z=i==="next"||!i,$=i==="prev"||!i;let O=0,P=0;const L=g?Math.ceil(u.length/m.grid.rows):u.length,M=(g?u[r].column:r)+(l&&typeof n>"u"?-o/2+.5:0);if(M<y){O=Math.max(y-M,w);for(let E=0;E<y-M;E+=1){const x=E-Math.floor(E/L)*L;if(g){const D=L-x-1;for(let q=u.length-1;q>=0;q-=1)u[q].column===D&&h.push(q)}else h.push(L-x-1)}}else if(M+o>L-y){P=Math.max(M-(L-y*2),w);for(let E=0;E<P;E+=1){const x=E-Math.floor(E/L)*L;g?u.forEach((D,q)=>{D.column===x&&S.push(q)}):S.push(x)}}if(a.__preventObserver__=!0,requestAnimationFrame(()=>{a.__preventObserver__=!1}),$&&h.forEach(E=>{u[E].swiperLoopMoveDOM=!0,v.prepend(u[E]),u[E].swiperLoopMoveDOM=!1}),z&&S.forEach(E=>{u[E].swiperLoopMoveDOM=!0,v.append(u[E]),u[E].swiperLoopMoveDOM=!1}),a.recalcSlides(),m.slidesPerView==="auto"?a.updateSlides():g&&(h.length>0&&$||S.length>0&&z)&&a.slides.forEach((E,x)=>{a.grid.updateSlide(x,E,a.slides)}),m.watchSlidesProgress&&a.updateSlidesOffset(),t){if(h.length>0&&$){if(typeof e>"u"){const E=a.slidesGrid[b],D=a.slidesGrid[b+O]-E;c?a.setTranslate(a.translate-D):(a.slideTo(b+Math.ceil(O),0,!1,!0),n&&(a.touchEventsData.startTranslate=a.touchEventsData.startTranslate-D,a.touchEventsData.currentTranslate=a.touchEventsData.currentTranslate-D))}else if(n){const E=g?h.length/m.grid.rows:h.length;a.slideTo(a.activeIndex+E,0,!1,!0),a.touchEventsData.currentTranslate=a.translate}}else if(S.length>0&&z)if(typeof e>"u"){const E=a.slidesGrid[b],D=a.slidesGrid[b-P]-E;c?a.setTranslate(a.translate-D):(a.slideTo(b-P,0,!1,!0),n&&(a.touchEventsData.startTranslate=a.touchEventsData.startTranslate-D,a.touchEventsData.currentTranslate=a.touchEventsData.currentTranslate-D))}else{const E=g?S.length/m.grid.rows:S.length;a.slideTo(a.activeIndex-E,0,!1,!0)}}if(a.allowSlidePrev=f,a.allowSlideNext=p,a.controller&&a.controller.control&&!d){const E={slideRealIndex:e,direction:i,setTranslate:n,activeSlideIndex:r,byController:!0};Array.isArray(a.controller.control)?a.controller.control.forEach(x=>{!x.destroyed&&x.params.loop&&x.loopFix({...E,slideTo:x.params.slidesPerView===m.slidesPerView?t:!1})}):a.controller.control instanceof a.constructor&&a.controller.control.params.loop&&a.controller.control.loopFix({...E,slideTo:a.controller.control.params.slidesPerView===m.slidesPerView?t:!1})}a.emit("loopFix")}function ts(){const s=this,{params:e,slidesEl:t}=s;if(!e.loop||s.virtual&&s.params.virtual.enabled)return;s.recalcSlides();const i=[];s.slides.forEach(n=>{const r=typeof n.swiperSlideIndex>"u"?n.getAttribute("data-swiper-slide-index")*1:n.swiperSlideIndex;i[r]=n}),s.slides.forEach(n=>{n.removeAttribute("data-swiper-slide-index")}),i.forEach(n=>{t.append(n)}),s.recalcSlides(),s.slideTo(s.realIndex,0)}var ss={loopCreate:Jt,loopFix:es,loopDestroy:ts};function is(s){const e=this;if(!e.params.simulateTouch||e.params.watchOverflow&&e.isLocked||e.params.cssMode)return;const t=e.params.touchEventsTarget==="container"?e.el:e.wrapperEl;e.isElement&&(e.__preventObserver__=!0),t.style.cursor="move",t.style.cursor=s?"grabbing":"grab",e.isElement&&requestAnimationFrame(()=>{e.__preventObserver__=!1})}function rs(){const s=this;s.params.watchOverflow&&s.isLocked||s.params.cssMode||(s.isElement&&(s.__preventObserver__=!0),s[s.params.touchEventsTarget==="container"?"el":"wrapperEl"].style.cursor="",s.isElement&&requestAnimationFrame(()=>{s.__preventObserver__=!1}))}var ns={setGrabCursor:is,unsetGrabCursor:rs};function as(s,e){e===void 0&&(e=this);function t(i){if(!i||i===N()||i===R())return null;i.assignedSlot&&(i=i.assignedSlot);const n=i.closest(s);return!n&&!i.getRootNode?null:n||t(i.getRootNode().host)}return t(e)}function Ze(s,e,t){const i=R(),{params:n}=s,r=n.edgeSwipeDetection,d=n.edgeSwipeThreshold;return r&&(t<=d||t>=i.innerWidth-d)?r==="prevent"?(e.preventDefault(),!0):!1:!0}function ls(s){const e=this,t=N();let i=s;i.originalEvent&&(i=i.originalEvent);const n=e.touchEventsData;if(i.type==="pointerdown"){if(n.pointerId!==null&&n.pointerId!==i.pointerId)return;n.pointerId=i.pointerId}else i.type==="touchstart"&&i.targetTouches.length===1&&(n.touchId=i.targetTouches[0].identifier);if(i.type==="touchstart"){Ze(e,i,i.targetTouches[0].pageX);return}const{params:r,touches:d,enabled:c}=e;if(!c||!r.simulateTouch&&i.pointerType==="mouse"||e.animating&&r.preventInteractionOnTransition)return;!e.animating&&r.cssMode&&r.loop&&e.loopFix();let a=i.target;if(r.touchEventsTarget==="wrapper"&&!mt(a,e.wrapperEl)||"which"in i&&i.which===3||"button"in i&&i.button>0||n.isTouched&&n.isMoved)return;const u=!!r.noSwipingClass&&r.noSwipingClass!=="",f=i.composedPath?i.composedPath():i.path;u&&i.target&&i.target.shadowRoot&&f&&(a=f[0]);const p=r.noSwipingSelector?r.noSwipingSelector:`.${r.noSwipingClass}`,v=!!(i.target&&i.target.shadowRoot);if(r.noSwiping&&(v?as(p,a):a.closest(p))){e.allowClick=!0;return}if(r.swipeHandler&&!a.closest(r.swipeHandler))return;d.currentX=i.pageX,d.currentY=i.pageY;const m=d.currentX,l=d.currentY;if(!Ze(e,i,m))return;Object.assign(n,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),d.startX=m,d.startY=l,n.touchStartTime=Q(),e.allowClick=!0,e.updateSize(),e.swipeDirection=void 0,r.threshold>0&&(n.allowThresholdMove=!1);let o=!0;a.matches(n.focusableElements)&&(o=!1,a.nodeName==="SELECT"&&(n.isTouched=!1)),t.activeElement&&t.activeElement.matches(n.focusableElements)&&t.activeElement!==a&&(i.pointerType==="mouse"||i.pointerType!=="mouse"&&!a.matches(n.focusableElements))&&t.activeElement.blur();const w=o&&e.allowTouchMove&&r.touchStartPreventDefault;(r.touchStartForcePreventDefault||w)&&!a.isContentEditable&&i.preventDefault(),r.freeMode&&r.freeMode.enabled&&e.freeMode&&e.animating&&!r.cssMode&&e.freeMode.onTouchStart(),e.emit("touchStart",i)}function os(s){const e=N(),t=this,i=t.touchEventsData,{params:n,touches:r,rtlTranslate:d,enabled:c}=t;if(!c||!n.simulateTouch&&s.pointerType==="mouse")return;let a=s;if(a.originalEvent&&(a=a.originalEvent),a.type==="pointermove"&&(i.touchId!==null||a.pointerId!==i.pointerId))return;let u;if(a.type==="touchmove"){if(u=[...a.changedTouches].find(b=>b.identifier===i.touchId),!u||u.identifier!==i.touchId)return}else u=a;if(!i.isTouched){i.startMoving&&i.isScrolling&&t.emit("touchMoveOpposite",a);return}const f=u.pageX,p=u.pageY;if(a.preventedByNestedSwiper){r.startX=f,r.startY=p;return}if(!t.allowTouchMove){a.target.matches(i.focusableElements)||(t.allowClick=!1),i.isTouched&&(Object.assign(r,{startX:f,startY:p,currentX:f,currentY:p}),i.touchStartTime=Q());return}if(n.touchReleaseOnEdges&&!n.loop){if(t.isVertical()){if(p<r.startY&&t.translate<=t.maxTranslate()||p>r.startY&&t.translate>=t.minTranslate()){i.isTouched=!1,i.isMoved=!1;return}}else if(f<r.startX&&t.translate<=t.maxTranslate()||f>r.startX&&t.translate>=t.minTranslate())return}if(e.activeElement&&e.activeElement.matches(i.focusableElements)&&e.activeElement!==a.target&&a.pointerType!=="mouse"&&e.activeElement.blur(),e.activeElement&&a.target===e.activeElement&&a.target.matches(i.focusableElements)){i.isMoved=!0,t.allowClick=!1;return}i.allowTouchCallbacks&&t.emit("touchMove",a),r.previousX=r.currentX,r.previousY=r.currentY,r.currentX=f,r.currentY=p;const v=r.currentX-r.startX,m=r.currentY-r.startY;if(t.params.threshold&&Math.sqrt(v**2+m**2)<t.params.threshold)return;if(typeof i.isScrolling>"u"){let b;t.isHorizontal()&&r.currentY===r.startY||t.isVertical()&&r.currentX===r.startX?i.isScrolling=!1:v*v+m*m>=25&&(b=Math.atan2(Math.abs(m),Math.abs(v))*180/Math.PI,i.isScrolling=t.isHorizontal()?b>n.touchAngle:90-b>n.touchAngle)}if(i.isScrolling&&t.emit("touchMoveOpposite",a),typeof i.startMoving>"u"&&(r.currentX!==r.startX||r.currentY!==r.startY)&&(i.startMoving=!0),i.isScrolling||a.type==="touchmove"&&i.preventTouchMoveFromPointerMove){i.isTouched=!1;return}if(!i.startMoving)return;t.allowClick=!1,!n.cssMode&&a.cancelable&&a.preventDefault(),n.touchMoveStopPropagation&&!n.nested&&a.stopPropagation();let l=t.isHorizontal()?v:m,o=t.isHorizontal()?r.currentX-r.previousX:r.currentY-r.previousY;n.oneWayMovement&&(l=Math.abs(l)*(d?1:-1),o=Math.abs(o)*(d?1:-1)),r.diff=l,l*=n.touchRatio,d&&(l=-l,o=-o);const w=t.touchesDirection;t.swipeDirection=l>0?"prev":"next",t.touchesDirection=o>0?"prev":"next";const y=t.params.loop&&!n.cssMode,g=t.touchesDirection==="next"&&t.allowSlideNext||t.touchesDirection==="prev"&&t.allowSlidePrev;if(!i.isMoved){if(y&&g&&t.loopFix({direction:t.swipeDirection}),i.startTranslate=t.getTranslate(),t.setTransition(0),t.animating){const b=new window.CustomEvent("transitionend",{bubbles:!0,cancelable:!0,detail:{bySwiperTouchMove:!0}});t.wrapperEl.dispatchEvent(b)}i.allowMomentumBounce=!1,n.grabCursor&&(t.allowSlideNext===!0||t.allowSlidePrev===!0)&&t.setGrabCursor(!0),t.emit("sliderFirstMove",a)}if(new Date().getTime(),i.isMoved&&i.allowThresholdMove&&w!==t.touchesDirection&&y&&g&&Math.abs(l)>=1){Object.assign(r,{startX:f,startY:p,currentX:f,currentY:p,startTranslate:i.currentTranslate}),i.loopSwapReset=!0,i.startTranslate=i.currentTranslate;return}t.emit("sliderMove",a),i.isMoved=!0,i.currentTranslate=l+i.startTranslate;let h=!0,S=n.resistanceRatio;if(n.touchReleaseOnEdges&&(S=0),l>0?(y&&g&&i.allowThresholdMove&&i.currentTranslate>(n.centeredSlides?t.minTranslate()-t.slidesSizesGrid[t.activeIndex+1]-(n.slidesPerView!=="auto"&&t.slides.length-n.slidesPerView>=2?t.slidesSizesGrid[t.activeIndex+1]+t.params.spaceBetween:0)-t.params.spaceBetween:t.minTranslate())&&t.loopFix({direction:"prev",setTranslate:!0,activeSlideIndex:0}),i.currentTranslate>t.minTranslate()&&(h=!1,n.resistance&&(i.currentTranslate=t.minTranslate()-1+(-t.minTranslate()+i.startTranslate+l)**S))):l<0&&(y&&g&&i.allowThresholdMove&&i.currentTranslate<(n.centeredSlides?t.maxTranslate()+t.slidesSizesGrid[t.slidesSizesGrid.length-1]+t.params.spaceBetween+(n.slidesPerView!=="auto"&&t.slides.length-n.slidesPerView>=2?t.slidesSizesGrid[t.slidesSizesGrid.length-1]+t.params.spaceBetween:0):t.maxTranslate())&&t.loopFix({direction:"next",setTranslate:!0,activeSlideIndex:t.slides.length-(n.slidesPerView==="auto"?t.slidesPerViewDynamic():Math.ceil(parseFloat(n.slidesPerView,10)))}),i.currentTranslate<t.maxTranslate()&&(h=!1,n.resistance&&(i.currentTranslate=t.maxTranslate()+1-(t.maxTranslate()-i.startTranslate-l)**S))),h&&(a.preventedByNestedSwiper=!0),!t.allowSlideNext&&t.swipeDirection==="next"&&i.currentTranslate<i.startTranslate&&(i.currentTranslate=i.startTranslate),!t.allowSlidePrev&&t.swipeDirection==="prev"&&i.currentTranslate>i.startTranslate&&(i.currentTranslate=i.startTranslate),!t.allowSlidePrev&&!t.allowSlideNext&&(i.currentTranslate=i.startTranslate),n.threshold>0)if(Math.abs(l)>n.threshold||i.allowThresholdMove){if(!i.allowThresholdMove){i.allowThresholdMove=!0,r.startX=r.currentX,r.startY=r.currentY,i.currentTranslate=i.startTranslate,r.diff=t.isHorizontal()?r.currentX-r.startX:r.currentY-r.startY;return}}else{i.currentTranslate=i.startTranslate;return}!n.followFinger||n.cssMode||((n.freeMode&&n.freeMode.enabled&&t.freeMode||n.watchSlidesProgress)&&(t.updateActiveIndex(),t.updateSlidesClasses()),n.freeMode&&n.freeMode.enabled&&t.freeMode&&t.freeMode.onTouchMove(),t.updateProgress(i.currentTranslate),t.setTranslate(i.currentTranslate))}function ds(s){const e=this,t=e.touchEventsData;let i=s;i.originalEvent&&(i=i.originalEvent);let n;if(i.type==="touchend"||i.type==="touchcancel"){if(n=[...i.changedTouches].find(b=>b.identifier===t.touchId),!n||n.identifier!==t.touchId)return}else{if(t.touchId!==null||i.pointerId!==t.pointerId)return;n=i}if(["pointercancel","pointerout","pointerleave","contextmenu"].includes(i.type)&&!(["pointercancel","contextmenu"].includes(i.type)&&(e.browser.isSafari||e.browser.isWebView)))return;t.pointerId=null,t.touchId=null;const{params:d,touches:c,rtlTranslate:a,slidesGrid:u,enabled:f}=e;if(!f||!d.simulateTouch&&i.pointerType==="mouse")return;if(t.allowTouchCallbacks&&e.emit("touchEnd",i),t.allowTouchCallbacks=!1,!t.isTouched){t.isMoved&&d.grabCursor&&e.setGrabCursor(!1),t.isMoved=!1,t.startMoving=!1;return}d.grabCursor&&t.isMoved&&t.isTouched&&(e.allowSlideNext===!0||e.allowSlidePrev===!0)&&e.setGrabCursor(!1);const p=Q(),v=p-t.touchStartTime;if(e.allowClick){const b=i.path||i.composedPath&&i.composedPath();e.updateClickedSlide(b&&b[0]||i.target,b),e.emit("tap click",i),v<300&&p-t.lastClickTime<300&&e.emit("doubleTap doubleClick",i)}if(t.lastClickTime=Q(),de(()=>{e.destroyed||(e.allowClick=!0)}),!t.isTouched||!t.isMoved||!e.swipeDirection||c.diff===0&&!t.loopSwapReset||t.currentTranslate===t.startTranslate&&!t.loopSwapReset){t.isTouched=!1,t.isMoved=!1,t.startMoving=!1;return}t.isTouched=!1,t.isMoved=!1,t.startMoving=!1;let m;if(d.followFinger?m=a?e.translate:-e.translate:m=-t.currentTranslate,d.cssMode)return;if(d.freeMode&&d.freeMode.enabled){e.freeMode.onTouchEnd({currentPos:m});return}const l=m>=-e.maxTranslate()&&!e.params.loop;let o=0,w=e.slidesSizesGrid[0];for(let b=0;b<u.length;b+=b<d.slidesPerGroupSkip?1:d.slidesPerGroup){const z=b<d.slidesPerGroupSkip-1?1:d.slidesPerGroup;typeof u[b+z]<"u"?(l||m>=u[b]&&m<u[b+z])&&(o=b,w=u[b+z]-u[b]):(l||m>=u[b])&&(o=b,w=u[u.length-1]-u[u.length-2])}let y=null,g=null;d.rewind&&(e.isBeginning?g=d.virtual&&d.virtual.enabled&&e.virtual?e.virtual.slides.length-1:e.slides.length-1:e.isEnd&&(y=0));const h=(m-u[o])/w,S=o<d.slidesPerGroupSkip-1?1:d.slidesPerGroup;if(v>d.longSwipesMs){if(!d.longSwipes){e.slideTo(e.activeIndex);return}e.swipeDirection==="next"&&(h>=d.longSwipesRatio?e.slideTo(d.rewind&&e.isEnd?y:o+S):e.slideTo(o)),e.swipeDirection==="prev"&&(h>1-d.longSwipesRatio?e.slideTo(o+S):g!==null&&h<0&&Math.abs(h)>d.longSwipesRatio?e.slideTo(g):e.slideTo(o))}else{if(!d.shortSwipes){e.slideTo(e.activeIndex);return}e.navigation&&(i.target===e.navigation.nextEl||i.target===e.navigation.prevEl)?i.target===e.navigation.nextEl?e.slideTo(o+S):e.slideTo(o):(e.swipeDirection==="next"&&e.slideTo(y!==null?y:o+S),e.swipeDirection==="prev"&&e.slideTo(g!==null?g:o))}}function Qe(){const s=this,{params:e,el:t}=s;if(t&&t.offsetWidth===0)return;e.breakpoints&&s.setBreakpoint();const{allowSlideNext:i,allowSlidePrev:n,snapGrid:r}=s,d=s.virtual&&s.params.virtual.enabled;s.allowSlideNext=!0,s.allowSlidePrev=!0,s.updateSize(),s.updateSlides(),s.updateSlidesClasses();const c=d&&e.loop;(e.slidesPerView==="auto"||e.slidesPerView>1)&&s.isEnd&&!s.isBeginning&&!s.params.centeredSlides&&!c?s.slideTo(s.slides.length-1,0,!1,!0):s.params.loop&&!d?s.slideToLoop(s.realIndex,0,!1,!0):s.slideTo(s.activeIndex,0,!1,!0),s.autoplay&&s.autoplay.running&&s.autoplay.paused&&(clearTimeout(s.autoplay.resizeTimeout),s.autoplay.resizeTimeout=setTimeout(()=>{s.autoplay&&s.autoplay.running&&s.autoplay.paused&&s.autoplay.resume()},500)),s.allowSlidePrev=n,s.allowSlideNext=i,s.params.watchOverflow&&r!==s.snapGrid&&s.checkOverflow()}function cs(s){const e=this;e.enabled&&(e.allowClick||(e.params.preventClicks&&s.preventDefault(),e.params.preventClicksPropagation&&e.animating&&(s.stopPropagation(),s.stopImmediatePropagation())))}function fs(){const s=this,{wrapperEl:e,rtlTranslate:t,enabled:i}=s;if(!i)return;s.previousTranslate=s.translate,s.isHorizontal()?s.translate=-e.scrollLeft:s.translate=-e.scrollTop,s.translate===0&&(s.translate=0),s.updateActiveIndex(),s.updateSlidesClasses();let n;const r=s.maxTranslate()-s.minTranslate();r===0?n=0:n=(s.translate-s.minTranslate())/r,n!==s.progress&&s.updateProgress(t?-s.translate:s.translate),s.emit("setTranslate",s.translate,!1)}function us(s){const e=this;Pe(e,s.target),!(e.params.cssMode||e.params.slidesPerView!=="auto"&&!e.params.autoHeight)&&e.update()}function ps(){const s=this;s.documentTouchHandlerProceeded||(s.documentTouchHandlerProceeded=!0,s.params.touchReleaseOnEdges&&(s.el.style.touchAction="auto"))}const at=(s,e)=>{const t=N(),{params:i,el:n,wrapperEl:r,device:d}=s,c=!!i.nested,a=e==="on"?"addEventListener":"removeEventListener",u=e;!n||typeof n=="string"||(t[a]("touchstart",s.onDocumentTouchStart,{passive:!1,capture:c}),n[a]("touchstart",s.onTouchStart,{passive:!1}),n[a]("pointerdown",s.onTouchStart,{passive:!1}),t[a]("touchmove",s.onTouchMove,{passive:!1,capture:c}),t[a]("pointermove",s.onTouchMove,{passive:!1,capture:c}),t[a]("touchend",s.onTouchEnd,{passive:!0}),t[a]("pointerup",s.onTouchEnd,{passive:!0}),t[a]("pointercancel",s.onTouchEnd,{passive:!0}),t[a]("touchcancel",s.onTouchEnd,{passive:!0}),t[a]("pointerout",s.onTouchEnd,{passive:!0}),t[a]("pointerleave",s.onTouchEnd,{passive:!0}),t[a]("contextmenu",s.onTouchEnd,{passive:!0}),(i.preventClicks||i.preventClicksPropagation)&&n[a]("click",s.onClick,!0),i.cssMode&&r[a]("scroll",s.onScroll),i.updateOnWindowResize?s[u](d.ios||d.android?"resize orientationchange observerUpdate":"resize observerUpdate",Qe,!0):s[u]("observerUpdate",Qe,!0),n[a]("load",s.onLoad,{capture:!0}))};function ms(){const s=this,{params:e}=s;s.onTouchStart=ls.bind(s),s.onTouchMove=os.bind(s),s.onTouchEnd=ds.bind(s),s.onDocumentTouchStart=ps.bind(s),e.cssMode&&(s.onScroll=fs.bind(s)),s.onClick=cs.bind(s),s.onLoad=us.bind(s),at(s,"on")}function hs(){at(this,"off")}var gs={attachEvents:ms,detachEvents:hs};const Je=(s,e)=>s.grid&&e.grid&&e.grid.rows>1;function vs(){const s=this,{realIndex:e,initialized:t,params:i,el:n}=s,r=i.breakpoints;if(!r||r&&Object.keys(r).length===0)return;const d=N(),c=i.breakpointsBase==="window"||!i.breakpointsBase?i.breakpointsBase:"container",a=["window","container"].includes(i.breakpointsBase)||!i.breakpointsBase?s.el:d.querySelector(i.breakpointsBase),u=s.getBreakpoint(r,c,a);if(!u||s.currentBreakpoint===u)return;const p=(u in r?r[u]:void 0)||s.originalParams,v=Je(s,i),m=Je(s,p),l=s.params.grabCursor,o=p.grabCursor,w=i.enabled;v&&!m?(n.classList.remove(`${i.containerModifierClass}grid`,`${i.containerModifierClass}grid-column`),s.emitContainerClasses()):!v&&m&&(n.classList.add(`${i.containerModifierClass}grid`),(p.grid.fill&&p.grid.fill==="column"||!p.grid.fill&&i.grid.fill==="column")&&n.classList.add(`${i.containerModifierClass}grid-column`),s.emitContainerClasses()),l&&!o?s.unsetGrabCursor():!l&&o&&s.setGrabCursor(),["navigation","pagination","scrollbar"].forEach(z=>{if(typeof p[z]>"u")return;const $=i[z]&&i[z].enabled,O=p[z]&&p[z].enabled;$&&!O&&s[z].disable(),!$&&O&&s[z].enable()});const y=p.direction&&p.direction!==i.direction,g=i.loop&&(p.slidesPerView!==i.slidesPerView||y),h=i.loop;y&&t&&s.changeDirection(),K(s.params,p);const S=s.params.enabled,b=s.params.loop;Object.assign(s,{allowTouchMove:s.params.allowTouchMove,allowSlideNext:s.params.allowSlideNext,allowSlidePrev:s.params.allowSlidePrev}),w&&!S?s.disable():!w&&S&&s.enable(),s.currentBreakpoint=u,s.emit("_beforeBreakpoint",p),t&&(g?(s.loopDestroy(),s.loopCreate(e),s.updateSlides()):!h&&b?(s.loopCreate(e),s.updateSlides()):h&&!b&&s.loopDestroy()),s.emit("breakpoint",p)}function ws(s,e,t){if(e===void 0&&(e="window"),!s||e==="container"&&!t)return;let i=!1;const n=R(),r=e==="window"?n.innerHeight:t.clientHeight,d=Object.keys(s).map(c=>{if(typeof c=="string"&&c.indexOf("@")===0){const a=parseFloat(c.substr(1));return{value:r*a,point:c}}return{value:c,point:c}});d.sort((c,a)=>parseInt(c.value,10)-parseInt(a.value,10));for(let c=0;c<d.length;c+=1){const{point:a,value:u}=d[c];e==="window"?n.matchMedia(`(min-width: ${u}px)`).matches&&(i=a):u<=t.clientWidth&&(i=a)}return i||"max"}var ys={setBreakpoint:vs,getBreakpoint:ws};function Ss(s,e){const t=[];return s.forEach(i=>{typeof i=="object"?Object.keys(i).forEach(n=>{i[n]&&t.push(e+n)}):typeof i=="string"&&t.push(e+i)}),t}function bs(){const s=this,{classNames:e,params:t,rtl:i,el:n,device:r}=s,d=Ss(["initialized",t.direction,{"free-mode":s.params.freeMode&&t.freeMode.enabled},{autoheight:t.autoHeight},{rtl:i},{grid:t.grid&&t.grid.rows>1},{"grid-column":t.grid&&t.grid.rows>1&&t.grid.fill==="column"},{android:r.android},{ios:r.ios},{"css-mode":t.cssMode},{centered:t.cssMode&&t.centeredSlides},{"watch-progress":t.watchSlidesProgress}],t.containerModifierClass);e.push(...d),n.classList.add(...e),s.emitContainerClasses()}function Es(){const s=this,{el:e,classNames:t}=s;!e||typeof e=="string"||(e.classList.remove(...t),s.emitContainerClasses())}var xs={addClasses:bs,removeClasses:Es};function Ts(){const s=this,{isLocked:e,params:t}=s,{slidesOffsetBefore:i}=t;if(i){const n=s.slides.length-1,r=s.slidesGrid[n]+s.slidesSizesGrid[n]+i*2;s.isLocked=s.size>r}else s.isLocked=s.snapGrid.length===1;t.allowSlideNext===!0&&(s.allowSlideNext=!s.isLocked),t.allowSlidePrev===!0&&(s.allowSlidePrev=!s.isLocked),e&&e!==s.isLocked&&(s.isEnd=!1),e!==s.isLocked&&s.emit(s.isLocked?"lock":"unlock")}var Ms={checkOverflow:Ts},et={init:!0,direction:"horizontal",oneWayMovement:!1,swiperElementNodeName:"SWIPER-CONTAINER",touchEventsTarget:"wrapper",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,resizeObserver:!0,nested:!1,createElements:!1,eventsPrefix:"swiper",enabled:!0,focusableElements:"input, select, option, textarea, button, video, label",width:null,height:null,preventInteractionOnTransition:!1,userAgent:null,url:null,edgeSwipeDetection:!1,edgeSwipeThreshold:20,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,breakpointsBase:"window",spaceBetween:0,slidesPerView:1,slidesPerGroup:1,slidesPerGroupSkip:0,slidesPerGroupAuto:!1,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!0,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:5,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,loop:!1,loopAddBlankSlides:!0,loopAdditionalSlides:0,loopPreventsSliding:!0,rewind:!1,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,maxBackfaceHiddenSlides:10,containerModifierClass:"swiper-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-blank",slideActiveClass:"swiper-slide-active",slideVisibleClass:"swiper-slide-visible",slideFullyVisibleClass:"swiper-slide-fully-visible",slideNextClass:"swiper-slide-next",slidePrevClass:"swiper-slide-prev",wrapperClass:"swiper-wrapper",lazyPreloaderClass:"swiper-lazy-preloader",lazyPreloadPrevNext:0,runCallbacksOnInit:!0,_emitClasses:!1};function Cs(s,e){return function(i){i===void 0&&(i={});const n=Object.keys(i)[0],r=i[n];if(typeof r!="object"||r===null){K(e,i);return}if(s[n]===!0&&(s[n]={enabled:!0}),n==="navigation"&&s[n]&&s[n].enabled&&!s[n].prevEl&&!s[n].nextEl&&(s[n].auto=!0),["pagination","scrollbar"].indexOf(n)>=0&&s[n]&&s[n].enabled&&!s[n].el&&(s[n].auto=!0),!(n in s&&"enabled"in r)){K(e,i);return}typeof s[n]=="object"&&!("enabled"in s[n])&&(s[n].enabled=!0),s[n]||(s[n]={enabled:!1}),K(e,i)}}const Ve={eventsEmitter:xt,update:$t,translate:Gt,transition:Yt,slide:Qt,loop:ss,grabCursor:ns,events:gs,breakpoints:ys,checkOverflow:Ms,classes:xs},Re={};class Y{constructor(){let e,t;for(var i=arguments.length,n=new Array(i),r=0;r<i;r++)n[r]=arguments[r];n.length===1&&n[0].constructor&&Object.prototype.toString.call(n[0]).slice(8,-1)==="Object"?t=n[0]:[e,t]=n,t||(t={}),t=K({},t),e&&!t.el&&(t.el=e);const d=N();if(t.el&&typeof t.el=="string"&&d.querySelectorAll(t.el).length>1){const f=[];return d.querySelectorAll(t.el).forEach(p=>{const v=K({},t,{el:p});f.push(new Y(v))}),f}const c=this;c.__swiper__=!0,c.support=it(),c.device=rt({userAgent:t.userAgent}),c.browser=St(),c.eventsListeners={},c.eventsAnyListeners=[],c.modules=[...c.__modules__],t.modules&&Array.isArray(t.modules)&&c.modules.push(...t.modules);const a={};c.modules.forEach(f=>{f({params:t,swiper:c,extendParams:Cs(t,a),on:c.on.bind(c),once:c.once.bind(c),off:c.off.bind(c),emit:c.emit.bind(c)})});const u=K({},et,a);return c.params=K({},u,Re,t),c.originalParams=K({},c.params),c.passedParams=K({},t),c.params&&c.params.on&&Object.keys(c.params.on).forEach(f=>{c.on(f,c.params.on[f])}),c.params&&c.params.onAny&&c.onAny(c.params.onAny),Object.assign(c,{enabled:c.params.enabled,el:e,classNames:[],slides:[],slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal(){return c.params.direction==="horizontal"},isVertical(){return c.params.direction==="vertical"},activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,cssOverflowAdjustment(){return Math.trunc(this.translate/2**23)*2**23},allowSlideNext:c.params.allowSlideNext,allowSlidePrev:c.params.allowSlidePrev,touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,focusableElements:c.params.focusableElements,lastClickTime:0,clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,startMoving:void 0,pointerId:null,touchId:null},allowClick:!0,allowTouchMove:c.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),c.emit("_swiper"),c.params.init&&c.init(),c}getDirectionLabel(e){return this.isHorizontal()?e:{width:"height","margin-top":"margin-left","margin-bottom ":"margin-right","margin-left":"margin-top","margin-right":"margin-bottom","padding-left":"padding-top","padding-right":"padding-bottom",marginRight:"marginBottom"}[e]}getSlideIndex(e){const{slidesEl:t,params:i}=this,n=W(t,`.${i.slideClass}, swiper-slide`),r=Ee(n[0]);return Ee(e)-r}getSlideIndexByData(e){return this.getSlideIndex(this.slides.find(t=>t.getAttribute("data-swiper-slide-index")*1===e))}recalcSlides(){const e=this,{slidesEl:t,params:i}=e;e.slides=W(t,`.${i.slideClass}, swiper-slide`)}enable(){const e=this;e.enabled||(e.enabled=!0,e.params.grabCursor&&e.setGrabCursor(),e.emit("enable"))}disable(){const e=this;e.enabled&&(e.enabled=!1,e.params.grabCursor&&e.unsetGrabCursor(),e.emit("disable"))}setProgress(e,t){const i=this;e=Math.min(Math.max(e,0),1);const n=i.minTranslate(),d=(i.maxTranslate()-n)*e+n;i.translateTo(d,typeof t>"u"?0:t),i.updateActiveIndex(),i.updateSlidesClasses()}emitContainerClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=e.el.className.split(" ").filter(i=>i.indexOf("swiper")===0||i.indexOf(e.params.containerModifierClass)===0);e.emit("_containerClasses",t.join(" "))}getSlideClasses(e){const t=this;return t.destroyed?"":e.className.split(" ").filter(i=>i.indexOf("swiper-slide")===0||i.indexOf(t.params.slideClass)===0).join(" ")}emitSlidesClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=[];e.slides.forEach(i=>{const n=e.getSlideClasses(i);t.push({slideEl:i,classNames:n}),e.emit("_slideClass",i,n)}),e.emit("_slideClasses",t)}slidesPerViewDynamic(e,t){e===void 0&&(e="current"),t===void 0&&(t=!1);const i=this,{params:n,slides:r,slidesGrid:d,slidesSizesGrid:c,size:a,activeIndex:u}=i;let f=1;if(typeof n.slidesPerView=="number")return n.slidesPerView;if(n.centeredSlides){let p=r[u]?Math.ceil(r[u].swiperSlideSize):0,v;for(let m=u+1;m<r.length;m+=1)r[m]&&!v&&(p+=Math.ceil(r[m].swiperSlideSize),f+=1,p>a&&(v=!0));for(let m=u-1;m>=0;m-=1)r[m]&&!v&&(p+=r[m].swiperSlideSize,f+=1,p>a&&(v=!0))}else if(e==="current")for(let p=u+1;p<r.length;p+=1)(t?d[p]+c[p]-d[u]<a:d[p]-d[u]<a)&&(f+=1);else for(let p=u-1;p>=0;p-=1)d[u]-d[p]<a&&(f+=1);return f}update(){const e=this;if(!e||e.destroyed)return;const{snapGrid:t,params:i}=e;i.breakpoints&&e.setBreakpoint(),[...e.el.querySelectorAll('[loading="lazy"]')].forEach(d=>{d.complete&&Pe(e,d)}),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses();function n(){const d=e.rtlTranslate?e.translate*-1:e.translate,c=Math.min(Math.max(d,e.maxTranslate()),e.minTranslate());e.setTranslate(c),e.updateActiveIndex(),e.updateSlidesClasses()}let r;if(i.freeMode&&i.freeMode.enabled&&!i.cssMode)n(),i.autoHeight&&e.updateAutoHeight();else{if((i.slidesPerView==="auto"||i.slidesPerView>1)&&e.isEnd&&!i.centeredSlides){const d=e.virtual&&i.virtual.enabled?e.virtual.slides:e.slides;r=e.slideTo(d.length-1,0,!1,!0)}else r=e.slideTo(e.activeIndex,0,!1,!0);r||n()}i.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}changeDirection(e,t){t===void 0&&(t=!0);const i=this,n=i.params.direction;return e||(e=n==="horizontal"?"vertical":"horizontal"),e===n||e!=="horizontal"&&e!=="vertical"||(i.el.classList.remove(`${i.params.containerModifierClass}${n}`),i.el.classList.add(`${i.params.containerModifierClass}${e}`),i.emitContainerClasses(),i.params.direction=e,i.slides.forEach(r=>{e==="vertical"?r.style.width="":r.style.height=""}),i.emit("changeDirection"),t&&i.update()),i}changeLanguageDirection(e){const t=this;t.rtl&&e==="rtl"||!t.rtl&&e==="ltr"||(t.rtl=e==="rtl",t.rtlTranslate=t.params.direction==="horizontal"&&t.rtl,t.rtl?(t.el.classList.add(`${t.params.containerModifierClass}rtl`),t.el.dir="rtl"):(t.el.classList.remove(`${t.params.containerModifierClass}rtl`),t.el.dir="ltr"),t.update())}mount(e){const t=this;if(t.mounted)return!0;let i=e||t.params.el;if(typeof i=="string"&&(i=document.querySelector(i)),!i)return!1;i.swiper=t,i.parentNode&&i.parentNode.host&&i.parentNode.host.nodeName===t.params.swiperElementNodeName.toUpperCase()&&(t.isElement=!0);const n=()=>`.${(t.params.wrapperClass||"").trim().split(" ").join(".")}`;let d=i&&i.shadowRoot&&i.shadowRoot.querySelector?i.shadowRoot.querySelector(n()):W(i,n())[0];return!d&&t.params.createElements&&(d=Z("div",t.params.wrapperClass),i.append(d),W(i,`.${t.params.slideClass}`).forEach(c=>{d.append(c)})),Object.assign(t,{el:i,wrapperEl:d,slidesEl:t.isElement&&!i.parentNode.host.slideSlots?i.parentNode.host:d,hostEl:t.isElement?i.parentNode.host:i,mounted:!0,rtl:i.dir.toLowerCase()==="rtl"||le(i,"direction")==="rtl",rtlTranslate:t.params.direction==="horizontal"&&(i.dir.toLowerCase()==="rtl"||le(i,"direction")==="rtl"),wrongRTL:le(d,"display")==="-webkit-box"}),!0}init(e){const t=this;if(t.initialized||t.mount(e)===!1)return t;t.emit("beforeInit"),t.params.breakpoints&&t.setBreakpoint(),t.addClasses(),t.updateSize(),t.updateSlides(),t.params.watchOverflow&&t.checkOverflow(),t.params.grabCursor&&t.enabled&&t.setGrabCursor(),t.params.loop&&t.virtual&&t.params.virtual.enabled?t.slideTo(t.params.initialSlide+t.virtual.slidesBefore,0,t.params.runCallbacksOnInit,!1,!0):t.slideTo(t.params.initialSlide,0,t.params.runCallbacksOnInit,!1,!0),t.params.loop&&t.loopCreate(),t.attachEvents();const n=[...t.el.querySelectorAll('[loading="lazy"]')];return t.isElement&&n.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),n.forEach(r=>{r.complete?Pe(t,r):r.addEventListener("load",d=>{Pe(t,d.target)})}),Ne(t),t.initialized=!0,Ne(t),t.emit("init"),t.emit("afterInit"),t}destroy(e,t){e===void 0&&(e=!0),t===void 0&&(t=!0);const i=this,{params:n,el:r,wrapperEl:d,slides:c}=i;return typeof i.params>"u"||i.destroyed||(i.emit("beforeDestroy"),i.initialized=!1,i.detachEvents(),n.loop&&i.loopDestroy(),t&&(i.removeClasses(),r&&typeof r!="string"&&r.removeAttribute("style"),d&&d.removeAttribute("style"),c&&c.length&&c.forEach(a=>{a.classList.remove(n.slideVisibleClass,n.slideFullyVisibleClass,n.slideActiveClass,n.slideNextClass,n.slidePrevClass),a.removeAttribute("style"),a.removeAttribute("data-swiper-slide-index")})),i.emit("destroy"),Object.keys(i.eventsListeners).forEach(a=>{i.off(a)}),e!==!1&&(i.el&&typeof i.el!="string"&&(i.el.swiper=null),ct(i)),i.destroyed=!0),null}static extendDefaults(e){K(Re,e)}static get extendedDefaults(){return Re}static get defaults(){return et}static installModule(e){Y.prototype.__modules__||(Y.prototype.__modules__=[]);const t=Y.prototype.__modules__;typeof e=="function"&&t.indexOf(e)<0&&t.push(e)}static use(e){return Array.isArray(e)?(e.forEach(t=>Y.installModule(t)),Y):(Y.installModule(e),Y)}}Object.keys(Ve).forEach(s=>{Object.keys(Ve[s]).forEach(e=>{Y.prototype[e]=Ve[s][e]})});Y.use([bt,Et]);function Ps(s){let{swiper:e,extendParams:t,on:i,emit:n}=s;t({virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,renderExternalUpdate:!0,addSlidesBefore:0,addSlidesAfter:0}});let r;const d=N();e.virtual={cache:{},from:void 0,to:void 0,slides:[],offset:0,slidesGrid:[]};const c=d.createElement("div");function a(l,o){const w=e.params.virtual;if(w.cache&&e.virtual.cache[o])return e.virtual.cache[o];let y;return w.renderSlide?(y=w.renderSlide.call(e,l,o),typeof y=="string"&&(c.innerHTML=y,y=c.children[0])):e.isElement?y=Z("swiper-slide"):y=Z("div",e.params.slideClass),y.setAttribute("data-swiper-slide-index",o),w.renderSlide||(y.innerHTML=l),w.cache&&(e.virtual.cache[o]=y),y}function u(l,o){const{slidesPerView:w,slidesPerGroup:y,centeredSlides:g,loop:h,initialSlide:S}=e.params;if(o&&!h&&S>0)return;const{addSlidesBefore:b,addSlidesAfter:z}=e.params.virtual,{from:$,to:O,slides:P,slidesGrid:L,offset:A}=e.virtual;e.params.cssMode||e.updateActiveIndex();const M=e.activeIndex||0;let E;e.rtlTranslate?E="right":E=e.isHorizontal()?"left":"top";let x,D;g?(x=Math.floor(w/2)+y+z,D=Math.floor(w/2)+y+b):(x=w+(y-1)+z,D=(h?w:y)+b);let q=M-D,C=M+x;h||(q=Math.max(q,0),C=Math.min(C,P.length-1));let I=(e.slidesGrid[q]||0)-(e.slidesGrid[0]||0);h&&M>=D?(q-=D,g||(I+=e.slidesGrid[0])):h&&M<D&&(q=-D,g&&(I+=e.slidesGrid[0])),Object.assign(e.virtual,{from:q,to:C,offset:I,slidesGrid:e.slidesGrid,slidesBefore:D,slidesAfter:x});function H(){e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),n("virtualUpdate")}if($===q&&O===C&&!l){e.slidesGrid!==L&&I!==A&&e.slides.forEach(T=>{T.style[E]=`${I-Math.abs(e.cssOverflowAdjustment())}px`}),e.updateProgress(),n("virtualUpdate");return}if(e.params.virtual.renderExternal){e.params.virtual.renderExternal.call(e,{offset:I,from:q,to:C,slides:function(){const k=[];for(let B=q;B<=C;B+=1)k.push(P[B]);return k}()}),e.params.virtual.renderExternalUpdate?H():n("virtualUpdate");return}const _=[],X=[],F=T=>{let k=T;return T<0?k=P.length+T:k>=P.length&&(k=k-P.length),k};if(l)e.slides.filter(T=>T.matches(`.${e.params.slideClass}, swiper-slide`)).forEach(T=>{T.remove()});else for(let T=$;T<=O;T+=1)if(T<q||T>C){const k=F(T);e.slides.filter(B=>B.matches(`.${e.params.slideClass}[data-swiper-slide-index="${k}"], swiper-slide[data-swiper-slide-index="${k}"]`)).forEach(B=>{B.remove()})}const J=h?-P.length:0,pe=h?P.length*2:P.length;for(let T=J;T<pe;T+=1)if(T>=q&&T<=C){const k=F(T);typeof O>"u"||l?X.push(k):(T>O&&X.push(k),T<$&&_.push(k))}if(X.forEach(T=>{e.slidesEl.append(a(P[T],T))}),h)for(let T=_.length-1;T>=0;T-=1){const k=_[T];e.slidesEl.prepend(a(P[k],k))}else _.sort((T,k)=>k-T),_.forEach(T=>{e.slidesEl.prepend(a(P[T],T))});W(e.slidesEl,".swiper-slide, swiper-slide").forEach(T=>{T.style[E]=`${I-Math.abs(e.cssOverflowAdjustment())}px`}),H()}function f(l){if(typeof l=="object"&&"length"in l)for(let o=0;o<l.length;o+=1)l[o]&&e.virtual.slides.push(l[o]);else e.virtual.slides.push(l);u(!0)}function p(l){const o=e.activeIndex;let w=o+1,y=1;if(Array.isArray(l)){for(let g=0;g<l.length;g+=1)l[g]&&e.virtual.slides.unshift(l[g]);w=o+l.length,y=l.length}else e.virtual.slides.unshift(l);if(e.params.virtual.cache){const g=e.virtual.cache,h={};Object.keys(g).forEach(S=>{const b=g[S],z=b.getAttribute("data-swiper-slide-index");z&&b.setAttribute("data-swiper-slide-index",parseInt(z,10)+y),h[parseInt(S,10)+y]=b}),e.virtual.cache=h}u(!0),e.slideTo(w,0)}function v(l){if(typeof l>"u"||l===null)return;let o=e.activeIndex;if(Array.isArray(l))for(let w=l.length-1;w>=0;w-=1)e.params.virtual.cache&&(delete e.virtual.cache[l[w]],Object.keys(e.virtual.cache).forEach(y=>{y>l&&(e.virtual.cache[y-1]=e.virtual.cache[y],e.virtual.cache[y-1].setAttribute("data-swiper-slide-index",y-1),delete e.virtual.cache[y])})),e.virtual.slides.splice(l[w],1),l[w]<o&&(o-=1),o=Math.max(o,0);else e.params.virtual.cache&&(delete e.virtual.cache[l],Object.keys(e.virtual.cache).forEach(w=>{w>l&&(e.virtual.cache[w-1]=e.virtual.cache[w],e.virtual.cache[w-1].setAttribute("data-swiper-slide-index",w-1),delete e.virtual.cache[w])})),e.virtual.slides.splice(l,1),l<o&&(o-=1),o=Math.max(o,0);u(!0),e.slideTo(o,0)}function m(){e.virtual.slides=[],e.params.virtual.cache&&(e.virtual.cache={}),u(!0),e.slideTo(0,0)}i("beforeInit",()=>{if(!e.params.virtual.enabled)return;let l;if(typeof e.passedParams.virtual.slides>"u"){const o=[...e.slidesEl.children].filter(w=>w.matches(`.${e.params.slideClass}, swiper-slide`));o.length&&(e.virtual.slides=[...o],l=!0,o.forEach((w,y)=>{w.setAttribute("data-swiper-slide-index",y),e.virtual.cache[y]=w,w.remove()}))}l||(e.virtual.slides=e.params.virtual.slides),e.classNames.push(`${e.params.containerModifierClass}virtual`),e.params.watchSlidesProgress=!0,e.originalParams.watchSlidesProgress=!0,u(!1,!0)}),i("setTranslate",()=>{e.params.virtual.enabled&&(e.params.cssMode&&!e._immediateVirtual?(clearTimeout(r),r=setTimeout(()=>{u()},100)):u())}),i("init update resize",()=>{e.params.virtual.enabled&&e.params.cssMode&&Se(e.wrapperEl,"--swiper-virtual-size",`${e.virtualSize}px`)}),Object.assign(e.virtual,{appendSlide:f,prependSlide:p,removeSlide:v,removeAllSlides:m,update:u})}function Ls(s){let{swiper:e,extendParams:t,on:i,emit:n}=s;const r=N(),d=R();e.keyboard={enabled:!1},t({keyboard:{enabled:!1,onlyInViewport:!0,pageUpDown:!0}});function c(f){if(!e.enabled)return;const{rtlTranslate:p}=e;let v=f;v.originalEvent&&(v=v.originalEvent);const m=v.keyCode||v.charCode,l=e.params.keyboard.pageUpDown,o=l&&m===33,w=l&&m===34,y=m===37,g=m===39,h=m===38,S=m===40;if(!e.allowSlideNext&&(e.isHorizontal()&&g||e.isVertical()&&S||w)||!e.allowSlidePrev&&(e.isHorizontal()&&y||e.isVertical()&&h||o))return!1;if(!(v.shiftKey||v.altKey||v.ctrlKey||v.metaKey)&&!(r.activeElement&&r.activeElement.nodeName&&(r.activeElement.nodeName.toLowerCase()==="input"||r.activeElement.nodeName.toLowerCase()==="textarea"))){if(e.params.keyboard.onlyInViewport&&(o||w||y||g||h||S)){let b=!1;if(oe(e.el,`.${e.params.slideClass}, swiper-slide`).length>0&&oe(e.el,`.${e.params.slideActiveClass}`).length===0)return;const z=e.el,$=z.clientWidth,O=z.clientHeight,P=d.innerWidth,L=d.innerHeight,A=Ie(z);p&&(A.left-=z.scrollLeft);const M=[[A.left,A.top],[A.left+$,A.top],[A.left,A.top+O],[A.left+$,A.top+O]];for(let E=0;E<M.length;E+=1){const x=M[E];if(x[0]>=0&&x[0]<=P&&x[1]>=0&&x[1]<=L){if(x[0]===0&&x[1]===0)continue;b=!0}}if(!b)return}e.isHorizontal()?((o||w||y||g)&&(v.preventDefault?v.preventDefault():v.returnValue=!1),((w||g)&&!p||(o||y)&&p)&&e.slideNext(),((o||y)&&!p||(w||g)&&p)&&e.slidePrev()):((o||w||h||S)&&(v.preventDefault?v.preventDefault():v.returnValue=!1),(w||S)&&e.slideNext(),(o||h)&&e.slidePrev()),n("keyPress",m)}}function a(){e.keyboard.enabled||(r.addEventListener("keydown",c),e.keyboard.enabled=!0)}function u(){e.keyboard.enabled&&(r.removeEventListener("keydown",c),e.keyboard.enabled=!1)}i("init",()=>{e.params.keyboard.enabled&&a()}),i("destroy",()=>{e.keyboard.enabled&&u()}),Object.assign(e.keyboard,{enable:a,disable:u})}function Is(s){let{swiper:e,extendParams:t,on:i,emit:n}=s;const r=R();t({mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarget:"container",thresholdDelta:null,thresholdTime:null,noMousewheelClass:"swiper-no-mousewheel"}}),e.mousewheel={enabled:!1};let d,c=Q(),a;const u=[];function f(h){let $=0,O=0,P=0,L=0;return"detail"in h&&(O=h.detail),"wheelDelta"in h&&(O=-h.wheelDelta/120),"wheelDeltaY"in h&&(O=-h.wheelDeltaY/120),"wheelDeltaX"in h&&($=-h.wheelDeltaX/120),"axis"in h&&h.axis===h.HORIZONTAL_AXIS&&($=O,O=0),P=$*10,L=O*10,"deltaY"in h&&(L=h.deltaY),"deltaX"in h&&(P=h.deltaX),h.shiftKey&&!P&&(P=L,L=0),(P||L)&&h.deltaMode&&(h.deltaMode===1?(P*=40,L*=40):(P*=800,L*=800)),P&&!$&&($=P<1?-1:1),L&&!O&&(O=L<1?-1:1),{spinX:$,spinY:O,pixelX:P,pixelY:L}}function p(){e.enabled&&(e.mouseEntered=!0)}function v(){e.enabled&&(e.mouseEntered=!1)}function m(h){return e.params.mousewheel.thresholdDelta&&h.delta<e.params.mousewheel.thresholdDelta||e.params.mousewheel.thresholdTime&&Q()-c<e.params.mousewheel.thresholdTime?!1:h.delta>=6&&Q()-c<60?!0:(h.direction<0?(!e.isEnd||e.params.loop)&&!e.animating&&(e.slideNext(),n("scroll",h.raw)):(!e.isBeginning||e.params.loop)&&!e.animating&&(e.slidePrev(),n("scroll",h.raw)),c=new r.Date().getTime(),!1)}function l(h){const S=e.params.mousewheel;if(h.direction<0){if(e.isEnd&&!e.params.loop&&S.releaseOnEdges)return!0}else if(e.isBeginning&&!e.params.loop&&S.releaseOnEdges)return!0;return!1}function o(h){let S=h,b=!0;if(!e.enabled||h.target.closest(`.${e.params.mousewheel.noMousewheelClass}`))return;const z=e.params.mousewheel;e.params.cssMode&&S.preventDefault();let $=e.el;e.params.mousewheel.eventsTarget!=="container"&&($=document.querySelector(e.params.mousewheel.eventsTarget));const O=$&&$.contains(S.target);if(!e.mouseEntered&&!O&&!z.releaseOnEdges)return!0;S.originalEvent&&(S=S.originalEvent);let P=0;const L=e.rtlTranslate?-1:1,A=f(S);if(z.forceToAxis)if(e.isHorizontal())if(Math.abs(A.pixelX)>Math.abs(A.pixelY))P=-A.pixelX*L;else return!0;else if(Math.abs(A.pixelY)>Math.abs(A.pixelX))P=-A.pixelY;else return!0;else P=Math.abs(A.pixelX)>Math.abs(A.pixelY)?-A.pixelX*L:-A.pixelY;if(P===0)return!0;z.invert&&(P=-P);let M=e.getTranslate()+P*z.sensitivity;if(M>=e.minTranslate()&&(M=e.minTranslate()),M<=e.maxTranslate()&&(M=e.maxTranslate()),b=e.params.loop?!0:!(M===e.minTranslate()||M===e.maxTranslate()),b&&e.params.nested&&S.stopPropagation(),!e.params.freeMode||!e.params.freeMode.enabled){const E={time:Q(),delta:Math.abs(P),direction:Math.sign(P),raw:h};u.length>=2&&u.shift();const x=u.length?u[u.length-1]:void 0;if(u.push(E),x?(E.direction!==x.direction||E.delta>x.delta||E.time>x.time+150)&&m(E):m(E),l(E))return!0}else{const E={time:Q(),delta:Math.abs(P),direction:Math.sign(P)},x=a&&E.time<a.time+500&&E.delta<=a.delta&&E.direction===a.direction;if(!x){a=void 0;let D=e.getTranslate()+P*z.sensitivity;const q=e.isBeginning,C=e.isEnd;if(D>=e.minTranslate()&&(D=e.minTranslate()),D<=e.maxTranslate()&&(D=e.maxTranslate()),e.setTransition(0),e.setTranslate(D),e.updateProgress(),e.updateActiveIndex(),e.updateSlidesClasses(),(!q&&e.isBeginning||!C&&e.isEnd)&&e.updateSlidesClasses(),e.params.loop&&e.loopFix({direction:E.direction<0?"next":"prev",byMousewheel:!0}),e.params.freeMode.sticky){clearTimeout(d),d=void 0,u.length>=15&&u.shift();const I=u.length?u[u.length-1]:void 0,H=u[0];if(u.push(E),I&&(E.delta>I.delta||E.direction!==I.direction))u.splice(0);else if(u.length>=15&&E.time-H.time<500&&H.delta-E.delta>=1&&E.delta<=6){const _=P>0?.8:.2;a=E,u.splice(0),d=de(()=>{e.destroyed||!e.params||e.slideToClosest(e.params.speed,!0,void 0,_)},0)}d||(d=de(()=>{if(e.destroyed||!e.params)return;const _=.5;a=E,u.splice(0),e.slideToClosest(e.params.speed,!0,void 0,_)},500))}if(x||n("scroll",S),e.params.autoplay&&e.params.autoplay.disableOnInteraction&&e.autoplay.stop(),z.releaseOnEdges&&(D===e.minTranslate()||D===e.maxTranslate()))return!0}}return S.preventDefault?S.preventDefault():S.returnValue=!1,!1}function w(h){let S=e.el;e.params.mousewheel.eventsTarget!=="container"&&(S=document.querySelector(e.params.mousewheel.eventsTarget)),S[h]("mouseenter",p),S[h]("mouseleave",v),S[h]("wheel",o)}function y(){return e.params.cssMode?(e.wrapperEl.removeEventListener("wheel",o),!0):e.mousewheel.enabled?!1:(w("addEventListener"),e.mousewheel.enabled=!0,!0)}function g(){return e.params.cssMode?(e.wrapperEl.addEventListener(event,o),!0):e.mousewheel.enabled?(w("removeEventListener"),e.mousewheel.enabled=!1,!0):!1}i("init",()=>{!e.params.mousewheel.enabled&&e.params.cssMode&&g(),e.params.mousewheel.enabled&&y()}),i("destroy",()=>{e.params.cssMode&&y(),e.mousewheel.enabled&&g()}),Object.assign(e.mousewheel,{enable:y,disable:g})}function We(s,e,t,i){return s.params.createElements&&Object.keys(i).forEach(n=>{if(!t[n]&&t.auto===!0){let r=W(s.el,`.${i[n]}`)[0];r||(r=Z("div",i[n]),r.className=i[n],s.el.append(r)),t[n]=r,e[n]=r}}),t}function As(s){let{swiper:e,extendParams:t,on:i,emit:n}=s;t({navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock",navigationDisabledClass:"swiper-navigation-disabled"}}),e.navigation={nextEl:null,prevEl:null};function r(l){let o;return l&&typeof l=="string"&&e.isElement&&(o=e.el.querySelector(l)||e.hostEl.querySelector(l),o)?o:(l&&(typeof l=="string"&&(o=[...document.querySelectorAll(l)]),e.params.uniqueNavElements&&typeof l=="string"&&o&&o.length>1&&e.el.querySelectorAll(l).length===1?o=e.el.querySelector(l):o&&o.length===1&&(o=o[0])),l&&!o?l:o)}function d(l,o){const w=e.params.navigation;l=G(l),l.forEach(y=>{y&&(y.classList[o?"add":"remove"](...w.disabledClass.split(" ")),y.tagName==="BUTTON"&&(y.disabled=o),e.params.watchOverflow&&e.enabled&&y.classList[e.isLocked?"add":"remove"](w.lockClass))})}function c(){const{nextEl:l,prevEl:o}=e.navigation;if(e.params.loop){d(o,!1),d(l,!1);return}d(o,e.isBeginning&&!e.params.rewind),d(l,e.isEnd&&!e.params.rewind)}function a(l){l.preventDefault(),!(e.isBeginning&&!e.params.loop&&!e.params.rewind)&&(e.slidePrev(),n("navigationPrev"))}function u(l){l.preventDefault(),!(e.isEnd&&!e.params.loop&&!e.params.rewind)&&(e.slideNext(),n("navigationNext"))}function f(){const l=e.params.navigation;if(e.params.navigation=We(e,e.originalParams.navigation,e.params.navigation,{nextEl:"swiper-button-next",prevEl:"swiper-button-prev"}),!(l.nextEl||l.prevEl))return;let o=r(l.nextEl),w=r(l.prevEl);Object.assign(e.navigation,{nextEl:o,prevEl:w}),o=G(o),w=G(w);const y=(g,h)=>{g&&g.addEventListener("click",h==="next"?u:a),!e.enabled&&g&&g.classList.add(...l.lockClass.split(" "))};o.forEach(g=>y(g,"next")),w.forEach(g=>y(g,"prev"))}function p(){let{nextEl:l,prevEl:o}=e.navigation;l=G(l),o=G(o);const w=(y,g)=>{y.removeEventListener("click",g==="next"?u:a),y.classList.remove(...e.params.navigation.disabledClass.split(" "))};l.forEach(y=>w(y,"next")),o.forEach(y=>w(y,"prev"))}i("init",()=>{e.params.navigation.enabled===!1?m():(f(),c())}),i("toEdge fromEdge lock unlock",()=>{c()}),i("destroy",()=>{p()}),i("enable disable",()=>{let{nextEl:l,prevEl:o}=e.navigation;if(l=G(l),o=G(o),e.enabled){c();return}[...l,...o].filter(w=>!!w).forEach(w=>w.classList.add(e.params.navigation.lockClass))}),i("click",(l,o)=>{let{nextEl:w,prevEl:y}=e.navigation;w=G(w),y=G(y);const g=o.target;let h=y.includes(g)||w.includes(g);if(e.isElement&&!h){const S=o.path||o.composedPath&&o.composedPath();S&&(h=S.find(b=>w.includes(b)||y.includes(b)))}if(e.params.navigation.hideOnClick&&!h){if(e.pagination&&e.params.pagination&&e.params.pagination.clickable&&(e.pagination.el===g||e.pagination.el.contains(g)))return;let S;w.length?S=w[0].classList.contains(e.params.navigation.hiddenClass):y.length&&(S=y[0].classList.contains(e.params.navigation.hiddenClass)),n(S===!0?"navigationShow":"navigationHide"),[...w,...y].filter(b=>!!b).forEach(b=>b.classList.toggle(e.params.navigation.hiddenClass))}});const v=()=>{e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")),f(),c()},m=()=>{e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")),p()};Object.assign(e.navigation,{enable:v,disable:m,update:c,init:f,destroy:p})}function se(s){return s===void 0&&(s=""),`.${s.trim().replace(/([\.:!+\/])/g,"\\$1").replace(/ /g,".")}`}function zs(s){let{swiper:e,extendParams:t,on:i,emit:n}=s;const r="swiper-pagination";t({pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:g=>g,formatFractionTotal:g=>g,bulletClass:`${r}-bullet`,bulletActiveClass:`${r}-bullet-active`,modifierClass:`${r}-`,currentClass:`${r}-current`,totalClass:`${r}-total`,hiddenClass:`${r}-hidden`,progressbarFillClass:`${r}-progressbar-fill`,progressbarOppositeClass:`${r}-progressbar-opposite`,clickableClass:`${r}-clickable`,lockClass:`${r}-lock`,horizontalClass:`${r}-horizontal`,verticalClass:`${r}-vertical`,paginationDisabledClass:`${r}-disabled`}}),e.pagination={el:null,bullets:[]};let d,c=0;function a(){return!e.params.pagination.el||!e.pagination.el||Array.isArray(e.pagination.el)&&e.pagination.el.length===0}function u(g,h){const{bulletActiveClass:S}=e.params.pagination;g&&(g=g[`${h==="prev"?"previous":"next"}ElementSibling`],g&&(g.classList.add(`${S}-${h}`),g=g[`${h==="prev"?"previous":"next"}ElementSibling`],g&&g.classList.add(`${S}-${h}-${h}`)))}function f(g,h,S){if(g=g%S,h=h%S,h===g+1)return"next";if(h===g-1)return"previous"}function p(g){const h=g.target.closest(se(e.params.pagination.bulletClass));if(!h)return;g.preventDefault();const S=Ee(h)*e.params.slidesPerGroup;if(e.params.loop){if(e.realIndex===S)return;const b=f(e.realIndex,S,e.slides.length);b==="next"?e.slideNext():b==="previous"?e.slidePrev():e.slideToLoop(S)}else e.slideTo(S)}function v(){const g=e.rtl,h=e.params.pagination;if(a())return;let S=e.pagination.el;S=G(S);let b,z;const $=e.virtual&&e.params.virtual.enabled?e.virtual.slides.length:e.slides.length,O=e.params.loop?Math.ceil($/e.params.slidesPerGroup):e.snapGrid.length;if(e.params.loop?(z=e.previousRealIndex||0,b=e.params.slidesPerGroup>1?Math.floor(e.realIndex/e.params.slidesPerGroup):e.realIndex):typeof e.snapIndex<"u"?(b=e.snapIndex,z=e.previousSnapIndex):(z=e.previousIndex||0,b=e.activeIndex||0),h.type==="bullets"&&e.pagination.bullets&&e.pagination.bullets.length>0){const P=e.pagination.bullets;let L,A,M;if(h.dynamicBullets&&(d=Ye(P[0],e.isHorizontal()?"width":"height"),S.forEach(E=>{E.style[e.isHorizontal()?"width":"height"]=`${d*(h.dynamicMainBullets+4)}px`}),h.dynamicMainBullets>1&&z!==void 0&&(c+=b-(z||0),c>h.dynamicMainBullets-1?c=h.dynamicMainBullets-1:c<0&&(c=0)),L=Math.max(b-c,0),A=L+(Math.min(P.length,h.dynamicMainBullets)-1),M=(A+L)/2),P.forEach(E=>{const x=[...["","-next","-next-next","-prev","-prev-prev","-main"].map(D=>`${h.bulletActiveClass}${D}`)].map(D=>typeof D=="string"&&D.includes(" ")?D.split(" "):D).flat();E.classList.remove(...x)}),S.length>1)P.forEach(E=>{const x=Ee(E);x===b?E.classList.add(...h.bulletActiveClass.split(" ")):e.isElement&&E.setAttribute("part","bullet"),h.dynamicBullets&&(x>=L&&x<=A&&E.classList.add(...`${h.bulletActiveClass}-main`.split(" ")),x===L&&u(E,"prev"),x===A&&u(E,"next"))});else{const E=P[b];if(E&&E.classList.add(...h.bulletActiveClass.split(" ")),e.isElement&&P.forEach((x,D)=>{x.setAttribute("part",D===b?"bullet-active":"bullet")}),h.dynamicBullets){const x=P[L],D=P[A];for(let q=L;q<=A;q+=1)P[q]&&P[q].classList.add(...`${h.bulletActiveClass}-main`.split(" "));u(x,"prev"),u(D,"next")}}if(h.dynamicBullets){const E=Math.min(P.length,h.dynamicMainBullets+4),x=(d*E-d)/2-M*d,D=g?"right":"left";P.forEach(q=>{q.style[e.isHorizontal()?D:"top"]=`${x}px`})}}S.forEach((P,L)=>{if(h.type==="fraction"&&(P.querySelectorAll(se(h.currentClass)).forEach(A=>{A.textContent=h.formatFractionCurrent(b+1)}),P.querySelectorAll(se(h.totalClass)).forEach(A=>{A.textContent=h.formatFractionTotal(O)})),h.type==="progressbar"){let A;h.progressbarOpposite?A=e.isHorizontal()?"vertical":"horizontal":A=e.isHorizontal()?"horizontal":"vertical";const M=(b+1)/O;let E=1,x=1;A==="horizontal"?E=M:x=M,P.querySelectorAll(se(h.progressbarFillClass)).forEach(D=>{D.style.transform=`translate3d(0,0,0) scaleX(${E}) scaleY(${x})`,D.style.transitionDuration=`${e.params.speed}ms`})}h.type==="custom"&&h.renderCustom?(P.innerHTML=h.renderCustom(e,b+1,O),L===0&&n("paginationRender",P)):(L===0&&n("paginationRender",P),n("paginationUpdate",P)),e.params.watchOverflow&&e.enabled&&P.classList[e.isLocked?"add":"remove"](h.lockClass)})}function m(){const g=e.params.pagination;if(a())return;const h=e.virtual&&e.params.virtual.enabled?e.virtual.slides.length:e.grid&&e.params.grid.rows>1?e.slides.length/Math.ceil(e.params.grid.rows):e.slides.length;let S=e.pagination.el;S=G(S);let b="";if(g.type==="bullets"){let z=e.params.loop?Math.ceil(h/e.params.slidesPerGroup):e.snapGrid.length;e.params.freeMode&&e.params.freeMode.enabled&&z>h&&(z=h);for(let $=0;$<z;$+=1)g.renderBullet?b+=g.renderBullet.call(e,$,g.bulletClass):b+=`<${g.bulletElement} ${e.isElement?'part="bullet"':""} class="${g.bulletClass}"></${g.bulletElement}>`}g.type==="fraction"&&(g.renderFraction?b=g.renderFraction.call(e,g.currentClass,g.totalClass):b=`<span class="${g.currentClass}"></span> / <span class="${g.totalClass}"></span>`),g.type==="progressbar"&&(g.renderProgressbar?b=g.renderProgressbar.call(e,g.progressbarFillClass):b=`<span class="${g.progressbarFillClass}"></span>`),e.pagination.bullets=[],S.forEach(z=>{g.type!=="custom"&&(z.innerHTML=b||""),g.type==="bullets"&&e.pagination.bullets.push(...z.querySelectorAll(se(g.bulletClass)))}),g.type!=="custom"&&n("paginationRender",S[0])}function l(){e.params.pagination=We(e,e.originalParams.pagination,e.params.pagination,{el:"swiper-pagination"});const g=e.params.pagination;if(!g.el)return;let h;typeof g.el=="string"&&e.isElement&&(h=e.el.querySelector(g.el)),!h&&typeof g.el=="string"&&(h=[...document.querySelectorAll(g.el)]),h||(h=g.el),!(!h||h.length===0)&&(e.params.uniqueNavElements&&typeof g.el=="string"&&Array.isArray(h)&&h.length>1&&(h=[...e.el.querySelectorAll(g.el)],h.length>1&&(h=h.find(S=>oe(S,".swiper")[0]===e.el))),Array.isArray(h)&&h.length===1&&(h=h[0]),Object.assign(e.pagination,{el:h}),h=G(h),h.forEach(S=>{g.type==="bullets"&&g.clickable&&S.classList.add(...(g.clickableClass||"").split(" ")),S.classList.add(g.modifierClass+g.type),S.classList.add(e.isHorizontal()?g.horizontalClass:g.verticalClass),g.type==="bullets"&&g.dynamicBullets&&(S.classList.add(`${g.modifierClass}${g.type}-dynamic`),c=0,g.dynamicMainBullets<1&&(g.dynamicMainBullets=1)),g.type==="progressbar"&&g.progressbarOpposite&&S.classList.add(g.progressbarOppositeClass),g.clickable&&S.addEventListener("click",p),e.enabled||S.classList.add(g.lockClass)}))}function o(){const g=e.params.pagination;if(a())return;let h=e.pagination.el;h&&(h=G(h),h.forEach(S=>{S.classList.remove(g.hiddenClass),S.classList.remove(g.modifierClass+g.type),S.classList.remove(e.isHorizontal()?g.horizontalClass:g.verticalClass),g.clickable&&(S.classList.remove(...(g.clickableClass||"").split(" ")),S.removeEventListener("click",p))})),e.pagination.bullets&&e.pagination.bullets.forEach(S=>S.classList.remove(...g.bulletActiveClass.split(" ")))}i("changeDirection",()=>{if(!e.pagination||!e.pagination.el)return;const g=e.params.pagination;let{el:h}=e.pagination;h=G(h),h.forEach(S=>{S.classList.remove(g.horizontalClass,g.verticalClass),S.classList.add(e.isHorizontal()?g.horizontalClass:g.verticalClass)})}),i("init",()=>{e.params.pagination.enabled===!1?y():(l(),m(),v())}),i("activeIndexChange",()=>{typeof e.snapIndex>"u"&&v()}),i("snapIndexChange",()=>{v()}),i("snapGridLengthChange",()=>{m(),v()}),i("destroy",()=>{o()}),i("enable disable",()=>{let{el:g}=e.pagination;g&&(g=G(g),g.forEach(h=>h.classList[e.enabled?"remove":"add"](e.params.pagination.lockClass)))}),i("lock unlock",()=>{v()}),i("click",(g,h)=>{const S=h.target,b=G(e.pagination.el);if(e.params.pagination.el&&e.params.pagination.hideOnClick&&b&&b.length>0&&!S.classList.contains(e.params.pagination.bulletClass)){if(e.navigation&&(e.navigation.nextEl&&S===e.navigation.nextEl||e.navigation.prevEl&&S===e.navigation.prevEl))return;const z=b[0].classList.contains(e.params.pagination.hiddenClass);n(z===!0?"paginationShow":"paginationHide"),b.forEach($=>$.classList.toggle(e.params.pagination.hiddenClass))}});const w=()=>{e.el.classList.remove(e.params.pagination.paginationDisabledClass);let{el:g}=e.pagination;g&&(g=G(g),g.forEach(h=>h.classList.remove(e.params.pagination.paginationDisabledClass))),l(),m(),v()},y=()=>{e.el.classList.add(e.params.pagination.paginationDisabledClass);let{el:g}=e.pagination;g&&(g=G(g),g.forEach(h=>h.classList.add(e.params.pagination.paginationDisabledClass))),o()};Object.assign(e.pagination,{enable:w,disable:y,render:m,update:v,init:l,destroy:o})}function Os(s){let{swiper:e,extendParams:t,on:i,emit:n}=s;const r=N();let d=!1,c=null,a=null,u,f,p,v;t({scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag",scrollbarDisabledClass:"swiper-scrollbar-disabled",horizontalClass:"swiper-scrollbar-horizontal",verticalClass:"swiper-scrollbar-vertical"}}),e.scrollbar={el:null,dragEl:null};function m(){if(!e.params.scrollbar.el||!e.scrollbar.el)return;const{scrollbar:M,rtlTranslate:E}=e,{dragEl:x,el:D}=M,q=e.params.scrollbar,C=e.params.loop?e.progressLoop:e.progress;let I=f,H=(p-f)*C;E?(H=-H,H>0?(I=f-H,H=0):-H+f>p&&(I=p+H)):H<0?(I=f+H,H=0):H+f>p&&(I=p-H),e.isHorizontal()?(x.style.transform=`translate3d(${H}px, 0, 0)`,x.style.width=`${I}px`):(x.style.transform=`translate3d(0px, ${H}px, 0)`,x.style.height=`${I}px`),q.hide&&(clearTimeout(c),D.style.opacity=1,c=setTimeout(()=>{D.style.opacity=0,D.style.transitionDuration="400ms"},1e3))}function l(M){!e.params.scrollbar.el||!e.scrollbar.el||(e.scrollbar.dragEl.style.transitionDuration=`${M}ms`)}function o(){if(!e.params.scrollbar.el||!e.scrollbar.el)return;const{scrollbar:M}=e,{dragEl:E,el:x}=M;E.style.width="",E.style.height="",p=e.isHorizontal()?x.offsetWidth:x.offsetHeight,v=e.size/(e.virtualSize+e.params.slidesOffsetBefore-(e.params.centeredSlides?e.snapGrid[0]:0)),e.params.scrollbar.dragSize==="auto"?f=p*v:f=parseInt(e.params.scrollbar.dragSize,10),e.isHorizontal()?E.style.width=`${f}px`:E.style.height=`${f}px`,v>=1?x.style.display="none":x.style.display="",e.params.scrollbar.hide&&(x.style.opacity=0),e.params.watchOverflow&&e.enabled&&M.el.classList[e.isLocked?"add":"remove"](e.params.scrollbar.lockClass)}function w(M){return e.isHorizontal()?M.clientX:M.clientY}function y(M){const{scrollbar:E,rtlTranslate:x}=e,{el:D}=E;let q;q=(w(M)-Ie(D)[e.isHorizontal()?"left":"top"]-(u!==null?u:f/2))/(p-f),q=Math.max(Math.min(q,1),0),x&&(q=1-q);const C=e.minTranslate()+(e.maxTranslate()-e.minTranslate())*q;e.updateProgress(C),e.setTranslate(C),e.updateActiveIndex(),e.updateSlidesClasses()}function g(M){const E=e.params.scrollbar,{scrollbar:x,wrapperEl:D}=e,{el:q,dragEl:C}=x;d=!0,u=M.target===C?w(M)-M.target.getBoundingClientRect()[e.isHorizontal()?"left":"top"]:null,M.preventDefault(),M.stopPropagation(),D.style.transitionDuration="100ms",C.style.transitionDuration="100ms",y(M),clearTimeout(a),q.style.transitionDuration="0ms",E.hide&&(q.style.opacity=1),e.params.cssMode&&(e.wrapperEl.style["scroll-snap-type"]="none"),n("scrollbarDragStart",M)}function h(M){const{scrollbar:E,wrapperEl:x}=e,{el:D,dragEl:q}=E;d&&(M.preventDefault&&M.cancelable?M.preventDefault():M.returnValue=!1,y(M),x.style.transitionDuration="0ms",D.style.transitionDuration="0ms",q.style.transitionDuration="0ms",n("scrollbarDragMove",M))}function S(M){const E=e.params.scrollbar,{scrollbar:x,wrapperEl:D}=e,{el:q}=x;d&&(d=!1,e.params.cssMode&&(e.wrapperEl.style["scroll-snap-type"]="",D.style.transitionDuration=""),E.hide&&(clearTimeout(a),a=de(()=>{q.style.opacity=0,q.style.transitionDuration="400ms"},1e3)),n("scrollbarDragEnd",M),E.snapOnRelease&&e.slideToClosest())}function b(M){const{scrollbar:E,params:x}=e,D=E.el;if(!D)return;const q=D,C=x.passiveListeners?{passive:!1,capture:!1}:!1,I=x.passiveListeners?{passive:!0,capture:!1}:!1;if(!q)return;const H=M==="on"?"addEventListener":"removeEventListener";q[H]("pointerdown",g,C),r[H]("pointermove",h,C),r[H]("pointerup",S,I)}function z(){!e.params.scrollbar.el||!e.scrollbar.el||b("on")}function $(){!e.params.scrollbar.el||!e.scrollbar.el||b("off")}function O(){const{scrollbar:M,el:E}=e;e.params.scrollbar=We(e,e.originalParams.scrollbar,e.params.scrollbar,{el:"swiper-scrollbar"});const x=e.params.scrollbar;if(!x.el)return;let D;if(typeof x.el=="string"&&e.isElement&&(D=e.el.querySelector(x.el)),!D&&typeof x.el=="string"){if(D=r.querySelectorAll(x.el),!D.length)return}else D||(D=x.el);e.params.uniqueNavElements&&typeof x.el=="string"&&D.length>1&&E.querySelectorAll(x.el).length===1&&(D=E.querySelector(x.el)),D.length>0&&(D=D[0]),D.classList.add(e.isHorizontal()?x.horizontalClass:x.verticalClass);let q;D&&(q=D.querySelector(se(e.params.scrollbar.dragClass)),q||(q=Z("div",e.params.scrollbar.dragClass),D.append(q))),Object.assign(M,{el:D,dragEl:q}),x.draggable&&z(),D&&D.classList[e.enabled?"remove":"add"](...ae(e.params.scrollbar.lockClass))}function P(){const M=e.params.scrollbar,E=e.scrollbar.el;E&&E.classList.remove(...ae(e.isHorizontal()?M.horizontalClass:M.verticalClass)),$()}i("changeDirection",()=>{if(!e.scrollbar||!e.scrollbar.el)return;const M=e.params.scrollbar;let{el:E}=e.scrollbar;E=G(E),E.forEach(x=>{x.classList.remove(M.horizontalClass,M.verticalClass),x.classList.add(e.isHorizontal()?M.horizontalClass:M.verticalClass)})}),i("init",()=>{e.params.scrollbar.enabled===!1?A():(O(),o(),m())}),i("update resize observerUpdate lock unlock changeDirection",()=>{o()}),i("setTranslate",()=>{m()}),i("setTransition",(M,E)=>{l(E)}),i("enable disable",()=>{const{el:M}=e.scrollbar;M&&M.classList[e.enabled?"remove":"add"](...ae(e.params.scrollbar.lockClass))}),i("destroy",()=>{P()});const L=()=>{e.el.classList.remove(...ae(e.params.scrollbar.scrollbarDisabledClass)),e.scrollbar.el&&e.scrollbar.el.classList.remove(...ae(e.params.scrollbar.scrollbarDisabledClass)),O(),o(),m()},A=()=>{e.el.classList.add(...ae(e.params.scrollbar.scrollbarDisabledClass)),e.scrollbar.el&&e.scrollbar.el.classList.add(...ae(e.params.scrollbar.scrollbarDisabledClass)),P()};Object.assign(e.scrollbar,{enable:L,disable:A,updateSize:o,setTranslate:m,init:O,destroy:P})}function Ds(s){let{swiper:e,extendParams:t,on:i}=s;t({parallax:{enabled:!1}});const n="[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]",r=(a,u)=>{const{rtl:f}=e,p=f?-1:1,v=a.getAttribute("data-swiper-parallax")||"0";let m=a.getAttribute("data-swiper-parallax-x"),l=a.getAttribute("data-swiper-parallax-y");const o=a.getAttribute("data-swiper-parallax-scale"),w=a.getAttribute("data-swiper-parallax-opacity"),y=a.getAttribute("data-swiper-parallax-rotate");if(m||l?(m=m||"0",l=l||"0"):e.isHorizontal()?(m=v,l="0"):(l=v,m="0"),m.indexOf("%")>=0?m=`${parseInt(m,10)*u*p}%`:m=`${m*u*p}px`,l.indexOf("%")>=0?l=`${parseInt(l,10)*u}%`:l=`${l*u}px`,typeof w<"u"&&w!==null){const h=w-(w-1)*(1-Math.abs(u));a.style.opacity=h}let g=`translate3d(${m}, ${l}, 0px)`;if(typeof o<"u"&&o!==null){const h=o-(o-1)*(1-Math.abs(u));g+=` scale(${h})`}if(y&&typeof y<"u"&&y!==null){const h=y*u*-1;g+=` rotate(${h}deg)`}a.style.transform=g},d=()=>{const{el:a,slides:u,progress:f,snapGrid:p,isElement:v}=e,m=W(a,n);e.isElement&&m.push(...W(e.hostEl,n)),m.forEach(l=>{r(l,f)}),u.forEach((l,o)=>{let w=l.progress;e.params.slidesPerGroup>1&&e.params.slidesPerView!=="auto"&&(w+=Math.ceil(o/2)-f*(p.length-1)),w=Math.min(Math.max(w,-1),1),l.querySelectorAll(`${n}, [data-swiper-parallax-rotate]`).forEach(y=>{r(y,w)})})},c=function(a){a===void 0&&(a=e.params.speed);const{el:u,hostEl:f}=e,p=[...u.querySelectorAll(n)];e.isElement&&p.push(...f.querySelectorAll(n)),p.forEach(v=>{let m=parseInt(v.getAttribute("data-swiper-parallax-duration"),10)||a;a===0&&(m=0),v.style.transitionDuration=`${m}ms`})};i("beforeInit",()=>{e.params.parallax.enabled&&(e.params.watchSlidesProgress=!0,e.originalParams.watchSlidesProgress=!0)}),i("init",()=>{e.params.parallax.enabled&&d()}),i("setTranslate",()=>{e.params.parallax.enabled&&d()}),i("setTransition",(a,u)=>{e.params.parallax.enabled&&c(u)})}function $s(s){let{swiper:e,extendParams:t,on:i,emit:n}=s;const r=R();t({zoom:{enabled:!1,limitToOriginalSize:!1,maxRatio:3,minRatio:1,panOnMouseMove:!1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}}),e.zoom={enabled:!1};let d=1,c=!1,a=!1,u={x:0,y:0};const f=-3;let p,v;const m=[],l={originX:0,originY:0,slideEl:void 0,slideWidth:void 0,slideHeight:void 0,imageEl:void 0,imageWrapEl:void 0,maxRatio:3},o={isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},w={x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0};let y=1;Object.defineProperty(e.zoom,"scale",{get(){return y},set(T){if(y!==T){const k=l.imageEl,B=l.slideEl;n("zoomChange",T,k,B)}y=T}});function g(){if(m.length<2)return 1;const T=m[0].pageX,k=m[0].pageY,B=m[1].pageX,V=m[1].pageY;return Math.sqrt((B-T)**2+(V-k)**2)}function h(){const T=e.params.zoom,k=l.imageWrapEl.getAttribute("data-swiper-zoom")||T.maxRatio;if(T.limitToOriginalSize&&l.imageEl&&l.imageEl.naturalWidth){const B=l.imageEl.naturalWidth/l.imageEl.offsetWidth;return Math.min(B,k)}return k}function S(){if(m.length<2)return{x:null,y:null};const T=l.imageEl.getBoundingClientRect();return[(m[0].pageX+(m[1].pageX-m[0].pageX)/2-T.x-r.scrollX)/d,(m[0].pageY+(m[1].pageY-m[0].pageY)/2-T.y-r.scrollY)/d]}function b(){return e.isElement?"swiper-slide":`.${e.params.slideClass}`}function z(T){const k=b();return!!(T.target.matches(k)||e.slides.filter(B=>B.contains(T.target)).length>0)}function $(T){const k=`.${e.params.zoom.containerClass}`;return!!(T.target.matches(k)||[...e.hostEl.querySelectorAll(k)].filter(B=>B.contains(T.target)).length>0)}function O(T){if(T.pointerType==="mouse"&&m.splice(0,m.length),!z(T))return;const k=e.params.zoom;if(p=!1,v=!1,m.push(T),!(m.length<2)){if(p=!0,l.scaleStart=g(),!l.slideEl){l.slideEl=T.target.closest(`.${e.params.slideClass}, swiper-slide`),l.slideEl||(l.slideEl=e.slides[e.activeIndex]);let B=l.slideEl.querySelector(`.${k.containerClass}`);if(B&&(B=B.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),l.imageEl=B,B?l.imageWrapEl=oe(l.imageEl,`.${k.containerClass}`)[0]:l.imageWrapEl=void 0,!l.imageWrapEl){l.imageEl=void 0;return}l.maxRatio=h()}if(l.imageEl){const[B,V]=S();l.originX=B,l.originY=V,l.imageEl.style.transitionDuration="0ms"}c=!0}}function P(T){if(!z(T))return;const k=e.params.zoom,B=e.zoom,V=m.findIndex(j=>j.pointerId===T.pointerId);V>=0&&(m[V]=T),!(m.length<2)&&(v=!0,l.scaleMove=g(),l.imageEl&&(B.scale=l.scaleMove/l.scaleStart*d,B.scale>l.maxRatio&&(B.scale=l.maxRatio-1+(B.scale-l.maxRatio+1)**.5),B.scale<k.minRatio&&(B.scale=k.minRatio+1-(k.minRatio-B.scale+1)**.5),l.imageEl.style.transform=`translate3d(0,0,0) scale(${B.scale})`))}function L(T){if(!z(T)||T.pointerType==="mouse"&&T.type==="pointerout")return;const k=e.params.zoom,B=e.zoom,V=m.findIndex(j=>j.pointerId===T.pointerId);V>=0&&m.splice(V,1),!(!p||!v)&&(p=!1,v=!1,l.imageEl&&(B.scale=Math.max(Math.min(B.scale,l.maxRatio),k.minRatio),l.imageEl.style.transitionDuration=`${e.params.speed}ms`,l.imageEl.style.transform=`translate3d(0,0,0) scale(${B.scale})`,d=B.scale,c=!1,B.scale>1&&l.slideEl?l.slideEl.classList.add(`${k.zoomedSlideClass}`):B.scale<=1&&l.slideEl&&l.slideEl.classList.remove(`${k.zoomedSlideClass}`),B.scale===1&&(l.originX=0,l.originY=0,l.slideEl=void 0)))}let A;function M(){e.touchEventsData.preventTouchMoveFromPointerMove=!1}function E(){clearTimeout(A),e.touchEventsData.preventTouchMoveFromPointerMove=!0,A=setTimeout(()=>{e.destroyed||M()})}function x(T){const k=e.device;if(!l.imageEl||o.isTouched)return;k.android&&T.cancelable&&T.preventDefault(),o.isTouched=!0;const B=m.length>0?m[0]:T;o.touchesStart.x=B.pageX,o.touchesStart.y=B.pageY}function D(T){const B=T.pointerType==="mouse"&&e.params.zoom.panOnMouseMove;if(!z(T)||!$(T))return;const V=e.zoom;if(!l.imageEl)return;if(!o.isTouched||!l.slideEl){B&&I(T);return}if(B){I(T);return}o.isMoved||(o.width=l.imageEl.offsetWidth||l.imageEl.clientWidth,o.height=l.imageEl.offsetHeight||l.imageEl.clientHeight,o.startX=Xe(l.imageWrapEl,"x")||0,o.startY=Xe(l.imageWrapEl,"y")||0,l.slideWidth=l.slideEl.offsetWidth,l.slideHeight=l.slideEl.offsetHeight,l.imageWrapEl.style.transitionDuration="0ms");const j=o.width*V.scale,ie=o.height*V.scale;if(o.minX=Math.min(l.slideWidth/2-j/2,0),o.maxX=-o.minX,o.minY=Math.min(l.slideHeight/2-ie/2,0),o.maxY=-o.minY,o.touchesCurrent.x=m.length>0?m[0].pageX:T.pageX,o.touchesCurrent.y=m.length>0?m[0].pageY:T.pageY,Math.max(Math.abs(o.touchesCurrent.x-o.touchesStart.x),Math.abs(o.touchesCurrent.y-o.touchesStart.y))>5&&(e.allowClick=!1),!o.isMoved&&!c){if(e.isHorizontal()&&(Math.floor(o.minX)===Math.floor(o.startX)&&o.touchesCurrent.x<o.touchesStart.x||Math.floor(o.maxX)===Math.floor(o.startX)&&o.touchesCurrent.x>o.touchesStart.x)){o.isTouched=!1,M();return}if(!e.isHorizontal()&&(Math.floor(o.minY)===Math.floor(o.startY)&&o.touchesCurrent.y<o.touchesStart.y||Math.floor(o.maxY)===Math.floor(o.startY)&&o.touchesCurrent.y>o.touchesStart.y)){o.isTouched=!1,M();return}}T.cancelable&&T.preventDefault(),T.stopPropagation(),E(),o.isMoved=!0;const ee=(V.scale-d)/(l.maxRatio-e.params.zoom.minRatio),{originX:ne,originY:U}=l;o.currentX=o.touchesCurrent.x-o.touchesStart.x+o.startX+ee*(o.width-ne*2),o.currentY=o.touchesCurrent.y-o.touchesStart.y+o.startY+ee*(o.height-U*2),o.currentX<o.minX&&(o.currentX=o.minX+1-(o.minX-o.currentX+1)**.8),o.currentX>o.maxX&&(o.currentX=o.maxX-1+(o.currentX-o.maxX+1)**.8),o.currentY<o.minY&&(o.currentY=o.minY+1-(o.minY-o.currentY+1)**.8),o.currentY>o.maxY&&(o.currentY=o.maxY-1+(o.currentY-o.maxY+1)**.8),w.prevPositionX||(w.prevPositionX=o.touchesCurrent.x),w.prevPositionY||(w.prevPositionY=o.touchesCurrent.y),w.prevTime||(w.prevTime=Date.now()),w.x=(o.touchesCurrent.x-w.prevPositionX)/(Date.now()-w.prevTime)/2,w.y=(o.touchesCurrent.y-w.prevPositionY)/(Date.now()-w.prevTime)/2,Math.abs(o.touchesCurrent.x-w.prevPositionX)<2&&(w.x=0),Math.abs(o.touchesCurrent.y-w.prevPositionY)<2&&(w.y=0),w.prevPositionX=o.touchesCurrent.x,w.prevPositionY=o.touchesCurrent.y,w.prevTime=Date.now(),l.imageWrapEl.style.transform=`translate3d(${o.currentX}px, ${o.currentY}px,0)`}function q(){const T=e.zoom;if(m.length=0,!l.imageEl)return;if(!o.isTouched||!o.isMoved){o.isTouched=!1,o.isMoved=!1;return}o.isTouched=!1,o.isMoved=!1;let k=300,B=300;const V=w.x*k,j=o.currentX+V,ie=w.y*B,re=o.currentY+ie;w.x!==0&&(k=Math.abs((j-o.currentX)/w.x)),w.y!==0&&(B=Math.abs((re-o.currentY)/w.y));const ee=Math.max(k,B);o.currentX=j,o.currentY=re;const ne=o.width*T.scale,U=o.height*T.scale;o.minX=Math.min(l.slideWidth/2-ne/2,0),o.maxX=-o.minX,o.minY=Math.min(l.slideHeight/2-U/2,0),o.maxY=-o.minY,o.currentX=Math.max(Math.min(o.currentX,o.maxX),o.minX),o.currentY=Math.max(Math.min(o.currentY,o.maxY),o.minY),l.imageWrapEl.style.transitionDuration=`${ee}ms`,l.imageWrapEl.style.transform=`translate3d(${o.currentX}px, ${o.currentY}px,0)`}function C(){const T=e.zoom;l.slideEl&&e.activeIndex!==e.slides.indexOf(l.slideEl)&&(l.imageEl&&(l.imageEl.style.transform="translate3d(0,0,0) scale(1)"),l.imageWrapEl&&(l.imageWrapEl.style.transform="translate3d(0,0,0)"),l.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`),T.scale=1,d=1,l.slideEl=void 0,l.imageEl=void 0,l.imageWrapEl=void 0,l.originX=0,l.originY=0)}function I(T){if(d<=1||!l.imageWrapEl||!z(T)||!$(T))return;const k=r.getComputedStyle(l.imageWrapEl).transform,B=new r.DOMMatrix(k);if(!a){a=!0,u.x=T.clientX,u.y=T.clientY,o.startX=B.e,o.startY=B.f,o.width=l.imageEl.offsetWidth||l.imageEl.clientWidth,o.height=l.imageEl.offsetHeight||l.imageEl.clientHeight,l.slideWidth=l.slideEl.offsetWidth,l.slideHeight=l.slideEl.offsetHeight;return}const V=(T.clientX-u.x)*f,j=(T.clientY-u.y)*f,ie=o.width*d,re=o.height*d,ee=l.slideWidth,ne=l.slideHeight,U=Math.min(ee/2-ie/2,0),te=-U,me=Math.min(ne/2-re/2,0),Te=-me,he=Math.max(Math.min(o.startX+V,te),U),ge=Math.max(Math.min(o.startY+j,Te),me);l.imageWrapEl.style.transitionDuration="0ms",l.imageWrapEl.style.transform=`translate3d(${he}px, ${ge}px, 0)`,u.x=T.clientX,u.y=T.clientY,o.startX=he,o.startY=ge}function H(T){const k=e.zoom,B=e.params.zoom;if(!l.slideEl){T&&T.target&&(l.slideEl=T.target.closest(`.${e.params.slideClass}, swiper-slide`)),l.slideEl||(e.params.virtual&&e.params.virtual.enabled&&e.virtual?l.slideEl=W(e.slidesEl,`.${e.params.slideActiveClass}`)[0]:l.slideEl=e.slides[e.activeIndex]);let we=l.slideEl.querySelector(`.${B.containerClass}`);we&&(we=we.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),l.imageEl=we,we?l.imageWrapEl=oe(l.imageEl,`.${B.containerClass}`)[0]:l.imageWrapEl=void 0}if(!l.imageEl||!l.imageWrapEl)return;e.params.cssMode&&(e.wrapperEl.style.overflow="hidden",e.wrapperEl.style.touchAction="none"),l.slideEl.classList.add(`${B.zoomedSlideClass}`);let V,j,ie,re,ee,ne,U,te,me,Te,he,ge,Me,Ce,Oe,De,$e,ke;typeof o.touchesStart.x>"u"&&T?(V=T.pageX,j=T.pageY):(V=o.touchesStart.x,j=o.touchesStart.y);const ve=typeof T=="number"?T:null;d===1&&ve&&(V=void 0,j=void 0,o.touchesStart.x=void 0,o.touchesStart.y=void 0);const je=h();k.scale=ve||je,d=ve||je,T&&!(d===1&&ve)?($e=l.slideEl.offsetWidth,ke=l.slideEl.offsetHeight,ie=Ie(l.slideEl).left+r.scrollX,re=Ie(l.slideEl).top+r.scrollY,ee=ie+$e/2-V,ne=re+ke/2-j,me=l.imageEl.offsetWidth||l.imageEl.clientWidth,Te=l.imageEl.offsetHeight||l.imageEl.clientHeight,he=me*k.scale,ge=Te*k.scale,Me=Math.min($e/2-he/2,0),Ce=Math.min(ke/2-ge/2,0),Oe=-Me,De=-Ce,U=ee*k.scale,te=ne*k.scale,U<Me&&(U=Me),U>Oe&&(U=Oe),te<Ce&&(te=Ce),te>De&&(te=De)):(U=0,te=0),ve&&k.scale===1&&(l.originX=0,l.originY=0),l.imageWrapEl.style.transitionDuration="300ms",l.imageWrapEl.style.transform=`translate3d(${U}px, ${te}px,0)`,l.imageEl.style.transitionDuration="300ms",l.imageEl.style.transform=`translate3d(0,0,0) scale(${k.scale})`}function _(){const T=e.zoom,k=e.params.zoom;if(!l.slideEl){e.params.virtual&&e.params.virtual.enabled&&e.virtual?l.slideEl=W(e.slidesEl,`.${e.params.slideActiveClass}`)[0]:l.slideEl=e.slides[e.activeIndex];let B=l.slideEl.querySelector(`.${k.containerClass}`);B&&(B=B.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),l.imageEl=B,B?l.imageWrapEl=oe(l.imageEl,`.${k.containerClass}`)[0]:l.imageWrapEl=void 0}!l.imageEl||!l.imageWrapEl||(e.params.cssMode&&(e.wrapperEl.style.overflow="",e.wrapperEl.style.touchAction=""),T.scale=1,d=1,o.touchesStart.x=void 0,o.touchesStart.y=void 0,l.imageWrapEl.style.transitionDuration="300ms",l.imageWrapEl.style.transform="translate3d(0,0,0)",l.imageEl.style.transitionDuration="300ms",l.imageEl.style.transform="translate3d(0,0,0) scale(1)",l.slideEl.classList.remove(`${k.zoomedSlideClass}`),l.slideEl=void 0,l.originX=0,l.originY=0,e.params.zoom.panOnMouseMove&&(u={x:0,y:0},a&&(a=!1,o.startX=0,o.startY=0)))}function X(T){const k=e.zoom;k.scale&&k.scale!==1?_():H(T)}function F(){const T=e.params.passiveListeners?{passive:!0,capture:!1}:!1,k=e.params.passiveListeners?{passive:!1,capture:!0}:!0;return{passiveListener:T,activeListenerWithCapture:k}}function J(){const T=e.zoom;if(T.enabled)return;T.enabled=!0;const{passiveListener:k,activeListenerWithCapture:B}=F();e.wrapperEl.addEventListener("pointerdown",O,k),e.wrapperEl.addEventListener("pointermove",P,B),["pointerup","pointercancel","pointerout"].forEach(V=>{e.wrapperEl.addEventListener(V,L,k)}),e.wrapperEl.addEventListener("pointermove",D,B)}function pe(){const T=e.zoom;if(!T.enabled)return;T.enabled=!1;const{passiveListener:k,activeListenerWithCapture:B}=F();e.wrapperEl.removeEventListener("pointerdown",O,k),e.wrapperEl.removeEventListener("pointermove",P,B),["pointerup","pointercancel","pointerout"].forEach(V=>{e.wrapperEl.removeEventListener(V,L,k)}),e.wrapperEl.removeEventListener("pointermove",D,B)}i("init",()=>{e.params.zoom.enabled&&J()}),i("destroy",()=>{pe()}),i("touchStart",(T,k)=>{e.zoom.enabled&&x(k)}),i("touchEnd",(T,k)=>{e.zoom.enabled&&q()}),i("doubleTap",(T,k)=>{!e.animating&&e.params.zoom.enabled&&e.zoom.enabled&&e.params.zoom.toggle&&X(k)}),i("transitionEnd",()=>{e.zoom.enabled&&e.params.zoom.enabled&&C()}),i("slideChange",()=>{e.zoom.enabled&&e.params.zoom.enabled&&e.params.cssMode&&C()}),Object.assign(e.zoom,{enable:J,disable:pe,in:H,out:_,toggle:X})}function ks(s){let{swiper:e,extendParams:t,on:i}=s;t({controller:{control:void 0,inverse:!1,by:"slide"}}),e.controller={control:void 0};function n(u,f){const p=function(){let o,w,y;return(g,h)=>{for(w=-1,o=g.length;o-w>1;)y=o+w>>1,g[y]<=h?w=y:o=y;return o}}();this.x=u,this.y=f,this.lastIndex=u.length-1;let v,m;return this.interpolate=function(o){return o?(m=p(this.x,o),v=m-1,(o-this.x[v])*(this.y[m]-this.y[v])/(this.x[m]-this.x[v])+this.y[v]):0},this}function r(u){e.controller.spline=e.params.loop?new n(e.slidesGrid,u.slidesGrid):new n(e.snapGrid,u.snapGrid)}function d(u,f){const p=e.controller.control;let v,m;const l=e.constructor;function o(w){if(w.destroyed)return;const y=e.rtlTranslate?-e.translate:e.translate;e.params.controller.by==="slide"&&(r(w),m=-e.controller.spline.interpolate(-y)),(!m||e.params.controller.by==="container")&&(v=(w.maxTranslate()-w.minTranslate())/(e.maxTranslate()-e.minTranslate()),(Number.isNaN(v)||!Number.isFinite(v))&&(v=1),m=(y-e.minTranslate())*v+w.minTranslate()),e.params.controller.inverse&&(m=w.maxTranslate()-m),w.updateProgress(m),w.setTranslate(m,e),w.updateActiveIndex(),w.updateSlidesClasses()}if(Array.isArray(p))for(let w=0;w<p.length;w+=1)p[w]!==f&&p[w]instanceof l&&o(p[w]);else p instanceof l&&f!==p&&o(p)}function c(u,f){const p=e.constructor,v=e.controller.control;let m;function l(o){o.destroyed||(o.setTransition(u,e),u!==0&&(o.transitionStart(),o.params.autoHeight&&de(()=>{o.updateAutoHeight()}),be(o.wrapperEl,()=>{v&&o.transitionEnd()})))}if(Array.isArray(v))for(m=0;m<v.length;m+=1)v[m]!==f&&v[m]instanceof p&&l(v[m]);else v instanceof p&&f!==v&&l(v)}function a(){e.controller.control&&e.controller.spline&&(e.controller.spline=void 0,delete e.controller.spline)}i("beforeInit",()=>{if(typeof window<"u"&&(typeof e.params.controller.control=="string"||e.params.controller.control instanceof HTMLElement)){(typeof e.params.controller.control=="string"?[...document.querySelectorAll(e.params.controller.control)]:[e.params.controller.control]).forEach(f=>{if(e.controller.control||(e.controller.control=[]),f&&f.swiper)e.controller.control.push(f.swiper);else if(f){const p=`${e.params.eventsPrefix}init`,v=m=>{e.controller.control.push(m.detail[0]),e.update(),f.removeEventListener(p,v)};f.addEventListener(p,v)}});return}e.controller.control=e.params.controller.control}),i("update",()=>{a()}),i("resize",()=>{a()}),i("observerUpdate",()=>{a()}),i("setTranslate",(u,f,p)=>{!e.controller.control||e.controller.control.destroyed||e.controller.setTranslate(f,p)}),i("setTransition",(u,f,p)=>{!e.controller.control||e.controller.control.destroyed||e.controller.setTransition(f,p)}),Object.assign(e.controller,{setTranslate:d,setTransition:c})}function Bs(s){let{swiper:e,extendParams:t,on:i}=s;t({a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}",slideLabelMessage:"{{index}} / {{slidesLength}}",containerMessage:null,containerRoleDescriptionMessage:null,containerRole:null,itemRoleDescriptionMessage:null,slideRole:"group",id:null,scrollOnFocus:!0}}),e.a11y={clicked:!1};let n=null,r,d,c=new Date().getTime();function a(C){const I=n;I.length!==0&&(I.innerHTML="",I.innerHTML=C)}function u(C){const I=()=>Math.round(16*Math.random()).toString(16);return"x".repeat(C).replace(/x/g,I)}function f(C){C=G(C),C.forEach(I=>{I.setAttribute("tabIndex","0")})}function p(C){C=G(C),C.forEach(I=>{I.setAttribute("tabIndex","-1")})}function v(C,I){C=G(C),C.forEach(H=>{H.setAttribute("role",I)})}function m(C,I){C=G(C),C.forEach(H=>{H.setAttribute("aria-roledescription",I)})}function l(C,I){C=G(C),C.forEach(H=>{H.setAttribute("aria-controls",I)})}function o(C,I){C=G(C),C.forEach(H=>{H.setAttribute("aria-label",I)})}function w(C,I){C=G(C),C.forEach(H=>{H.setAttribute("id",I)})}function y(C,I){C=G(C),C.forEach(H=>{H.setAttribute("aria-live",I)})}function g(C){C=G(C),C.forEach(I=>{I.setAttribute("aria-disabled",!0)})}function h(C){C=G(C),C.forEach(I=>{I.setAttribute("aria-disabled",!1)})}function S(C){if(C.keyCode!==13&&C.keyCode!==32)return;const I=e.params.a11y,H=C.target;if(!(e.pagination&&e.pagination.el&&(H===e.pagination.el||e.pagination.el.contains(C.target))&&!C.target.matches(se(e.params.pagination.bulletClass)))){if(e.navigation&&e.navigation.prevEl&&e.navigation.nextEl){const _=G(e.navigation.prevEl);G(e.navigation.nextEl).includes(H)&&(e.isEnd&&!e.params.loop||e.slideNext(),e.isEnd?a(I.lastSlideMessage):a(I.nextSlideMessage)),_.includes(H)&&(e.isBeginning&&!e.params.loop||e.slidePrev(),e.isBeginning?a(I.firstSlideMessage):a(I.prevSlideMessage))}e.pagination&&H.matches(se(e.params.pagination.bulletClass))&&H.click()}}function b(){if(e.params.loop||e.params.rewind||!e.navigation)return;const{nextEl:C,prevEl:I}=e.navigation;I&&(e.isBeginning?(g(I),p(I)):(h(I),f(I))),C&&(e.isEnd?(g(C),p(C)):(h(C),f(C)))}function z(){return e.pagination&&e.pagination.bullets&&e.pagination.bullets.length}function $(){return z()&&e.params.pagination.clickable}function O(){const C=e.params.a11y;z()&&e.pagination.bullets.forEach(I=>{e.params.pagination.clickable&&(f(I),e.params.pagination.renderBullet||(v(I,"button"),o(I,C.paginationBulletMessage.replace(/\{\{index\}\}/,Ee(I)+1)))),I.matches(se(e.params.pagination.bulletActiveClass))?I.setAttribute("aria-current","true"):I.removeAttribute("aria-current")})}const P=(C,I,H)=>{f(C),C.tagName!=="BUTTON"&&(v(C,"button"),C.addEventListener("keydown",S)),o(C,H),l(C,I)},L=C=>{d&&d!==C.target&&!d.contains(C.target)&&(r=!0),e.a11y.clicked=!0},A=()=>{r=!1,requestAnimationFrame(()=>{requestAnimationFrame(()=>{e.destroyed||(e.a11y.clicked=!1)})})},M=C=>{c=new Date().getTime()},E=C=>{if(e.a11y.clicked||!e.params.a11y.scrollOnFocus||new Date().getTime()-c<100)return;const I=C.target.closest(`.${e.params.slideClass}, swiper-slide`);if(!I||!e.slides.includes(I))return;d=I;const H=e.slides.indexOf(I)===e.activeIndex,_=e.params.watchSlidesProgress&&e.visibleSlides&&e.visibleSlides.includes(I);H||_||C.sourceCapabilities&&C.sourceCapabilities.firesTouchEvents||(e.isHorizontal()?e.el.scrollLeft=0:e.el.scrollTop=0,requestAnimationFrame(()=>{r||(e.params.loop?e.slideToLoop(parseInt(I.getAttribute("data-swiper-slide-index")),0):e.slideTo(e.slides.indexOf(I),0),r=!1)}))},x=()=>{const C=e.params.a11y;C.itemRoleDescriptionMessage&&m(e.slides,C.itemRoleDescriptionMessage),C.slideRole&&v(e.slides,C.slideRole);const I=e.slides.length;C.slideLabelMessage&&e.slides.forEach((H,_)=>{const X=e.params.loop?parseInt(H.getAttribute("data-swiper-slide-index"),10):_,F=C.slideLabelMessage.replace(/\{\{index\}\}/,X+1).replace(/\{\{slidesLength\}\}/,I);o(H,F)})},D=()=>{const C=e.params.a11y;e.el.append(n);const I=e.el;C.containerRoleDescriptionMessage&&m(I,C.containerRoleDescriptionMessage),C.containerMessage&&o(I,C.containerMessage),C.containerRole&&v(I,C.containerRole);const H=e.wrapperEl,_=C.id||H.getAttribute("id")||`swiper-wrapper-${u(16)}`,X=e.params.autoplay&&e.params.autoplay.enabled?"off":"polite";w(H,_),y(H,X),x();let{nextEl:F,prevEl:J}=e.navigation?e.navigation:{};F=G(F),J=G(J),F&&F.forEach(T=>P(T,_,C.nextSlideMessage)),J&&J.forEach(T=>P(T,_,C.prevSlideMessage)),$()&&G(e.pagination.el).forEach(k=>{k.addEventListener("keydown",S)}),N().addEventListener("visibilitychange",M),e.el.addEventListener("focus",E,!0),e.el.addEventListener("focus",E,!0),e.el.addEventListener("pointerdown",L,!0),e.el.addEventListener("pointerup",A,!0)};function q(){n&&n.remove();let{nextEl:C,prevEl:I}=e.navigation?e.navigation:{};C=G(C),I=G(I),C&&C.forEach(_=>_.removeEventListener("keydown",S)),I&&I.forEach(_=>_.removeEventListener("keydown",S)),$()&&G(e.pagination.el).forEach(X=>{X.removeEventListener("keydown",S)}),N().removeEventListener("visibilitychange",M),e.el&&typeof e.el!="string"&&(e.el.removeEventListener("focus",E,!0),e.el.removeEventListener("pointerdown",L,!0),e.el.removeEventListener("pointerup",A,!0))}i("beforeInit",()=>{n=Z("span",e.params.a11y.notificationClass),n.setAttribute("aria-live","assertive"),n.setAttribute("aria-atomic","true")}),i("afterInit",()=>{e.params.a11y.enabled&&D()}),i("slidesLengthChange snapGridLengthChange slidesGridLengthChange",()=>{e.params.a11y.enabled&&x()}),i("fromEdge toEdge afterInit lock unlock",()=>{e.params.a11y.enabled&&b()}),i("paginationUpdate",()=>{e.params.a11y.enabled&&O()}),i("destroy",()=>{e.params.a11y.enabled&&q()})}function Hs(s){let{swiper:e,extendParams:t,on:i}=s;t({history:{enabled:!1,root:"",replaceState:!1,key:"slides",keepQuery:!1}});let n=!1,r={};const d=m=>m.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,""),c=m=>{const l=R();let o;m?o=new URL(m):o=l.location;const w=o.pathname.slice(1).split("/").filter(S=>S!==""),y=w.length,g=w[y-2],h=w[y-1];return{key:g,value:h}},a=(m,l)=>{const o=R();if(!n||!e.params.history.enabled)return;let w;e.params.url?w=new URL(e.params.url):w=o.location;const y=e.virtual&&e.params.virtual.enabled?e.slidesEl.querySelector(`[data-swiper-slide-index="${l}"]`):e.slides[l];let g=d(y.getAttribute("data-history"));if(e.params.history.root.length>0){let S=e.params.history.root;S[S.length-1]==="/"&&(S=S.slice(0,S.length-1)),g=`${S}/${m?`${m}/`:""}${g}`}else w.pathname.includes(m)||(g=`${m?`${m}/`:""}${g}`);e.params.history.keepQuery&&(g+=w.search);const h=o.history.state;h&&h.value===g||(e.params.history.replaceState?o.history.replaceState({value:g},null,g):o.history.pushState({value:g},null,g))},u=(m,l,o)=>{if(l)for(let w=0,y=e.slides.length;w<y;w+=1){const g=e.slides[w];if(d(g.getAttribute("data-history"))===l){const S=e.getSlideIndex(g);e.slideTo(S,m,o)}}else e.slideTo(0,m,o)},f=()=>{r=c(e.params.url),u(e.params.speed,r.value,!1)},p=()=>{const m=R();if(e.params.history){if(!m.history||!m.history.pushState){e.params.history.enabled=!1,e.params.hashNavigation.enabled=!0;return}if(n=!0,r=c(e.params.url),!r.key&&!r.value){e.params.history.replaceState||m.addEventListener("popstate",f);return}u(0,r.value,e.params.runCallbacksOnInit),e.params.history.replaceState||m.addEventListener("popstate",f)}},v=()=>{const m=R();e.params.history.replaceState||m.removeEventListener("popstate",f)};i("init",()=>{e.params.history.enabled&&p()}),i("destroy",()=>{e.params.history.enabled&&v()}),i("transitionEnd _freeModeNoMomentumRelease",()=>{n&&a(e.params.history.key,e.activeIndex)}),i("slideChange",()=>{n&&e.params.cssMode&&a(e.params.history.key,e.activeIndex)})}function qs(s){let{swiper:e,extendParams:t,emit:i,on:n}=s,r=!1;const d=N(),c=R();t({hashNavigation:{enabled:!1,replaceState:!1,watchState:!1,getSlideIndex(v,m){if(e.virtual&&e.params.virtual.enabled){const l=e.slides.find(w=>w.getAttribute("data-hash")===m);return l?parseInt(l.getAttribute("data-swiper-slide-index"),10):0}return e.getSlideIndex(W(e.slidesEl,`.${e.params.slideClass}[data-hash="${m}"], swiper-slide[data-hash="${m}"]`)[0])}}});const a=()=>{i("hashChange");const v=d.location.hash.replace("#",""),m=e.virtual&&e.params.virtual.enabled?e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`):e.slides[e.activeIndex],l=m?m.getAttribute("data-hash"):"";if(v!==l){const o=e.params.hashNavigation.getSlideIndex(e,v);if(typeof o>"u"||Number.isNaN(o))return;e.slideTo(o)}},u=()=>{if(!r||!e.params.hashNavigation.enabled)return;const v=e.virtual&&e.params.virtual.enabled?e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`):e.slides[e.activeIndex],m=v?v.getAttribute("data-hash")||v.getAttribute("data-history"):"";e.params.hashNavigation.replaceState&&c.history&&c.history.replaceState?(c.history.replaceState(null,null,`#${m}`||""),i("hashSet")):(d.location.hash=m||"",i("hashSet"))},f=()=>{if(!e.params.hashNavigation.enabled||e.params.history&&e.params.history.enabled)return;r=!0;const v=d.location.hash.replace("#","");if(v){const l=e.params.hashNavigation.getSlideIndex(e,v);e.slideTo(l||0,0,e.params.runCallbacksOnInit,!0)}e.params.hashNavigation.watchState&&c.addEventListener("hashchange",a)},p=()=>{e.params.hashNavigation.watchState&&c.removeEventListener("hashchange",a)};n("init",()=>{e.params.hashNavigation.enabled&&f()}),n("destroy",()=>{e.params.hashNavigation.enabled&&p()}),n("transitionEnd _freeModeNoMomentumRelease",()=>{r&&u()}),n("slideChange",()=>{r&&e.params.cssMode&&u()})}function _s(s){let{swiper:e,extendParams:t,on:i,emit:n,params:r}=s;e.autoplay={running:!1,paused:!1,timeLeft:0},t({autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!1,stopOnLastSlide:!1,reverseDirection:!1,pauseOnMouseEnter:!1}});let d,c,a=r&&r.autoplay?r.autoplay.delay:3e3,u=r&&r.autoplay?r.autoplay.delay:3e3,f,p=new Date().getTime(),v,m,l,o,w,y,g;function h(I){!e||e.destroyed||!e.wrapperEl||I.target===e.wrapperEl&&(e.wrapperEl.removeEventListener("transitionend",h),!(g||I.detail&&I.detail.bySwiperTouchMove)&&L())}const S=()=>{if(e.destroyed||!e.autoplay.running)return;e.autoplay.paused?v=!0:v&&(u=f,v=!1);const I=e.autoplay.paused?f:p+u-new Date().getTime();e.autoplay.timeLeft=I,n("autoplayTimeLeft",I,I/a),c=requestAnimationFrame(()=>{S()})},b=()=>{let I;return e.virtual&&e.params.virtual.enabled?I=e.slides.find(_=>_.classList.contains("swiper-slide-active")):I=e.slides[e.activeIndex],I?parseInt(I.getAttribute("data-swiper-autoplay"),10):void 0},z=I=>{if(e.destroyed||!e.autoplay.running)return;cancelAnimationFrame(c),S();let H=typeof I>"u"?e.params.autoplay.delay:I;a=e.params.autoplay.delay,u=e.params.autoplay.delay;const _=b();!Number.isNaN(_)&&_>0&&typeof I>"u"&&(H=_,a=_,u=_),f=H;const X=e.params.speed,F=()=>{!e||e.destroyed||(e.params.autoplay.reverseDirection?!e.isBeginning||e.params.loop||e.params.rewind?(e.slidePrev(X,!0,!0),n("autoplay")):e.params.autoplay.stopOnLastSlide||(e.slideTo(e.slides.length-1,X,!0,!0),n("autoplay")):!e.isEnd||e.params.loop||e.params.rewind?(e.slideNext(X,!0,!0),n("autoplay")):e.params.autoplay.stopOnLastSlide||(e.slideTo(0,X,!0,!0),n("autoplay")),e.params.cssMode&&(p=new Date().getTime(),requestAnimationFrame(()=>{z()})))};return H>0?(clearTimeout(d),d=setTimeout(()=>{F()},H)):requestAnimationFrame(()=>{F()}),H},$=()=>{p=new Date().getTime(),e.autoplay.running=!0,z(),n("autoplayStart")},O=()=>{e.autoplay.running=!1,clearTimeout(d),cancelAnimationFrame(c),n("autoplayStop")},P=(I,H)=>{if(e.destroyed||!e.autoplay.running)return;clearTimeout(d),I||(y=!0);const _=()=>{n("autoplayPause"),e.params.autoplay.waitForTransition?e.wrapperEl.addEventListener("transitionend",h):L()};if(e.autoplay.paused=!0,H){w&&(f=e.params.autoplay.delay),w=!1,_();return}f=(f||e.params.autoplay.delay)-(new Date().getTime()-p),!(e.isEnd&&f<0&&!e.params.loop)&&(f<0&&(f=0),_())},L=()=>{e.isEnd&&f<0&&!e.params.loop||e.destroyed||!e.autoplay.running||(p=new Date().getTime(),y?(y=!1,z(f)):z(),e.autoplay.paused=!1,n("autoplayResume"))},A=()=>{if(e.destroyed||!e.autoplay.running)return;const I=N();I.visibilityState==="hidden"&&(y=!0,P(!0)),I.visibilityState==="visible"&&L()},M=I=>{I.pointerType==="mouse"&&(y=!0,g=!0,!(e.animating||e.autoplay.paused)&&P(!0))},E=I=>{I.pointerType==="mouse"&&(g=!1,e.autoplay.paused&&L())},x=()=>{e.params.autoplay.pauseOnMouseEnter&&(e.el.addEventListener("pointerenter",M),e.el.addEventListener("pointerleave",E))},D=()=>{e.el&&typeof e.el!="string"&&(e.el.removeEventListener("pointerenter",M),e.el.removeEventListener("pointerleave",E))},q=()=>{N().addEventListener("visibilitychange",A)},C=()=>{N().removeEventListener("visibilitychange",A)};i("init",()=>{e.params.autoplay.enabled&&(x(),q(),$())}),i("destroy",()=>{D(),C(),e.autoplay.running&&O()}),i("_freeModeStaticRelease",()=>{(l||y)&&L()}),i("_freeModeNoMomentumRelease",()=>{e.params.autoplay.disableOnInteraction?O():P(!0,!0)}),i("beforeTransitionStart",(I,H,_)=>{e.destroyed||!e.autoplay.running||(_||!e.params.autoplay.disableOnInteraction?P(!0,!0):O())}),i("sliderFirstMove",()=>{if(!(e.destroyed||!e.autoplay.running)){if(e.params.autoplay.disableOnInteraction){O();return}m=!0,l=!1,y=!1,o=setTimeout(()=>{y=!0,l=!0,P(!0)},200)}}),i("touchEnd",()=>{if(!(e.destroyed||!e.autoplay.running||!m)){if(clearTimeout(o),clearTimeout(d),e.params.autoplay.disableOnInteraction){l=!1,m=!1;return}l&&e.params.cssMode&&L(),l=!1,m=!1}}),i("slideChange",()=>{e.destroyed||!e.autoplay.running||(w=!0)}),Object.assign(e.autoplay,{start:$,stop:O,pause:P,resume:L})}function Gs(s){let{swiper:e,extendParams:t,on:i}=s;t({thumbs:{swiper:null,multipleActiveThumbs:!0,autoScrollOffset:0,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-thumbs"}});let n=!1,r=!1;e.thumbs={swiper:null};function d(){const u=e.thumbs.swiper;if(!u||u.destroyed)return;const f=u.clickedIndex,p=u.clickedSlide;if(p&&p.classList.contains(e.params.thumbs.slideThumbActiveClass)||typeof f>"u"||f===null)return;let v;u.params.loop?v=parseInt(u.clickedSlide.getAttribute("data-swiper-slide-index"),10):v=f,e.params.loop?e.slideToLoop(v):e.slideTo(v)}function c(){const{thumbs:u}=e.params;if(n)return!1;n=!0;const f=e.constructor;if(u.swiper instanceof f)e.thumbs.swiper=u.swiper,Object.assign(e.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),Object.assign(e.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1}),e.thumbs.swiper.update();else if(ye(u.swiper)){const p=Object.assign({},u.swiper);Object.assign(p,{watchSlidesProgress:!0,slideToClickedSlide:!1}),e.thumbs.swiper=new f(p),r=!0}return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass),e.thumbs.swiper.on("tap",d),!0}function a(u){const f=e.thumbs.swiper;if(!f||f.destroyed)return;const p=f.params.slidesPerView==="auto"?f.slidesPerViewDynamic():f.params.slidesPerView;let v=1;const m=e.params.thumbs.slideThumbActiveClass;if(e.params.slidesPerView>1&&!e.params.centeredSlides&&(v=e.params.slidesPerView),e.params.thumbs.multipleActiveThumbs||(v=1),v=Math.floor(v),f.slides.forEach(w=>w.classList.remove(m)),f.params.loop||f.params.virtual&&f.params.virtual.enabled)for(let w=0;w<v;w+=1)W(f.slidesEl,`[data-swiper-slide-index="${e.realIndex+w}"]`).forEach(y=>{y.classList.add(m)});else for(let w=0;w<v;w+=1)f.slides[e.realIndex+w]&&f.slides[e.realIndex+w].classList.add(m);const l=e.params.thumbs.autoScrollOffset,o=l&&!f.params.loop;if(e.realIndex!==f.realIndex||o){const w=f.activeIndex;let y,g;if(f.params.loop){const h=f.slides.find(S=>S.getAttribute("data-swiper-slide-index")===`${e.realIndex}`);y=f.slides.indexOf(h),g=e.activeIndex>e.previousIndex?"next":"prev"}else y=e.realIndex,g=y>e.previousIndex?"next":"prev";o&&(y+=g==="next"?l:-1*l),f.visibleSlidesIndexes&&f.visibleSlidesIndexes.indexOf(y)<0&&(f.params.centeredSlides?y>w?y=y-Math.floor(p/2)+1:y=y+Math.floor(p/2)-1:y>w&&f.params.slidesPerGroup,f.slideTo(y,u?0:void 0))}}i("beforeInit",()=>{const{thumbs:u}=e.params;if(!(!u||!u.swiper))if(typeof u.swiper=="string"||u.swiper instanceof HTMLElement){const f=N(),p=()=>{const m=typeof u.swiper=="string"?f.querySelector(u.swiper):u.swiper;if(m&&m.swiper)u.swiper=m.swiper,c(),a(!0);else if(m){const l=`${e.params.eventsPrefix}init`,o=w=>{u.swiper=w.detail[0],m.removeEventListener(l,o),c(),a(!0),u.swiper.update(),e.update()};m.addEventListener(l,o)}return m},v=()=>{if(e.destroyed)return;p()||requestAnimationFrame(v)};requestAnimationFrame(v)}else c(),a(!0)}),i("slideChange update resize observerUpdate",()=>{a()}),i("setTransition",(u,f)=>{const p=e.thumbs.swiper;!p||p.destroyed||p.setTransition(f)}),i("beforeDestroy",()=>{const u=e.thumbs.swiper;!u||u.destroyed||r&&u.destroy()}),Object.assign(e.thumbs,{init:c,update:a})}function Vs(s){let{swiper:e,extendParams:t,emit:i,once:n}=s;t({freeMode:{enabled:!1,momentum:!0,momentumRatio:1,momentumBounce:!0,momentumBounceRatio:1,momentumVelocityRatio:1,sticky:!1,minimumVelocity:.02}});function r(){if(e.params.cssMode)return;const a=e.getTranslate();e.setTranslate(a),e.setTransition(0),e.touchEventsData.velocities.length=0,e.freeMode.onTouchEnd({currentPos:e.rtl?e.translate:-e.translate})}function d(){if(e.params.cssMode)return;const{touchEventsData:a,touches:u}=e;a.velocities.length===0&&a.velocities.push({position:u[e.isHorizontal()?"startX":"startY"],time:a.touchStartTime}),a.velocities.push({position:u[e.isHorizontal()?"currentX":"currentY"],time:Q()})}function c(a){let{currentPos:u}=a;if(e.params.cssMode)return;const{params:f,wrapperEl:p,rtlTranslate:v,snapGrid:m,touchEventsData:l}=e,w=Q()-l.touchStartTime;if(u<-e.minTranslate()){e.slideTo(e.activeIndex);return}if(u>-e.maxTranslate()){e.slides.length<m.length?e.slideTo(m.length-1):e.slideTo(e.slides.length-1);return}if(f.freeMode.momentum){if(l.velocities.length>1){const O=l.velocities.pop(),P=l.velocities.pop(),L=O.position-P.position,A=O.time-P.time;e.velocity=L/A,e.velocity/=2,Math.abs(e.velocity)<f.freeMode.minimumVelocity&&(e.velocity=0),(A>150||Q()-O.time>300)&&(e.velocity=0)}else e.velocity=0;e.velocity*=f.freeMode.momentumVelocityRatio,l.velocities.length=0;let y=1e3*f.freeMode.momentumRatio;const g=e.velocity*y;let h=e.translate+g;v&&(h=-h);let S=!1,b;const z=Math.abs(e.velocity)*20*f.freeMode.momentumBounceRatio;let $;if(h<e.maxTranslate())f.freeMode.momentumBounce?(h+e.maxTranslate()<-z&&(h=e.maxTranslate()-z),b=e.maxTranslate(),S=!0,l.allowMomentumBounce=!0):h=e.maxTranslate(),f.loop&&f.centeredSlides&&($=!0);else if(h>e.minTranslate())f.freeMode.momentumBounce?(h-e.minTranslate()>z&&(h=e.minTranslate()+z),b=e.minTranslate(),S=!0,l.allowMomentumBounce=!0):h=e.minTranslate(),f.loop&&f.centeredSlides&&($=!0);else if(f.freeMode.sticky){let O;for(let P=0;P<m.length;P+=1)if(m[P]>-h){O=P;break}Math.abs(m[O]-h)<Math.abs(m[O-1]-h)||e.swipeDirection==="next"?h=m[O]:h=m[O-1],h=-h}if($&&n("transitionEnd",()=>{e.loopFix()}),e.velocity!==0){if(v?y=Math.abs((-h-e.translate)/e.velocity):y=Math.abs((h-e.translate)/e.velocity),f.freeMode.sticky){const O=Math.abs((v?-h:h)-e.translate),P=e.slidesSizesGrid[e.activeIndex];O<P?y=f.speed:O<2*P?y=f.speed*1.5:y=f.speed*2.5}}else if(f.freeMode.sticky){e.slideToClosest();return}f.freeMode.momentumBounce&&S?(e.updateProgress(b),e.setTransition(y),e.setTranslate(h),e.transitionStart(!0,e.swipeDirection),e.animating=!0,be(p,()=>{!e||e.destroyed||!l.allowMomentumBounce||(i("momentumBounce"),e.setTransition(f.speed),setTimeout(()=>{e.setTranslate(b),be(p,()=>{!e||e.destroyed||e.transitionEnd()})},0))})):e.velocity?(i("_freeModeNoMomentumRelease"),e.updateProgress(h),e.setTransition(y),e.setTranslate(h),e.transitionStart(!0,e.swipeDirection),e.animating||(e.animating=!0,be(p,()=>{!e||e.destroyed||e.transitionEnd()}))):e.updateProgress(h),e.updateActiveIndex(),e.updateSlidesClasses()}else if(f.freeMode.sticky){e.slideToClosest();return}else f.freeMode&&i("_freeModeNoMomentumRelease");(!f.freeMode.momentum||w>=f.longSwipesMs)&&(i("_freeModeStaticRelease"),e.updateProgress(),e.updateActiveIndex(),e.updateSlidesClasses())}Object.assign(e,{freeMode:{onTouchStart:r,onTouchMove:d,onTouchEnd:c}})}function Rs(s){let{swiper:e,extendParams:t,on:i}=s;t({grid:{rows:1,fill:"column"}});let n,r,d,c;const a=()=>{let o=e.params.spaceBetween;return typeof o=="string"&&o.indexOf("%")>=0?o=parseFloat(o.replace("%",""))/100*e.size:typeof o=="string"&&(o=parseFloat(o)),o},u=o=>{const{slidesPerView:w}=e.params,{rows:y,fill:g}=e.params.grid,h=e.virtual&&e.params.virtual.enabled?e.virtual.slides.length:o.length;d=Math.floor(h/y),Math.floor(h/y)===h/y?n=h:n=Math.ceil(h/y)*y,w!=="auto"&&g==="row"&&(n=Math.max(n,w*y)),r=n/y},f=()=>{e.slides&&e.slides.forEach(o=>{o.swiperSlideGridSet&&(o.style.height="",o.style[e.getDirectionLabel("margin-top")]="")})},p=(o,w,y)=>{const{slidesPerGroup:g}=e.params,h=a(),{rows:S,fill:b}=e.params.grid,z=e.virtual&&e.params.virtual.enabled?e.virtual.slides.length:y.length;let $,O,P;if(b==="row"&&g>1){const L=Math.floor(o/(g*S)),A=o-S*g*L,M=L===0?g:Math.min(Math.ceil((z-L*S*g)/S),g);P=Math.floor(A/M),O=A-P*M+L*g,$=O+P*n/S,w.style.order=$}else b==="column"?(O=Math.floor(o/S),P=o-O*S,(O>d||O===d&&P===S-1)&&(P+=1,P>=S&&(P=0,O+=1))):(P=Math.floor(o/r),O=o-P*r);w.row=P,w.column=O,w.style.height=`calc((100% - ${(S-1)*h}px) / ${S})`,w.style[e.getDirectionLabel("margin-top")]=P!==0?h&&`${h}px`:"",w.swiperSlideGridSet=!0},v=(o,w)=>{const{centeredSlides:y,roundLengths:g}=e.params,h=a(),{rows:S}=e.params.grid;if(e.virtualSize=(o+h)*n,e.virtualSize=Math.ceil(e.virtualSize/S)-h,e.params.cssMode||(e.wrapperEl.style[e.getDirectionLabel("width")]=`${e.virtualSize+h}px`),y){const b=[];for(let z=0;z<w.length;z+=1){let $=w[z];g&&($=Math.floor($)),w[z]<e.virtualSize+w[0]&&b.push($)}w.splice(0,w.length),w.push(...b)}},m=()=>{c=e.params.grid&&e.params.grid.rows>1},l=()=>{const{params:o,el:w}=e,y=o.grid&&o.grid.rows>1;c&&!y?(w.classList.remove(`${o.containerModifierClass}grid`,`${o.containerModifierClass}grid-column`),d=1,e.emitContainerClasses()):!c&&y&&(w.classList.add(`${o.containerModifierClass}grid`),o.grid.fill==="column"&&w.classList.add(`${o.containerModifierClass}grid-column`),e.emitContainerClasses()),c=y};i("init",m),i("update",l),e.grid={initSlides:u,unsetSlides:f,updateSlide:p,updateWrapperSize:v}}function Xs(s){const e=this,{params:t,slidesEl:i}=e;t.loop&&e.loopDestroy();const n=r=>{if(typeof r=="string"){const d=document.createElement("div");d.innerHTML=r,i.append(d.children[0]),d.innerHTML=""}else i.append(r)};if(typeof s=="object"&&"length"in s)for(let r=0;r<s.length;r+=1)s[r]&&n(s[r]);else n(s);e.recalcSlides(),t.loop&&e.loopCreate(),(!t.observer||e.isElement)&&e.update()}function Ys(s){const e=this,{params:t,activeIndex:i,slidesEl:n}=e;t.loop&&e.loopDestroy();let r=i+1;const d=c=>{if(typeof c=="string"){const a=document.createElement("div");a.innerHTML=c,n.prepend(a.children[0]),a.innerHTML=""}else n.prepend(c)};if(typeof s=="object"&&"length"in s){for(let c=0;c<s.length;c+=1)s[c]&&d(s[c]);r=i+s.length}else d(s);e.recalcSlides(),t.loop&&e.loopCreate(),(!t.observer||e.isElement)&&e.update(),e.slideTo(r,0,!1)}function Ns(s,e){const t=this,{params:i,activeIndex:n,slidesEl:r}=t;let d=n;i.loop&&(d-=t.loopedSlides,t.loopDestroy(),t.recalcSlides());const c=t.slides.length;if(s<=0){t.prependSlide(e);return}if(s>=c){t.appendSlide(e);return}let a=d>s?d+1:d;const u=[];for(let f=c-1;f>=s;f-=1){const p=t.slides[f];p.remove(),u.unshift(p)}if(typeof e=="object"&&"length"in e){for(let f=0;f<e.length;f+=1)e[f]&&r.append(e[f]);a=d>s?d+e.length:d}else r.append(e);for(let f=0;f<u.length;f+=1)r.append(u[f]);t.recalcSlides(),i.loop&&t.loopCreate(),(!i.observer||t.isElement)&&t.update(),i.loop?t.slideTo(a+t.loopedSlides,0,!1):t.slideTo(a,0,!1)}function Fs(s){const e=this,{params:t,activeIndex:i}=e;let n=i;t.loop&&(n-=e.loopedSlides,e.loopDestroy());let r=n,d;if(typeof s=="object"&&"length"in s){for(let c=0;c<s.length;c+=1)d=s[c],e.slides[d]&&e.slides[d].remove(),d<r&&(r-=1);r=Math.max(r,0)}else d=s,e.slides[d]&&e.slides[d].remove(),d<r&&(r-=1),r=Math.max(r,0);e.recalcSlides(),t.loop&&e.loopCreate(),(!t.observer||e.isElement)&&e.update(),t.loop?e.slideTo(r+e.loopedSlides,0,!1):e.slideTo(r,0,!1)}function Ws(){const s=this,e=[];for(let t=0;t<s.slides.length;t+=1)e.push(t);s.removeSlide(e)}function js(s){let{swiper:e}=s;Object.assign(e,{appendSlide:Xs.bind(e),prependSlide:Ys.bind(e),addSlide:Ns.bind(e),removeSlide:Fs.bind(e),removeAllSlides:Ws.bind(e)})}function ue(s){const{effect:e,swiper:t,on:i,setTranslate:n,setTransition:r,overwriteParams:d,perspective:c,recreateShadows:a,getEffectParams:u}=s;i("beforeInit",()=>{if(t.params.effect!==e)return;t.classNames.push(`${t.params.containerModifierClass}${e}`),c&&c()&&t.classNames.push(`${t.params.containerModifierClass}3d`);const p=d?d():{};Object.assign(t.params,p),Object.assign(t.originalParams,p)}),i("setTranslate",()=>{t.params.effect===e&&n()}),i("setTransition",(p,v)=>{t.params.effect===e&&r(v)}),i("transitionEnd",()=>{if(t.params.effect===e&&a){if(!u||!u().slideShadows)return;t.slides.forEach(p=>{p.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(v=>v.remove())}),a()}});let f;i("virtualUpdate",()=>{t.params.effect===e&&(t.slides.length||(f=!0),requestAnimationFrame(()=>{f&&t.slides&&t.slides.length&&(n(),f=!1)}))})}function xe(s,e){const t=ce(e);return t!==e&&(t.style.backfaceVisibility="hidden",t.style["-webkit-backface-visibility"]="hidden"),t}function ze(s){let{swiper:e,duration:t,transformElements:i,allSlides:n}=s;const{activeIndex:r}=e,d=c=>c.parentElement?c.parentElement:e.slides.find(u=>u.shadowRoot&&u.shadowRoot===c.parentNode);if(e.params.virtualTranslate&&t!==0){let c=!1,a;n?a=i:a=i.filter(u=>{const f=u.classList.contains("swiper-slide-transform")?d(u):u;return e.getSlideIndex(f)===r}),a.forEach(u=>{be(u,()=>{if(c||!e||e.destroyed)return;c=!0,e.animating=!1;const f=new window.CustomEvent("transitionend",{bubbles:!0,cancelable:!0});e.wrapperEl.dispatchEvent(f)})})}}function Us(s){let{swiper:e,extendParams:t,on:i}=s;t({fadeEffect:{crossFade:!1}}),ue({effect:"fade",swiper:e,on:i,setTranslate:()=>{const{slides:d}=e,c=e.params.fadeEffect;for(let a=0;a<d.length;a+=1){const u=e.slides[a];let p=-u.swiperSlideOffset;e.params.virtualTranslate||(p-=e.translate);let v=0;e.isHorizontal()||(v=p,p=0);const m=e.params.fadeEffect.crossFade?Math.max(1-Math.abs(u.progress),0):1+Math.min(Math.max(u.progress,-1),0),l=xe(c,u);l.style.opacity=m,l.style.transform=`translate3d(${p}px, ${v}px, 0px)`}},setTransition:d=>{const c=e.slides.map(a=>ce(a));c.forEach(a=>{a.style.transitionDuration=`${d}ms`}),ze({swiper:e,duration:d,transformElements:c,allSlides:!0})},overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!e.params.cssMode})})}function Ks(s){let{swiper:e,extendParams:t,on:i}=s;t({cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}});const n=(a,u,f)=>{let p=f?a.querySelector(".swiper-slide-shadow-left"):a.querySelector(".swiper-slide-shadow-top"),v=f?a.querySelector(".swiper-slide-shadow-right"):a.querySelector(".swiper-slide-shadow-bottom");p||(p=Z("div",`swiper-slide-shadow-cube swiper-slide-shadow-${f?"left":"top"}`.split(" ")),a.append(p)),v||(v=Z("div",`swiper-slide-shadow-cube swiper-slide-shadow-${f?"right":"bottom"}`.split(" ")),a.append(v)),p&&(p.style.opacity=Math.max(-u,0)),v&&(v.style.opacity=Math.max(u,0))};ue({effect:"cube",swiper:e,on:i,setTranslate:()=>{const{el:a,wrapperEl:u,slides:f,width:p,height:v,rtlTranslate:m,size:l,browser:o}=e,w=Ae(e),y=e.params.cubeEffect,g=e.isHorizontal(),h=e.virtual&&e.params.virtual.enabled;let S=0,b;y.shadow&&(g?(b=e.wrapperEl.querySelector(".swiper-cube-shadow"),b||(b=Z("div","swiper-cube-shadow"),e.wrapperEl.append(b)),b.style.height=`${p}px`):(b=a.querySelector(".swiper-cube-shadow"),b||(b=Z("div","swiper-cube-shadow"),a.append(b))));for(let $=0;$<f.length;$+=1){const O=f[$];let P=$;h&&(P=parseInt(O.getAttribute("data-swiper-slide-index"),10));let L=P*90,A=Math.floor(L/360);m&&(L=-L,A=Math.floor(-L/360));const M=Math.max(Math.min(O.progress,1),-1);let E=0,x=0,D=0;P%4===0?(E=-A*4*l,D=0):(P-1)%4===0?(E=0,D=-A*4*l):(P-2)%4===0?(E=l+A*4*l,D=l):(P-3)%4===0&&(E=-l,D=3*l+l*4*A),m&&(E=-E),g||(x=E,E=0);const q=`rotateX(${w(g?0:-L)}deg) rotateY(${w(g?L:0)}deg) translate3d(${E}px, ${x}px, ${D}px)`;M<=1&&M>-1&&(S=P*90+M*90,m&&(S=-P*90-M*90)),O.style.transform=q,y.slideShadows&&n(O,M,g)}if(u.style.transformOrigin=`50% 50% -${l/2}px`,u.style["-webkit-transform-origin"]=`50% 50% -${l/2}px`,y.shadow)if(g)b.style.transform=`translate3d(0px, ${p/2+y.shadowOffset}px, ${-p/2}px) rotateX(89.99deg) rotateZ(0deg) scale(${y.shadowScale})`;else{const $=Math.abs(S)-Math.floor(Math.abs(S)/90)*90,O=1.5-(Math.sin($*2*Math.PI/360)/2+Math.cos($*2*Math.PI/360)/2),P=y.shadowScale,L=y.shadowScale/O,A=y.shadowOffset;b.style.transform=`scale3d(${P}, 1, ${L}) translate3d(0px, ${v/2+A}px, ${-v/2/L}px) rotateX(-89.99deg)`}const z=(o.isSafari||o.isWebView)&&o.needPerspectiveFix?-l/2:0;u.style.transform=`translate3d(0px,0,${z}px) rotateX(${w(e.isHorizontal()?0:S)}deg) rotateY(${w(e.isHorizontal()?-S:0)}deg)`,u.style.setProperty("--swiper-cube-translate-z",`${z}px`)},setTransition:a=>{const{el:u,slides:f}=e;if(f.forEach(p=>{p.style.transitionDuration=`${a}ms`,p.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(v=>{v.style.transitionDuration=`${a}ms`})}),e.params.cubeEffect.shadow&&!e.isHorizontal()){const p=u.querySelector(".swiper-cube-shadow");p&&(p.style.transitionDuration=`${a}ms`)}},recreateShadows:()=>{const a=e.isHorizontal();e.slides.forEach(u=>{const f=Math.max(Math.min(u.progress,1),-1);n(u,f,a)})},getEffectParams:()=>e.params.cubeEffect,perspective:()=>!0,overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0})})}function fe(s,e,t){const i=`swiper-slide-shadow${t?`-${t}`:""}${s?` swiper-slide-shadow-${s}`:""}`,n=ce(e);let r=n.querySelector(`.${i.split(" ").join(".")}`);return r||(r=Z("div",i.split(" ")),n.append(r)),r}function Zs(s){let{swiper:e,extendParams:t,on:i}=s;t({flipEffect:{slideShadows:!0,limitRotation:!0}});const n=(a,u)=>{let f=e.isHorizontal()?a.querySelector(".swiper-slide-shadow-left"):a.querySelector(".swiper-slide-shadow-top"),p=e.isHorizontal()?a.querySelector(".swiper-slide-shadow-right"):a.querySelector(".swiper-slide-shadow-bottom");f||(f=fe("flip",a,e.isHorizontal()?"left":"top")),p||(p=fe("flip",a,e.isHorizontal()?"right":"bottom")),f&&(f.style.opacity=Math.max(-u,0)),p&&(p.style.opacity=Math.max(u,0))};ue({effect:"flip",swiper:e,on:i,setTranslate:()=>{const{slides:a,rtlTranslate:u}=e,f=e.params.flipEffect,p=Ae(e);for(let v=0;v<a.length;v+=1){const m=a[v];let l=m.progress;e.params.flipEffect.limitRotation&&(l=Math.max(Math.min(m.progress,1),-1));const o=m.swiperSlideOffset;let y=-180*l,g=0,h=e.params.cssMode?-o-e.translate:-o,S=0;e.isHorizontal()?u&&(y=-y):(S=h,h=0,g=-y,y=0),m.style.zIndex=-Math.abs(Math.round(l))+a.length,f.slideShadows&&n(m,l);const b=`translate3d(${h}px, ${S}px, 0px) rotateX(${p(g)}deg) rotateY(${p(y)}deg)`,z=xe(f,m);z.style.transform=b}},setTransition:a=>{const u=e.slides.map(f=>ce(f));u.forEach(f=>{f.style.transitionDuration=`${a}ms`,f.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(p=>{p.style.transitionDuration=`${a}ms`})}),ze({swiper:e,duration:a,transformElements:u})},recreateShadows:()=>{e.params.flipEffect,e.slides.forEach(a=>{let u=a.progress;e.params.flipEffect.limitRotation&&(u=Math.max(Math.min(a.progress,1),-1)),n(a,u)})},getEffectParams:()=>e.params.flipEffect,perspective:()=>!0,overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!e.params.cssMode})})}function Qs(s){let{swiper:e,extendParams:t,on:i}=s;t({coverflowEffect:{rotate:50,stretch:0,depth:100,scale:1,modifier:1,slideShadows:!0}}),ue({effect:"coverflow",swiper:e,on:i,setTranslate:()=>{const{width:d,height:c,slides:a,slidesSizesGrid:u}=e,f=e.params.coverflowEffect,p=e.isHorizontal(),v=e.translate,m=p?-v+d/2:-v+c/2,l=p?f.rotate:-f.rotate,o=f.depth,w=Ae(e);for(let y=0,g=a.length;y<g;y+=1){const h=a[y],S=u[y],b=h.swiperSlideOffset,z=(m-b-S/2)/S,$=typeof f.modifier=="function"?f.modifier(z):z*f.modifier;let O=p?l*$:0,P=p?0:l*$,L=-o*Math.abs($),A=f.stretch;typeof A=="string"&&A.indexOf("%")!==-1&&(A=parseFloat(f.stretch)/100*S);let M=p?0:A*$,E=p?A*$:0,x=1-(1-f.scale)*Math.abs($);Math.abs(E)<.001&&(E=0),Math.abs(M)<.001&&(M=0),Math.abs(L)<.001&&(L=0),Math.abs(O)<.001&&(O=0),Math.abs(P)<.001&&(P=0),Math.abs(x)<.001&&(x=0);const D=`translate3d(${E}px,${M}px,${L}px)  rotateX(${w(P)}deg) rotateY(${w(O)}deg) scale(${x})`,q=xe(f,h);if(q.style.transform=D,h.style.zIndex=-Math.abs(Math.round($))+1,f.slideShadows){let C=p?h.querySelector(".swiper-slide-shadow-left"):h.querySelector(".swiper-slide-shadow-top"),I=p?h.querySelector(".swiper-slide-shadow-right"):h.querySelector(".swiper-slide-shadow-bottom");C||(C=fe("coverflow",h,p?"left":"top")),I||(I=fe("coverflow",h,p?"right":"bottom")),C&&(C.style.opacity=$>0?$:0),I&&(I.style.opacity=-$>0?-$:0)}}},setTransition:d=>{e.slides.map(a=>ce(a)).forEach(a=>{a.style.transitionDuration=`${d}ms`,a.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(u=>{u.style.transitionDuration=`${d}ms`})})},perspective:()=>!0,overwriteParams:()=>({watchSlidesProgress:!0})})}function Js(s){let{swiper:e,extendParams:t,on:i}=s;t({creativeEffect:{limitProgress:1,shadowPerProgress:!1,progressMultiplier:1,perspective:!0,prev:{translate:[0,0,0],rotate:[0,0,0],opacity:1,scale:1},next:{translate:[0,0,0],rotate:[0,0,0],opacity:1,scale:1}}});const n=c=>typeof c=="string"?c:`${c}px`;ue({effect:"creative",swiper:e,on:i,setTranslate:()=>{const{slides:c,wrapperEl:a,slidesSizesGrid:u}=e,f=e.params.creativeEffect,{progressMultiplier:p}=f,v=e.params.centeredSlides,m=Ae(e);if(v){const l=u[0]/2-e.params.slidesOffsetBefore||0;a.style.transform=`translateX(calc(50% - ${l}px))`}for(let l=0;l<c.length;l+=1){const o=c[l],w=o.progress,y=Math.min(Math.max(o.progress,-f.limitProgress),f.limitProgress);let g=y;v||(g=Math.min(Math.max(o.originalProgress,-f.limitProgress),f.limitProgress));const h=o.swiperSlideOffset,S=[e.params.cssMode?-h-e.translate:-h,0,0],b=[0,0,0];let z=!1;e.isHorizontal()||(S[1]=S[0],S[0]=0);let $={translate:[0,0,0],rotate:[0,0,0],scale:1,opacity:1};y<0?($=f.next,z=!0):y>0&&($=f.prev,z=!0),S.forEach((x,D)=>{S[D]=`calc(${x}px + (${n($.translate[D])} * ${Math.abs(y*p)}))`}),b.forEach((x,D)=>{let q=$.rotate[D]*Math.abs(y*p);b[D]=q}),o.style.zIndex=-Math.abs(Math.round(w))+c.length;const O=S.join(", "),P=`rotateX(${m(b[0])}deg) rotateY(${m(b[1])}deg) rotateZ(${m(b[2])}deg)`,L=g<0?`scale(${1+(1-$.scale)*g*p})`:`scale(${1-(1-$.scale)*g*p})`,A=g<0?1+(1-$.opacity)*g*p:1-(1-$.opacity)*g*p,M=`translate3d(${O}) ${P} ${L}`;if(z&&$.shadow||!z){let x=o.querySelector(".swiper-slide-shadow");if(!x&&$.shadow&&(x=fe("creative",o)),x){const D=f.shadowPerProgress?y*(1/f.limitProgress):y;x.style.opacity=Math.min(Math.max(Math.abs(D),0),1)}}const E=xe(f,o);E.style.transform=M,E.style.opacity=A,$.origin&&(E.style.transformOrigin=$.origin)}},setTransition:c=>{const a=e.slides.map(u=>ce(u));a.forEach(u=>{u.style.transitionDuration=`${c}ms`,u.querySelectorAll(".swiper-slide-shadow").forEach(f=>{f.style.transitionDuration=`${c}ms`})}),ze({swiper:e,duration:c,transformElements:a,allSlides:!0})},perspective:()=>e.params.creativeEffect.perspective,overwriteParams:()=>({watchSlidesProgress:!0,virtualTranslate:!e.params.cssMode})})}function ei(s){let{swiper:e,extendParams:t,on:i}=s;t({cardsEffect:{slideShadows:!0,rotate:!0,perSlideRotate:2,perSlideOffset:8}}),ue({effect:"cards",swiper:e,on:i,setTranslate:()=>{const{slides:d,activeIndex:c,rtlTranslate:a}=e,u=e.params.cardsEffect,{startTranslate:f,isTouched:p}=e.touchEventsData,v=a?-e.translate:e.translate;for(let m=0;m<d.length;m+=1){const l=d[m],o=l.progress,w=Math.min(Math.max(o,-4),4);let y=l.swiperSlideOffset;e.params.centeredSlides&&!e.params.cssMode&&(e.wrapperEl.style.transform=`translateX(${e.minTranslate()}px)`),e.params.centeredSlides&&e.params.cssMode&&(y-=d[0].swiperSlideOffset);let g=e.params.cssMode?-y-e.translate:-y,h=0;const S=-100*Math.abs(w);let b=1,z=-u.perSlideRotate*w,$=u.perSlideOffset-Math.abs(w)*.75;const O=e.virtual&&e.params.virtual.enabled?e.virtual.from+m:m,P=(O===c||O===c-1)&&w>0&&w<1&&(p||e.params.cssMode)&&v<f,L=(O===c||O===c+1)&&w<0&&w>-1&&(p||e.params.cssMode)&&v>f;if(P||L){const x=(1-Math.abs((Math.abs(w)-.5)/.5))**.5;z+=-28*w*x,b+=-.5*x,$+=96*x,h=`${-25*x*Math.abs(w)}%`}if(w<0?g=`calc(${g}px ${a?"-":"+"} (${$*Math.abs(w)}%))`:w>0?g=`calc(${g}px ${a?"-":"+"} (-${$*Math.abs(w)}%))`:g=`${g}px`,!e.isHorizontal()){const x=h;h=g,g=x}const A=w<0?`${1+(1-b)*w}`:`${1-(1-b)*w}`,M=`
        translate3d(${g}, ${h}, ${S}px)
        rotateZ(${u.rotate?a?-z:z:0}deg)
        scale(${A})
      `;if(u.slideShadows){let x=l.querySelector(".swiper-slide-shadow");x||(x=fe("cards",l)),x&&(x.style.opacity=Math.min(Math.max((Math.abs(w)-.5)/.5,0),1))}l.style.zIndex=-Math.abs(Math.round(o))+d.length;const E=xe(u,l);E.style.transform=M}},setTransition:d=>{const c=e.slides.map(a=>ce(a));c.forEach(a=>{a.style.transitionDuration=`${d}ms`,a.querySelectorAll(".swiper-slide-shadow").forEach(u=>{u.style.transitionDuration=`${d}ms`})}),ze({swiper:e,duration:d,transformElements:c})},perspective:()=>!0,overwriteParams:()=>({watchSlidesProgress:!0,virtualTranslate:!e.params.cssMode})})}const ti=[Ps,Ls,Is,As,zs,Os,Ds,$s,ks,Bs,Hs,qs,_s,Gs,Vs,Rs,js,Us,Ks,Zs,Qs,Js,ei];Y.use(ti);function si(){const s=".communitySwiper",e=".marqueeSwiper",t=".reviewsSwiper",i=".specialSwiper",n=".previewSwiper",r=".timelineSwiper",d=".detailsSwiper";if(document.querySelector(s)){let p=function(){const m=document.querySelector(".community .c-grid"),l=document.querySelector(".community__carousel");return m&&l&&m.getBoundingClientRect().left+Number.parseInt(window.getComputedStyle(m).paddingLeft,10)||0};var c=p;const v=new Y(s,{loop:!0,slidesPerView:"auto",speed:1e3,spaceBetween:38,slidesOffsetBefore:p(),breakpoints:{320:{spaceBetween:8},768:{spaceBetween:38}}});window.addEventListener("resize",()=>{v&&v.params&&(v.params.slidesOffsetBefore=p(),v.update())}),p()}if(document.querySelector(n)){let p=function(){const m=document.querySelector(".preview .c-grid"),l=document.querySelector(".preview__carousel");return m&&l&&m.getBoundingClientRect().left+Number.parseInt(window.getComputedStyle(m).paddingLeft,10)||0};var a=p;const v=new Y(n,{loop:!1,slidesPerView:"auto",speed:1e3,spaceBetween:38,slidesOffsetBefore:p(),slidesOffsetAfter:p(),navigation:{nextEl:".preview__carousel .special__navigation--next",prevEl:".preview__carousel .special__navigation--prev"},pagination:{el:document.querySelector(n+" .swiper-pagination"),clickable:!0},breakpoints:{320:{slidesPerView:1,slidesOffsetBefore:0,slidesOffsetAfter:0},1280:{slidesPerView:"auto",slidesOffsetBefore:p(),slidesOffsetAfter:p()}}});window.addEventListener("resize",()=>{v&&v.params&&(v.params.slidesOffsetBefore=p(),v.params.slidesOffsetAfter=p(),v.update())}),p()}if(document.querySelector(e))for(const p of document.querySelectorAll(e))new Y(p,{loop:!0,spaceBetween:32,speed:5e3,autoplay:{delay:0,disableOnInteraction:!0},loopedSlides:4,slidesPerView:"auto",allowTouchMove:!1});if(document.querySelector(t)&&new Y(t,{speed:1e3,effect:"cards",grabCursor:!0,pagination:{el:document.querySelector(t+" .swiper-pagination"),clickable:!0}}),document.querySelector(i)&&new Y(i,{speed:1e3,slidesPerView:"4",spaceBetween:38,navigation:{nextEl:".special__carousel .special__navigation--next",prevEl:".special__carousel .special__navigation--prev"},pagination:{el:document.querySelector(i+" .swiper-pagination"),clickable:!0},breakpoints:{320:{slidesPerView:"2",spaceBetween:10},768:{slidesPerView:"3",spaceBetween:20},1280:{slidesPerView:"4",spaceBetween:38}}}),document.querySelector(d)&&new Y(d,{speed:1e3,slidesPerView:"auto",spaceBetween:16,slidesOffsetBefore:16,slidesOffsetAfter:16,pagination:{el:document.querySelector(d+" .swiper-pagination"),clickable:!0}}),document.querySelector(".categories__carousel")){let p=function(){const v=document.querySelector(".categories .c-grid"),m=document.querySelector(".categories__carousel");return v&&m&&v.getBoundingClientRect().left+Number.parseInt(window.getComputedStyle(v).paddingLeft,10)||0};var u=p;for(const[v,m]of document.querySelectorAll(".categories__carousel").entries()){let l=`categoriesSwiper + ${v}`;l=new Y(m.querySelector(".swiper"),{speed:1e3,slidesPerView:"auto",spaceBetween:38,navigation:{nextEl:m.querySelector(" .special__navigation--next"),prevEl:m.querySelector(" .special__navigation--prev")},slidesOffsetBefore:p(),slidesOffsetAfter:16,pagination:{el:m.querySelector(" .swiper-pagination"),clickable:!0},breakpoints:{320:{spaceBetween:10},768:{spaceBetween:38}}}),window.addEventListener("resize",()=>{l&&l.params&&(l.params.slidesOffsetBefore=p(),l.update())}),p()}}if(document.querySelector(r)&&new Y(r,{speed:1e3,slidesPerView:"auto",spaceBetween:60,centeredSlides:!0,pagination:{el:document.querySelector(".timeline .swiper-pagination"),clickable:!0},breakpoints:{320:{spaceBetween:10,slidesPerView:1},768:{spaceBetween:30,slidesPerView:"auto"},1024:{spaceBetween:60,slidesPerView:"auto"}}}),document.querySelector(".promisesSwiper")){let v=function(){window.innerWidth<=767?p||(p=new Y(".promisesSwiper",{slidesPerView:"auto",spaceBetween:12,pagination:{el:document.querySelector(".promisesSwiper .swiper-pagination"),clickable:!0}})):p&&(p.destroy(!0,!0),p=null)};var f=v;let p=null;v(),window.addEventListener("resize",v)}}function ii(){if(!document.querySelector(".details__part a"))return;const s=document.querySelectorAll(".details__part a");for(const e of s)e.addEventListener("click",t=>{t.preventDefault();const i=t.currentTarget;for(const n of s)n.classList.remove("is-active");i.classList.add("is-active")})}function ri(){if(document.querySelector(".rank__dropdown")){const s=document.querySelectorAll(".rank__dropdown-toggle");for(const e of s)e.addEventListener("click",t=>{const n=e.parentNode.querySelector(".rank__dropdown");t.currentTarget.classList.toggle("is-active"),n.classList.toggle("is-open")})}}function ni(){if(!document.querySelector(".header__dropdown"))return;const s=document.querySelector(".header__dropdown-toggle"),e=document.querySelector(".header__toggle"),t=document.querySelector(".header__dropdown");s.addEventListener("click",i=>{i.preventDefault(),i.currentTarget.classList.toggle("is-active"),document.body.classList.toggle("is-hideScroll"),t.classList.toggle("is-open")}),e.addEventListener("click",i=>{i.preventDefault(),i.currentTarget.classList.toggle("is-active"),document.body.classList.toggle("is-hideScroll"),t.classList.toggle("is-open")})}function ai(){const s=document.querySelector(".header__location-toggle"),e=document.querySelector(".header__location-close"),t=document.querySelector(".header__location-dropdown");s.addEventListener("click",i=>{i.preventDefault(),i.currentTarget.classList.toggle("is-active"),document.body.classList.toggle("is-hideScroll"),t.classList.toggle("is-open")}),e.addEventListener("click",i=>{i.preventDefault(),i.currentTarget.classList.remove("is-active"),document.body.classList.remove("is-hideScroll"),t.classList.remove("is-open")})}function li(){if(!document.querySelector(".products__filters nav"))return;const s=document.querySelector(".products__filters nav"),e=s.querySelectorAll("a"),t=document.querySelector(".products__filters .active-background");function i(r){if(!r)return;const d=r.getBoundingClientRect(),c=s.getBoundingClientRect();t.style.width=`${d.width}px`,t.style.transform=`translateX(${d.left-c.left}px)`,t.classList.add("is-active")}let n=s.querySelector(".active");n&&i(n);for(const[r,d]of e.entries())d.addEventListener("click",c=>{c.preventDefault();for(const a of e)a.classList.remove("active");d.classList.add("active");for(const a of t.classList)a.startsWith("is-")&&t.classList.remove(a);t.classList.add(`is-${r}`),i(d),n=d});window.addEventListener("resize",()=>{i(n)})}function oi(){const s=document.querySelector("#progress-bar");if(!s)return;function e(){requestAnimationFrame(()=>{const t=document.body.scrollHeight-window.innerHeight,i=window.scrollY/t*100;s.style.width=`${i}%`})}e(),window.addEventListener("scroll",e),window.addEventListener("resize",e)}function di(){const s=document.querySelectorAll(".more__nav a"),e=document.querySelector("header"),t=[];if(s.length===0||!e)return;for(const r of s){const d=r.getAttribute("href").slice(1),c=document.getElementById(d);c&&t.push({section:c,link:r})}function i(){e.offsetHeight;const r=window.scrollY+20;for(const{section:d,link:c}of t){const a=d.offsetTop-20,u=a+d.offsetHeight;r>=a&&r<u?c.classList.add("is-active"):c.classList.remove("is-active")}}function n(r){r.preventDefault();const d=this.getAttribute("href").slice(1),c=document.getElementById(d);if(c){e.offsetHeight;const a=c.offsetTop-20;window.scrollTo({top:a,behavior:"smooth"})}}window.addEventListener("scroll",i),i();for(const r of s)r.addEventListener("click",n)}function ci(){const s=document.querySelectorAll(".menu-link");document.getElementById("header"),document.getElementById("alert"),s.forEach(e=>{e.addEventListener("click",t=>{t.preventDefault();const i=e.getAttribute("href").substring(1),n=document.getElementById(i);if(n){const r=n.offsetTop;window.scrollTo({top:r,behavior:"smooth"})}})})}function fi(){const s=document.querySelector(".details__sticky"),e=document.querySelector("#details");if(!s||!e)return;function t(){const i=e.getBoundingClientRect();i.top<=window.innerHeight/2&&i.bottom>=window.innerHeight/2?s.classList.add("is-visible"):s.classList.remove("is-visible")}window.addEventListener("scroll",t),window.addEventListener("resize",t),t()}document.addEventListener("DOMContentLoaded",()=>{(()=>{const e=document.querySelectorAll("a");for(const[t,i]of e.entries())i.addEventListener("click",n=>{i.getAttribute("href")==="#"&&n.preventDefault()})})(),lt(),si(),ot(),ci(),ai(),ni(),ii(),oi(),di(),ri(),fi(),setTimeout(()=>li(),300)});

*/

(function () {
    const e = document.createElement("link").relList;
    if (e && e.supports && e.supports("modulepreload")) return;
    for (const n of document.querySelectorAll('link[rel="modulepreload"]')) i(n);
    new MutationObserver((n) => {
        for (const r of n) if (r.type === "childList") for (const d of r.addedNodes) d.tagName === "LINK" && d.rel === "modulepreload" && i(d);
    }).observe(document, { childList: !0, subtree: !0 });
    function t(n) {
        const r = {};
        return (
            n.integrity && (r.integrity = n.integrity),
            n.referrerPolicy && (r.referrerPolicy = n.referrerPolicy),
            n.crossOrigin === "use-credentials" ? (r.credentials = "include") : n.crossOrigin === "anonymous" ? (r.credentials = "omit") : (r.credentials = "same-origin"),
            r
        );
    }
    function i(n) {
        if (n.ep) return;
        n.ep = !0;
        const r = t(n);
        fetch(n.href, r);
    }
})();
function lt() {
    const s = document.querySelector(".faq__accordion-container");
    if (!s) return;
    const e = s.querySelectorAll(".faq__accordion-node");
    e.forEach((t) => {
        t.querySelector(".faq__accordion-toggle").addEventListener("click", (n) => {
            n.preventDefault(),
                e.forEach((d) => {
                    if (d !== t) {
                        d.classList.remove("is-active");
                        const c = d.querySelector(".faq__accordion-content");
                        c && (c.style.maxHeight = null);
                    }
                });
            const r = t.querySelector(".faq__accordion-content");
            r && (t.classList.contains("is-active") ? (t.classList.remove("is-active"), (r.style.maxHeight = null)) : (t.classList.add("is-active"), (r.style.maxHeight = `${r.scrollHeight}px`)));
        });
    });
}
function ot() {
   /* const s = document.querySelectorAll(".c-card");
    for (const t of s) {
        let u = function () {
            a > 0 ? ((i.style.display = "none"), (n.style.display = "flex"), (c.textContent = a)) : ((i.style.display = "flex"), (n.style.display = "none"));
        };
        var e = u;
        if (!t.querySelector(".add-to-cart-btn")) continue;
        const i = t.querySelector(".add-to-cart-btn"),
            n = t.querySelector(".quantity-actions"),
            r = t.querySelector(".increment-btn"),
            d = t.querySelector(".decrement-btn"),
            c = t.querySelector(".quantity-count");
        let a = 0;
        i.addEventListener("click", (f) => {
            f.preventDefault(), (a = 1), u();
        }),
            r.addEventListener("click", (f) => {
                f.preventDefault(), a++, u();
            }),
            d.addEventListener("click", (f) => {
                f.preventDefault(), a > 1 ? a-- : (a = 0), u();
            });
    }*/
}
function Ue(s) {
    return s !== null && typeof s == "object" && "constructor" in s && s.constructor === Object;
}
function Fe(s, e) {
    s === void 0 && (s = {}),
        e === void 0 && (e = {}),
        Object.keys(e).forEach((t) => {
            typeof s[t] > "u" ? (s[t] = e[t]) : Ue(e[t]) && Ue(s[t]) && Object.keys(e[t]).length > 0 && Fe(s[t], e[t]);
        });
}
const tt = {
    body: {},
    addEventListener() {},
    removeEventListener() {},
    activeElement: { blur() {}, nodeName: "" },
    querySelector() {
        return null;
    },
    querySelectorAll() {
        return [];
    },
    getElementById() {
        return null;
    },
    createEvent() {
        return { initEvent() {} };
    },
    createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() {},
            getElementsByTagName() {
                return [];
            },
        };
    },
    createElementNS() {
        return {};
    },
    importNode() {
        return null;
    },
    location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
};
function N() {
    const s = typeof document < "u" ? document : {};
    return Fe(s, tt), s;
}
const dt = {
    document: tt,
    navigator: { userAgent: "" },
    location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
    history: { replaceState() {}, pushState() {}, go() {}, back() {} },
    CustomEvent: function () {
        return this;
    },
    addEventListener() {},
    removeEventListener() {},
    getComputedStyle() {
        return {
            getPropertyValue() {
                return "";
            },
        };
    },
    Image() {},
    Date() {},
    screen: {},
    setTimeout() {},
    clearTimeout() {},
    matchMedia() {
        return {};
    },
    requestAnimationFrame(s) {
        return typeof setTimeout > "u" ? (s(), null) : setTimeout(s, 0);
    },
    cancelAnimationFrame(s) {
        typeof setTimeout > "u" || clearTimeout(s);
    },
};
function R() {
    const s = typeof window < "u" ? window : {};
    return Fe(s, dt), s;
}
function ae(s) {
    return (
        s === void 0 && (s = ""),
        s
            .trim()
            .split(" ")
            .filter((e) => !!e.trim())
    );
}
function ct(s) {
    const e = s;
    Object.keys(e).forEach((t) => {
        try {
            e[t] = null;
        } catch {}
        try {
            delete e[t];
        } catch {}
    });
}
function de(s, e) {
    return e === void 0 && (e = 0), setTimeout(s, e);
}
function Q() {
    return Date.now();
}
function ft(s) {
    const e = R();
    let t;
    return e.getComputedStyle && (t = e.getComputedStyle(s, null)), !t && s.currentStyle && (t = s.currentStyle), t || (t = s.style), t;
}
function Xe(s, e) {
    e === void 0 && (e = "x");
    const t = R();
    let i, n, r;
    const d = ft(s);
    return (
        t.WebKitCSSMatrix
            ? ((n = d.transform || d.webkitTransform),
              n.split(",").length > 6 &&
                  (n = n
                      .split(", ")
                      .map((c) => c.replace(",", "."))
                      .join(", ")),
              (r = new t.WebKitCSSMatrix(n === "none" ? "" : n)))
            : ((r = d.MozTransform || d.OTransform || d.MsTransform || d.msTransform || d.transform || d.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")), (i = r.toString().split(","))),
        e === "x" && (t.WebKitCSSMatrix ? (n = r.m41) : i.length === 16 ? (n = parseFloat(i[12])) : (n = parseFloat(i[4]))),
        e === "y" && (t.WebKitCSSMatrix ? (n = r.m42) : i.length === 16 ? (n = parseFloat(i[13])) : (n = parseFloat(i[5]))),
        n || 0
    );
}
function ye(s) {
    return typeof s == "object" && s !== null && s.constructor && Object.prototype.toString.call(s).slice(8, -1) === "Object";
}
function ut(s) {
    return typeof window < "u" && typeof window.HTMLElement < "u" ? s instanceof HTMLElement : s && (s.nodeType === 1 || s.nodeType === 11);
}
function K() {
    const s = Object(arguments.length <= 0 ? void 0 : arguments[0]),
        e = ["__proto__", "constructor", "prototype"];
    for (let t = 1; t < arguments.length; t += 1) {
        const i = t < 0 || arguments.length <= t ? void 0 : arguments[t];
        if (i != null && !ut(i)) {
            const n = Object.keys(Object(i)).filter((r) => e.indexOf(r) < 0);
            for (let r = 0, d = n.length; r < d; r += 1) {
                const c = n[r],
                    a = Object.getOwnPropertyDescriptor(i, c);
                a !== void 0 && a.enumerable && (ye(s[c]) && ye(i[c]) ? (i[c].__swiper__ ? (s[c] = i[c]) : K(s[c], i[c])) : !ye(s[c]) && ye(i[c]) ? ((s[c] = {}), i[c].__swiper__ ? (s[c] = i[c]) : K(s[c], i[c])) : (s[c] = i[c]));
            }
        }
    }
    return s;
}
function Se(s, e, t) {
    s.style.setProperty(e, t);
}
function st(s) {
    let { swiper: e, targetPosition: t, side: i } = s;
    const n = R(),
        r = -e.translate;
    let d = null,
        c;
    const a = e.params.speed;
    (e.wrapperEl.style.scrollSnapType = "none"), n.cancelAnimationFrame(e.cssModeFrameID);
    const u = t > r ? "next" : "prev",
        f = (v, m) => (u === "next" && v >= m) || (u === "prev" && v <= m),
        p = () => {
            (c = new Date().getTime()), d === null && (d = c);
            const v = Math.max(Math.min((c - d) / a, 1), 0),
                m = 0.5 - Math.cos(v * Math.PI) / 2;
            let l = r + m * (t - r);
            if ((f(l, t) && (l = t), e.wrapperEl.scrollTo({ [i]: l }), f(l, t))) {
                (e.wrapperEl.style.overflow = "hidden"),
                    (e.wrapperEl.style.scrollSnapType = ""),
                    setTimeout(() => {
                        (e.wrapperEl.style.overflow = ""), e.wrapperEl.scrollTo({ [i]: l });
                    }),
                    n.cancelAnimationFrame(e.cssModeFrameID);
                return;
            }
            e.cssModeFrameID = n.requestAnimationFrame(p);
        };
    p();
}
function ce(s) {
    return s.querySelector(".swiper-slide-transform") || (s.shadowRoot && s.shadowRoot.querySelector(".swiper-slide-transform")) || s;
}
function W(s, e) {
    e === void 0 && (e = "");
    const t = R(),
        i = [...s.children];
    return t.HTMLSlotElement && s instanceof HTMLSlotElement && i.push(...s.assignedElements()), e ? i.filter((n) => n.matches(e)) : i;
}
function pt(s, e) {
    var i, n;
    const t = [e];
    for (; t.length > 0; ) {
        const r = t.shift();
        if (s === r) return !0;
        t.push(...r.children, ...(((i = r.shadowRoot) == null ? void 0 : i.children) || []), ...(((n = r.assignedElements) == null ? void 0 : n.call(r)) || []));
    }
}
function mt(s, e) {
    const t = R();
    let i = e.contains(s);
    return !i && t.HTMLSlotElement && e instanceof HTMLSlotElement && ((i = [...e.assignedElements()].includes(s)), i || (i = pt(s, e))), i;
}
function Le(s) {
    try {
        console.warn(s);
        return;
    } catch {}
}
function Z(s, e) {
    e === void 0 && (e = []);
    const t = document.createElement(s);
    return t.classList.add(...(Array.isArray(e) ? e : ae(e))), t;
}
function Ie(s) {
    const e = R(),
        t = N(),
        i = s.getBoundingClientRect(),
        n = t.body,
        r = s.clientTop || n.clientTop || 0,
        d = s.clientLeft || n.clientLeft || 0,
        c = s === e ? e.scrollY : s.scrollTop,
        a = s === e ? e.scrollX : s.scrollLeft;
    return { top: i.top + c - r, left: i.left + a - d };
}
function ht(s, e) {
    const t = [];
    for (; s.previousElementSibling; ) {
        const i = s.previousElementSibling;
        e ? i.matches(e) && t.push(i) : t.push(i), (s = i);
    }
    return t;
}
function gt(s, e) {
    const t = [];
    for (; s.nextElementSibling; ) {
        const i = s.nextElementSibling;
        e ? i.matches(e) && t.push(i) : t.push(i), (s = i);
    }
    return t;
}
function le(s, e) {
    return R().getComputedStyle(s, null).getPropertyValue(e);
}
function Ee(s) {
    let e = s,
        t;
    if (e) {
        for (t = 0; (e = e.previousSibling) !== null; ) e.nodeType === 1 && (t += 1);
        return t;
    }
}
function oe(s, e) {
    const t = [];
    let i = s.parentElement;
    for (; i; ) e ? i.matches(e) && t.push(i) : t.push(i), (i = i.parentElement);
    return t;
}
function be(s, e) {
    function t(i) {
        i.target === s && (e.call(s, i), s.removeEventListener("transitionend", t));
    }
    e && s.addEventListener("transitionend", t);
}
function Ye(s, e, t) {
    const i = R();
    return (
        s[e === "width" ? "offsetWidth" : "offsetHeight"] +
        parseFloat(i.getComputedStyle(s, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) +
        parseFloat(i.getComputedStyle(s, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"))
    );
}
function G(s) {
    return (Array.isArray(s) ? s : [s]).filter((e) => !!e);
}
function Ae(s) {
    return (e) => (Math.abs(e) > 0 && s.browser && s.browser.need3dFix && Math.abs(e) % 90 === 0 ? e + 0.001 : e);
}
let Be;
function vt() {
    const s = R(),
        e = N();
    return { smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style, touch: !!("ontouchstart" in s || (s.DocumentTouch && e instanceof s.DocumentTouch)) };
}
function it() {
    return Be || (Be = vt()), Be;
}
let He;
function wt(s) {
    let { userAgent: e } = s === void 0 ? {} : s;
    const t = it(),
        i = R(),
        n = i.navigator.platform,
        r = e || i.navigator.userAgent,
        d = { ios: !1, android: !1 },
        c = i.screen.width,
        a = i.screen.height,
        u = r.match(/(Android);?[\s\/]+([\d.]+)?/);
    let f = r.match(/(iPad).*OS\s([\d_]+)/);
    const p = r.match(/(iPod)(.*OS\s([\d_]+))?/),
        v = !f && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
        m = n === "Win32";
    let l = n === "MacIntel";
    const o = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
    return (
        !f && l && t.touch && o.indexOf(`${c}x${a}`) >= 0 && ((f = r.match(/(Version)\/([\d.]+)/)), f || (f = [0, 1, "13_0_0"]), (l = !1)),
        u && !m && ((d.os = "android"), (d.android = !0)),
        (f || v || p) && ((d.os = "ios"), (d.ios = !0)),
        d
    );
}
function rt(s) {
    return s === void 0 && (s = {}), He || (He = wt(s)), He;
}
let qe;
function yt() {
    const s = R(),
        e = rt();
    let t = !1;
    function i() {
        const c = s.navigator.userAgent.toLowerCase();
        return c.indexOf("safari") >= 0 && c.indexOf("chrome") < 0 && c.indexOf("android") < 0;
    }
    if (i()) {
        const c = String(s.navigator.userAgent);
        if (c.includes("Version/")) {
            const [a, u] = c
                .split("Version/")[1]
                .split(" ")[0]
                .split(".")
                .map((f) => Number(f));
            t = a < 16 || (a === 16 && u < 2);
        }
    }
    const n = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(s.navigator.userAgent),
        r = i(),
        d = r || (n && e.ios);
    return { isSafari: t || r, needPerspectiveFix: t, need3dFix: d, isWebView: n };
}
function St() {
    return qe || (qe = yt()), qe;
}
function bt(s) {
    let { swiper: e, on: t, emit: i } = s;
    const n = R();
    let r = null,
        d = null;
    const c = () => {
            !e || e.destroyed || !e.initialized || (i("beforeResize"), i("resize"));
        },
        a = () => {
            !e ||
                e.destroyed ||
                !e.initialized ||
                ((r = new ResizeObserver((p) => {
                    d = n.requestAnimationFrame(() => {
                        const { width: v, height: m } = e;
                        let l = v,
                            o = m;
                        p.forEach((w) => {
                            let { contentBoxSize: y, contentRect: g, target: h } = w;
                            (h && h !== e.el) || ((l = g ? g.width : (y[0] || y).inlineSize), (o = g ? g.height : (y[0] || y).blockSize));
                        }),
                            (l !== v || o !== m) && c();
                    });
                })),
                r.observe(e.el));
        },
        u = () => {
            d && n.cancelAnimationFrame(d), r && r.unobserve && e.el && (r.unobserve(e.el), (r = null));
        },
        f = () => {
            !e || e.destroyed || !e.initialized || i("orientationchange");
        };
    t("init", () => {
        if (e.params.resizeObserver && typeof n.ResizeObserver < "u") {
            a();
            return;
        }
        n.addEventListener("resize", c), n.addEventListener("orientationchange", f);
    }),
        t("destroy", () => {
            u(), n.removeEventListener("resize", c), n.removeEventListener("orientationchange", f);
        });
}
function Et(s) {
    let { swiper: e, extendParams: t, on: i, emit: n } = s;
    const r = [],
        d = R(),
        c = function (f, p) {
            p === void 0 && (p = {});
            const v = d.MutationObserver || d.WebkitMutationObserver,
                m = new v((l) => {
                    if (e.__preventObserver__) return;
                    if (l.length === 1) {
                        n("observerUpdate", l[0]);
                        return;
                    }
                    const o = function () {
                        n("observerUpdate", l[0]);
                    };
                    d.requestAnimationFrame ? d.requestAnimationFrame(o) : d.setTimeout(o, 0);
                });
            m.observe(f, { attributes: typeof p.attributes > "u" ? !0 : p.attributes, childList: e.isElement || (typeof p.childList > "u" ? !0 : p).childList, characterData: typeof p.characterData > "u" ? !0 : p.characterData }), r.push(m);
        },
        a = () => {
            if (e.params.observer) {
                if (e.params.observeParents) {
                    const f = oe(e.hostEl);
                    for (let p = 0; p < f.length; p += 1) c(f[p]);
                }
                c(e.hostEl, { childList: e.params.observeSlideChildren }), c(e.wrapperEl, { attributes: !1 });
            }
        },
        u = () => {
            r.forEach((f) => {
                f.disconnect();
            }),
                r.splice(0, r.length);
        };
    t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }), i("init", a), i("destroy", u);
}
var xt = {
    on(s, e, t) {
        const i = this;
        if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
        const n = t ? "unshift" : "push";
        return (
            s.split(" ").forEach((r) => {
                i.eventsListeners[r] || (i.eventsListeners[r] = []), i.eventsListeners[r][n](e);
            }),
            i
        );
    },
    once(s, e, t) {
        const i = this;
        if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
        function n() {
            i.off(s, n), n.__emitterProxy && delete n.__emitterProxy;
            for (var r = arguments.length, d = new Array(r), c = 0; c < r; c++) d[c] = arguments[c];
            e.apply(i, d);
        }
        return (n.__emitterProxy = e), i.on(s, n, t);
    },
    onAny(s, e) {
        const t = this;
        if (!t.eventsListeners || t.destroyed || typeof s != "function") return t;
        const i = e ? "unshift" : "push";
        return t.eventsAnyListeners.indexOf(s) < 0 && t.eventsAnyListeners[i](s), t;
    },
    offAny(s) {
        const e = this;
        if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
        const t = e.eventsAnyListeners.indexOf(s);
        return t >= 0 && e.eventsAnyListeners.splice(t, 1), e;
    },
    off(s, e) {
        const t = this;
        return (
            !t.eventsListeners ||
                t.destroyed ||
                !t.eventsListeners ||
                s.split(" ").forEach((i) => {
                    typeof e > "u"
                        ? (t.eventsListeners[i] = [])
                        : t.eventsListeners[i] &&
                          t.eventsListeners[i].forEach((n, r) => {
                              (n === e || (n.__emitterProxy && n.__emitterProxy === e)) && t.eventsListeners[i].splice(r, 1);
                          });
                }),
            t
        );
    },
    emit() {
        const s = this;
        if (!s.eventsListeners || s.destroyed || !s.eventsListeners) return s;
        let e, t, i;
        for (var n = arguments.length, r = new Array(n), d = 0; d < n; d++) r[d] = arguments[d];
        return (
            typeof r[0] == "string" || Array.isArray(r[0]) ? ((e = r[0]), (t = r.slice(1, r.length)), (i = s)) : ((e = r[0].events), (t = r[0].data), (i = r[0].context || s)),
            t.unshift(i),
            (Array.isArray(e) ? e : e.split(" ")).forEach((a) => {
                s.eventsAnyListeners &&
                    s.eventsAnyListeners.length &&
                    s.eventsAnyListeners.forEach((u) => {
                        u.apply(i, [a, ...t]);
                    }),
                    s.eventsListeners &&
                        s.eventsListeners[a] &&
                        s.eventsListeners[a].forEach((u) => {
                            u.apply(i, t);
                        });
            }),
            s
        );
    },
};
function Tt() {
    const s = this;
    let e, t;
    const i = s.el;
    typeof s.params.width < "u" && s.params.width !== null ? (e = s.params.width) : (e = i.clientWidth),
        typeof s.params.height < "u" && s.params.height !== null ? (t = s.params.height) : (t = i.clientHeight),
        !((e === 0 && s.isHorizontal()) || (t === 0 && s.isVertical())) &&
            ((e = e - parseInt(le(i, "padding-left") || 0, 10) - parseInt(le(i, "padding-right") || 0, 10)),
            (t = t - parseInt(le(i, "padding-top") || 0, 10) - parseInt(le(i, "padding-bottom") || 0, 10)),
            Number.isNaN(e) && (e = 0),
            Number.isNaN(t) && (t = 0),
            Object.assign(s, { width: e, height: t, size: s.isHorizontal() ? e : t }));
}
function Mt() {
    const s = this;
    function e(L, A) {
        return parseFloat(L.getPropertyValue(s.getDirectionLabel(A)) || 0);
    }
    const t = s.params,
        { wrapperEl: i, slidesEl: n, size: r, rtlTranslate: d, wrongRTL: c } = s,
        a = s.virtual && t.virtual.enabled,
        u = a ? s.virtual.slides.length : s.slides.length,
        f = W(n, `.${s.params.slideClass}, swiper-slide`),
        p = a ? s.virtual.slides.length : f.length;
    let v = [];
    const m = [],
        l = [];
    let o = t.slidesOffsetBefore;
    typeof o == "function" && (o = t.slidesOffsetBefore.call(s));
    let w = t.slidesOffsetAfter;
    typeof w == "function" && (w = t.slidesOffsetAfter.call(s));
    const y = s.snapGrid.length,
        g = s.slidesGrid.length;
    let h = t.spaceBetween,
        S = -o,
        b = 0,
        z = 0;
    if (typeof r > "u") return;
    typeof h == "string" && h.indexOf("%") >= 0 ? (h = (parseFloat(h.replace("%", "")) / 100) * r) : typeof h == "string" && (h = parseFloat(h)),
        (s.virtualSize = -h),
        f.forEach((L) => {
            d ? (L.style.marginLeft = "") : (L.style.marginRight = ""), (L.style.marginBottom = ""), (L.style.marginTop = "");
        }),
        t.centeredSlides && t.cssMode && (Se(i, "--swiper-centered-offset-before", ""), Se(i, "--swiper-centered-offset-after", ""));
    const $ = t.grid && t.grid.rows > 1 && s.grid;
    $ ? s.grid.initSlides(f) : s.grid && s.grid.unsetSlides();
    let O;
    const P = t.slidesPerView === "auto" && t.breakpoints && Object.keys(t.breakpoints).filter((L) => typeof t.breakpoints[L].slidesPerView < "u").length > 0;
    for (let L = 0; L < p; L += 1) {
        O = 0;
        let A;
        if ((f[L] && (A = f[L]), $ && s.grid.updateSlide(L, A, f), !(f[L] && le(A, "display") === "none"))) {
            if (t.slidesPerView === "auto") {
                P && (f[L].style[s.getDirectionLabel("width")] = "");
                const M = getComputedStyle(A),
                    E = A.style.transform,
                    x = A.style.webkitTransform;
                if ((E && (A.style.transform = "none"), x && (A.style.webkitTransform = "none"), t.roundLengths)) O = s.isHorizontal() ? Ye(A, "width") : Ye(A, "height");
                else {
                    const D = e(M, "width"),
                        q = e(M, "padding-left"),
                        C = e(M, "padding-right"),
                        I = e(M, "margin-left"),
                        H = e(M, "margin-right"),
                        _ = M.getPropertyValue("box-sizing");
                    if (_ && _ === "border-box") O = D + I + H;
                    else {
                        const { clientWidth: X, offsetWidth: F } = A;
                        O = D + q + C + I + H + (F - X);
                    }
                }
                E && (A.style.transform = E), x && (A.style.webkitTransform = x), t.roundLengths && (O = Math.floor(O));
            } else (O = (r - (t.slidesPerView - 1) * h) / t.slidesPerView), t.roundLengths && (O = Math.floor(O)), f[L] && (f[L].style[s.getDirectionLabel("width")] = `${O}px`);
            f[L] && (f[L].swiperSlideSize = O),
                l.push(O),
                t.centeredSlides
                    ? ((S = S + O / 2 + b / 2 + h),
                      b === 0 && L !== 0 && (S = S - r / 2 - h),
                      L === 0 && (S = S - r / 2 - h),
                      Math.abs(S) < 1 / 1e3 && (S = 0),
                      t.roundLengths && (S = Math.floor(S)),
                      z % t.slidesPerGroup === 0 && v.push(S),
                      m.push(S))
                    : (t.roundLengths && (S = Math.floor(S)), (z - Math.min(s.params.slidesPerGroupSkip, z)) % s.params.slidesPerGroup === 0 && v.push(S), m.push(S), (S = S + O + h)),
                (s.virtualSize += O + h),
                (b = O),
                (z += 1);
        }
    }
    if (
        ((s.virtualSize = Math.max(s.virtualSize, r) + w),
        d && c && (t.effect === "slide" || t.effect === "coverflow") && (i.style.width = `${s.virtualSize + h}px`),
        t.setWrapperSize && (i.style[s.getDirectionLabel("width")] = `${s.virtualSize + h}px`),
        $ && s.grid.updateWrapperSize(O, v),
        !t.centeredSlides)
    ) {
        const L = [];
        for (let A = 0; A < v.length; A += 1) {
            let M = v[A];
            t.roundLengths && (M = Math.floor(M)), v[A] <= s.virtualSize - r && L.push(M);
        }
        (v = L), Math.floor(s.virtualSize - r) - Math.floor(v[v.length - 1]) > 1 && v.push(s.virtualSize - r);
    }
    if (a && t.loop) {
        const L = l[0] + h;
        if (t.slidesPerGroup > 1) {
            const A = Math.ceil((s.virtual.slidesBefore + s.virtual.slidesAfter) / t.slidesPerGroup),
                M = L * t.slidesPerGroup;
            for (let E = 0; E < A; E += 1) v.push(v[v.length - 1] + M);
        }
        for (let A = 0; A < s.virtual.slidesBefore + s.virtual.slidesAfter; A += 1) t.slidesPerGroup === 1 && v.push(v[v.length - 1] + L), m.push(m[m.length - 1] + L), (s.virtualSize += L);
    }
    if ((v.length === 0 && (v = [0]), h !== 0)) {
        const L = s.isHorizontal() && d ? "marginLeft" : s.getDirectionLabel("marginRight");
        f.filter((A, M) => (!t.cssMode || t.loop ? !0 : M !== f.length - 1)).forEach((A) => {
            A.style[L] = `${h}px`;
        });
    }
    if (t.centeredSlides && t.centeredSlidesBounds) {
        let L = 0;
        l.forEach((M) => {
            L += M + (h || 0);
        }),
            (L -= h);
        const A = L > r ? L - r : 0;
        v = v.map((M) => (M <= 0 ? -o : M > A ? A + w : M));
    }
    if (t.centerInsufficientSlides) {
        let L = 0;
        l.forEach((M) => {
            L += M + (h || 0);
        }),
            (L -= h);
        const A = (t.slidesOffsetBefore || 0) + (t.slidesOffsetAfter || 0);
        if (L + A < r) {
            const M = (r - L - A) / 2;
            v.forEach((E, x) => {
                v[x] = E - M;
            }),
                m.forEach((E, x) => {
                    m[x] = E + M;
                });
        }
    }
    if ((Object.assign(s, { slides: f, snapGrid: v, slidesGrid: m, slidesSizesGrid: l }), t.centeredSlides && t.cssMode && !t.centeredSlidesBounds)) {
        Se(i, "--swiper-centered-offset-before", `${-v[0]}px`), Se(i, "--swiper-centered-offset-after", `${s.size / 2 - l[l.length - 1] / 2}px`);
        const L = -s.snapGrid[0],
            A = -s.slidesGrid[0];
        (s.snapGrid = s.snapGrid.map((M) => M + L)), (s.slidesGrid = s.slidesGrid.map((M) => M + A));
    }
    if (
        (p !== u && s.emit("slidesLengthChange"),
        v.length !== y && (s.params.watchOverflow && s.checkOverflow(), s.emit("snapGridLengthChange")),
        m.length !== g && s.emit("slidesGridLengthChange"),
        t.watchSlidesProgress && s.updateSlidesOffset(),
        s.emit("slidesUpdated"),
        !a && !t.cssMode && (t.effect === "slide" || t.effect === "fade"))
    ) {
        const L = `${t.containerModifierClass}backface-hidden`,
            A = s.el.classList.contains(L);
        p <= t.maxBackfaceHiddenSlides ? A || s.el.classList.add(L) : A && s.el.classList.remove(L);
    }
}
function Ct(s) {
    const e = this,
        t = [],
        i = e.virtual && e.params.virtual.enabled;
    let n = 0,
        r;
    typeof s == "number" ? e.setTransition(s) : s === !0 && e.setTransition(e.params.speed);
    const d = (c) => (i ? e.slides[e.getSlideIndexByData(c)] : e.slides[c]);
    if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
        if (e.params.centeredSlides)
            (e.visibleSlides || []).forEach((c) => {
                t.push(c);
            });
        else
            for (r = 0; r < Math.ceil(e.params.slidesPerView); r += 1) {
                const c = e.activeIndex + r;
                if (c > e.slides.length && !i) break;
                t.push(d(c));
            }
    else t.push(d(e.activeIndex));
    for (r = 0; r < t.length; r += 1)
        if (typeof t[r] < "u") {
            const c = t[r].offsetHeight;
            n = c > n ? c : n;
        }
    (n || n === 0) && (e.wrapperEl.style.height = `${n}px`);
}
function Pt() {
    const s = this,
        e = s.slides,
        t = s.isElement ? (s.isHorizontal() ? s.wrapperEl.offsetLeft : s.wrapperEl.offsetTop) : 0;
    for (let i = 0; i < e.length; i += 1) e[i].swiperSlideOffset = (s.isHorizontal() ? e[i].offsetLeft : e[i].offsetTop) - t - s.cssOverflowAdjustment();
}
const Ke = (s, e, t) => {
    e && !s.classList.contains(t) ? s.classList.add(t) : !e && s.classList.contains(t) && s.classList.remove(t);
};
function Lt(s) {
    s === void 0 && (s = (this && this.translate) || 0);
    const e = this,
        t = e.params,
        { slides: i, rtlTranslate: n, snapGrid: r } = e;
    if (i.length === 0) return;
    typeof i[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
    let d = -s;
    n && (d = s), (e.visibleSlidesIndexes = []), (e.visibleSlides = []);
    let c = t.spaceBetween;
    typeof c == "string" && c.indexOf("%") >= 0 ? (c = (parseFloat(c.replace("%", "")) / 100) * e.size) : typeof c == "string" && (c = parseFloat(c));
    for (let a = 0; a < i.length; a += 1) {
        const u = i[a];
        let f = u.swiperSlideOffset;
        t.cssMode && t.centeredSlides && (f -= i[0].swiperSlideOffset);
        const p = (d + (t.centeredSlides ? e.minTranslate() : 0) - f) / (u.swiperSlideSize + c),
            v = (d - r[0] + (t.centeredSlides ? e.minTranslate() : 0) - f) / (u.swiperSlideSize + c),
            m = -(d - f),
            l = m + e.slidesSizesGrid[a],
            o = m >= 0 && m <= e.size - e.slidesSizesGrid[a],
            w = (m >= 0 && m < e.size - 1) || (l > 1 && l <= e.size) || (m <= 0 && l >= e.size);
        w && (e.visibleSlides.push(u), e.visibleSlidesIndexes.push(a)), Ke(u, w, t.slideVisibleClass), Ke(u, o, t.slideFullyVisibleClass), (u.progress = n ? -p : p), (u.originalProgress = n ? -v : v);
    }
}
function It(s) {
    const e = this;
    if (typeof s > "u") {
        const f = e.rtlTranslate ? -1 : 1;
        s = (e && e.translate && e.translate * f) || 0;
    }
    const t = e.params,
        i = e.maxTranslate() - e.minTranslate();
    let { progress: n, isBeginning: r, isEnd: d, progressLoop: c } = e;
    const a = r,
        u = d;
    if (i === 0) (n = 0), (r = !0), (d = !0);
    else {
        n = (s - e.minTranslate()) / i;
        const f = Math.abs(s - e.minTranslate()) < 1,
            p = Math.abs(s - e.maxTranslate()) < 1;
        (r = f || n <= 0), (d = p || n >= 1), f && (n = 0), p && (n = 1);
    }
    if (t.loop) {
        const f = e.getSlideIndexByData(0),
            p = e.getSlideIndexByData(e.slides.length - 1),
            v = e.slidesGrid[f],
            m = e.slidesGrid[p],
            l = e.slidesGrid[e.slidesGrid.length - 1],
            o = Math.abs(s);
        o >= v ? (c = (o - v) / l) : (c = (o + l - m) / l), c > 1 && (c -= 1);
    }
    Object.assign(e, { progress: n, progressLoop: c, isBeginning: r, isEnd: d }),
        (t.watchSlidesProgress || (t.centeredSlides && t.autoHeight)) && e.updateSlidesProgress(s),
        r && !a && e.emit("reachBeginning toEdge"),
        d && !u && e.emit("reachEnd toEdge"),
        ((a && !r) || (u && !d)) && e.emit("fromEdge"),
        e.emit("progress", n);
}
const _e = (s, e, t) => {
    e && !s.classList.contains(t) ? s.classList.add(t) : !e && s.classList.contains(t) && s.classList.remove(t);
};
function At() {
    const s = this,
        { slides: e, params: t, slidesEl: i, activeIndex: n } = s,
        r = s.virtual && t.virtual.enabled,
        d = s.grid && t.grid && t.grid.rows > 1,
        c = (p) => W(i, `.${t.slideClass}${p}, swiper-slide${p}`)[0];
    let a, u, f;
    if (r)
        if (t.loop) {
            let p = n - s.virtual.slidesBefore;
            p < 0 && (p = s.virtual.slides.length + p), p >= s.virtual.slides.length && (p -= s.virtual.slides.length), (a = c(`[data-swiper-slide-index="${p}"]`));
        } else a = c(`[data-swiper-slide-index="${n}"]`);
    else d ? ((a = e.find((p) => p.column === n)), (f = e.find((p) => p.column === n + 1)), (u = e.find((p) => p.column === n - 1))) : (a = e[n]);
    a && (d || ((f = gt(a, `.${t.slideClass}, swiper-slide`)[0]), t.loop && !f && (f = e[0]), (u = ht(a, `.${t.slideClass}, swiper-slide`)[0]), t.loop && !u === 0 && (u = e[e.length - 1]))),
        e.forEach((p) => {
            _e(p, p === a, t.slideActiveClass), _e(p, p === f, t.slideNextClass), _e(p, p === u, t.slidePrevClass);
        }),
        s.emitSlidesClasses();
}
const Pe = (s, e) => {
        if (!s || s.destroyed || !s.params) return;
        const t = () => (s.isElement ? "swiper-slide" : `.${s.params.slideClass}`),
            i = e.closest(t());
        if (i) {
            let n = i.querySelector(`.${s.params.lazyPreloaderClass}`);
            !n &&
                s.isElement &&
                (i.shadowRoot
                    ? (n = i.shadowRoot.querySelector(`.${s.params.lazyPreloaderClass}`))
                    : requestAnimationFrame(() => {
                          i.shadowRoot && ((n = i.shadowRoot.querySelector(`.${s.params.lazyPreloaderClass}`)), n && n.remove());
                      })),
                n && n.remove();
        }
    },
    Ge = (s, e) => {
        if (!s.slides[e]) return;
        const t = s.slides[e].querySelector('[loading="lazy"]');
        t && t.removeAttribute("loading");
    },
    Ne = (s) => {
        if (!s || s.destroyed || !s.params) return;
        let e = s.params.lazyPreloadPrevNext;
        const t = s.slides.length;
        if (!t || !e || e < 0) return;
        e = Math.min(e, t);
        const i = s.params.slidesPerView === "auto" ? s.slidesPerViewDynamic() : Math.ceil(s.params.slidesPerView),
            n = s.activeIndex;
        if (s.params.grid && s.params.grid.rows > 1) {
            const d = n,
                c = [d - e];
            c.push(...Array.from({ length: e }).map((a, u) => d + i + u)),
                s.slides.forEach((a, u) => {
                    c.includes(a.column) && Ge(s, u);
                });
            return;
        }
        const r = n + i - 1;
        if (s.params.rewind || s.params.loop)
            for (let d = n - e; d <= r + e; d += 1) {
                const c = ((d % t) + t) % t;
                (c < n || c > r) && Ge(s, c);
            }
        else for (let d = Math.max(n - e, 0); d <= Math.min(r + e, t - 1); d += 1) d !== n && (d > r || d < n) && Ge(s, d);
    };
function zt(s) {
    const { slidesGrid: e, params: t } = s,
        i = s.rtlTranslate ? s.translate : -s.translate;
    let n;
    for (let r = 0; r < e.length; r += 1) typeof e[r + 1] < "u" ? (i >= e[r] && i < e[r + 1] - (e[r + 1] - e[r]) / 2 ? (n = r) : i >= e[r] && i < e[r + 1] && (n = r + 1)) : i >= e[r] && (n = r);
    return t.normalizeSlideIndex && (n < 0 || typeof n > "u") && (n = 0), n;
}
function Ot(s) {
    const e = this,
        t = e.rtlTranslate ? e.translate : -e.translate,
        { snapGrid: i, params: n, activeIndex: r, realIndex: d, snapIndex: c } = e;
    let a = s,
        u;
    const f = (m) => {
        let l = m - e.virtual.slidesBefore;
        return l < 0 && (l = e.virtual.slides.length + l), l >= e.virtual.slides.length && (l -= e.virtual.slides.length), l;
    };
    if ((typeof a > "u" && (a = zt(e)), i.indexOf(t) >= 0)) u = i.indexOf(t);
    else {
        const m = Math.min(n.slidesPerGroupSkip, a);
        u = m + Math.floor((a - m) / n.slidesPerGroup);
    }
    if ((u >= i.length && (u = i.length - 1), a === r && !e.params.loop)) {
        u !== c && ((e.snapIndex = u), e.emit("snapIndexChange"));
        return;
    }
    if (a === r && e.params.loop && e.virtual && e.params.virtual.enabled) {
        e.realIndex = f(a);
        return;
    }
    const p = e.grid && n.grid && n.grid.rows > 1;
    let v;
    if (e.virtual && n.virtual.enabled && n.loop) v = f(a);
    else if (p) {
        const m = e.slides.find((o) => o.column === a);
        let l = parseInt(m.getAttribute("data-swiper-slide-index"), 10);
        Number.isNaN(l) && (l = Math.max(e.slides.indexOf(m), 0)), (v = Math.floor(l / n.grid.rows));
    } else if (e.slides[a]) {
        const m = e.slides[a].getAttribute("data-swiper-slide-index");
        m ? (v = parseInt(m, 10)) : (v = a);
    } else v = a;
    Object.assign(e, { previousSnapIndex: c, snapIndex: u, previousRealIndex: d, realIndex: v, previousIndex: r, activeIndex: a }),
        e.initialized && Ne(e),
        e.emit("activeIndexChange"),
        e.emit("snapIndexChange"),
        (e.initialized || e.params.runCallbacksOnInit) && (d !== v && e.emit("realIndexChange"), e.emit("slideChange"));
}
function Dt(s, e) {
    const t = this,
        i = t.params;
    let n = s.closest(`.${i.slideClass}, swiper-slide`);
    !n &&
        t.isElement &&
        e &&
        e.length > 1 &&
        e.includes(s) &&
        [...e.slice(e.indexOf(s) + 1, e.length)].forEach((c) => {
            !n && c.matches && c.matches(`.${i.slideClass}, swiper-slide`) && (n = c);
        });
    let r = !1,
        d;
    if (n) {
        for (let c = 0; c < t.slides.length; c += 1)
            if (t.slides[c] === n) {
                (r = !0), (d = c);
                break;
            }
    }
    if (n && r) (t.clickedSlide = n), t.virtual && t.params.virtual.enabled ? (t.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10)) : (t.clickedIndex = d);
    else {
        (t.clickedSlide = void 0), (t.clickedIndex = void 0);
        return;
    }
    i.slideToClickedSlide && t.clickedIndex !== void 0 && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
}
var $t = { updateSize: Tt, updateSlides: Mt, updateAutoHeight: Ct, updateSlidesOffset: Pt, updateSlidesProgress: Lt, updateProgress: It, updateSlidesClasses: At, updateActiveIndex: Ot, updateClickedSlide: Dt };
function kt(s) {
    s === void 0 && (s = this.isHorizontal() ? "x" : "y");
    const e = this,
        { params: t, rtlTranslate: i, translate: n, wrapperEl: r } = e;
    if (t.virtualTranslate) return i ? -n : n;
    if (t.cssMode) return n;
    let d = Xe(r, s);
    return (d += e.cssOverflowAdjustment()), i && (d = -d), d || 0;
}
function Bt(s, e) {
    const t = this,
        { rtlTranslate: i, params: n, wrapperEl: r, progress: d } = t;
    let c = 0,
        a = 0;
    const u = 0;
    t.isHorizontal() ? (c = i ? -s : s) : (a = s),
        n.roundLengths && ((c = Math.floor(c)), (a = Math.floor(a))),
        (t.previousTranslate = t.translate),
        (t.translate = t.isHorizontal() ? c : a),
        n.cssMode
            ? (r[t.isHorizontal() ? "scrollLeft" : "scrollTop"] = t.isHorizontal() ? -c : -a)
            : n.virtualTranslate || (t.isHorizontal() ? (c -= t.cssOverflowAdjustment()) : (a -= t.cssOverflowAdjustment()), (r.style.transform = `translate3d(${c}px, ${a}px, ${u}px)`));
    let f;
    const p = t.maxTranslate() - t.minTranslate();
    p === 0 ? (f = 0) : (f = (s - t.minTranslate()) / p), f !== d && t.updateProgress(s), t.emit("setTranslate", t.translate, e);
}
function Ht() {
    return -this.snapGrid[0];
}
function qt() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function _t(s, e, t, i, n) {
    s === void 0 && (s = 0), e === void 0 && (e = this.params.speed), t === void 0 && (t = !0), i === void 0 && (i = !0);
    const r = this,
        { params: d, wrapperEl: c } = r;
    if (r.animating && d.preventInteractionOnTransition) return !1;
    const a = r.minTranslate(),
        u = r.maxTranslate();
    let f;
    if ((i && s > a ? (f = a) : i && s < u ? (f = u) : (f = s), r.updateProgress(f), d.cssMode)) {
        const p = r.isHorizontal();
        if (e === 0) c[p ? "scrollLeft" : "scrollTop"] = -f;
        else {
            if (!r.support.smoothScroll) return st({ swiper: r, targetPosition: -f, side: p ? "left" : "top" }), !0;
            c.scrollTo({ [p ? "left" : "top"]: -f, behavior: "smooth" });
        }
        return !0;
    }
    return (
        e === 0
            ? (r.setTransition(0), r.setTranslate(f), t && (r.emit("beforeTransitionStart", e, n), r.emit("transitionEnd")))
            : (r.setTransition(e),
              r.setTranslate(f),
              t && (r.emit("beforeTransitionStart", e, n), r.emit("transitionStart")),
              r.animating ||
                  ((r.animating = !0),
                  r.onTranslateToWrapperTransitionEnd ||
                      (r.onTranslateToWrapperTransitionEnd = function (v) {
                          !r ||
                              r.destroyed ||
                              (v.target === this &&
                                  (r.wrapperEl.removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd),
                                  (r.onTranslateToWrapperTransitionEnd = null),
                                  delete r.onTranslateToWrapperTransitionEnd,
                                  (r.animating = !1),
                                  t && r.emit("transitionEnd")));
                      }),
                  r.wrapperEl.addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd))),
        !0
    );
}
var Gt = { getTranslate: kt, setTranslate: Bt, minTranslate: Ht, maxTranslate: qt, translateTo: _t };
function Vt(s, e) {
    const t = this;
    t.params.cssMode || ((t.wrapperEl.style.transitionDuration = `${s}ms`), (t.wrapperEl.style.transitionDelay = s === 0 ? "0ms" : "")), t.emit("setTransition", s, e);
}
function nt(s) {
    let { swiper: e, runCallbacks: t, direction: i, step: n } = s;
    const { activeIndex: r, previousIndex: d } = e;
    let c = i;
    if ((c || (r > d ? (c = "next") : r < d ? (c = "prev") : (c = "reset")), e.emit(`transition${n}`), t && r !== d)) {
        if (c === "reset") {
            e.emit(`slideResetTransition${n}`);
            return;
        }
        e.emit(`slideChangeTransition${n}`), c === "next" ? e.emit(`slideNextTransition${n}`) : e.emit(`slidePrevTransition${n}`);
    }
}
function Rt(s, e) {
    s === void 0 && (s = !0);
    const t = this,
        { params: i } = t;
    i.cssMode || (i.autoHeight && t.updateAutoHeight(), nt({ swiper: t, runCallbacks: s, direction: e, step: "Start" }));
}
function Xt(s, e) {
    s === void 0 && (s = !0);
    const t = this,
        { params: i } = t;
    (t.animating = !1), !i.cssMode && (t.setTransition(0), nt({ swiper: t, runCallbacks: s, direction: e, step: "End" }));
}
var Yt = { setTransition: Vt, transitionStart: Rt, transitionEnd: Xt };
function Nt(s, e, t, i, n) {
    s === void 0 && (s = 0), t === void 0 && (t = !0), typeof s == "string" && (s = parseInt(s, 10));
    const r = this;
    let d = s;
    d < 0 && (d = 0);
    const { params: c, snapGrid: a, slidesGrid: u, previousIndex: f, activeIndex: p, rtlTranslate: v, wrapperEl: m, enabled: l } = r;
    if ((!l && !i && !n) || r.destroyed || (r.animating && c.preventInteractionOnTransition)) return !1;
    typeof e > "u" && (e = r.params.speed);
    const o = Math.min(r.params.slidesPerGroupSkip, d);
    let w = o + Math.floor((d - o) / r.params.slidesPerGroup);
    w >= a.length && (w = a.length - 1);
    const y = -a[w];
    if (c.normalizeSlideIndex)
        for (let b = 0; b < u.length; b += 1) {
            const z = -Math.floor(y * 100),
                $ = Math.floor(u[b] * 100),
                O = Math.floor(u[b + 1] * 100);
            typeof u[b + 1] < "u" ? (z >= $ && z < O - (O - $) / 2 ? (d = b) : z >= $ && z < O && (d = b + 1)) : z >= $ && (d = b);
        }
    if (r.initialized && d !== p && ((!r.allowSlideNext && (v ? y > r.translate && y > r.minTranslate() : y < r.translate && y < r.minTranslate())) || (!r.allowSlidePrev && y > r.translate && y > r.maxTranslate() && (p || 0) !== d)))
        return !1;
    d !== (f || 0) && t && r.emit("beforeSlideChangeStart"), r.updateProgress(y);
    let g;
    d > p ? (g = "next") : d < p ? (g = "prev") : (g = "reset");
    const h = r.virtual && r.params.virtual.enabled;
    if (!(h && n) && ((v && -y === r.translate) || (!v && y === r.translate)))
        return r.updateActiveIndex(d), c.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), c.effect !== "slide" && r.setTranslate(y), g !== "reset" && (r.transitionStart(t, g), r.transitionEnd(t, g)), !1;
    if (c.cssMode) {
        const b = r.isHorizontal(),
            z = v ? y : -y;
        if (e === 0)
            h && ((r.wrapperEl.style.scrollSnapType = "none"), (r._immediateVirtual = !0)),
                h && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0
                    ? ((r._cssModeVirtualInitialSet = !0),
                      requestAnimationFrame(() => {
                          m[b ? "scrollLeft" : "scrollTop"] = z;
                      }))
                    : (m[b ? "scrollLeft" : "scrollTop"] = z),
                h &&
                    requestAnimationFrame(() => {
                        (r.wrapperEl.style.scrollSnapType = ""), (r._immediateVirtual = !1);
                    });
        else {
            if (!r.support.smoothScroll) return st({ swiper: r, targetPosition: z, side: b ? "left" : "top" }), !0;
            m.scrollTo({ [b ? "left" : "top"]: z, behavior: "smooth" });
        }
        return !0;
    }
    return (
        r.setTransition(e),
        r.setTranslate(y),
        r.updateActiveIndex(d),
        r.updateSlidesClasses(),
        r.emit("beforeTransitionStart", e, i),
        r.transitionStart(t, g),
        e === 0
            ? r.transitionEnd(t, g)
            : r.animating ||
              ((r.animating = !0),
              r.onSlideToWrapperTransitionEnd ||
                  (r.onSlideToWrapperTransitionEnd = function (z) {
                      !r ||
                          r.destroyed ||
                          (z.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd), (r.onSlideToWrapperTransitionEnd = null), delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(t, g)));
                  }),
              r.wrapperEl.addEventListener("transitionend", r.onSlideToWrapperTransitionEnd)),
        !0
    );
}
function Ft(s, e, t, i) {
    s === void 0 && (s = 0), t === void 0 && (t = !0), typeof s == "string" && (s = parseInt(s, 10));
    const n = this;
    if (n.destroyed) return;
    typeof e > "u" && (e = n.params.speed);
    const r = n.grid && n.params.grid && n.params.grid.rows > 1;
    let d = s;
    if (n.params.loop)
        if (n.virtual && n.params.virtual.enabled) d = d + n.virtual.slidesBefore;
        else {
            let c;
            if (r) {
                const v = d * n.params.grid.rows;
                c = n.slides.find((m) => m.getAttribute("data-swiper-slide-index") * 1 === v).column;
            } else c = n.getSlideIndexByData(d);
            const a = r ? Math.ceil(n.slides.length / n.params.grid.rows) : n.slides.length,
                { centeredSlides: u } = n.params;
            let f = n.params.slidesPerView;
            f === "auto" ? (f = n.slidesPerViewDynamic()) : ((f = Math.ceil(parseFloat(n.params.slidesPerView, 10))), u && f % 2 === 0 && (f = f + 1));
            let p = a - c < f;
            if ((u && (p = p || c < Math.ceil(f / 2)), i && u && n.params.slidesPerView !== "auto" && !r && (p = !1), p)) {
                const v = u ? (c < n.activeIndex ? "prev" : "next") : c - n.activeIndex - 1 < n.params.slidesPerView ? "next" : "prev";
                n.loopFix({ direction: v, slideTo: !0, activeSlideIndex: v === "next" ? c + 1 : c - a + 1, slideRealIndex: v === "next" ? n.realIndex : void 0 });
            }
            if (r) {
                const v = d * n.params.grid.rows;
                d = n.slides.find((m) => m.getAttribute("data-swiper-slide-index") * 1 === v).column;
            } else d = n.getSlideIndexByData(d);
        }
    return (
        requestAnimationFrame(() => {
            n.slideTo(d, e, t, i);
        }),
        n
    );
}
function Wt(s, e, t) {
    e === void 0 && (e = !0);
    const i = this,
        { enabled: n, params: r, animating: d } = i;
    if (!n || i.destroyed) return i;
    typeof s > "u" && (s = i.params.speed);
    let c = r.slidesPerGroup;
    r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (c = Math.max(i.slidesPerViewDynamic("current", !0), 1));
    const a = i.activeIndex < r.slidesPerGroupSkip ? 1 : c,
        u = i.virtual && r.virtual.enabled;
    if (r.loop) {
        if (d && !u && r.loopPreventsSliding) return !1;
        if ((i.loopFix({ direction: "next" }), (i._clientLeft = i.wrapperEl.clientLeft), i.activeIndex === i.slides.length - 1 && r.cssMode))
            return (
                requestAnimationFrame(() => {
                    i.slideTo(i.activeIndex + a, s, e, t);
                }),
                !0
            );
    }
    return r.rewind && i.isEnd ? i.slideTo(0, s, e, t) : i.slideTo(i.activeIndex + a, s, e, t);
}
function jt(s, e, t) {
    e === void 0 && (e = !0);
    const i = this,
        { params: n, snapGrid: r, slidesGrid: d, rtlTranslate: c, enabled: a, animating: u } = i;
    if (!a || i.destroyed) return i;
    typeof s > "u" && (s = i.params.speed);
    const f = i.virtual && n.virtual.enabled;
    if (n.loop) {
        if (u && !f && n.loopPreventsSliding) return !1;
        i.loopFix({ direction: "prev" }), (i._clientLeft = i.wrapperEl.clientLeft);
    }
    const p = c ? i.translate : -i.translate;
    function v(y) {
        return y < 0 ? -Math.floor(Math.abs(y)) : Math.floor(y);
    }
    const m = v(p),
        l = r.map((y) => v(y));
    let o = r[l.indexOf(m) - 1];
    if (typeof o > "u" && n.cssMode) {
        let y;
        r.forEach((g, h) => {
            m >= g && (y = h);
        }),
            typeof y < "u" && (o = r[y > 0 ? y - 1 : y]);
    }
    let w = 0;
    if (
        (typeof o < "u" && ((w = d.indexOf(o)), w < 0 && (w = i.activeIndex - 1), n.slidesPerView === "auto" && n.slidesPerGroup === 1 && n.slidesPerGroupAuto && ((w = w - i.slidesPerViewDynamic("previous", !0) + 1), (w = Math.max(w, 0)))),
        n.rewind && i.isBeginning)
    ) {
        const y = i.params.virtual && i.params.virtual.enabled && i.virtual ? i.virtual.slides.length - 1 : i.slides.length - 1;
        return i.slideTo(y, s, e, t);
    } else if (n.loop && i.activeIndex === 0 && n.cssMode)
        return (
            requestAnimationFrame(() => {
                i.slideTo(w, s, e, t);
            }),
            !0
        );
    return i.slideTo(w, s, e, t);
}
function Ut(s, e, t) {
    e === void 0 && (e = !0);
    const i = this;
    if (!i.destroyed) return typeof s > "u" && (s = i.params.speed), i.slideTo(i.activeIndex, s, e, t);
}
function Kt(s, e, t, i) {
    e === void 0 && (e = !0), i === void 0 && (i = 0.5);
    const n = this;
    if (n.destroyed) return;
    typeof s > "u" && (s = n.params.speed);
    let r = n.activeIndex;
    const d = Math.min(n.params.slidesPerGroupSkip, r),
        c = d + Math.floor((r - d) / n.params.slidesPerGroup),
        a = n.rtlTranslate ? n.translate : -n.translate;
    if (a >= n.snapGrid[c]) {
        const u = n.snapGrid[c],
            f = n.snapGrid[c + 1];
        a - u > (f - u) * i && (r += n.params.slidesPerGroup);
    } else {
        const u = n.snapGrid[c - 1],
            f = n.snapGrid[c];
        a - u <= (f - u) * i && (r -= n.params.slidesPerGroup);
    }
    return (r = Math.max(r, 0)), (r = Math.min(r, n.slidesGrid.length - 1)), n.slideTo(r, s, e, t);
}
function Zt() {
    const s = this;
    if (s.destroyed) return;
    const { params: e, slidesEl: t } = s,
        i = e.slidesPerView === "auto" ? s.slidesPerViewDynamic() : e.slidesPerView;
    let n = s.clickedIndex,
        r;
    const d = s.isElement ? "swiper-slide" : `.${e.slideClass}`;
    if (e.loop) {
        if (s.animating) return;
        (r = parseInt(s.clickedSlide.getAttribute("data-swiper-slide-index"), 10)),
            e.centeredSlides
                ? n < s.loopedSlides - i / 2 || n > s.slides.length - s.loopedSlides + i / 2
                    ? (s.loopFix(),
                      (n = s.getSlideIndex(W(t, `${d}[data-swiper-slide-index="${r}"]`)[0])),
                      de(() => {
                          s.slideTo(n);
                      }))
                    : s.slideTo(n)
                : n > s.slides.length - i
                ? (s.loopFix(),
                  (n = s.getSlideIndex(W(t, `${d}[data-swiper-slide-index="${r}"]`)[0])),
                  de(() => {
                      s.slideTo(n);
                  }))
                : s.slideTo(n);
    } else s.slideTo(n);
}
var Qt = { slideTo: Nt, slideToLoop: Ft, slideNext: Wt, slidePrev: jt, slideReset: Ut, slideToClosest: Kt, slideToClickedSlide: Zt };
function Jt(s) {
    const e = this,
        { params: t, slidesEl: i } = e;
    if (!t.loop || (e.virtual && e.params.virtual.enabled)) return;
    const n = () => {
            W(i, `.${t.slideClass}, swiper-slide`).forEach((p, v) => {
                p.setAttribute("data-swiper-slide-index", v);
            });
        },
        r = e.grid && t.grid && t.grid.rows > 1,
        d = t.slidesPerGroup * (r ? t.grid.rows : 1),
        c = e.slides.length % d !== 0,
        a = r && e.slides.length % t.grid.rows !== 0,
        u = (f) => {
            for (let p = 0; p < f; p += 1) {
                const v = e.isElement ? Z("swiper-slide", [t.slideBlankClass]) : Z("div", [t.slideClass, t.slideBlankClass]);
                e.slidesEl.append(v);
            }
        };
    if (c) {
        if (t.loopAddBlankSlides) {
            const f = d - (e.slides.length % d);
            u(f), e.recalcSlides(), e.updateSlides();
        } else Le("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        n();
    } else if (a) {
        if (t.loopAddBlankSlides) {
            const f = t.grid.rows - (e.slides.length % t.grid.rows);
            u(f), e.recalcSlides(), e.updateSlides();
        } else Le("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        n();
    } else n();
    e.loopFix({ slideRealIndex: s, direction: t.centeredSlides ? void 0 : "next" });
}
function es(s) {
    let { slideRealIndex: e, slideTo: t = !0, direction: i, setTranslate: n, activeSlideIndex: r, byController: d, byMousewheel: c } = s === void 0 ? {} : s;
    const a = this;
    if (!a.params.loop) return;
    a.emit("beforeLoopFix");
    const { slides: u, allowSlidePrev: f, allowSlideNext: p, slidesEl: v, params: m } = a,
        { centeredSlides: l } = m;
    if (((a.allowSlidePrev = !0), (a.allowSlideNext = !0), a.virtual && m.virtual.enabled)) {
        t &&
            (!m.centeredSlides && a.snapIndex === 0
                ? a.slideTo(a.virtual.slides.length, 0, !1, !0)
                : m.centeredSlides && a.snapIndex < m.slidesPerView
                ? a.slideTo(a.virtual.slides.length + a.snapIndex, 0, !1, !0)
                : a.snapIndex === a.snapGrid.length - 1 && a.slideTo(a.virtual.slidesBefore, 0, !1, !0)),
            (a.allowSlidePrev = f),
            (a.allowSlideNext = p),
            a.emit("loopFix");
        return;
    }
    let o = m.slidesPerView;
    o === "auto" ? (o = a.slidesPerViewDynamic()) : ((o = Math.ceil(parseFloat(m.slidesPerView, 10))), l && o % 2 === 0 && (o = o + 1));
    const w = m.slidesPerGroupAuto ? o : m.slidesPerGroup;
    let y = w;
    y % w !== 0 && (y += w - (y % w)), (y += m.loopAdditionalSlides), (a.loopedSlides = y);
    const g = a.grid && m.grid && m.grid.rows > 1;
    u.length < o + y
        ? Le(
              "Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters"
          )
        : g && m.grid.fill === "row" && Le("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const h = [],
        S = [];
    let b = a.activeIndex;
    typeof r > "u" ? (r = a.getSlideIndex(u.find((E) => E.classList.contains(m.slideActiveClass)))) : (b = r);
    const z = i === "next" || !i,
        $ = i === "prev" || !i;
    let O = 0,
        P = 0;
    const L = g ? Math.ceil(u.length / m.grid.rows) : u.length,
        M = (g ? u[r].column : r) + (l && typeof n > "u" ? -o / 2 + 0.5 : 0);
    if (M < y) {
        O = Math.max(y - M, w);
        for (let E = 0; E < y - M; E += 1) {
            const x = E - Math.floor(E / L) * L;
            if (g) {
                const D = L - x - 1;
                for (let q = u.length - 1; q >= 0; q -= 1) u[q].column === D && h.push(q);
            } else h.push(L - x - 1);
        }
    } else if (M + o > L - y) {
        P = Math.max(M - (L - y * 2), w);
        for (let E = 0; E < P; E += 1) {
            const x = E - Math.floor(E / L) * L;
            g
                ? u.forEach((D, q) => {
                      D.column === x && S.push(q);
                  })
                : S.push(x);
        }
    }
    if (
        ((a.__preventObserver__ = !0),
        requestAnimationFrame(() => {
            a.__preventObserver__ = !1;
        }),
        $ &&
            h.forEach((E) => {
                (u[E].swiperLoopMoveDOM = !0), v.prepend(u[E]), (u[E].swiperLoopMoveDOM = !1);
            }),
        z &&
            S.forEach((E) => {
                (u[E].swiperLoopMoveDOM = !0), v.append(u[E]), (u[E].swiperLoopMoveDOM = !1);
            }),
        a.recalcSlides(),
        m.slidesPerView === "auto"
            ? a.updateSlides()
            : g &&
              ((h.length > 0 && $) || (S.length > 0 && z)) &&
              a.slides.forEach((E, x) => {
                  a.grid.updateSlide(x, E, a.slides);
              }),
        m.watchSlidesProgress && a.updateSlidesOffset(),
        t)
    ) {
        if (h.length > 0 && $) {
            if (typeof e > "u") {
                const E = a.slidesGrid[b],
                    D = a.slidesGrid[b + O] - E;
                c
                    ? a.setTranslate(a.translate - D)
                    : (a.slideTo(b + Math.ceil(O), 0, !1, !0), n && ((a.touchEventsData.startTranslate = a.touchEventsData.startTranslate - D), (a.touchEventsData.currentTranslate = a.touchEventsData.currentTranslate - D)));
            } else if (n) {
                const E = g ? h.length / m.grid.rows : h.length;
                a.slideTo(a.activeIndex + E, 0, !1, !0), (a.touchEventsData.currentTranslate = a.translate);
            }
        } else if (S.length > 0 && z)
            if (typeof e > "u") {
                const E = a.slidesGrid[b],
                    D = a.slidesGrid[b - P] - E;
                c
                    ? a.setTranslate(a.translate - D)
                    : (a.slideTo(b - P, 0, !1, !0), n && ((a.touchEventsData.startTranslate = a.touchEventsData.startTranslate - D), (a.touchEventsData.currentTranslate = a.touchEventsData.currentTranslate - D)));
            } else {
                const E = g ? S.length / m.grid.rows : S.length;
                a.slideTo(a.activeIndex - E, 0, !1, !0);
            }
    }
    if (((a.allowSlidePrev = f), (a.allowSlideNext = p), a.controller && a.controller.control && !d)) {
        const E = { slideRealIndex: e, direction: i, setTranslate: n, activeSlideIndex: r, byController: !0 };
        Array.isArray(a.controller.control)
            ? a.controller.control.forEach((x) => {
                  !x.destroyed && x.params.loop && x.loopFix({ ...E, slideTo: x.params.slidesPerView === m.slidesPerView ? t : !1 });
              })
            : a.controller.control instanceof a.constructor && a.controller.control.params.loop && a.controller.control.loopFix({ ...E, slideTo: a.controller.control.params.slidesPerView === m.slidesPerView ? t : !1 });
    }
    a.emit("loopFix");
}
function ts() {
    const s = this,
        { params: e, slidesEl: t } = s;
    if (!e.loop || (s.virtual && s.params.virtual.enabled)) return;
    s.recalcSlides();
    const i = [];
    s.slides.forEach((n) => {
        const r = typeof n.swiperSlideIndex > "u" ? n.getAttribute("data-swiper-slide-index") * 1 : n.swiperSlideIndex;
        i[r] = n;
    }),
        s.slides.forEach((n) => {
            n.removeAttribute("data-swiper-slide-index");
        }),
        i.forEach((n) => {
            t.append(n);
        }),
        s.recalcSlides(),
        s.slideTo(s.realIndex, 0);
}
var ss = { loopCreate: Jt, loopFix: es, loopDestroy: ts };
function is(s) {
    const e = this;
    if (!e.params.simulateTouch || (e.params.watchOverflow && e.isLocked) || e.params.cssMode) return;
    const t = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
    e.isElement && (e.__preventObserver__ = !0),
        (t.style.cursor = "move"),
        (t.style.cursor = s ? "grabbing" : "grab"),
        e.isElement &&
            requestAnimationFrame(() => {
                e.__preventObserver__ = !1;
            });
}
function rs() {
    const s = this;
    (s.params.watchOverflow && s.isLocked) ||
        s.params.cssMode ||
        (s.isElement && (s.__preventObserver__ = !0),
        (s[s.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = ""),
        s.isElement &&
            requestAnimationFrame(() => {
                s.__preventObserver__ = !1;
            }));
}
var ns = { setGrabCursor: is, unsetGrabCursor: rs };
function as(s, e) {
    e === void 0 && (e = this);
    function t(i) {
        if (!i || i === N() || i === R()) return null;
        i.assignedSlot && (i = i.assignedSlot);
        const n = i.closest(s);
        return !n && !i.getRootNode ? null : n || t(i.getRootNode().host);
    }
    return t(e);
}
function Ze(s, e, t) {
    const i = R(),
        { params: n } = s,
        r = n.edgeSwipeDetection,
        d = n.edgeSwipeThreshold;
    return r && (t <= d || t >= i.innerWidth - d) ? (r === "prevent" ? (e.preventDefault(), !0) : !1) : !0;
}
function ls(s) {
    const e = this,
        t = N();
    let i = s;
    i.originalEvent && (i = i.originalEvent);
    const n = e.touchEventsData;
    if (i.type === "pointerdown") {
        if (n.pointerId !== null && n.pointerId !== i.pointerId) return;
        n.pointerId = i.pointerId;
    } else i.type === "touchstart" && i.targetTouches.length === 1 && (n.touchId = i.targetTouches[0].identifier);
    if (i.type === "touchstart") {
        Ze(e, i, i.targetTouches[0].pageX);
        return;
    }
    const { params: r, touches: d, enabled: c } = e;
    if (!c || (!r.simulateTouch && i.pointerType === "mouse") || (e.animating && r.preventInteractionOnTransition)) return;
    !e.animating && r.cssMode && r.loop && e.loopFix();
    let a = i.target;
    if ((r.touchEventsTarget === "wrapper" && !mt(a, e.wrapperEl)) || ("which" in i && i.which === 3) || ("button" in i && i.button > 0) || (n.isTouched && n.isMoved)) return;
    const u = !!r.noSwipingClass && r.noSwipingClass !== "",
        f = i.composedPath ? i.composedPath() : i.path;
    u && i.target && i.target.shadowRoot && f && (a = f[0]);
    const p = r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`,
        v = !!(i.target && i.target.shadowRoot);
    if (r.noSwiping && (v ? as(p, a) : a.closest(p))) {
        e.allowClick = !0;
        return;
    }
    if (r.swipeHandler && !a.closest(r.swipeHandler)) return;
    (d.currentX = i.pageX), (d.currentY = i.pageY);
    const m = d.currentX,
        l = d.currentY;
    if (!Ze(e, i, m)) return;
    Object.assign(n, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }),
        (d.startX = m),
        (d.startY = l),
        (n.touchStartTime = Q()),
        (e.allowClick = !0),
        e.updateSize(),
        (e.swipeDirection = void 0),
        r.threshold > 0 && (n.allowThresholdMove = !1);
    let o = !0;
    a.matches(n.focusableElements) && ((o = !1), a.nodeName === "SELECT" && (n.isTouched = !1)),
        t.activeElement && t.activeElement.matches(n.focusableElements) && t.activeElement !== a && (i.pointerType === "mouse" || (i.pointerType !== "mouse" && !a.matches(n.focusableElements))) && t.activeElement.blur();
    const w = o && e.allowTouchMove && r.touchStartPreventDefault;
    (r.touchStartForcePreventDefault || w) && !a.isContentEditable && i.preventDefault(), r.freeMode && r.freeMode.enabled && e.freeMode && e.animating && !r.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", i);
}
function os(s) {
    const e = N(),
        t = this,
        i = t.touchEventsData,
        { params: n, touches: r, rtlTranslate: d, enabled: c } = t;
    if (!c || (!n.simulateTouch && s.pointerType === "mouse")) return;
    let a = s;
    if ((a.originalEvent && (a = a.originalEvent), a.type === "pointermove" && (i.touchId !== null || a.pointerId !== i.pointerId))) return;
    let u;
    if (a.type === "touchmove") {
        if (((u = [...a.changedTouches].find((b) => b.identifier === i.touchId)), !u || u.identifier !== i.touchId)) return;
    } else u = a;
    if (!i.isTouched) {
        i.startMoving && i.isScrolling && t.emit("touchMoveOpposite", a);
        return;
    }
    const f = u.pageX,
        p = u.pageY;
    if (a.preventedByNestedSwiper) {
        (r.startX = f), (r.startY = p);
        return;
    }
    if (!t.allowTouchMove) {
        a.target.matches(i.focusableElements) || (t.allowClick = !1), i.isTouched && (Object.assign(r, { startX: f, startY: p, currentX: f, currentY: p }), (i.touchStartTime = Q()));
        return;
    }
    if (n.touchReleaseOnEdges && !n.loop) {
        if (t.isVertical()) {
            if ((p < r.startY && t.translate <= t.maxTranslate()) || (p > r.startY && t.translate >= t.minTranslate())) {
                (i.isTouched = !1), (i.isMoved = !1);
                return;
            }
        } else if ((f < r.startX && t.translate <= t.maxTranslate()) || (f > r.startX && t.translate >= t.minTranslate())) return;
    }
    if (
        (e.activeElement && e.activeElement.matches(i.focusableElements) && e.activeElement !== a.target && a.pointerType !== "mouse" && e.activeElement.blur(),
        e.activeElement && a.target === e.activeElement && a.target.matches(i.focusableElements))
    ) {
        (i.isMoved = !0), (t.allowClick = !1);
        return;
    }
    i.allowTouchCallbacks && t.emit("touchMove", a), (r.previousX = r.currentX), (r.previousY = r.currentY), (r.currentX = f), (r.currentY = p);
    const v = r.currentX - r.startX,
        m = r.currentY - r.startY;
    if (t.params.threshold && Math.sqrt(v ** 2 + m ** 2) < t.params.threshold) return;
    if (typeof i.isScrolling > "u") {
        let b;
        (t.isHorizontal() && r.currentY === r.startY) || (t.isVertical() && r.currentX === r.startX)
            ? (i.isScrolling = !1)
            : v * v + m * m >= 25 && ((b = (Math.atan2(Math.abs(m), Math.abs(v)) * 180) / Math.PI), (i.isScrolling = t.isHorizontal() ? b > n.touchAngle : 90 - b > n.touchAngle));
    }
    if (
        (i.isScrolling && t.emit("touchMoveOpposite", a),
        typeof i.startMoving > "u" && (r.currentX !== r.startX || r.currentY !== r.startY) && (i.startMoving = !0),
        i.isScrolling || (a.type === "touchmove" && i.preventTouchMoveFromPointerMove))
    ) {
        i.isTouched = !1;
        return;
    }
    if (!i.startMoving) return;
    (t.allowClick = !1), !n.cssMode && a.cancelable && a.preventDefault(), n.touchMoveStopPropagation && !n.nested && a.stopPropagation();
    let l = t.isHorizontal() ? v : m,
        o = t.isHorizontal() ? r.currentX - r.previousX : r.currentY - r.previousY;
    n.oneWayMovement && ((l = Math.abs(l) * (d ? 1 : -1)), (o = Math.abs(o) * (d ? 1 : -1))), (r.diff = l), (l *= n.touchRatio), d && ((l = -l), (o = -o));
    const w = t.touchesDirection;
    (t.swipeDirection = l > 0 ? "prev" : "next"), (t.touchesDirection = o > 0 ? "prev" : "next");
    const y = t.params.loop && !n.cssMode,
        g = (t.touchesDirection === "next" && t.allowSlideNext) || (t.touchesDirection === "prev" && t.allowSlidePrev);
    if (!i.isMoved) {
        if ((y && g && t.loopFix({ direction: t.swipeDirection }), (i.startTranslate = t.getTranslate()), t.setTransition(0), t.animating)) {
            const b = new window.CustomEvent("transitionend", { bubbles: !0, cancelable: !0, detail: { bySwiperTouchMove: !0 } });
            t.wrapperEl.dispatchEvent(b);
        }
        (i.allowMomentumBounce = !1), n.grabCursor && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!0), t.emit("sliderFirstMove", a);
    }
    if ((new Date().getTime(), i.isMoved && i.allowThresholdMove && w !== t.touchesDirection && y && g && Math.abs(l) >= 1)) {
        Object.assign(r, { startX: f, startY: p, currentX: f, currentY: p, startTranslate: i.currentTranslate }), (i.loopSwapReset = !0), (i.startTranslate = i.currentTranslate);
        return;
    }
    t.emit("sliderMove", a), (i.isMoved = !0), (i.currentTranslate = l + i.startTranslate);
    let h = !0,
        S = n.resistanceRatio;
    if (
        (n.touchReleaseOnEdges && (S = 0),
        l > 0
            ? (y &&
                  g &&
                  i.allowThresholdMove &&
                  i.currentTranslate >
                      (n.centeredSlides
                          ? t.minTranslate() -
                            t.slidesSizesGrid[t.activeIndex + 1] -
                            (n.slidesPerView !== "auto" && t.slides.length - n.slidesPerView >= 2 ? t.slidesSizesGrid[t.activeIndex + 1] + t.params.spaceBetween : 0) -
                            t.params.spaceBetween
                          : t.minTranslate()) &&
                  t.loopFix({ direction: "prev", setTranslate: !0, activeSlideIndex: 0 }),
              i.currentTranslate > t.minTranslate() && ((h = !1), n.resistance && (i.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + i.startTranslate + l) ** S)))
            : l < 0 &&
              (y &&
                  g &&
                  i.allowThresholdMove &&
                  i.currentTranslate <
                      (n.centeredSlides
                          ? t.maxTranslate() +
                            t.slidesSizesGrid[t.slidesSizesGrid.length - 1] +
                            t.params.spaceBetween +
                            (n.slidesPerView !== "auto" && t.slides.length - n.slidesPerView >= 2 ? t.slidesSizesGrid[t.slidesSizesGrid.length - 1] + t.params.spaceBetween : 0)
                          : t.maxTranslate()) &&
                  t.loopFix({ direction: "next", setTranslate: !0, activeSlideIndex: t.slides.length - (n.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(parseFloat(n.slidesPerView, 10))) }),
              i.currentTranslate < t.maxTranslate() && ((h = !1), n.resistance && (i.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - i.startTranslate - l) ** S))),
        h && (a.preventedByNestedSwiper = !0),
        !t.allowSlideNext && t.swipeDirection === "next" && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate),
        !t.allowSlidePrev && t.swipeDirection === "prev" && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate),
        !t.allowSlidePrev && !t.allowSlideNext && (i.currentTranslate = i.startTranslate),
        n.threshold > 0)
    )
        if (Math.abs(l) > n.threshold || i.allowThresholdMove) {
            if (!i.allowThresholdMove) {
                (i.allowThresholdMove = !0), (r.startX = r.currentX), (r.startY = r.currentY), (i.currentTranslate = i.startTranslate), (r.diff = t.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY);
                return;
            }
        } else {
            i.currentTranslate = i.startTranslate;
            return;
        }
    !n.followFinger ||
        n.cssMode ||
        (((n.freeMode && n.freeMode.enabled && t.freeMode) || n.watchSlidesProgress) && (t.updateActiveIndex(), t.updateSlidesClasses()),
        n.freeMode && n.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(),
        t.updateProgress(i.currentTranslate),
        t.setTranslate(i.currentTranslate));
}
function ds(s) {
    const e = this,
        t = e.touchEventsData;
    let i = s;
    i.originalEvent && (i = i.originalEvent);
    let n;
    if (i.type === "touchend" || i.type === "touchcancel") {
        if (((n = [...i.changedTouches].find((b) => b.identifier === t.touchId)), !n || n.identifier !== t.touchId)) return;
    } else {
        if (t.touchId !== null || i.pointerId !== t.pointerId) return;
        n = i;
    }
    if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(i.type) && !(["pointercancel", "contextmenu"].includes(i.type) && (e.browser.isSafari || e.browser.isWebView))) return;
    (t.pointerId = null), (t.touchId = null);
    const { params: d, touches: c, rtlTranslate: a, slidesGrid: u, enabled: f } = e;
    if (!f || (!d.simulateTouch && i.pointerType === "mouse")) return;
    if ((t.allowTouchCallbacks && e.emit("touchEnd", i), (t.allowTouchCallbacks = !1), !t.isTouched)) {
        t.isMoved && d.grabCursor && e.setGrabCursor(!1), (t.isMoved = !1), (t.startMoving = !1);
        return;
    }
    d.grabCursor && t.isMoved && t.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
    const p = Q(),
        v = p - t.touchStartTime;
    if (e.allowClick) {
        const b = i.path || (i.composedPath && i.composedPath());
        e.updateClickedSlide((b && b[0]) || i.target, b), e.emit("tap click", i), v < 300 && p - t.lastClickTime < 300 && e.emit("doubleTap doubleClick", i);
    }
    if (
        ((t.lastClickTime = Q()),
        de(() => {
            e.destroyed || (e.allowClick = !0);
        }),
        !t.isTouched || !t.isMoved || !e.swipeDirection || (c.diff === 0 && !t.loopSwapReset) || (t.currentTranslate === t.startTranslate && !t.loopSwapReset))
    ) {
        (t.isTouched = !1), (t.isMoved = !1), (t.startMoving = !1);
        return;
    }
    (t.isTouched = !1), (t.isMoved = !1), (t.startMoving = !1);
    let m;
    if ((d.followFinger ? (m = a ? e.translate : -e.translate) : (m = -t.currentTranslate), d.cssMode)) return;
    if (d.freeMode && d.freeMode.enabled) {
        e.freeMode.onTouchEnd({ currentPos: m });
        return;
    }
    const l = m >= -e.maxTranslate() && !e.params.loop;
    let o = 0,
        w = e.slidesSizesGrid[0];
    for (let b = 0; b < u.length; b += b < d.slidesPerGroupSkip ? 1 : d.slidesPerGroup) {
        const z = b < d.slidesPerGroupSkip - 1 ? 1 : d.slidesPerGroup;
        typeof u[b + z] < "u" ? (l || (m >= u[b] && m < u[b + z])) && ((o = b), (w = u[b + z] - u[b])) : (l || m >= u[b]) && ((o = b), (w = u[u.length - 1] - u[u.length - 2]));
    }
    let y = null,
        g = null;
    d.rewind && (e.isBeginning ? (g = d.virtual && d.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1) : e.isEnd && (y = 0));
    const h = (m - u[o]) / w,
        S = o < d.slidesPerGroupSkip - 1 ? 1 : d.slidesPerGroup;
    if (v > d.longSwipesMs) {
        if (!d.longSwipes) {
            e.slideTo(e.activeIndex);
            return;
        }
        e.swipeDirection === "next" && (h >= d.longSwipesRatio ? e.slideTo(d.rewind && e.isEnd ? y : o + S) : e.slideTo(o)),
            e.swipeDirection === "prev" && (h > 1 - d.longSwipesRatio ? e.slideTo(o + S) : g !== null && h < 0 && Math.abs(h) > d.longSwipesRatio ? e.slideTo(g) : e.slideTo(o));
    } else {
        if (!d.shortSwipes) {
            e.slideTo(e.activeIndex);
            return;
        }
        e.navigation && (i.target === e.navigation.nextEl || i.target === e.navigation.prevEl)
            ? i.target === e.navigation.nextEl
                ? e.slideTo(o + S)
                : e.slideTo(o)
            : (e.swipeDirection === "next" && e.slideTo(y !== null ? y : o + S), e.swipeDirection === "prev" && e.slideTo(g !== null ? g : o));
    }
}
function Qe() {
    const s = this,
        { params: e, el: t } = s;
    if (t && t.offsetWidth === 0) return;
    e.breakpoints && s.setBreakpoint();
    const { allowSlideNext: i, allowSlidePrev: n, snapGrid: r } = s,
        d = s.virtual && s.params.virtual.enabled;
    (s.allowSlideNext = !0), (s.allowSlidePrev = !0), s.updateSize(), s.updateSlides(), s.updateSlidesClasses();
    const c = d && e.loop;
    (e.slidesPerView === "auto" || e.slidesPerView > 1) && s.isEnd && !s.isBeginning && !s.params.centeredSlides && !c
        ? s.slideTo(s.slides.length - 1, 0, !1, !0)
        : s.params.loop && !d
        ? s.slideToLoop(s.realIndex, 0, !1, !0)
        : s.slideTo(s.activeIndex, 0, !1, !0),
        s.autoplay &&
            s.autoplay.running &&
            s.autoplay.paused &&
            (clearTimeout(s.autoplay.resizeTimeout),
            (s.autoplay.resizeTimeout = setTimeout(() => {
                s.autoplay && s.autoplay.running && s.autoplay.paused && s.autoplay.resume();
            }, 500))),
        (s.allowSlidePrev = n),
        (s.allowSlideNext = i),
        s.params.watchOverflow && r !== s.snapGrid && s.checkOverflow();
}
function cs(s) {
    const e = this;
    e.enabled && (e.allowClick || (e.params.preventClicks && s.preventDefault(), e.params.preventClicksPropagation && e.animating && (s.stopPropagation(), s.stopImmediatePropagation())));
}
function fs() {
    const s = this,
        { wrapperEl: e, rtlTranslate: t, enabled: i } = s;
    if (!i) return;
    (s.previousTranslate = s.translate), s.isHorizontal() ? (s.translate = -e.scrollLeft) : (s.translate = -e.scrollTop), s.translate === 0 && (s.translate = 0), s.updateActiveIndex(), s.updateSlidesClasses();
    let n;
    const r = s.maxTranslate() - s.minTranslate();
    r === 0 ? (n = 0) : (n = (s.translate - s.minTranslate()) / r), n !== s.progress && s.updateProgress(t ? -s.translate : s.translate), s.emit("setTranslate", s.translate, !1);
}
function us(s) {
    const e = this;
    Pe(e, s.target), !(e.params.cssMode || (e.params.slidesPerView !== "auto" && !e.params.autoHeight)) && e.update();
}
function ps() {
    const s = this;
    s.documentTouchHandlerProceeded || ((s.documentTouchHandlerProceeded = !0), s.params.touchReleaseOnEdges && (s.el.style.touchAction = "auto"));
}
const at = (s, e) => {
    const t = N(),
        { params: i, el: n, wrapperEl: r, device: d } = s,
        c = !!i.nested,
        a = e === "on" ? "addEventListener" : "removeEventListener",
        u = e;
    !n ||
        typeof n == "string" ||
        (t[a]("touchstart", s.onDocumentTouchStart, { passive: !1, capture: c }),
        n[a]("touchstart", s.onTouchStart, { passive: !1 }),
        n[a]("pointerdown", s.onTouchStart, { passive: !1 }),
        t[a]("touchmove", s.onTouchMove, { passive: !1, capture: c }),
        t[a]("pointermove", s.onTouchMove, { passive: !1, capture: c }),
        t[a]("touchend", s.onTouchEnd, { passive: !0 }),
        t[a]("pointerup", s.onTouchEnd, { passive: !0 }),
        t[a]("pointercancel", s.onTouchEnd, { passive: !0 }),
        t[a]("touchcancel", s.onTouchEnd, { passive: !0 }),
        t[a]("pointerout", s.onTouchEnd, { passive: !0 }),
        t[a]("pointerleave", s.onTouchEnd, { passive: !0 }),
        t[a]("contextmenu", s.onTouchEnd, { passive: !0 }),
        (i.preventClicks || i.preventClicksPropagation) && n[a]("click", s.onClick, !0),
        i.cssMode && r[a]("scroll", s.onScroll),
        i.updateOnWindowResize ? s[u](d.ios || d.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Qe, !0) : s[u]("observerUpdate", Qe, !0),
        n[a]("load", s.onLoad, { capture: !0 }));
};
function ms() {
    const s = this,
        { params: e } = s;
    (s.onTouchStart = ls.bind(s)), (s.onTouchMove = os.bind(s)), (s.onTouchEnd = ds.bind(s)), (s.onDocumentTouchStart = ps.bind(s)), e.cssMode && (s.onScroll = fs.bind(s)), (s.onClick = cs.bind(s)), (s.onLoad = us.bind(s)), at(s, "on");
}
function hs() {
    at(this, "off");
}
var gs = { attachEvents: ms, detachEvents: hs };
const Je = (s, e) => s.grid && e.grid && e.grid.rows > 1;
function vs() {
    const s = this,
        { realIndex: e, initialized: t, params: i, el: n } = s,
        r = i.breakpoints;
    if (!r || (r && Object.keys(r).length === 0)) return;
    const d = N(),
        c = i.breakpointsBase === "window" || !i.breakpointsBase ? i.breakpointsBase : "container",
        a = ["window", "container"].includes(i.breakpointsBase) || !i.breakpointsBase ? s.el : d.querySelector(i.breakpointsBase),
        u = s.getBreakpoint(r, c, a);
    if (!u || s.currentBreakpoint === u) return;
    const p = (u in r ? r[u] : void 0) || s.originalParams,
        v = Je(s, i),
        m = Je(s, p),
        l = s.params.grabCursor,
        o = p.grabCursor,
        w = i.enabled;
    v && !m
        ? (n.classList.remove(`${i.containerModifierClass}grid`, `${i.containerModifierClass}grid-column`), s.emitContainerClasses())
        : !v &&
          m &&
          (n.classList.add(`${i.containerModifierClass}grid`),
          ((p.grid.fill && p.grid.fill === "column") || (!p.grid.fill && i.grid.fill === "column")) && n.classList.add(`${i.containerModifierClass}grid-column`),
          s.emitContainerClasses()),
        l && !o ? s.unsetGrabCursor() : !l && o && s.setGrabCursor(),
        ["navigation", "pagination", "scrollbar"].forEach((z) => {
            if (typeof p[z] > "u") return;
            const $ = i[z] && i[z].enabled,
                O = p[z] && p[z].enabled;
            $ && !O && s[z].disable(), !$ && O && s[z].enable();
        });
    const y = p.direction && p.direction !== i.direction,
        g = i.loop && (p.slidesPerView !== i.slidesPerView || y),
        h = i.loop;
    y && t && s.changeDirection(), K(s.params, p);
    const S = s.params.enabled,
        b = s.params.loop;
    Object.assign(s, { allowTouchMove: s.params.allowTouchMove, allowSlideNext: s.params.allowSlideNext, allowSlidePrev: s.params.allowSlidePrev }),
        w && !S ? s.disable() : !w && S && s.enable(),
        (s.currentBreakpoint = u),
        s.emit("_beforeBreakpoint", p),
        t && (g ? (s.loopDestroy(), s.loopCreate(e), s.updateSlides()) : !h && b ? (s.loopCreate(e), s.updateSlides()) : h && !b && s.loopDestroy()),
        s.emit("breakpoint", p);
}
function ws(s, e, t) {
    if ((e === void 0 && (e = "window"), !s || (e === "container" && !t))) return;
    let i = !1;
    const n = R(),
        r = e === "window" ? n.innerHeight : t.clientHeight,
        d = Object.keys(s).map((c) => {
            if (typeof c == "string" && c.indexOf("@") === 0) {
                const a = parseFloat(c.substr(1));
                return { value: r * a, point: c };
            }
            return { value: c, point: c };
        });
    d.sort((c, a) => parseInt(c.value, 10) - parseInt(a.value, 10));
    for (let c = 0; c < d.length; c += 1) {
        const { point: a, value: u } = d[c];
        e === "window" ? n.matchMedia(`(min-width: ${u}px)`).matches && (i = a) : u <= t.clientWidth && (i = a);
    }
    return i || "max";
}
var ys = { setBreakpoint: vs, getBreakpoint: ws };
function Ss(s, e) {
    const t = [];
    return (
        s.forEach((i) => {
            typeof i == "object"
                ? Object.keys(i).forEach((n) => {
                      i[n] && t.push(e + n);
                  })
                : typeof i == "string" && t.push(e + i);
        }),
        t
    );
}
function bs() {
    const s = this,
        { classNames: e, params: t, rtl: i, el: n, device: r } = s,
        d = Ss(
            [
                "initialized",
                t.direction,
                { "free-mode": s.params.freeMode && t.freeMode.enabled },
                { autoheight: t.autoHeight },
                { rtl: i },
                { grid: t.grid && t.grid.rows > 1 },
                { "grid-column": t.grid && t.grid.rows > 1 && t.grid.fill === "column" },
                { android: r.android },
                { ios: r.ios },
                { "css-mode": t.cssMode },
                { centered: t.cssMode && t.centeredSlides },
                { "watch-progress": t.watchSlidesProgress },
            ],
            t.containerModifierClass
        );
    e.push(...d), n.classList.add(...e), s.emitContainerClasses();
}
function Es() {
    const s = this,
        { el: e, classNames: t } = s;
    !e || typeof e == "string" || (e.classList.remove(...t), s.emitContainerClasses());
}
var xs = { addClasses: bs, removeClasses: Es };
function Ts() {
    const s = this,
        { isLocked: e, params: t } = s,
        { slidesOffsetBefore: i } = t;
    if (i) {
        const n = s.slides.length - 1,
            r = s.slidesGrid[n] + s.slidesSizesGrid[n] + i * 2;
        s.isLocked = s.size > r;
    } else s.isLocked = s.snapGrid.length === 1;
    t.allowSlideNext === !0 && (s.allowSlideNext = !s.isLocked), t.allowSlidePrev === !0 && (s.allowSlidePrev = !s.isLocked), e && e !== s.isLocked && (s.isEnd = !1), e !== s.isLocked && s.emit(s.isLocked ? "lock" : "unlock");
}
var Ms = { checkOverflow: Ts },
    et = {
        init: !0,
        direction: "horizontal",
        oneWayMovement: !1,
        swiperElementNodeName: "SWIPER-CONTAINER",
        touchEventsTarget: "wrapper",
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        resizeObserver: !0,
        nested: !1,
        createElements: !1,
        eventsPrefix: "swiper",
        enabled: !0,
        focusableElements: "input, select, option, textarea, button, video, label",
        width: null,
        height: null,
        preventInteractionOnTransition: !1,
        userAgent: null,
        url: null,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        breakpointsBase: "window",
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        slidesPerGroupAuto: !1,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !0,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 5,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: 0.85,
        watchSlidesProgress: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        loop: !1,
        loopAddBlankSlides: !0,
        loopAdditionalSlides: 0,
        loopPreventsSliding: !0,
        rewind: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        maxBackfaceHiddenSlides: 10,
        containerModifierClass: "swiper-",
        slideClass: "swiper-slide",
        slideBlankClass: "swiper-slide-blank",
        slideActiveClass: "swiper-slide-active",
        slideVisibleClass: "swiper-slide-visible",
        slideFullyVisibleClass: "swiper-slide-fully-visible",
        slideNextClass: "swiper-slide-next",
        slidePrevClass: "swiper-slide-prev",
        wrapperClass: "swiper-wrapper",
        lazyPreloaderClass: "swiper-lazy-preloader",
        lazyPreloadPrevNext: 0,
        runCallbacksOnInit: !0,
        _emitClasses: !1,
    };
function Cs(s, e) {
    return function (i) {
        i === void 0 && (i = {});
        const n = Object.keys(i)[0],
            r = i[n];
        if (typeof r != "object" || r === null) {
            K(e, i);
            return;
        }
        if (
            (s[n] === !0 && (s[n] = { enabled: !0 }),
            n === "navigation" && s[n] && s[n].enabled && !s[n].prevEl && !s[n].nextEl && (s[n].auto = !0),
            ["pagination", "scrollbar"].indexOf(n) >= 0 && s[n] && s[n].enabled && !s[n].el && (s[n].auto = !0),
            !(n in s && "enabled" in r))
        ) {
            K(e, i);
            return;
        }
        typeof s[n] == "object" && !("enabled" in s[n]) && (s[n].enabled = !0), s[n] || (s[n] = { enabled: !1 }), K(e, i);
    };
}
const Ve = { eventsEmitter: xt, update: $t, translate: Gt, transition: Yt, slide: Qt, loop: ss, grabCursor: ns, events: gs, breakpoints: ys, checkOverflow: Ms, classes: xs },
    Re = {};
class Y {
    constructor() {
        let e, t;
        for (var i = arguments.length, n = new Array(i), r = 0; r < i; r++) n[r] = arguments[r];
        n.length === 1 && n[0].constructor && Object.prototype.toString.call(n[0]).slice(8, -1) === "Object" ? (t = n[0]) : ([e, t] = n), t || (t = {}), (t = K({}, t)), e && !t.el && (t.el = e);
        const d = N();
        if (t.el && typeof t.el == "string" && d.querySelectorAll(t.el).length > 1) {
            const f = [];
            return (
                d.querySelectorAll(t.el).forEach((p) => {
                    const v = K({}, t, { el: p });
                    f.push(new Y(v));
                }),
                f
            );
        }
        const c = this;
        (c.__swiper__ = !0),
            (c.support = it()),
            (c.device = rt({ userAgent: t.userAgent })),
            (c.browser = St()),
            (c.eventsListeners = {}),
            (c.eventsAnyListeners = []),
            (c.modules = [...c.__modules__]),
            t.modules && Array.isArray(t.modules) && c.modules.push(...t.modules);
        const a = {};
        c.modules.forEach((f) => {
            f({ params: t, swiper: c, extendParams: Cs(t, a), on: c.on.bind(c), once: c.once.bind(c), off: c.off.bind(c), emit: c.emit.bind(c) });
        });
        const u = K({}, et, a);
        return (
            (c.params = K({}, u, Re, t)),
            (c.originalParams = K({}, c.params)),
            (c.passedParams = K({}, t)),
            c.params &&
                c.params.on &&
                Object.keys(c.params.on).forEach((f) => {
                    c.on(f, c.params.on[f]);
                }),
            c.params && c.params.onAny && c.onAny(c.params.onAny),
            Object.assign(c, {
                enabled: c.params.enabled,
                el: e,
                classNames: [],
                slides: [],
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal() {
                    return c.params.direction === "horizontal";
                },
                isVertical() {
                    return c.params.direction === "vertical";
                },
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                cssOverflowAdjustment() {
                    return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
                },
                allowSlideNext: c.params.allowSlideNext,
                allowSlidePrev: c.params.allowSlidePrev,
                touchEventsData: {
                    isTouched: void 0,
                    isMoved: void 0,
                    allowTouchCallbacks: void 0,
                    touchStartTime: void 0,
                    isScrolling: void 0,
                    currentTranslate: void 0,
                    startTranslate: void 0,
                    allowThresholdMove: void 0,
                    focusableElements: c.params.focusableElements,
                    lastClickTime: 0,
                    clickTimeout: void 0,
                    velocities: [],
                    allowMomentumBounce: void 0,
                    startMoving: void 0,
                    pointerId: null,
                    touchId: null,
                },
                allowClick: !0,
                allowTouchMove: c.params.allowTouchMove,
                touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                imagesToLoad: [],
                imagesLoaded: 0,
            }),
            c.emit("_swiper"),
            c.params.init && c.init(),
            c
        );
    }
    getDirectionLabel(e) {
        return this.isHorizontal()
            ? e
            : {
                  width: "height",
                  "margin-top": "margin-left",
                  "margin-bottom ": "margin-right",
                  "margin-left": "margin-top",
                  "margin-right": "margin-bottom",
                  "padding-left": "padding-top",
                  "padding-right": "padding-bottom",
                  marginRight: "marginBottom",
              }[e];
    }
    getSlideIndex(e) {
        const { slidesEl: t, params: i } = this,
            n = W(t, `.${i.slideClass}, swiper-slide`),
            r = Ee(n[0]);
        return Ee(e) - r;
    }
    getSlideIndexByData(e) {
        return this.getSlideIndex(this.slides.find((t) => t.getAttribute("data-swiper-slide-index") * 1 === e));
    }
    recalcSlides() {
        const e = this,
            { slidesEl: t, params: i } = e;
        e.slides = W(t, `.${i.slideClass}, swiper-slide`);
    }
    enable() {
        const e = this;
        e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
    }
    disable() {
        const e = this;
        e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
    }
    setProgress(e, t) {
        const i = this;
        e = Math.min(Math.max(e, 0), 1);
        const n = i.minTranslate(),
            d = (i.maxTranslate() - n) * e + n;
        i.translateTo(d, typeof t > "u" ? 0 : t), i.updateActiveIndex(), i.updateSlidesClasses();
    }
    emitContainerClasses() {
        const e = this;
        if (!e.params._emitClasses || !e.el) return;
        const t = e.el.className.split(" ").filter((i) => i.indexOf("swiper") === 0 || i.indexOf(e.params.containerModifierClass) === 0);
        e.emit("_containerClasses", t.join(" "));
    }
    getSlideClasses(e) {
        const t = this;
        return t.destroyed
            ? ""
            : e.className
                  .split(" ")
                  .filter((i) => i.indexOf("swiper-slide") === 0 || i.indexOf(t.params.slideClass) === 0)
                  .join(" ");
    }
    emitSlidesClasses() {
        const e = this;
        if (!e.params._emitClasses || !e.el) return;
        const t = [];
        e.slides.forEach((i) => {
            const n = e.getSlideClasses(i);
            t.push({ slideEl: i, classNames: n }), e.emit("_slideClass", i, n);
        }),
            e.emit("_slideClasses", t);
    }
    slidesPerViewDynamic(e, t) {
        e === void 0 && (e = "current"), t === void 0 && (t = !1);
        const i = this,
            { params: n, slides: r, slidesGrid: d, slidesSizesGrid: c, size: a, activeIndex: u } = i;
        let f = 1;
        if (typeof n.slidesPerView == "number") return n.slidesPerView;
        if (n.centeredSlides) {
            let p = r[u] ? Math.ceil(r[u].swiperSlideSize) : 0,
                v;
            for (let m = u + 1; m < r.length; m += 1) r[m] && !v && ((p += Math.ceil(r[m].swiperSlideSize)), (f += 1), p > a && (v = !0));
            for (let m = u - 1; m >= 0; m -= 1) r[m] && !v && ((p += r[m].swiperSlideSize), (f += 1), p > a && (v = !0));
        } else if (e === "current") for (let p = u + 1; p < r.length; p += 1) (t ? d[p] + c[p] - d[u] < a : d[p] - d[u] < a) && (f += 1);
        else for (let p = u - 1; p >= 0; p -= 1) d[u] - d[p] < a && (f += 1);
        return f;
    }
    update() {
        const e = this;
        if (!e || e.destroyed) return;
        const { snapGrid: t, params: i } = e;
        i.breakpoints && e.setBreakpoint(),
            [...e.el.querySelectorAll('[loading="lazy"]')].forEach((d) => {
                d.complete && Pe(e, d);
            }),
            e.updateSize(),
            e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses();
        function n() {
            const d = e.rtlTranslate ? e.translate * -1 : e.translate,
                c = Math.min(Math.max(d, e.maxTranslate()), e.minTranslate());
            e.setTranslate(c), e.updateActiveIndex(), e.updateSlidesClasses();
        }
        let r;
        if (i.freeMode && i.freeMode.enabled && !i.cssMode) n(), i.autoHeight && e.updateAutoHeight();
        else {
            if ((i.slidesPerView === "auto" || i.slidesPerView > 1) && e.isEnd && !i.centeredSlides) {
                const d = e.virtual && i.virtual.enabled ? e.virtual.slides : e.slides;
                r = e.slideTo(d.length - 1, 0, !1, !0);
            } else r = e.slideTo(e.activeIndex, 0, !1, !0);
            r || n();
        }
        i.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
    }
    changeDirection(e, t) {
        t === void 0 && (t = !0);
        const i = this,
            n = i.params.direction;
        return (
            e || (e = n === "horizontal" ? "vertical" : "horizontal"),
            e === n ||
                (e !== "horizontal" && e !== "vertical") ||
                (i.el.classList.remove(`${i.params.containerModifierClass}${n}`),
                i.el.classList.add(`${i.params.containerModifierClass}${e}`),
                i.emitContainerClasses(),
                (i.params.direction = e),
                i.slides.forEach((r) => {
                    e === "vertical" ? (r.style.width = "") : (r.style.height = "");
                }),
                i.emit("changeDirection"),
                t && i.update()),
            i
        );
    }
    changeLanguageDirection(e) {
        const t = this;
        (t.rtl && e === "rtl") ||
            (!t.rtl && e === "ltr") ||
            ((t.rtl = e === "rtl"),
            (t.rtlTranslate = t.params.direction === "horizontal" && t.rtl),
            t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), (t.el.dir = "rtl")) : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), (t.el.dir = "ltr")),
            t.update());
    }
    mount(e) {
        const t = this;
        if (t.mounted) return !0;
        let i = e || t.params.el;
        if ((typeof i == "string" && (i = document.querySelector(i)), !i)) return !1;
        (i.swiper = t), i.parentNode && i.parentNode.host && i.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() && (t.isElement = !0);
        const n = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
        let d = i && i.shadowRoot && i.shadowRoot.querySelector ? i.shadowRoot.querySelector(n()) : W(i, n())[0];
        return (
            !d &&
                t.params.createElements &&
                ((d = Z("div", t.params.wrapperClass)),
                i.append(d),
                W(i, `.${t.params.slideClass}`).forEach((c) => {
                    d.append(c);
                })),
            Object.assign(t, {
                el: i,
                wrapperEl: d,
                slidesEl: t.isElement && !i.parentNode.host.slideSlots ? i.parentNode.host : d,
                hostEl: t.isElement ? i.parentNode.host : i,
                mounted: !0,
                rtl: i.dir.toLowerCase() === "rtl" || le(i, "direction") === "rtl",
                rtlTranslate: t.params.direction === "horizontal" && (i.dir.toLowerCase() === "rtl" || le(i, "direction") === "rtl"),
                wrongRTL: le(d, "display") === "-webkit-box",
            }),
            !0
        );
    }
    init(e) {
        const t = this;
        if (t.initialized || t.mount(e) === !1) return t;
        t.emit("beforeInit"),
            t.params.breakpoints && t.setBreakpoint(),
            t.addClasses(),
            t.updateSize(),
            t.updateSlides(),
            t.params.watchOverflow && t.checkOverflow(),
            t.params.grabCursor && t.enabled && t.setGrabCursor(),
            t.params.loop && t.virtual && t.params.virtual.enabled
                ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0)
                : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
            t.params.loop && t.loopCreate(),
            t.attachEvents();
        const n = [...t.el.querySelectorAll('[loading="lazy"]')];
        return (
            t.isElement && n.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
            n.forEach((r) => {
                r.complete
                    ? Pe(t, r)
                    : r.addEventListener("load", (d) => {
                          Pe(t, d.target);
                      });
            }),
            Ne(t),
            (t.initialized = !0),
            Ne(t),
            t.emit("init"),
            t.emit("afterInit"),
            t
        );
    }
    destroy(e, t) {
        e === void 0 && (e = !0), t === void 0 && (t = !0);
        const i = this,
            { params: n, el: r, wrapperEl: d, slides: c } = i;
        return (
            typeof i.params > "u" ||
                i.destroyed ||
                (i.emit("beforeDestroy"),
                (i.initialized = !1),
                i.detachEvents(),
                n.loop && i.loopDestroy(),
                t &&
                    (i.removeClasses(),
                    r && typeof r != "string" && r.removeAttribute("style"),
                    d && d.removeAttribute("style"),
                    c &&
                        c.length &&
                        c.forEach((a) => {
                            a.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), a.removeAttribute("style"), a.removeAttribute("data-swiper-slide-index");
                        })),
                i.emit("destroy"),
                Object.keys(i.eventsListeners).forEach((a) => {
                    i.off(a);
                }),
                e !== !1 && (i.el && typeof i.el != "string" && (i.el.swiper = null), ct(i)),
                (i.destroyed = !0)),
            null
        );
    }
    static extendDefaults(e) {
        K(Re, e);
    }
    static get extendedDefaults() {
        return Re;
    }
    static get defaults() {
        return et;
    }
    static installModule(e) {
        Y.prototype.__modules__ || (Y.prototype.__modules__ = []);
        const t = Y.prototype.__modules__;
        typeof e == "function" && t.indexOf(e) < 0 && t.push(e);
    }
    static use(e) {
        return Array.isArray(e) ? (e.forEach((t) => Y.installModule(t)), Y) : (Y.installModule(e), Y);
    }
}
Object.keys(Ve).forEach((s) => {
    Object.keys(Ve[s]).forEach((e) => {
        Y.prototype[e] = Ve[s][e];
    });
});
Y.use([bt, Et]);
function Ps(s) {
    let { swiper: e, extendParams: t, on: i, emit: n } = s;
    t({ virtual: { enabled: !1, slides: [], cache: !0, renderSlide: null, renderExternal: null, renderExternalUpdate: !0, addSlidesBefore: 0, addSlidesAfter: 0 } });
    let r;
    const d = N();
    e.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] };
    const c = d.createElement("div");
    function a(l, o) {
        const w = e.params.virtual;
        if (w.cache && e.virtual.cache[o]) return e.virtual.cache[o];
        let y;
        return (
            w.renderSlide ? ((y = w.renderSlide.call(e, l, o)), typeof y == "string" && ((c.innerHTML = y), (y = c.children[0]))) : e.isElement ? (y = Z("swiper-slide")) : (y = Z("div", e.params.slideClass)),
            y.setAttribute("data-swiper-slide-index", o),
            w.renderSlide || (y.innerHTML = l),
            w.cache && (e.virtual.cache[o] = y),
            y
        );
    }
    function u(l, o) {
        const { slidesPerView: w, slidesPerGroup: y, centeredSlides: g, loop: h, initialSlide: S } = e.params;
        if (o && !h && S > 0) return;
        const { addSlidesBefore: b, addSlidesAfter: z } = e.params.virtual,
            { from: $, to: O, slides: P, slidesGrid: L, offset: A } = e.virtual;
        e.params.cssMode || e.updateActiveIndex();
        const M = e.activeIndex || 0;
        let E;
        e.rtlTranslate ? (E = "right") : (E = e.isHorizontal() ? "left" : "top");
        let x, D;
        g ? ((x = Math.floor(w / 2) + y + z), (D = Math.floor(w / 2) + y + b)) : ((x = w + (y - 1) + z), (D = (h ? w : y) + b));
        let q = M - D,
            C = M + x;
        h || ((q = Math.max(q, 0)), (C = Math.min(C, P.length - 1)));
        let I = (e.slidesGrid[q] || 0) - (e.slidesGrid[0] || 0);
        h && M >= D ? ((q -= D), g || (I += e.slidesGrid[0])) : h && M < D && ((q = -D), g && (I += e.slidesGrid[0])), Object.assign(e.virtual, { from: q, to: C, offset: I, slidesGrid: e.slidesGrid, slidesBefore: D, slidesAfter: x });
        function H() {
            e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), n("virtualUpdate");
        }
        if ($ === q && O === C && !l) {
            e.slidesGrid !== L &&
                I !== A &&
                e.slides.forEach((T) => {
                    T.style[E] = `${I - Math.abs(e.cssOverflowAdjustment())}px`;
                }),
                e.updateProgress(),
                n("virtualUpdate");
            return;
        }
        if (e.params.virtual.renderExternal) {
            e.params.virtual.renderExternal.call(e, {
                offset: I,
                from: q,
                to: C,
                slides: (function () {
                    const k = [];
                    for (let B = q; B <= C; B += 1) k.push(P[B]);
                    return k;
                })(),
            }),
                e.params.virtual.renderExternalUpdate ? H() : n("virtualUpdate");
            return;
        }
        const _ = [],
            X = [],
            F = (T) => {
                let k = T;
                return T < 0 ? (k = P.length + T) : k >= P.length && (k = k - P.length), k;
            };
        if (l)
            e.slides
                .filter((T) => T.matches(`.${e.params.slideClass}, swiper-slide`))
                .forEach((T) => {
                    T.remove();
                });
        else
            for (let T = $; T <= O; T += 1)
                if (T < q || T > C) {
                    const k = F(T);
                    e.slides
                        .filter((B) => B.matches(`.${e.params.slideClass}[data-swiper-slide-index="${k}"], swiper-slide[data-swiper-slide-index="${k}"]`))
                        .forEach((B) => {
                            B.remove();
                        });
                }
        const J = h ? -P.length : 0,
            pe = h ? P.length * 2 : P.length;
        for (let T = J; T < pe; T += 1)
            if (T >= q && T <= C) {
                const k = F(T);
                typeof O > "u" || l ? X.push(k) : (T > O && X.push(k), T < $ && _.push(k));
            }
        if (
            (X.forEach((T) => {
                e.slidesEl.append(a(P[T], T));
            }),
            h)
        )
            for (let T = _.length - 1; T >= 0; T -= 1) {
                const k = _[T];
                e.slidesEl.prepend(a(P[k], k));
            }
        else
            _.sort((T, k) => k - T),
                _.forEach((T) => {
                    e.slidesEl.prepend(a(P[T], T));
                });
        W(e.slidesEl, ".swiper-slide, swiper-slide").forEach((T) => {
            T.style[E] = `${I - Math.abs(e.cssOverflowAdjustment())}px`;
        }),
            H();
    }
    function f(l) {
        if (typeof l == "object" && "length" in l) for (let o = 0; o < l.length; o += 1) l[o] && e.virtual.slides.push(l[o]);
        else e.virtual.slides.push(l);
        u(!0);
    }
    function p(l) {
        const o = e.activeIndex;
        let w = o + 1,
            y = 1;
        if (Array.isArray(l)) {
            for (let g = 0; g < l.length; g += 1) l[g] && e.virtual.slides.unshift(l[g]);
            (w = o + l.length), (y = l.length);
        } else e.virtual.slides.unshift(l);
        if (e.params.virtual.cache) {
            const g = e.virtual.cache,
                h = {};
            Object.keys(g).forEach((S) => {
                const b = g[S],
                    z = b.getAttribute("data-swiper-slide-index");
                z && b.setAttribute("data-swiper-slide-index", parseInt(z, 10) + y), (h[parseInt(S, 10) + y] = b);
            }),
                (e.virtual.cache = h);
        }
        u(!0), e.slideTo(w, 0);
    }
    function v(l) {
        if (typeof l > "u" || l === null) return;
        let o = e.activeIndex;
        if (Array.isArray(l))
            for (let w = l.length - 1; w >= 0; w -= 1)
                e.params.virtual.cache &&
                    (delete e.virtual.cache[l[w]],
                    Object.keys(e.virtual.cache).forEach((y) => {
                        y > l && ((e.virtual.cache[y - 1] = e.virtual.cache[y]), e.virtual.cache[y - 1].setAttribute("data-swiper-slide-index", y - 1), delete e.virtual.cache[y]);
                    })),
                    e.virtual.slides.splice(l[w], 1),
                    l[w] < o && (o -= 1),
                    (o = Math.max(o, 0));
        else
            e.params.virtual.cache &&
                (delete e.virtual.cache[l],
                Object.keys(e.virtual.cache).forEach((w) => {
                    w > l && ((e.virtual.cache[w - 1] = e.virtual.cache[w]), e.virtual.cache[w - 1].setAttribute("data-swiper-slide-index", w - 1), delete e.virtual.cache[w]);
                })),
                e.virtual.slides.splice(l, 1),
                l < o && (o -= 1),
                (o = Math.max(o, 0));
        u(!0), e.slideTo(o, 0);
    }
    function m() {
        (e.virtual.slides = []), e.params.virtual.cache && (e.virtual.cache = {}), u(!0), e.slideTo(0, 0);
    }
    i("beforeInit", () => {
        if (!e.params.virtual.enabled) return;
        let l;
        if (typeof e.passedParams.virtual.slides > "u") {
            const o = [...e.slidesEl.children].filter((w) => w.matches(`.${e.params.slideClass}, swiper-slide`));
            o.length &&
                ((e.virtual.slides = [...o]),
                (l = !0),
                o.forEach((w, y) => {
                    w.setAttribute("data-swiper-slide-index", y), (e.virtual.cache[y] = w), w.remove();
                }));
        }
        l || (e.virtual.slides = e.params.virtual.slides), e.classNames.push(`${e.params.containerModifierClass}virtual`), (e.params.watchSlidesProgress = !0), (e.originalParams.watchSlidesProgress = !0), u(!1, !0);
    }),
        i("setTranslate", () => {
            e.params.virtual.enabled &&
                (e.params.cssMode && !e._immediateVirtual
                    ? (clearTimeout(r),
                      (r = setTimeout(() => {
                          u();
                      }, 100)))
                    : u());
        }),
        i("init update resize", () => {
            e.params.virtual.enabled && e.params.cssMode && Se(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
        }),
        Object.assign(e.virtual, { appendSlide: f, prependSlide: p, removeSlide: v, removeAllSlides: m, update: u });
}
function Ls(s) {
    let { swiper: e, extendParams: t, on: i, emit: n } = s;
    const r = N(),
        d = R();
    (e.keyboard = { enabled: !1 }), t({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } });
    function c(f) {
        if (!e.enabled) return;
        const { rtlTranslate: p } = e;
        let v = f;
        v.originalEvent && (v = v.originalEvent);
        const m = v.keyCode || v.charCode,
            l = e.params.keyboard.pageUpDown,
            o = l && m === 33,
            w = l && m === 34,
            y = m === 37,
            g = m === 39,
            h = m === 38,
            S = m === 40;
        if ((!e.allowSlideNext && ((e.isHorizontal() && g) || (e.isVertical() && S) || w)) || (!e.allowSlidePrev && ((e.isHorizontal() && y) || (e.isVertical() && h) || o))) return !1;
        if (!(v.shiftKey || v.altKey || v.ctrlKey || v.metaKey) && !(r.activeElement && r.activeElement.nodeName && (r.activeElement.nodeName.toLowerCase() === "input" || r.activeElement.nodeName.toLowerCase() === "textarea"))) {
            if (e.params.keyboard.onlyInViewport && (o || w || y || g || h || S)) {
                let b = !1;
                if (oe(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && oe(e.el, `.${e.params.slideActiveClass}`).length === 0) return;
                const z = e.el,
                    $ = z.clientWidth,
                    O = z.clientHeight,
                    P = d.innerWidth,
                    L = d.innerHeight,
                    A = Ie(z);
                p && (A.left -= z.scrollLeft);
                const M = [
                    [A.left, A.top],
                    [A.left + $, A.top],
                    [A.left, A.top + O],
                    [A.left + $, A.top + O],
                ];
                for (let E = 0; E < M.length; E += 1) {
                    const x = M[E];
                    if (x[0] >= 0 && x[0] <= P && x[1] >= 0 && x[1] <= L) {
                        if (x[0] === 0 && x[1] === 0) continue;
                        b = !0;
                    }
                }
                if (!b) return;
            }
            e.isHorizontal()
                ? ((o || w || y || g) && (v.preventDefault ? v.preventDefault() : (v.returnValue = !1)), (((w || g) && !p) || ((o || y) && p)) && e.slideNext(), (((o || y) && !p) || ((w || g) && p)) && e.slidePrev())
                : ((o || w || h || S) && (v.preventDefault ? v.preventDefault() : (v.returnValue = !1)), (w || S) && e.slideNext(), (o || h) && e.slidePrev()),
                n("keyPress", m);
        }
    }
    function a() {
        e.keyboard.enabled || (r.addEventListener("keydown", c), (e.keyboard.enabled = !0));
    }
    function u() {
        e.keyboard.enabled && (r.removeEventListener("keydown", c), (e.keyboard.enabled = !1));
    }
    i("init", () => {
        e.params.keyboard.enabled && a();
    }),
        i("destroy", () => {
            e.keyboard.enabled && u();
        }),
        Object.assign(e.keyboard, { enable: a, disable: u });
}
function Is(s) {
    let { swiper: e, extendParams: t, on: i, emit: n } = s;
    const r = R();
    t({ mousewheel: { enabled: !1, releaseOnEdges: !1, invert: !1, forceToAxis: !1, sensitivity: 1, eventsTarget: "container", thresholdDelta: null, thresholdTime: null, noMousewheelClass: "swiper-no-mousewheel" } }),
        (e.mousewheel = { enabled: !1 });
    let d,
        c = Q(),
        a;
    const u = [];
    function f(h) {
        let $ = 0,
            O = 0,
            P = 0,
            L = 0;
        return (
            "detail" in h && (O = h.detail),
            "wheelDelta" in h && (O = -h.wheelDelta / 120),
            "wheelDeltaY" in h && (O = -h.wheelDeltaY / 120),
            "wheelDeltaX" in h && ($ = -h.wheelDeltaX / 120),
            "axis" in h && h.axis === h.HORIZONTAL_AXIS && (($ = O), (O = 0)),
            (P = $ * 10),
            (L = O * 10),
            "deltaY" in h && (L = h.deltaY),
            "deltaX" in h && (P = h.deltaX),
            h.shiftKey && !P && ((P = L), (L = 0)),
            (P || L) && h.deltaMode && (h.deltaMode === 1 ? ((P *= 40), (L *= 40)) : ((P *= 800), (L *= 800))),
            P && !$ && ($ = P < 1 ? -1 : 1),
            L && !O && (O = L < 1 ? -1 : 1),
            { spinX: $, spinY: O, pixelX: P, pixelY: L }
        );
    }
    function p() {
        e.enabled && (e.mouseEntered = !0);
    }
    function v() {
        e.enabled && (e.mouseEntered = !1);
    }
    function m(h) {
        return (e.params.mousewheel.thresholdDelta && h.delta < e.params.mousewheel.thresholdDelta) || (e.params.mousewheel.thresholdTime && Q() - c < e.params.mousewheel.thresholdTime)
            ? !1
            : h.delta >= 6 && Q() - c < 60
            ? !0
            : (h.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), n("scroll", h.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), n("scroll", h.raw)),
              (c = new r.Date().getTime()),
              !1);
    }
    function l(h) {
        const S = e.params.mousewheel;
        if (h.direction < 0) {
            if (e.isEnd && !e.params.loop && S.releaseOnEdges) return !0;
        } else if (e.isBeginning && !e.params.loop && S.releaseOnEdges) return !0;
        return !1;
    }
    function o(h) {
        let S = h,
            b = !0;
        if (!e.enabled || h.target.closest(`.${e.params.mousewheel.noMousewheelClass}`)) return;
        const z = e.params.mousewheel;
        e.params.cssMode && S.preventDefault();
        let $ = e.el;
        e.params.mousewheel.eventsTarget !== "container" && ($ = document.querySelector(e.params.mousewheel.eventsTarget));
        const O = $ && $.contains(S.target);
        if (!e.mouseEntered && !O && !z.releaseOnEdges) return !0;
        S.originalEvent && (S = S.originalEvent);
        let P = 0;
        const L = e.rtlTranslate ? -1 : 1,
            A = f(S);
        if (z.forceToAxis)
            if (e.isHorizontal())
                if (Math.abs(A.pixelX) > Math.abs(A.pixelY)) P = -A.pixelX * L;
                else return !0;
            else if (Math.abs(A.pixelY) > Math.abs(A.pixelX)) P = -A.pixelY;
            else return !0;
        else P = Math.abs(A.pixelX) > Math.abs(A.pixelY) ? -A.pixelX * L : -A.pixelY;
        if (P === 0) return !0;
        z.invert && (P = -P);
        let M = e.getTranslate() + P * z.sensitivity;
        if (
            (M >= e.minTranslate() && (M = e.minTranslate()),
            M <= e.maxTranslate() && (M = e.maxTranslate()),
            (b = e.params.loop ? !0 : !(M === e.minTranslate() || M === e.maxTranslate())),
            b && e.params.nested && S.stopPropagation(),
            !e.params.freeMode || !e.params.freeMode.enabled)
        ) {
            const E = { time: Q(), delta: Math.abs(P), direction: Math.sign(P), raw: h };
            u.length >= 2 && u.shift();
            const x = u.length ? u[u.length - 1] : void 0;
            if ((u.push(E), x ? (E.direction !== x.direction || E.delta > x.delta || E.time > x.time + 150) && m(E) : m(E), l(E))) return !0;
        } else {
            const E = { time: Q(), delta: Math.abs(P), direction: Math.sign(P) },
                x = a && E.time < a.time + 500 && E.delta <= a.delta && E.direction === a.direction;
            if (!x) {
                a = void 0;
                let D = e.getTranslate() + P * z.sensitivity;
                const q = e.isBeginning,
                    C = e.isEnd;
                if (
                    (D >= e.minTranslate() && (D = e.minTranslate()),
                    D <= e.maxTranslate() && (D = e.maxTranslate()),
                    e.setTransition(0),
                    e.setTranslate(D),
                    e.updateProgress(),
                    e.updateActiveIndex(),
                    e.updateSlidesClasses(),
                    ((!q && e.isBeginning) || (!C && e.isEnd)) && e.updateSlidesClasses(),
                    e.params.loop && e.loopFix({ direction: E.direction < 0 ? "next" : "prev", byMousewheel: !0 }),
                    e.params.freeMode.sticky)
                ) {
                    clearTimeout(d), (d = void 0), u.length >= 15 && u.shift();
                    const I = u.length ? u[u.length - 1] : void 0,
                        H = u[0];
                    if ((u.push(E), I && (E.delta > I.delta || E.direction !== I.direction))) u.splice(0);
                    else if (u.length >= 15 && E.time - H.time < 500 && H.delta - E.delta >= 1 && E.delta <= 6) {
                        const _ = P > 0 ? 0.8 : 0.2;
                        (a = E),
                            u.splice(0),
                            (d = de(() => {
                                e.destroyed || !e.params || e.slideToClosest(e.params.speed, !0, void 0, _);
                            }, 0));
                    }
                    d ||
                        (d = de(() => {
                            if (e.destroyed || !e.params) return;
                            const _ = 0.5;
                            (a = E), u.splice(0), e.slideToClosest(e.params.speed, !0, void 0, _);
                        }, 500));
                }
                if ((x || n("scroll", S), e.params.autoplay && e.params.autoplay.disableOnInteraction && e.autoplay.stop(), z.releaseOnEdges && (D === e.minTranslate() || D === e.maxTranslate()))) return !0;
            }
        }
        return S.preventDefault ? S.preventDefault() : (S.returnValue = !1), !1;
    }
    function w(h) {
        let S = e.el;
        e.params.mousewheel.eventsTarget !== "container" && (S = document.querySelector(e.params.mousewheel.eventsTarget)), S[h]("mouseenter", p), S[h]("mouseleave", v), S[h]("wheel", o);
    }
    function y() {
        return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", o), !0) : e.mousewheel.enabled ? !1 : (w("addEventListener"), (e.mousewheel.enabled = !0), !0);
    }
    function g() {
        return e.params.cssMode ? (e.wrapperEl.addEventListener(event, o), !0) : e.mousewheel.enabled ? (w("removeEventListener"), (e.mousewheel.enabled = !1), !0) : !1;
    }
    i("init", () => {
        !e.params.mousewheel.enabled && e.params.cssMode && g(), e.params.mousewheel.enabled && y();
    }),
        i("destroy", () => {
            e.params.cssMode && y(), e.mousewheel.enabled && g();
        }),
        Object.assign(e.mousewheel, { enable: y, disable: g });
}
function We(s, e, t, i) {
    return (
        s.params.createElements &&
            Object.keys(i).forEach((n) => {
                if (!t[n] && t.auto === !0) {
                    let r = W(s.el, `.${i[n]}`)[0];
                    r || ((r = Z("div", i[n])), (r.className = i[n]), s.el.append(r)), (t[n] = r), (e[n] = r);
                }
            }),
        t
    );
}
function As(s) {
    let { swiper: e, extendParams: t, on: i, emit: n } = s;
    t({ navigation: { nextEl: null, prevEl: null, hideOnClick: !1, disabledClass: "swiper-button-disabled", hiddenClass: "swiper-button-hidden", lockClass: "swiper-button-lock", navigationDisabledClass: "swiper-navigation-disabled" } }),
        (e.navigation = { nextEl: null, prevEl: null });
    function r(l) {
        let o;
        return l && typeof l == "string" && e.isElement && ((o = e.el.querySelector(l) || e.hostEl.querySelector(l)), o)
            ? o
            : (l &&
                  (typeof l == "string" && (o = [...document.querySelectorAll(l)]),
                  e.params.uniqueNavElements && typeof l == "string" && o && o.length > 1 && e.el.querySelectorAll(l).length === 1 ? (o = e.el.querySelector(l)) : o && o.length === 1 && (o = o[0])),
              l && !o ? l : o);
    }
    function d(l, o) {
        const w = e.params.navigation;
        (l = G(l)),
            l.forEach((y) => {
                y && (y.classList[o ? "add" : "remove"](...w.disabledClass.split(" ")), y.tagName === "BUTTON" && (y.disabled = o), e.params.watchOverflow && e.enabled && y.classList[e.isLocked ? "add" : "remove"](w.lockClass));
            });
    }
    function c() {
        const { nextEl: l, prevEl: o } = e.navigation;
        if (e.params.loop) {
            d(o, !1), d(l, !1);
            return;
        }
        d(o, e.isBeginning && !e.params.rewind), d(l, e.isEnd && !e.params.rewind);
    }
    function a(l) {
        l.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), n("navigationPrev"));
    }
    function u(l) {
        l.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), n("navigationNext"));
    }
    function f() {
        const l = e.params.navigation;
        if (((e.params.navigation = We(e, e.originalParams.navigation, e.params.navigation, { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" })), !(l.nextEl || l.prevEl))) return;
        let o = r(l.nextEl),
            w = r(l.prevEl);
        Object.assign(e.navigation, { nextEl: o, prevEl: w }), (o = G(o)), (w = G(w));
        const y = (g, h) => {
            g && g.addEventListener("click", h === "next" ? u : a), !e.enabled && g && g.classList.add(...l.lockClass.split(" "));
        };
        o.forEach((g) => y(g, "next")), w.forEach((g) => y(g, "prev"));
    }
    function p() {
        let { nextEl: l, prevEl: o } = e.navigation;
        (l = G(l)), (o = G(o));
        const w = (y, g) => {
            y.removeEventListener("click", g === "next" ? u : a), y.classList.remove(...e.params.navigation.disabledClass.split(" "));
        };
        l.forEach((y) => w(y, "next")), o.forEach((y) => w(y, "prev"));
    }
    i("init", () => {
        e.params.navigation.enabled === !1 ? m() : (f(), c());
    }),
        i("toEdge fromEdge lock unlock", () => {
            c();
        }),
        i("destroy", () => {
            p();
        }),
        i("enable disable", () => {
            let { nextEl: l, prevEl: o } = e.navigation;
            if (((l = G(l)), (o = G(o)), e.enabled)) {
                c();
                return;
            }
            [...l, ...o].filter((w) => !!w).forEach((w) => w.classList.add(e.params.navigation.lockClass));
        }),
        i("click", (l, o) => {
            let { nextEl: w, prevEl: y } = e.navigation;
            (w = G(w)), (y = G(y));
            const g = o.target;
            let h = y.includes(g) || w.includes(g);
            if (e.isElement && !h) {
                const S = o.path || (o.composedPath && o.composedPath());
                S && (h = S.find((b) => w.includes(b) || y.includes(b)));
            }
            if (e.params.navigation.hideOnClick && !h) {
                if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === g || e.pagination.el.contains(g))) return;
                let S;
                w.length ? (S = w[0].classList.contains(e.params.navigation.hiddenClass)) : y.length && (S = y[0].classList.contains(e.params.navigation.hiddenClass)),
                    n(S === !0 ? "navigationShow" : "navigationHide"),
                    [...w, ...y].filter((b) => !!b).forEach((b) => b.classList.toggle(e.params.navigation.hiddenClass));
            }
        });
    const v = () => {
            e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), f(), c();
        },
        m = () => {
            e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), p();
        };
    Object.assign(e.navigation, { enable: v, disable: m, update: c, init: f, destroy: p });
}
function se(s) {
    return (
        s === void 0 && (s = ""),
        `.${s
            .trim()
            .replace(/([\.:!+\/])/g, "\\$1")
            .replace(/ /g, ".")}`
    );
}
function zs(s) {
    let { swiper: e, extendParams: t, on: i, emit: n } = s;
    const r = "swiper-pagination";
    t({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: (g) => g,
            formatFractionTotal: (g) => g,
            bulletClass: `${r}-bullet`,
            bulletActiveClass: `${r}-bullet-active`,
            modifierClass: `${r}-`,
            currentClass: `${r}-current`,
            totalClass: `${r}-total`,
            hiddenClass: `${r}-hidden`,
            progressbarFillClass: `${r}-progressbar-fill`,
            progressbarOppositeClass: `${r}-progressbar-opposite`,
            clickableClass: `${r}-clickable`,
            lockClass: `${r}-lock`,
            horizontalClass: `${r}-horizontal`,
            verticalClass: `${r}-vertical`,
            paginationDisabledClass: `${r}-disabled`,
        },
    }),
        (e.pagination = { el: null, bullets: [] });
    let d,
        c = 0;
    function a() {
        return !e.params.pagination.el || !e.pagination.el || (Array.isArray(e.pagination.el) && e.pagination.el.length === 0);
    }
    function u(g, h) {
        const { bulletActiveClass: S } = e.params.pagination;
        g && ((g = g[`${h === "prev" ? "previous" : "next"}ElementSibling`]), g && (g.classList.add(`${S}-${h}`), (g = g[`${h === "prev" ? "previous" : "next"}ElementSibling`]), g && g.classList.add(`${S}-${h}-${h}`)));
    }
    function f(g, h, S) {
        if (((g = g % S), (h = h % S), h === g + 1)) return "next";
        if (h === g - 1) return "previous";
    }
    function p(g) {
        const h = g.target.closest(se(e.params.pagination.bulletClass));
        if (!h) return;
        g.preventDefault();
        const S = Ee(h) * e.params.slidesPerGroup;
        if (e.params.loop) {
            if (e.realIndex === S) return;
            const b = f(e.realIndex, S, e.slides.length);
            b === "next" ? e.slideNext() : b === "previous" ? e.slidePrev() : e.slideToLoop(S);
        } else e.slideTo(S);
    }
    function v() {
        const g = e.rtl,
            h = e.params.pagination;
        if (a()) return;
        let S = e.pagination.el;
        S = G(S);
        let b, z;
        const $ = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
            O = e.params.loop ? Math.ceil($ / e.params.slidesPerGroup) : e.snapGrid.length;
        if (
            (e.params.loop
                ? ((z = e.previousRealIndex || 0), (b = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex))
                : typeof e.snapIndex < "u"
                ? ((b = e.snapIndex), (z = e.previousSnapIndex))
                : ((z = e.previousIndex || 0), (b = e.activeIndex || 0)),
            h.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0)
        ) {
            const P = e.pagination.bullets;
            let L, A, M;
            if (
                (h.dynamicBullets &&
                    ((d = Ye(P[0], e.isHorizontal() ? "width" : "height")),
                    S.forEach((E) => {
                        E.style[e.isHorizontal() ? "width" : "height"] = `${d * (h.dynamicMainBullets + 4)}px`;
                    }),
                    h.dynamicMainBullets > 1 && z !== void 0 && ((c += b - (z || 0)), c > h.dynamicMainBullets - 1 ? (c = h.dynamicMainBullets - 1) : c < 0 && (c = 0)),
                    (L = Math.max(b - c, 0)),
                    (A = L + (Math.min(P.length, h.dynamicMainBullets) - 1)),
                    (M = (A + L) / 2)),
                P.forEach((E) => {
                    const x = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((D) => `${h.bulletActiveClass}${D}`)].map((D) => (typeof D == "string" && D.includes(" ") ? D.split(" ") : D)).flat();
                    E.classList.remove(...x);
                }),
                S.length > 1)
            )
                P.forEach((E) => {
                    const x = Ee(E);
                    x === b ? E.classList.add(...h.bulletActiveClass.split(" ")) : e.isElement && E.setAttribute("part", "bullet"),
                        h.dynamicBullets && (x >= L && x <= A && E.classList.add(...`${h.bulletActiveClass}-main`.split(" ")), x === L && u(E, "prev"), x === A && u(E, "next"));
                });
            else {
                const E = P[b];
                if (
                    (E && E.classList.add(...h.bulletActiveClass.split(" ")),
                    e.isElement &&
                        P.forEach((x, D) => {
                            x.setAttribute("part", D === b ? "bullet-active" : "bullet");
                        }),
                    h.dynamicBullets)
                ) {
                    const x = P[L],
                        D = P[A];
                    for (let q = L; q <= A; q += 1) P[q] && P[q].classList.add(...`${h.bulletActiveClass}-main`.split(" "));
                    u(x, "prev"), u(D, "next");
                }
            }
            if (h.dynamicBullets) {
                const E = Math.min(P.length, h.dynamicMainBullets + 4),
                    x = (d * E - d) / 2 - M * d,
                    D = g ? "right" : "left";
                P.forEach((q) => {
                    q.style[e.isHorizontal() ? D : "top"] = `${x}px`;
                });
            }
        }
        S.forEach((P, L) => {
            if (
                (h.type === "fraction" &&
                    (P.querySelectorAll(se(h.currentClass)).forEach((A) => {
                        A.textContent = h.formatFractionCurrent(b + 1);
                    }),
                    P.querySelectorAll(se(h.totalClass)).forEach((A) => {
                        A.textContent = h.formatFractionTotal(O);
                    })),
                h.type === "progressbar")
            ) {
                let A;
                h.progressbarOpposite ? (A = e.isHorizontal() ? "vertical" : "horizontal") : (A = e.isHorizontal() ? "horizontal" : "vertical");
                const M = (b + 1) / O;
                let E = 1,
                    x = 1;
                A === "horizontal" ? (E = M) : (x = M),
                    P.querySelectorAll(se(h.progressbarFillClass)).forEach((D) => {
                        (D.style.transform = `translate3d(0,0,0) scaleX(${E}) scaleY(${x})`), (D.style.transitionDuration = `${e.params.speed}ms`);
                    });
            }
            h.type === "custom" && h.renderCustom ? ((P.innerHTML = h.renderCustom(e, b + 1, O)), L === 0 && n("paginationRender", P)) : (L === 0 && n("paginationRender", P), n("paginationUpdate", P)),
                e.params.watchOverflow && e.enabled && P.classList[e.isLocked ? "add" : "remove"](h.lockClass);
        });
    }
    function m() {
        const g = e.params.pagination;
        if (a()) return;
        const h = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
        let S = e.pagination.el;
        S = G(S);
        let b = "";
        if (g.type === "bullets") {
            let z = e.params.loop ? Math.ceil(h / e.params.slidesPerGroup) : e.snapGrid.length;
            e.params.freeMode && e.params.freeMode.enabled && z > h && (z = h);
            for (let $ = 0; $ < z; $ += 1) g.renderBullet ? (b += g.renderBullet.call(e, $, g.bulletClass)) : (b += `<${g.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${g.bulletClass}"></${g.bulletElement}>`);
        }
        g.type === "fraction" && (g.renderFraction ? (b = g.renderFraction.call(e, g.currentClass, g.totalClass)) : (b = `<span class="${g.currentClass}"></span> / <span class="${g.totalClass}"></span>`)),
            g.type === "progressbar" && (g.renderProgressbar ? (b = g.renderProgressbar.call(e, g.progressbarFillClass)) : (b = `<span class="${g.progressbarFillClass}"></span>`)),
            (e.pagination.bullets = []),
            S.forEach((z) => {
                g.type !== "custom" && (z.innerHTML = b || ""), g.type === "bullets" && e.pagination.bullets.push(...z.querySelectorAll(se(g.bulletClass)));
            }),
            g.type !== "custom" && n("paginationRender", S[0]);
    }
    function l() {
        e.params.pagination = We(e, e.originalParams.pagination, e.params.pagination, { el: "swiper-pagination" });
        const g = e.params.pagination;
        if (!g.el) return;
        let h;
        typeof g.el == "string" && e.isElement && (h = e.el.querySelector(g.el)),
            !h && typeof g.el == "string" && (h = [...document.querySelectorAll(g.el)]),
            h || (h = g.el),
            !(!h || h.length === 0) &&
                (e.params.uniqueNavElements && typeof g.el == "string" && Array.isArray(h) && h.length > 1 && ((h = [...e.el.querySelectorAll(g.el)]), h.length > 1 && (h = h.find((S) => oe(S, ".swiper")[0] === e.el))),
                Array.isArray(h) && h.length === 1 && (h = h[0]),
                Object.assign(e.pagination, { el: h }),
                (h = G(h)),
                h.forEach((S) => {
                    g.type === "bullets" && g.clickable && S.classList.add(...(g.clickableClass || "").split(" ")),
                        S.classList.add(g.modifierClass + g.type),
                        S.classList.add(e.isHorizontal() ? g.horizontalClass : g.verticalClass),
                        g.type === "bullets" && g.dynamicBullets && (S.classList.add(`${g.modifierClass}${g.type}-dynamic`), (c = 0), g.dynamicMainBullets < 1 && (g.dynamicMainBullets = 1)),
                        g.type === "progressbar" && g.progressbarOpposite && S.classList.add(g.progressbarOppositeClass),
                        g.clickable && S.addEventListener("click", p),
                        e.enabled || S.classList.add(g.lockClass);
                }));
    }
    function o() {
        const g = e.params.pagination;
        if (a()) return;
        let h = e.pagination.el;
        h &&
            ((h = G(h)),
            h.forEach((S) => {
                S.classList.remove(g.hiddenClass),
                    S.classList.remove(g.modifierClass + g.type),
                    S.classList.remove(e.isHorizontal() ? g.horizontalClass : g.verticalClass),
                    g.clickable && (S.classList.remove(...(g.clickableClass || "").split(" ")), S.removeEventListener("click", p));
            })),
            e.pagination.bullets && e.pagination.bullets.forEach((S) => S.classList.remove(...g.bulletActiveClass.split(" ")));
    }
    i("changeDirection", () => {
        if (!e.pagination || !e.pagination.el) return;
        const g = e.params.pagination;
        let { el: h } = e.pagination;
        (h = G(h)),
            h.forEach((S) => {
                S.classList.remove(g.horizontalClass, g.verticalClass), S.classList.add(e.isHorizontal() ? g.horizontalClass : g.verticalClass);
            });
    }),
        i("init", () => {
            e.params.pagination.enabled === !1 ? y() : (l(), m(), v());
        }),
        i("activeIndexChange", () => {
            typeof e.snapIndex > "u" && v();
        }),
        i("snapIndexChange", () => {
            v();
        }),
        i("snapGridLengthChange", () => {
            m(), v();
        }),
        i("destroy", () => {
            o();
        }),
        i("enable disable", () => {
            let { el: g } = e.pagination;
            g && ((g = G(g)), g.forEach((h) => h.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
        }),
        i("lock unlock", () => {
            v();
        }),
        i("click", (g, h) => {
            const S = h.target,
                b = G(e.pagination.el);
            if (e.params.pagination.el && e.params.pagination.hideOnClick && b && b.length > 0 && !S.classList.contains(e.params.pagination.bulletClass)) {
                if (e.navigation && ((e.navigation.nextEl && S === e.navigation.nextEl) || (e.navigation.prevEl && S === e.navigation.prevEl))) return;
                const z = b[0].classList.contains(e.params.pagination.hiddenClass);
                n(z === !0 ? "paginationShow" : "paginationHide"), b.forEach(($) => $.classList.toggle(e.params.pagination.hiddenClass));
            }
        });
    const w = () => {
            e.el.classList.remove(e.params.pagination.paginationDisabledClass);
            let { el: g } = e.pagination;
            g && ((g = G(g)), g.forEach((h) => h.classList.remove(e.params.pagination.paginationDisabledClass))), l(), m(), v();
        },
        y = () => {
            e.el.classList.add(e.params.pagination.paginationDisabledClass);
            let { el: g } = e.pagination;
            g && ((g = G(g)), g.forEach((h) => h.classList.add(e.params.pagination.paginationDisabledClass))), o();
        };
    Object.assign(e.pagination, { enable: w, disable: y, render: m, update: v, init: l, destroy: o });
}
function Os(s) {
    let { swiper: e, extendParams: t, on: i, emit: n } = s;
    const r = N();
    let d = !1,
        c = null,
        a = null,
        u,
        f,
        p,
        v;
    t({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: !1,
            draggable: !1,
            snapOnRelease: !0,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: "swiper-scrollbar-horizontal",
            verticalClass: "swiper-scrollbar-vertical",
        },
    }),
        (e.scrollbar = { el: null, dragEl: null });
    function m() {
        if (!e.params.scrollbar.el || !e.scrollbar.el) return;
        const { scrollbar: M, rtlTranslate: E } = e,
            { dragEl: x, el: D } = M,
            q = e.params.scrollbar,
            C = e.params.loop ? e.progressLoop : e.progress;
        let I = f,
            H = (p - f) * C;
        E ? ((H = -H), H > 0 ? ((I = f - H), (H = 0)) : -H + f > p && (I = p + H)) : H < 0 ? ((I = f + H), (H = 0)) : H + f > p && (I = p - H),
            e.isHorizontal() ? ((x.style.transform = `translate3d(${H}px, 0, 0)`), (x.style.width = `${I}px`)) : ((x.style.transform = `translate3d(0px, ${H}px, 0)`), (x.style.height = `${I}px`)),
            q.hide &&
                (clearTimeout(c),
                (D.style.opacity = 1),
                (c = setTimeout(() => {
                    (D.style.opacity = 0), (D.style.transitionDuration = "400ms");
                }, 1e3)));
    }
    function l(M) {
        !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = `${M}ms`);
    }
    function o() {
        if (!e.params.scrollbar.el || !e.scrollbar.el) return;
        const { scrollbar: M } = e,
            { dragEl: E, el: x } = M;
        (E.style.width = ""),
            (E.style.height = ""),
            (p = e.isHorizontal() ? x.offsetWidth : x.offsetHeight),
            (v = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0))),
            e.params.scrollbar.dragSize === "auto" ? (f = p * v) : (f = parseInt(e.params.scrollbar.dragSize, 10)),
            e.isHorizontal() ? (E.style.width = `${f}px`) : (E.style.height = `${f}px`),
            v >= 1 ? (x.style.display = "none") : (x.style.display = ""),
            e.params.scrollbar.hide && (x.style.opacity = 0),
            e.params.watchOverflow && e.enabled && M.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
    }
    function w(M) {
        return e.isHorizontal() ? M.clientX : M.clientY;
    }
    function y(M) {
        const { scrollbar: E, rtlTranslate: x } = e,
            { el: D } = E;
        let q;
        (q = (w(M) - Ie(D)[e.isHorizontal() ? "left" : "top"] - (u !== null ? u : f / 2)) / (p - f)), (q = Math.max(Math.min(q, 1), 0)), x && (q = 1 - q);
        const C = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * q;
        e.updateProgress(C), e.setTranslate(C), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    function g(M) {
        const E = e.params.scrollbar,
            { scrollbar: x, wrapperEl: D } = e,
            { el: q, dragEl: C } = x;
        (d = !0),
            (u = M.target === C ? w(M) - M.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null),
            M.preventDefault(),
            M.stopPropagation(),
            (D.style.transitionDuration = "100ms"),
            (C.style.transitionDuration = "100ms"),
            y(M),
            clearTimeout(a),
            (q.style.transitionDuration = "0ms"),
            E.hide && (q.style.opacity = 1),
            e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"),
            n("scrollbarDragStart", M);
    }
    function h(M) {
        const { scrollbar: E, wrapperEl: x } = e,
            { el: D, dragEl: q } = E;
        d && (M.preventDefault && M.cancelable ? M.preventDefault() : (M.returnValue = !1), y(M), (x.style.transitionDuration = "0ms"), (D.style.transitionDuration = "0ms"), (q.style.transitionDuration = "0ms"), n("scrollbarDragMove", M));
    }
    function S(M) {
        const E = e.params.scrollbar,
            { scrollbar: x, wrapperEl: D } = e,
            { el: q } = x;
        d &&
            ((d = !1),
            e.params.cssMode && ((e.wrapperEl.style["scroll-snap-type"] = ""), (D.style.transitionDuration = "")),
            E.hide &&
                (clearTimeout(a),
                (a = de(() => {
                    (q.style.opacity = 0), (q.style.transitionDuration = "400ms");
                }, 1e3))),
            n("scrollbarDragEnd", M),
            E.snapOnRelease && e.slideToClosest());
    }
    function b(M) {
        const { scrollbar: E, params: x } = e,
            D = E.el;
        if (!D) return;
        const q = D,
            C = x.passiveListeners ? { passive: !1, capture: !1 } : !1,
            I = x.passiveListeners ? { passive: !0, capture: !1 } : !1;
        if (!q) return;
        const H = M === "on" ? "addEventListener" : "removeEventListener";
        q[H]("pointerdown", g, C), r[H]("pointermove", h, C), r[H]("pointerup", S, I);
    }
    function z() {
        !e.params.scrollbar.el || !e.scrollbar.el || b("on");
    }
    function $() {
        !e.params.scrollbar.el || !e.scrollbar.el || b("off");
    }
    function O() {
        const { scrollbar: M, el: E } = e;
        e.params.scrollbar = We(e, e.originalParams.scrollbar, e.params.scrollbar, { el: "swiper-scrollbar" });
        const x = e.params.scrollbar;
        if (!x.el) return;
        let D;
        if ((typeof x.el == "string" && e.isElement && (D = e.el.querySelector(x.el)), !D && typeof x.el == "string")) {
            if (((D = r.querySelectorAll(x.el)), !D.length)) return;
        } else D || (D = x.el);
        e.params.uniqueNavElements && typeof x.el == "string" && D.length > 1 && E.querySelectorAll(x.el).length === 1 && (D = E.querySelector(x.el)),
            D.length > 0 && (D = D[0]),
            D.classList.add(e.isHorizontal() ? x.horizontalClass : x.verticalClass);
        let q;
        D && ((q = D.querySelector(se(e.params.scrollbar.dragClass))), q || ((q = Z("div", e.params.scrollbar.dragClass)), D.append(q))),
            Object.assign(M, { el: D, dragEl: q }),
            x.draggable && z(),
            D && D.classList[e.enabled ? "remove" : "add"](...ae(e.params.scrollbar.lockClass));
    }
    function P() {
        const M = e.params.scrollbar,
            E = e.scrollbar.el;
        E && E.classList.remove(...ae(e.isHorizontal() ? M.horizontalClass : M.verticalClass)), $();
    }
    i("changeDirection", () => {
        if (!e.scrollbar || !e.scrollbar.el) return;
        const M = e.params.scrollbar;
        let { el: E } = e.scrollbar;
        (E = G(E)),
            E.forEach((x) => {
                x.classList.remove(M.horizontalClass, M.verticalClass), x.classList.add(e.isHorizontal() ? M.horizontalClass : M.verticalClass);
            });
    }),
        i("init", () => {
            e.params.scrollbar.enabled === !1 ? A() : (O(), o(), m());
        }),
        i("update resize observerUpdate lock unlock changeDirection", () => {
            o();
        }),
        i("setTranslate", () => {
            m();
        }),
        i("setTransition", (M, E) => {
            l(E);
        }),
        i("enable disable", () => {
            const { el: M } = e.scrollbar;
            M && M.classList[e.enabled ? "remove" : "add"](...ae(e.params.scrollbar.lockClass));
        }),
        i("destroy", () => {
            P();
        });
    const L = () => {
            e.el.classList.remove(...ae(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.remove(...ae(e.params.scrollbar.scrollbarDisabledClass)), O(), o(), m();
        },
        A = () => {
            e.el.classList.add(...ae(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.add(...ae(e.params.scrollbar.scrollbarDisabledClass)), P();
        };
    Object.assign(e.scrollbar, { enable: L, disable: A, updateSize: o, setTranslate: m, init: O, destroy: P });
}
function Ds(s) {
    let { swiper: e, extendParams: t, on: i } = s;
    t({ parallax: { enabled: !1 } });
    const n = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]",
        r = (a, u) => {
            const { rtl: f } = e,
                p = f ? -1 : 1,
                v = a.getAttribute("data-swiper-parallax") || "0";
            let m = a.getAttribute("data-swiper-parallax-x"),
                l = a.getAttribute("data-swiper-parallax-y");
            const o = a.getAttribute("data-swiper-parallax-scale"),
                w = a.getAttribute("data-swiper-parallax-opacity"),
                y = a.getAttribute("data-swiper-parallax-rotate");
            if (
                (m || l ? ((m = m || "0"), (l = l || "0")) : e.isHorizontal() ? ((m = v), (l = "0")) : ((l = v), (m = "0")),
                m.indexOf("%") >= 0 ? (m = `${parseInt(m, 10) * u * p}%`) : (m = `${m * u * p}px`),
                l.indexOf("%") >= 0 ? (l = `${parseInt(l, 10) * u}%`) : (l = `${l * u}px`),
                typeof w < "u" && w !== null)
            ) {
                const h = w - (w - 1) * (1 - Math.abs(u));
                a.style.opacity = h;
            }
            let g = `translate3d(${m}, ${l}, 0px)`;
            if (typeof o < "u" && o !== null) {
                const h = o - (o - 1) * (1 - Math.abs(u));
                g += ` scale(${h})`;
            }
            if (y && typeof y < "u" && y !== null) {
                const h = y * u * -1;
                g += ` rotate(${h}deg)`;
            }
            a.style.transform = g;
        },
        d = () => {
            const { el: a, slides: u, progress: f, snapGrid: p, isElement: v } = e,
                m = W(a, n);
            e.isElement && m.push(...W(e.hostEl, n)),
                m.forEach((l) => {
                    r(l, f);
                }),
                u.forEach((l, o) => {
                    let w = l.progress;
                    e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (w += Math.ceil(o / 2) - f * (p.length - 1)),
                        (w = Math.min(Math.max(w, -1), 1)),
                        l.querySelectorAll(`${n}, [data-swiper-parallax-rotate]`).forEach((y) => {
                            r(y, w);
                        });
                });
        },
        c = function (a) {
            a === void 0 && (a = e.params.speed);
            const { el: u, hostEl: f } = e,
                p = [...u.querySelectorAll(n)];
            e.isElement && p.push(...f.querySelectorAll(n)),
                p.forEach((v) => {
                    let m = parseInt(v.getAttribute("data-swiper-parallax-duration"), 10) || a;
                    a === 0 && (m = 0), (v.style.transitionDuration = `${m}ms`);
                });
        };
    i("beforeInit", () => {
        e.params.parallax.enabled && ((e.params.watchSlidesProgress = !0), (e.originalParams.watchSlidesProgress = !0));
    }),
        i("init", () => {
            e.params.parallax.enabled && d();
        }),
        i("setTranslate", () => {
            e.params.parallax.enabled && d();
        }),
        i("setTransition", (a, u) => {
            e.params.parallax.enabled && c(u);
        });
}
function $s(s) {
    let { swiper: e, extendParams: t, on: i, emit: n } = s;
    const r = R();
    t({ zoom: { enabled: !1, limitToOriginalSize: !1, maxRatio: 3, minRatio: 1, panOnMouseMove: !1, toggle: !0, containerClass: "swiper-zoom-container", zoomedSlideClass: "swiper-slide-zoomed" } }), (e.zoom = { enabled: !1 });
    let d = 1,
        c = !1,
        a = !1,
        u = { x: 0, y: 0 };
    const f = -3;
    let p, v;
    const m = [],
        l = { originX: 0, originY: 0, slideEl: void 0, slideWidth: void 0, slideHeight: void 0, imageEl: void 0, imageWrapEl: void 0, maxRatio: 3 },
        o = {
            isTouched: void 0,
            isMoved: void 0,
            currentX: void 0,
            currentY: void 0,
            minX: void 0,
            minY: void 0,
            maxX: void 0,
            maxY: void 0,
            width: void 0,
            height: void 0,
            startX: void 0,
            startY: void 0,
            touchesStart: {},
            touchesCurrent: {},
        },
        w = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 };
    let y = 1;
    Object.defineProperty(e.zoom, "scale", {
        get() {
            return y;
        },
        set(T) {
            if (y !== T) {
                const k = l.imageEl,
                    B = l.slideEl;
                n("zoomChange", T, k, B);
            }
            y = T;
        },
    });
    function g() {
        if (m.length < 2) return 1;
        const T = m[0].pageX,
            k = m[0].pageY,
            B = m[1].pageX,
            V = m[1].pageY;
        return Math.sqrt((B - T) ** 2 + (V - k) ** 2);
    }
    function h() {
        const T = e.params.zoom,
            k = l.imageWrapEl.getAttribute("data-swiper-zoom") || T.maxRatio;
        if (T.limitToOriginalSize && l.imageEl && l.imageEl.naturalWidth) {
            const B = l.imageEl.naturalWidth / l.imageEl.offsetWidth;
            return Math.min(B, k);
        }
        return k;
    }
    function S() {
        if (m.length < 2) return { x: null, y: null };
        const T = l.imageEl.getBoundingClientRect();
        return [(m[0].pageX + (m[1].pageX - m[0].pageX) / 2 - T.x - r.scrollX) / d, (m[0].pageY + (m[1].pageY - m[0].pageY) / 2 - T.y - r.scrollY) / d];
    }
    function b() {
        return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
    }
    function z(T) {
        const k = b();
        return !!(T.target.matches(k) || e.slides.filter((B) => B.contains(T.target)).length > 0);
    }
    function $(T) {
        const k = `.${e.params.zoom.containerClass}`;
        return !!(T.target.matches(k) || [...e.hostEl.querySelectorAll(k)].filter((B) => B.contains(T.target)).length > 0);
    }
    function O(T) {
        if ((T.pointerType === "mouse" && m.splice(0, m.length), !z(T))) return;
        const k = e.params.zoom;
        if (((p = !1), (v = !1), m.push(T), !(m.length < 2))) {
            if (((p = !0), (l.scaleStart = g()), !l.slideEl)) {
                (l.slideEl = T.target.closest(`.${e.params.slideClass}, swiper-slide`)), l.slideEl || (l.slideEl = e.slides[e.activeIndex]);
                let B = l.slideEl.querySelector(`.${k.containerClass}`);
                if ((B && (B = B.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), (l.imageEl = B), B ? (l.imageWrapEl = oe(l.imageEl, `.${k.containerClass}`)[0]) : (l.imageWrapEl = void 0), !l.imageWrapEl)) {
                    l.imageEl = void 0;
                    return;
                }
                l.maxRatio = h();
            }
            if (l.imageEl) {
                const [B, V] = S();
                (l.originX = B), (l.originY = V), (l.imageEl.style.transitionDuration = "0ms");
            }
            c = !0;
        }
    }
    function P(T) {
        if (!z(T)) return;
        const k = e.params.zoom,
            B = e.zoom,
            V = m.findIndex((j) => j.pointerId === T.pointerId);
        V >= 0 && (m[V] = T),
            !(m.length < 2) &&
                ((v = !0),
                (l.scaleMove = g()),
                l.imageEl &&
                    ((B.scale = (l.scaleMove / l.scaleStart) * d),
                    B.scale > l.maxRatio && (B.scale = l.maxRatio - 1 + (B.scale - l.maxRatio + 1) ** 0.5),
                    B.scale < k.minRatio && (B.scale = k.minRatio + 1 - (k.minRatio - B.scale + 1) ** 0.5),
                    (l.imageEl.style.transform = `translate3d(0,0,0) scale(${B.scale})`)));
    }
    function L(T) {
        if (!z(T) || (T.pointerType === "mouse" && T.type === "pointerout")) return;
        const k = e.params.zoom,
            B = e.zoom,
            V = m.findIndex((j) => j.pointerId === T.pointerId);
        V >= 0 && m.splice(V, 1),
            !(!p || !v) &&
                ((p = !1),
                (v = !1),
                l.imageEl &&
                    ((B.scale = Math.max(Math.min(B.scale, l.maxRatio), k.minRatio)),
                    (l.imageEl.style.transitionDuration = `${e.params.speed}ms`),
                    (l.imageEl.style.transform = `translate3d(0,0,0) scale(${B.scale})`),
                    (d = B.scale),
                    (c = !1),
                    B.scale > 1 && l.slideEl ? l.slideEl.classList.add(`${k.zoomedSlideClass}`) : B.scale <= 1 && l.slideEl && l.slideEl.classList.remove(`${k.zoomedSlideClass}`),
                    B.scale === 1 && ((l.originX = 0), (l.originY = 0), (l.slideEl = void 0))));
    }
    let A;
    function M() {
        e.touchEventsData.preventTouchMoveFromPointerMove = !1;
    }
    function E() {
        clearTimeout(A),
            (e.touchEventsData.preventTouchMoveFromPointerMove = !0),
            (A = setTimeout(() => {
                e.destroyed || M();
            }));
    }
    function x(T) {
        const k = e.device;
        if (!l.imageEl || o.isTouched) return;
        k.android && T.cancelable && T.preventDefault(), (o.isTouched = !0);
        const B = m.length > 0 ? m[0] : T;
        (o.touchesStart.x = B.pageX), (o.touchesStart.y = B.pageY);
    }
    function D(T) {
        const B = T.pointerType === "mouse" && e.params.zoom.panOnMouseMove;
        if (!z(T) || !$(T)) return;
        const V = e.zoom;
        if (!l.imageEl) return;
        if (!o.isTouched || !l.slideEl) {
            B && I(T);
            return;
        }
        if (B) {
            I(T);
            return;
        }
        o.isMoved ||
            ((o.width = l.imageEl.offsetWidth || l.imageEl.clientWidth),
            (o.height = l.imageEl.offsetHeight || l.imageEl.clientHeight),
            (o.startX = Xe(l.imageWrapEl, "x") || 0),
            (o.startY = Xe(l.imageWrapEl, "y") || 0),
            (l.slideWidth = l.slideEl.offsetWidth),
            (l.slideHeight = l.slideEl.offsetHeight),
            (l.imageWrapEl.style.transitionDuration = "0ms"));
        const j = o.width * V.scale,
            ie = o.height * V.scale;
        if (
            ((o.minX = Math.min(l.slideWidth / 2 - j / 2, 0)),
            (o.maxX = -o.minX),
            (o.minY = Math.min(l.slideHeight / 2 - ie / 2, 0)),
            (o.maxY = -o.minY),
            (o.touchesCurrent.x = m.length > 0 ? m[0].pageX : T.pageX),
            (o.touchesCurrent.y = m.length > 0 ? m[0].pageY : T.pageY),
            Math.max(Math.abs(o.touchesCurrent.x - o.touchesStart.x), Math.abs(o.touchesCurrent.y - o.touchesStart.y)) > 5 && (e.allowClick = !1),
            !o.isMoved && !c)
        ) {
            if (e.isHorizontal() && ((Math.floor(o.minX) === Math.floor(o.startX) && o.touchesCurrent.x < o.touchesStart.x) || (Math.floor(o.maxX) === Math.floor(o.startX) && o.touchesCurrent.x > o.touchesStart.x))) {
                (o.isTouched = !1), M();
                return;
            }
            if (!e.isHorizontal() && ((Math.floor(o.minY) === Math.floor(o.startY) && o.touchesCurrent.y < o.touchesStart.y) || (Math.floor(o.maxY) === Math.floor(o.startY) && o.touchesCurrent.y > o.touchesStart.y))) {
                (o.isTouched = !1), M();
                return;
            }
        }
        T.cancelable && T.preventDefault(), T.stopPropagation(), E(), (o.isMoved = !0);
        const ee = (V.scale - d) / (l.maxRatio - e.params.zoom.minRatio),
            { originX: ne, originY: U } = l;
        (o.currentX = o.touchesCurrent.x - o.touchesStart.x + o.startX + ee * (o.width - ne * 2)),
            (o.currentY = o.touchesCurrent.y - o.touchesStart.y + o.startY + ee * (o.height - U * 2)),
            o.currentX < o.minX && (o.currentX = o.minX + 1 - (o.minX - o.currentX + 1) ** 0.8),
            o.currentX > o.maxX && (o.currentX = o.maxX - 1 + (o.currentX - o.maxX + 1) ** 0.8),
            o.currentY < o.minY && (o.currentY = o.minY + 1 - (o.minY - o.currentY + 1) ** 0.8),
            o.currentY > o.maxY && (o.currentY = o.maxY - 1 + (o.currentY - o.maxY + 1) ** 0.8),
            w.prevPositionX || (w.prevPositionX = o.touchesCurrent.x),
            w.prevPositionY || (w.prevPositionY = o.touchesCurrent.y),
            w.prevTime || (w.prevTime = Date.now()),
            (w.x = (o.touchesCurrent.x - w.prevPositionX) / (Date.now() - w.prevTime) / 2),
            (w.y = (o.touchesCurrent.y - w.prevPositionY) / (Date.now() - w.prevTime) / 2),
            Math.abs(o.touchesCurrent.x - w.prevPositionX) < 2 && (w.x = 0),
            Math.abs(o.touchesCurrent.y - w.prevPositionY) < 2 && (w.y = 0),
            (w.prevPositionX = o.touchesCurrent.x),
            (w.prevPositionY = o.touchesCurrent.y),
            (w.prevTime = Date.now()),
            (l.imageWrapEl.style.transform = `translate3d(${o.currentX}px, ${o.currentY}px,0)`);
    }
    function q() {
        const T = e.zoom;
        if (((m.length = 0), !l.imageEl)) return;
        if (!o.isTouched || !o.isMoved) {
            (o.isTouched = !1), (o.isMoved = !1);
            return;
        }
        (o.isTouched = !1), (o.isMoved = !1);
        let k = 300,
            B = 300;
        const V = w.x * k,
            j = o.currentX + V,
            ie = w.y * B,
            re = o.currentY + ie;
        w.x !== 0 && (k = Math.abs((j - o.currentX) / w.x)), w.y !== 0 && (B = Math.abs((re - o.currentY) / w.y));
        const ee = Math.max(k, B);
        (o.currentX = j), (o.currentY = re);
        const ne = o.width * T.scale,
            U = o.height * T.scale;
        (o.minX = Math.min(l.slideWidth / 2 - ne / 2, 0)),
            (o.maxX = -o.minX),
            (o.minY = Math.min(l.slideHeight / 2 - U / 2, 0)),
            (o.maxY = -o.minY),
            (o.currentX = Math.max(Math.min(o.currentX, o.maxX), o.minX)),
            (o.currentY = Math.max(Math.min(o.currentY, o.maxY), o.minY)),
            (l.imageWrapEl.style.transitionDuration = `${ee}ms`),
            (l.imageWrapEl.style.transform = `translate3d(${o.currentX}px, ${o.currentY}px,0)`);
    }
    function C() {
        const T = e.zoom;
        l.slideEl &&
            e.activeIndex !== e.slides.indexOf(l.slideEl) &&
            (l.imageEl && (l.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
            l.imageWrapEl && (l.imageWrapEl.style.transform = "translate3d(0,0,0)"),
            l.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`),
            (T.scale = 1),
            (d = 1),
            (l.slideEl = void 0),
            (l.imageEl = void 0),
            (l.imageWrapEl = void 0),
            (l.originX = 0),
            (l.originY = 0));
    }
    function I(T) {
        if (d <= 1 || !l.imageWrapEl || !z(T) || !$(T)) return;
        const k = r.getComputedStyle(l.imageWrapEl).transform,
            B = new r.DOMMatrix(k);
        if (!a) {
            (a = !0),
                (u.x = T.clientX),
                (u.y = T.clientY),
                (o.startX = B.e),
                (o.startY = B.f),
                (o.width = l.imageEl.offsetWidth || l.imageEl.clientWidth),
                (o.height = l.imageEl.offsetHeight || l.imageEl.clientHeight),
                (l.slideWidth = l.slideEl.offsetWidth),
                (l.slideHeight = l.slideEl.offsetHeight);
            return;
        }
        const V = (T.clientX - u.x) * f,
            j = (T.clientY - u.y) * f,
            ie = o.width * d,
            re = o.height * d,
            ee = l.slideWidth,
            ne = l.slideHeight,
            U = Math.min(ee / 2 - ie / 2, 0),
            te = -U,
            me = Math.min(ne / 2 - re / 2, 0),
            Te = -me,
            he = Math.max(Math.min(o.startX + V, te), U),
            ge = Math.max(Math.min(o.startY + j, Te), me);
        (l.imageWrapEl.style.transitionDuration = "0ms"), (l.imageWrapEl.style.transform = `translate3d(${he}px, ${ge}px, 0)`), (u.x = T.clientX), (u.y = T.clientY), (o.startX = he), (o.startY = ge);
    }
    function H(T) {
        const k = e.zoom,
            B = e.params.zoom;
        if (!l.slideEl) {
            T && T.target && (l.slideEl = T.target.closest(`.${e.params.slideClass}, swiper-slide`)),
                l.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? (l.slideEl = W(e.slidesEl, `.${e.params.slideActiveClass}`)[0]) : (l.slideEl = e.slides[e.activeIndex]));
            let we = l.slideEl.querySelector(`.${B.containerClass}`);
            we && (we = we.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), (l.imageEl = we), we ? (l.imageWrapEl = oe(l.imageEl, `.${B.containerClass}`)[0]) : (l.imageWrapEl = void 0);
        }
        if (!l.imageEl || !l.imageWrapEl) return;
        e.params.cssMode && ((e.wrapperEl.style.overflow = "hidden"), (e.wrapperEl.style.touchAction = "none")), l.slideEl.classList.add(`${B.zoomedSlideClass}`);
        let V, j, ie, re, ee, ne, U, te, me, Te, he, ge, Me, Ce, Oe, De, $e, ke;
        typeof o.touchesStart.x > "u" && T ? ((V = T.pageX), (j = T.pageY)) : ((V = o.touchesStart.x), (j = o.touchesStart.y));
        const ve = typeof T == "number" ? T : null;
        d === 1 && ve && ((V = void 0), (j = void 0), (o.touchesStart.x = void 0), (o.touchesStart.y = void 0));
        const je = h();
        (k.scale = ve || je),
            (d = ve || je),
            T && !(d === 1 && ve)
                ? (($e = l.slideEl.offsetWidth),
                  (ke = l.slideEl.offsetHeight),
                  (ie = Ie(l.slideEl).left + r.scrollX),
                  (re = Ie(l.slideEl).top + r.scrollY),
                  (ee = ie + $e / 2 - V),
                  (ne = re + ke / 2 - j),
                  (me = l.imageEl.offsetWidth || l.imageEl.clientWidth),
                  (Te = l.imageEl.offsetHeight || l.imageEl.clientHeight),
                  (he = me * k.scale),
                  (ge = Te * k.scale),
                  (Me = Math.min($e / 2 - he / 2, 0)),
                  (Ce = Math.min(ke / 2 - ge / 2, 0)),
                  (Oe = -Me),
                  (De = -Ce),
                  (U = ee * k.scale),
                  (te = ne * k.scale),
                  U < Me && (U = Me),
                  U > Oe && (U = Oe),
                  te < Ce && (te = Ce),
                  te > De && (te = De))
                : ((U = 0), (te = 0)),
            ve && k.scale === 1 && ((l.originX = 0), (l.originY = 0)),
            (l.imageWrapEl.style.transitionDuration = "300ms"),
            (l.imageWrapEl.style.transform = `translate3d(${U}px, ${te}px,0)`),
            (l.imageEl.style.transitionDuration = "300ms"),
            (l.imageEl.style.transform = `translate3d(0,0,0) scale(${k.scale})`);
    }
    function _() {
        const T = e.zoom,
            k = e.params.zoom;
        if (!l.slideEl) {
            e.params.virtual && e.params.virtual.enabled && e.virtual ? (l.slideEl = W(e.slidesEl, `.${e.params.slideActiveClass}`)[0]) : (l.slideEl = e.slides[e.activeIndex]);
            let B = l.slideEl.querySelector(`.${k.containerClass}`);
            B && (B = B.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), (l.imageEl = B), B ? (l.imageWrapEl = oe(l.imageEl, `.${k.containerClass}`)[0]) : (l.imageWrapEl = void 0);
        }
        !l.imageEl ||
            !l.imageWrapEl ||
            (e.params.cssMode && ((e.wrapperEl.style.overflow = ""), (e.wrapperEl.style.touchAction = "")),
            (T.scale = 1),
            (d = 1),
            (o.touchesStart.x = void 0),
            (o.touchesStart.y = void 0),
            (l.imageWrapEl.style.transitionDuration = "300ms"),
            (l.imageWrapEl.style.transform = "translate3d(0,0,0)"),
            (l.imageEl.style.transitionDuration = "300ms"),
            (l.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
            l.slideEl.classList.remove(`${k.zoomedSlideClass}`),
            (l.slideEl = void 0),
            (l.originX = 0),
            (l.originY = 0),
            e.params.zoom.panOnMouseMove && ((u = { x: 0, y: 0 }), a && ((a = !1), (o.startX = 0), (o.startY = 0))));
    }
    function X(T) {
        const k = e.zoom;
        k.scale && k.scale !== 1 ? _() : H(T);
    }
    function F() {
        const T = e.params.passiveListeners ? { passive: !0, capture: !1 } : !1,
            k = e.params.passiveListeners ? { passive: !1, capture: !0 } : !0;
        return { passiveListener: T, activeListenerWithCapture: k };
    }
    function J() {
        const T = e.zoom;
        if (T.enabled) return;
        T.enabled = !0;
        const { passiveListener: k, activeListenerWithCapture: B } = F();
        e.wrapperEl.addEventListener("pointerdown", O, k),
            e.wrapperEl.addEventListener("pointermove", P, B),
            ["pointerup", "pointercancel", "pointerout"].forEach((V) => {
                e.wrapperEl.addEventListener(V, L, k);
            }),
            e.wrapperEl.addEventListener("pointermove", D, B);
    }
    function pe() {
        const T = e.zoom;
        if (!T.enabled) return;
        T.enabled = !1;
        const { passiveListener: k, activeListenerWithCapture: B } = F();
        e.wrapperEl.removeEventListener("pointerdown", O, k),
            e.wrapperEl.removeEventListener("pointermove", P, B),
            ["pointerup", "pointercancel", "pointerout"].forEach((V) => {
                e.wrapperEl.removeEventListener(V, L, k);
            }),
            e.wrapperEl.removeEventListener("pointermove", D, B);
    }
    i("init", () => {
        e.params.zoom.enabled && J();
    }),
        i("destroy", () => {
            pe();
        }),
        i("touchStart", (T, k) => {
            e.zoom.enabled && x(k);
        }),
        i("touchEnd", (T, k) => {
            e.zoom.enabled && q();
        }),
        i("doubleTap", (T, k) => {
            !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && X(k);
        }),
        i("transitionEnd", () => {
            e.zoom.enabled && e.params.zoom.enabled && C();
        }),
        i("slideChange", () => {
            e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && C();
        }),
        Object.assign(e.zoom, { enable: J, disable: pe, in: H, out: _, toggle: X });
}
function ks(s) {
    let { swiper: e, extendParams: t, on: i } = s;
    t({ controller: { control: void 0, inverse: !1, by: "slide" } }), (e.controller = { control: void 0 });
    function n(u, f) {
        const p = (function () {
            let o, w, y;
            return (g, h) => {
                for (w = -1, o = g.length; o - w > 1; ) (y = (o + w) >> 1), g[y] <= h ? (w = y) : (o = y);
                return o;
            };
        })();
        (this.x = u), (this.y = f), (this.lastIndex = u.length - 1);
        let v, m;
        return (
            (this.interpolate = function (o) {
                return o ? ((m = p(this.x, o)), (v = m - 1), ((o - this.x[v]) * (this.y[m] - this.y[v])) / (this.x[m] - this.x[v]) + this.y[v]) : 0;
            }),
            this
        );
    }
    function r(u) {
        e.controller.spline = e.params.loop ? new n(e.slidesGrid, u.slidesGrid) : new n(e.snapGrid, u.snapGrid);
    }
    function d(u, f) {
        const p = e.controller.control;
        let v, m;
        const l = e.constructor;
        function o(w) {
            if (w.destroyed) return;
            const y = e.rtlTranslate ? -e.translate : e.translate;
            e.params.controller.by === "slide" && (r(w), (m = -e.controller.spline.interpolate(-y))),
                (!m || e.params.controller.by === "container") &&
                    ((v = (w.maxTranslate() - w.minTranslate()) / (e.maxTranslate() - e.minTranslate())), (Number.isNaN(v) || !Number.isFinite(v)) && (v = 1), (m = (y - e.minTranslate()) * v + w.minTranslate())),
                e.params.controller.inverse && (m = w.maxTranslate() - m),
                w.updateProgress(m),
                w.setTranslate(m, e),
                w.updateActiveIndex(),
                w.updateSlidesClasses();
        }
        if (Array.isArray(p)) for (let w = 0; w < p.length; w += 1) p[w] !== f && p[w] instanceof l && o(p[w]);
        else p instanceof l && f !== p && o(p);
    }
    function c(u, f) {
        const p = e.constructor,
            v = e.controller.control;
        let m;
        function l(o) {
            o.destroyed ||
                (o.setTransition(u, e),
                u !== 0 &&
                    (o.transitionStart(),
                    o.params.autoHeight &&
                        de(() => {
                            o.updateAutoHeight();
                        }),
                    be(o.wrapperEl, () => {
                        v && o.transitionEnd();
                    })));
        }
        if (Array.isArray(v)) for (m = 0; m < v.length; m += 1) v[m] !== f && v[m] instanceof p && l(v[m]);
        else v instanceof p && f !== v && l(v);
    }
    function a() {
        e.controller.control && e.controller.spline && ((e.controller.spline = void 0), delete e.controller.spline);
    }
    i("beforeInit", () => {
        if (typeof window < "u" && (typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
            (typeof e.params.controller.control == "string" ? [...document.querySelectorAll(e.params.controller.control)] : [e.params.controller.control]).forEach((f) => {
                if ((e.controller.control || (e.controller.control = []), f && f.swiper)) e.controller.control.push(f.swiper);
                else if (f) {
                    const p = `${e.params.eventsPrefix}init`,
                        v = (m) => {
                            e.controller.control.push(m.detail[0]), e.update(), f.removeEventListener(p, v);
                        };
                    f.addEventListener(p, v);
                }
            });
            return;
        }
        e.controller.control = e.params.controller.control;
    }),
        i("update", () => {
            a();
        }),
        i("resize", () => {
            a();
        }),
        i("observerUpdate", () => {
            a();
        }),
        i("setTranslate", (u, f, p) => {
            !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(f, p);
        }),
        i("setTransition", (u, f, p) => {
            !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(f, p);
        }),
        Object.assign(e.controller, { setTranslate: d, setTransition: c });
}
function Bs(s) {
    let { swiper: e, extendParams: t, on: i } = s;
    t({
        a11y: {
            enabled: !0,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null,
            scrollOnFocus: !0,
        },
    }),
        (e.a11y = { clicked: !1 });
    let n = null,
        r,
        d,
        c = new Date().getTime();
    function a(C) {
        const I = n;
        I.length !== 0 && ((I.innerHTML = ""), (I.innerHTML = C));
    }
    function u(C) {
        const I = () => Math.round(16 * Math.random()).toString(16);
        return "x".repeat(C).replace(/x/g, I);
    }
    function f(C) {
        (C = G(C)),
            C.forEach((I) => {
                I.setAttribute("tabIndex", "0");
            });
    }
    function p(C) {
        (C = G(C)),
            C.forEach((I) => {
                I.setAttribute("tabIndex", "-1");
            });
    }
    function v(C, I) {
        (C = G(C)),
            C.forEach((H) => {
                H.setAttribute("role", I);
            });
    }
    function m(C, I) {
        (C = G(C)),
            C.forEach((H) => {
                H.setAttribute("aria-roledescription", I);
            });
    }
    function l(C, I) {
        (C = G(C)),
            C.forEach((H) => {
                H.setAttribute("aria-controls", I);
            });
    }
    function o(C, I) {
        (C = G(C)),
            C.forEach((H) => {
                H.setAttribute("aria-label", I);
            });
    }
    function w(C, I) {
        (C = G(C)),
            C.forEach((H) => {
                H.setAttribute("id", I);
            });
    }
    function y(C, I) {
        (C = G(C)),
            C.forEach((H) => {
                H.setAttribute("aria-live", I);
            });
    }
    function g(C) {
        (C = G(C)),
            C.forEach((I) => {
                I.setAttribute("aria-disabled", !0);
            });
    }
    function h(C) {
        (C = G(C)),
            C.forEach((I) => {
                I.setAttribute("aria-disabled", !1);
            });
    }
    function S(C) {
        if (C.keyCode !== 13 && C.keyCode !== 32) return;
        const I = e.params.a11y,
            H = C.target;
        if (!(e.pagination && e.pagination.el && (H === e.pagination.el || e.pagination.el.contains(C.target)) && !C.target.matches(se(e.params.pagination.bulletClass)))) {
            if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
                const _ = G(e.navigation.prevEl);
                G(e.navigation.nextEl).includes(H) && ((e.isEnd && !e.params.loop) || e.slideNext(), e.isEnd ? a(I.lastSlideMessage) : a(I.nextSlideMessage)),
                    _.includes(H) && ((e.isBeginning && !e.params.loop) || e.slidePrev(), e.isBeginning ? a(I.firstSlideMessage) : a(I.prevSlideMessage));
            }
            e.pagination && H.matches(se(e.params.pagination.bulletClass)) && H.click();
        }
    }
    function b() {
        if (e.params.loop || e.params.rewind || !e.navigation) return;
        const { nextEl: C, prevEl: I } = e.navigation;
        I && (e.isBeginning ? (g(I), p(I)) : (h(I), f(I))), C && (e.isEnd ? (g(C), p(C)) : (h(C), f(C)));
    }
    function z() {
        return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
    }
    function $() {
        return z() && e.params.pagination.clickable;
    }
    function O() {
        const C = e.params.a11y;
        z() &&
            e.pagination.bullets.forEach((I) => {
                e.params.pagination.clickable && (f(I), e.params.pagination.renderBullet || (v(I, "button"), o(I, C.paginationBulletMessage.replace(/\{\{index\}\}/, Ee(I) + 1)))),
                    I.matches(se(e.params.pagination.bulletActiveClass)) ? I.setAttribute("aria-current", "true") : I.removeAttribute("aria-current");
            });
    }
    const P = (C, I, H) => {
            f(C), C.tagName !== "BUTTON" && (v(C, "button"), C.addEventListener("keydown", S)), o(C, H), l(C, I);
        },
        L = (C) => {
            d && d !== C.target && !d.contains(C.target) && (r = !0), (e.a11y.clicked = !0);
        },
        A = () => {
            (r = !1),
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        e.destroyed || (e.a11y.clicked = !1);
                    });
                });
        },
        M = (C) => {
            c = new Date().getTime();
        },
        E = (C) => {
            if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || new Date().getTime() - c < 100) return;
            const I = C.target.closest(`.${e.params.slideClass}, swiper-slide`);
            if (!I || !e.slides.includes(I)) return;
            d = I;
            const H = e.slides.indexOf(I) === e.activeIndex,
                _ = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(I);
            H ||
                _ ||
                (C.sourceCapabilities && C.sourceCapabilities.firesTouchEvents) ||
                (e.isHorizontal() ? (e.el.scrollLeft = 0) : (e.el.scrollTop = 0),
                requestAnimationFrame(() => {
                    r || (e.params.loop ? e.slideToLoop(parseInt(I.getAttribute("data-swiper-slide-index")), 0) : e.slideTo(e.slides.indexOf(I), 0), (r = !1));
                }));
        },
        x = () => {
            const C = e.params.a11y;
            C.itemRoleDescriptionMessage && m(e.slides, C.itemRoleDescriptionMessage), C.slideRole && v(e.slides, C.slideRole);
            const I = e.slides.length;
            C.slideLabelMessage &&
                e.slides.forEach((H, _) => {
                    const X = e.params.loop ? parseInt(H.getAttribute("data-swiper-slide-index"), 10) : _,
                        F = C.slideLabelMessage.replace(/\{\{index\}\}/, X + 1).replace(/\{\{slidesLength\}\}/, I);
                    o(H, F);
                });
        },
        D = () => {
            const C = e.params.a11y;
            e.el.append(n);
            const I = e.el;
            C.containerRoleDescriptionMessage && m(I, C.containerRoleDescriptionMessage), C.containerMessage && o(I, C.containerMessage), C.containerRole && v(I, C.containerRole);
            const H = e.wrapperEl,
                _ = C.id || H.getAttribute("id") || `swiper-wrapper-${u(16)}`,
                X = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
            w(H, _), y(H, X), x();
            let { nextEl: F, prevEl: J } = e.navigation ? e.navigation : {};
            (F = G(F)),
                (J = G(J)),
                F && F.forEach((T) => P(T, _, C.nextSlideMessage)),
                J && J.forEach((T) => P(T, _, C.prevSlideMessage)),
                $() &&
                    G(e.pagination.el).forEach((k) => {
                        k.addEventListener("keydown", S);
                    }),
                N().addEventListener("visibilitychange", M),
                e.el.addEventListener("focus", E, !0),
                e.el.addEventListener("focus", E, !0),
                e.el.addEventListener("pointerdown", L, !0),
                e.el.addEventListener("pointerup", A, !0);
        };
    function q() {
        n && n.remove();
        let { nextEl: C, prevEl: I } = e.navigation ? e.navigation : {};
        (C = G(C)),
            (I = G(I)),
            C && C.forEach((_) => _.removeEventListener("keydown", S)),
            I && I.forEach((_) => _.removeEventListener("keydown", S)),
            $() &&
                G(e.pagination.el).forEach((X) => {
                    X.removeEventListener("keydown", S);
                }),
            N().removeEventListener("visibilitychange", M),
            e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", E, !0), e.el.removeEventListener("pointerdown", L, !0), e.el.removeEventListener("pointerup", A, !0));
    }
    i("beforeInit", () => {
        (n = Z("span", e.params.a11y.notificationClass)), n.setAttribute("aria-live", "assertive"), n.setAttribute("aria-atomic", "true");
    }),
        i("afterInit", () => {
            e.params.a11y.enabled && D();
        }),
        i("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
            e.params.a11y.enabled && x();
        }),
        i("fromEdge toEdge afterInit lock unlock", () => {
            e.params.a11y.enabled && b();
        }),
        i("paginationUpdate", () => {
            e.params.a11y.enabled && O();
        }),
        i("destroy", () => {
            e.params.a11y.enabled && q();
        });
}
function Hs(s) {
    let { swiper: e, extendParams: t, on: i } = s;
    t({ history: { enabled: !1, root: "", replaceState: !1, key: "slides", keepQuery: !1 } });
    let n = !1,
        r = {};
    const d = (m) =>
            m
                .toString()
                .replace(/\s+/g, "-")
                .replace(/[^\w-]+/g, "")
                .replace(/--+/g, "-")
                .replace(/^-+/, "")
                .replace(/-+$/, ""),
        c = (m) => {
            const l = R();
            let o;
            m ? (o = new URL(m)) : (o = l.location);
            const w = o.pathname
                    .slice(1)
                    .split("/")
                    .filter((S) => S !== ""),
                y = w.length,
                g = w[y - 2],
                h = w[y - 1];
            return { key: g, value: h };
        },
        a = (m, l) => {
            const o = R();
            if (!n || !e.params.history.enabled) return;
            let w;
            e.params.url ? (w = new URL(e.params.url)) : (w = o.location);
            const y = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${l}"]`) : e.slides[l];
            let g = d(y.getAttribute("data-history"));
            if (e.params.history.root.length > 0) {
                let S = e.params.history.root;
                S[S.length - 1] === "/" && (S = S.slice(0, S.length - 1)), (g = `${S}/${m ? `${m}/` : ""}${g}`);
            } else w.pathname.includes(m) || (g = `${m ? `${m}/` : ""}${g}`);
            e.params.history.keepQuery && (g += w.search);
            const h = o.history.state;
            (h && h.value === g) || (e.params.history.replaceState ? o.history.replaceState({ value: g }, null, g) : o.history.pushState({ value: g }, null, g));
        },
        u = (m, l, o) => {
            if (l)
                for (let w = 0, y = e.slides.length; w < y; w += 1) {
                    const g = e.slides[w];
                    if (d(g.getAttribute("data-history")) === l) {
                        const S = e.getSlideIndex(g);
                        e.slideTo(S, m, o);
                    }
                }
            else e.slideTo(0, m, o);
        },
        f = () => {
            (r = c(e.params.url)), u(e.params.speed, r.value, !1);
        },
        p = () => {
            const m = R();
            if (e.params.history) {
                if (!m.history || !m.history.pushState) {
                    (e.params.history.enabled = !1), (e.params.hashNavigation.enabled = !0);
                    return;
                }
                if (((n = !0), (r = c(e.params.url)), !r.key && !r.value)) {
                    e.params.history.replaceState || m.addEventListener("popstate", f);
                    return;
                }
                u(0, r.value, e.params.runCallbacksOnInit), e.params.history.replaceState || m.addEventListener("popstate", f);
            }
        },
        v = () => {
            const m = R();
            e.params.history.replaceState || m.removeEventListener("popstate", f);
        };
    i("init", () => {
        e.params.history.enabled && p();
    }),
        i("destroy", () => {
            e.params.history.enabled && v();
        }),
        i("transitionEnd _freeModeNoMomentumRelease", () => {
            n && a(e.params.history.key, e.activeIndex);
        }),
        i("slideChange", () => {
            n && e.params.cssMode && a(e.params.history.key, e.activeIndex);
        });
}
function qs(s) {
    let { swiper: e, extendParams: t, emit: i, on: n } = s,
        r = !1;
    const d = N(),
        c = R();
    t({
        hashNavigation: {
            enabled: !1,
            replaceState: !1,
            watchState: !1,
            getSlideIndex(v, m) {
                if (e.virtual && e.params.virtual.enabled) {
                    const l = e.slides.find((w) => w.getAttribute("data-hash") === m);
                    return l ? parseInt(l.getAttribute("data-swiper-slide-index"), 10) : 0;
                }
                return e.getSlideIndex(W(e.slidesEl, `.${e.params.slideClass}[data-hash="${m}"], swiper-slide[data-hash="${m}"]`)[0]);
            },
        },
    });
    const a = () => {
            i("hashChange");
            const v = d.location.hash.replace("#", ""),
                m = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex],
                l = m ? m.getAttribute("data-hash") : "";
            if (v !== l) {
                const o = e.params.hashNavigation.getSlideIndex(e, v);
                if (typeof o > "u" || Number.isNaN(o)) return;
                e.slideTo(o);
            }
        },
        u = () => {
            if (!r || !e.params.hashNavigation.enabled) return;
            const v = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex],
                m = v ? v.getAttribute("data-hash") || v.getAttribute("data-history") : "";
            e.params.hashNavigation.replaceState && c.history && c.history.replaceState ? (c.history.replaceState(null, null, `#${m}` || ""), i("hashSet")) : ((d.location.hash = m || ""), i("hashSet"));
        },
        f = () => {
            if (!e.params.hashNavigation.enabled || (e.params.history && e.params.history.enabled)) return;
            r = !0;
            const v = d.location.hash.replace("#", "");
            if (v) {
                const l = e.params.hashNavigation.getSlideIndex(e, v);
                e.slideTo(l || 0, 0, e.params.runCallbacksOnInit, !0);
            }
            e.params.hashNavigation.watchState && c.addEventListener("hashchange", a);
        },
        p = () => {
            e.params.hashNavigation.watchState && c.removeEventListener("hashchange", a);
        };
    n("init", () => {
        e.params.hashNavigation.enabled && f();
    }),
        n("destroy", () => {
            e.params.hashNavigation.enabled && p();
        }),
        n("transitionEnd _freeModeNoMomentumRelease", () => {
            r && u();
        }),
        n("slideChange", () => {
            r && e.params.cssMode && u();
        });
}
function _s(s) {
    let { swiper: e, extendParams: t, on: i, emit: n, params: r } = s;
    (e.autoplay = { running: !1, paused: !1, timeLeft: 0 }), t({ autoplay: { enabled: !1, delay: 3e3, waitForTransition: !0, disableOnInteraction: !1, stopOnLastSlide: !1, reverseDirection: !1, pauseOnMouseEnter: !1 } });
    let d,
        c,
        a = r && r.autoplay ? r.autoplay.delay : 3e3,
        u = r && r.autoplay ? r.autoplay.delay : 3e3,
        f,
        p = new Date().getTime(),
        v,
        m,
        l,
        o,
        w,
        y,
        g;
    function h(I) {
        !e || e.destroyed || !e.wrapperEl || (I.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", h), !(g || (I.detail && I.detail.bySwiperTouchMove)) && L()));
    }
    const S = () => {
            if (e.destroyed || !e.autoplay.running) return;
            e.autoplay.paused ? (v = !0) : v && ((u = f), (v = !1));
            const I = e.autoplay.paused ? f : p + u - new Date().getTime();
            (e.autoplay.timeLeft = I),
                n("autoplayTimeLeft", I, I / a),
                (c = requestAnimationFrame(() => {
                    S();
                }));
        },
        b = () => {
            let I;
            return e.virtual && e.params.virtual.enabled ? (I = e.slides.find((_) => _.classList.contains("swiper-slide-active"))) : (I = e.slides[e.activeIndex]), I ? parseInt(I.getAttribute("data-swiper-autoplay"), 10) : void 0;
        },
        z = (I) => {
            if (e.destroyed || !e.autoplay.running) return;
            cancelAnimationFrame(c), S();
            let H = typeof I > "u" ? e.params.autoplay.delay : I;
            (a = e.params.autoplay.delay), (u = e.params.autoplay.delay);
            const _ = b();
            !Number.isNaN(_) && _ > 0 && typeof I > "u" && ((H = _), (a = _), (u = _)), (f = H);
            const X = e.params.speed,
                F = () => {
                    !e ||
                        e.destroyed ||
                        (e.params.autoplay.reverseDirection
                            ? !e.isBeginning || e.params.loop || e.params.rewind
                                ? (e.slidePrev(X, !0, !0), n("autoplay"))
                                : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, X, !0, !0), n("autoplay"))
                            : !e.isEnd || e.params.loop || e.params.rewind
                            ? (e.slideNext(X, !0, !0), n("autoplay"))
                            : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, X, !0, !0), n("autoplay")),
                        e.params.cssMode &&
                            ((p = new Date().getTime()),
                            requestAnimationFrame(() => {
                                z();
                            })));
                };
            return (
                H > 0
                    ? (clearTimeout(d),
                      (d = setTimeout(() => {
                          F();
                      }, H)))
                    : requestAnimationFrame(() => {
                          F();
                      }),
                H
            );
        },
        $ = () => {
            (p = new Date().getTime()), (e.autoplay.running = !0), z(), n("autoplayStart");
        },
        O = () => {
            (e.autoplay.running = !1), clearTimeout(d), cancelAnimationFrame(c), n("autoplayStop");
        },
        P = (I, H) => {
            if (e.destroyed || !e.autoplay.running) return;
            clearTimeout(d), I || (y = !0);
            const _ = () => {
                n("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", h) : L();
            };
            if (((e.autoplay.paused = !0), H)) {
                w && (f = e.params.autoplay.delay), (w = !1), _();
                return;
            }
            (f = (f || e.params.autoplay.delay) - (new Date().getTime() - p)), !(e.isEnd && f < 0 && !e.params.loop) && (f < 0 && (f = 0), _());
        },
        L = () => {
            (e.isEnd && f < 0 && !e.params.loop) || e.destroyed || !e.autoplay.running || ((p = new Date().getTime()), y ? ((y = !1), z(f)) : z(), (e.autoplay.paused = !1), n("autoplayResume"));
        },
        A = () => {
            if (e.destroyed || !e.autoplay.running) return;
            const I = N();
            I.visibilityState === "hidden" && ((y = !0), P(!0)), I.visibilityState === "visible" && L();
        },
        M = (I) => {
            I.pointerType === "mouse" && ((y = !0), (g = !0), !(e.animating || e.autoplay.paused) && P(!0));
        },
        E = (I) => {
            I.pointerType === "mouse" && ((g = !1), e.autoplay.paused && L());
        },
        x = () => {
            e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", M), e.el.addEventListener("pointerleave", E));
        },
        D = () => {
            e.el && typeof e.el != "string" && (e.el.removeEventListener("pointerenter", M), e.el.removeEventListener("pointerleave", E));
        },
        q = () => {
            N().addEventListener("visibilitychange", A);
        },
        C = () => {
            N().removeEventListener("visibilitychange", A);
        };
    i("init", () => {
        e.params.autoplay.enabled && (x(), q(), $());
    }),
        i("destroy", () => {
            D(), C(), e.autoplay.running && O();
        }),
        i("_freeModeStaticRelease", () => {
            (l || y) && L();
        }),
        i("_freeModeNoMomentumRelease", () => {
            e.params.autoplay.disableOnInteraction ? O() : P(!0, !0);
        }),
        i("beforeTransitionStart", (I, H, _) => {
            e.destroyed || !e.autoplay.running || (_ || !e.params.autoplay.disableOnInteraction ? P(!0, !0) : O());
        }),
        i("sliderFirstMove", () => {
            if (!(e.destroyed || !e.autoplay.running)) {
                if (e.params.autoplay.disableOnInteraction) {
                    O();
                    return;
                }
                (m = !0),
                    (l = !1),
                    (y = !1),
                    (o = setTimeout(() => {
                        (y = !0), (l = !0), P(!0);
                    }, 200));
            }
        }),
        i("touchEnd", () => {
            if (!(e.destroyed || !e.autoplay.running || !m)) {
                if ((clearTimeout(o), clearTimeout(d), e.params.autoplay.disableOnInteraction)) {
                    (l = !1), (m = !1);
                    return;
                }
                l && e.params.cssMode && L(), (l = !1), (m = !1);
            }
        }),
        i("slideChange", () => {
            e.destroyed || !e.autoplay.running || (w = !0);
        }),
        Object.assign(e.autoplay, { start: $, stop: O, pause: P, resume: L });
}
function Gs(s) {
    let { swiper: e, extendParams: t, on: i } = s;
    t({ thumbs: { swiper: null, multipleActiveThumbs: !0, autoScrollOffset: 0, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-thumbs" } });
    let n = !1,
        r = !1;
    e.thumbs = { swiper: null };
    function d() {
        const u = e.thumbs.swiper;
        if (!u || u.destroyed) return;
        const f = u.clickedIndex,
            p = u.clickedSlide;
        if ((p && p.classList.contains(e.params.thumbs.slideThumbActiveClass)) || typeof f > "u" || f === null) return;
        let v;
        u.params.loop ? (v = parseInt(u.clickedSlide.getAttribute("data-swiper-slide-index"), 10)) : (v = f), e.params.loop ? e.slideToLoop(v) : e.slideTo(v);
    }
    function c() {
        const { thumbs: u } = e.params;
        if (n) return !1;
        n = !0;
        const f = e.constructor;
        if (u.swiper instanceof f)
            (e.thumbs.swiper = u.swiper),
                Object.assign(e.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                Object.assign(e.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                e.thumbs.swiper.update();
        else if (ye(u.swiper)) {
            const p = Object.assign({}, u.swiper);
            Object.assign(p, { watchSlidesProgress: !0, slideToClickedSlide: !1 }), (e.thumbs.swiper = new f(p)), (r = !0);
        }
        return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", d), !0;
    }
    function a(u) {
        const f = e.thumbs.swiper;
        if (!f || f.destroyed) return;
        const p = f.params.slidesPerView === "auto" ? f.slidesPerViewDynamic() : f.params.slidesPerView;
        let v = 1;
        const m = e.params.thumbs.slideThumbActiveClass;
        if (
            (e.params.slidesPerView > 1 && !e.params.centeredSlides && (v = e.params.slidesPerView),
            e.params.thumbs.multipleActiveThumbs || (v = 1),
            (v = Math.floor(v)),
            f.slides.forEach((w) => w.classList.remove(m)),
            f.params.loop || (f.params.virtual && f.params.virtual.enabled))
        )
            for (let w = 0; w < v; w += 1)
                W(f.slidesEl, `[data-swiper-slide-index="${e.realIndex + w}"]`).forEach((y) => {
                    y.classList.add(m);
                });
        else for (let w = 0; w < v; w += 1) f.slides[e.realIndex + w] && f.slides[e.realIndex + w].classList.add(m);
        const l = e.params.thumbs.autoScrollOffset,
            o = l && !f.params.loop;
        if (e.realIndex !== f.realIndex || o) {
            const w = f.activeIndex;
            let y, g;
            if (f.params.loop) {
                const h = f.slides.find((S) => S.getAttribute("data-swiper-slide-index") === `${e.realIndex}`);
                (y = f.slides.indexOf(h)), (g = e.activeIndex > e.previousIndex ? "next" : "prev");
            } else (y = e.realIndex), (g = y > e.previousIndex ? "next" : "prev");
            o && (y += g === "next" ? l : -1 * l),
                f.visibleSlidesIndexes &&
                    f.visibleSlidesIndexes.indexOf(y) < 0 &&
                    (f.params.centeredSlides ? (y > w ? (y = y - Math.floor(p / 2) + 1) : (y = y + Math.floor(p / 2) - 1)) : y > w && f.params.slidesPerGroup, f.slideTo(y, u ? 0 : void 0));
        }
    }
    i("beforeInit", () => {
        const { thumbs: u } = e.params;
        if (!(!u || !u.swiper))
            if (typeof u.swiper == "string" || u.swiper instanceof HTMLElement) {
                const f = N(),
                    p = () => {
                        const m = typeof u.swiper == "string" ? f.querySelector(u.swiper) : u.swiper;
                        if (m && m.swiper) (u.swiper = m.swiper), c(), a(!0);
                        else if (m) {
                            const l = `${e.params.eventsPrefix}init`,
                                o = (w) => {
                                    (u.swiper = w.detail[0]), m.removeEventListener(l, o), c(), a(!0), u.swiper.update(), e.update();
                                };
                            m.addEventListener(l, o);
                        }
                        return m;
                    },
                    v = () => {
                        if (e.destroyed) return;
                        p() || requestAnimationFrame(v);
                    };
                requestAnimationFrame(v);
            } else c(), a(!0);
    }),
        i("slideChange update resize observerUpdate", () => {
            a();
        }),
        i("setTransition", (u, f) => {
            const p = e.thumbs.swiper;
            !p || p.destroyed || p.setTransition(f);
        }),
        i("beforeDestroy", () => {
            const u = e.thumbs.swiper;
            !u || u.destroyed || (r && u.destroy());
        }),
        Object.assign(e.thumbs, { init: c, update: a });
}
function Vs(s) {
    let { swiper: e, extendParams: t, emit: i, once: n } = s;
    t({ freeMode: { enabled: !1, momentum: !0, momentumRatio: 1, momentumBounce: !0, momentumBounceRatio: 1, momentumVelocityRatio: 1, sticky: !1, minimumVelocity: 0.02 } });
    function r() {
        if (e.params.cssMode) return;
        const a = e.getTranslate();
        e.setTranslate(a), e.setTransition(0), (e.touchEventsData.velocities.length = 0), e.freeMode.onTouchEnd({ currentPos: e.rtl ? e.translate : -e.translate });
    }
    function d() {
        if (e.params.cssMode) return;
        const { touchEventsData: a, touches: u } = e;
        a.velocities.length === 0 && a.velocities.push({ position: u[e.isHorizontal() ? "startX" : "startY"], time: a.touchStartTime }), a.velocities.push({ position: u[e.isHorizontal() ? "currentX" : "currentY"], time: Q() });
    }
    function c(a) {
        let { currentPos: u } = a;
        if (e.params.cssMode) return;
        const { params: f, wrapperEl: p, rtlTranslate: v, snapGrid: m, touchEventsData: l } = e,
            w = Q() - l.touchStartTime;
        if (u < -e.minTranslate()) {
            e.slideTo(e.activeIndex);
            return;
        }
        if (u > -e.maxTranslate()) {
            e.slides.length < m.length ? e.slideTo(m.length - 1) : e.slideTo(e.slides.length - 1);
            return;
        }
        if (f.freeMode.momentum) {
            if (l.velocities.length > 1) {
                const O = l.velocities.pop(),
                    P = l.velocities.pop(),
                    L = O.position - P.position,
                    A = O.time - P.time;
                (e.velocity = L / A), (e.velocity /= 2), Math.abs(e.velocity) < f.freeMode.minimumVelocity && (e.velocity = 0), (A > 150 || Q() - O.time > 300) && (e.velocity = 0);
            } else e.velocity = 0;
            (e.velocity *= f.freeMode.momentumVelocityRatio), (l.velocities.length = 0);
            let y = 1e3 * f.freeMode.momentumRatio;
            const g = e.velocity * y;
            let h = e.translate + g;
            v && (h = -h);
            let S = !1,
                b;
            const z = Math.abs(e.velocity) * 20 * f.freeMode.momentumBounceRatio;
            let $;
            if (h < e.maxTranslate())
                f.freeMode.momentumBounce ? (h + e.maxTranslate() < -z && (h = e.maxTranslate() - z), (b = e.maxTranslate()), (S = !0), (l.allowMomentumBounce = !0)) : (h = e.maxTranslate()), f.loop && f.centeredSlides && ($ = !0);
            else if (h > e.minTranslate())
                f.freeMode.momentumBounce ? (h - e.minTranslate() > z && (h = e.minTranslate() + z), (b = e.minTranslate()), (S = !0), (l.allowMomentumBounce = !0)) : (h = e.minTranslate()), f.loop && f.centeredSlides && ($ = !0);
            else if (f.freeMode.sticky) {
                let O;
                for (let P = 0; P < m.length; P += 1)
                    if (m[P] > -h) {
                        O = P;
                        break;
                    }
                Math.abs(m[O] - h) < Math.abs(m[O - 1] - h) || e.swipeDirection === "next" ? (h = m[O]) : (h = m[O - 1]), (h = -h);
            }
            if (
                ($ &&
                    n("transitionEnd", () => {
                        e.loopFix();
                    }),
                e.velocity !== 0)
            ) {
                if ((v ? (y = Math.abs((-h - e.translate) / e.velocity)) : (y = Math.abs((h - e.translate) / e.velocity)), f.freeMode.sticky)) {
                    const O = Math.abs((v ? -h : h) - e.translate),
                        P = e.slidesSizesGrid[e.activeIndex];
                    O < P ? (y = f.speed) : O < 2 * P ? (y = f.speed * 1.5) : (y = f.speed * 2.5);
                }
            } else if (f.freeMode.sticky) {
                e.slideToClosest();
                return;
            }
            f.freeMode.momentumBounce && S
                ? (e.updateProgress(b),
                  e.setTransition(y),
                  e.setTranslate(h),
                  e.transitionStart(!0, e.swipeDirection),
                  (e.animating = !0),
                  be(p, () => {
                      !e ||
                          e.destroyed ||
                          !l.allowMomentumBounce ||
                          (i("momentumBounce"),
                          e.setTransition(f.speed),
                          setTimeout(() => {
                              e.setTranslate(b),
                                  be(p, () => {
                                      !e || e.destroyed || e.transitionEnd();
                                  });
                          }, 0));
                  }))
                : e.velocity
                ? (i("_freeModeNoMomentumRelease"),
                  e.updateProgress(h),
                  e.setTransition(y),
                  e.setTranslate(h),
                  e.transitionStart(!0, e.swipeDirection),
                  e.animating ||
                      ((e.animating = !0),
                      be(p, () => {
                          !e || e.destroyed || e.transitionEnd();
                      })))
                : e.updateProgress(h),
                e.updateActiveIndex(),
                e.updateSlidesClasses();
        } else if (f.freeMode.sticky) {
            e.slideToClosest();
            return;
        } else f.freeMode && i("_freeModeNoMomentumRelease");
        (!f.freeMode.momentum || w >= f.longSwipesMs) && (i("_freeModeStaticRelease"), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
    }
    Object.assign(e, { freeMode: { onTouchStart: r, onTouchMove: d, onTouchEnd: c } });
}
function Rs(s) {
    let { swiper: e, extendParams: t, on: i } = s;
    t({ grid: { rows: 1, fill: "column" } });
    let n, r, d, c;
    const a = () => {
            let o = e.params.spaceBetween;
            return typeof o == "string" && o.indexOf("%") >= 0 ? (o = (parseFloat(o.replace("%", "")) / 100) * e.size) : typeof o == "string" && (o = parseFloat(o)), o;
        },
        u = (o) => {
            const { slidesPerView: w } = e.params,
                { rows: y, fill: g } = e.params.grid,
                h = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : o.length;
            (d = Math.floor(h / y)), Math.floor(h / y) === h / y ? (n = h) : (n = Math.ceil(h / y) * y), w !== "auto" && g === "row" && (n = Math.max(n, w * y)), (r = n / y);
        },
        f = () => {
            e.slides &&
                e.slides.forEach((o) => {
                    o.swiperSlideGridSet && ((o.style.height = ""), (o.style[e.getDirectionLabel("margin-top")] = ""));
                });
        },
        p = (o, w, y) => {
            const { slidesPerGroup: g } = e.params,
                h = a(),
                { rows: S, fill: b } = e.params.grid,
                z = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : y.length;
            let $, O, P;
            if (b === "row" && g > 1) {
                const L = Math.floor(o / (g * S)),
                    A = o - S * g * L,
                    M = L === 0 ? g : Math.min(Math.ceil((z - L * S * g) / S), g);
                (P = Math.floor(A / M)), (O = A - P * M + L * g), ($ = O + (P * n) / S), (w.style.order = $);
            } else b === "column" ? ((O = Math.floor(o / S)), (P = o - O * S), (O > d || (O === d && P === S - 1)) && ((P += 1), P >= S && ((P = 0), (O += 1)))) : ((P = Math.floor(o / r)), (O = o - P * r));
            (w.row = P), (w.column = O), (w.style.height = `calc((100% - ${(S - 1) * h}px) / ${S})`), (w.style[e.getDirectionLabel("margin-top")] = P !== 0 ? h && `${h}px` : ""), (w.swiperSlideGridSet = !0);
        },
        v = (o, w) => {
            const { centeredSlides: y, roundLengths: g } = e.params,
                h = a(),
                { rows: S } = e.params.grid;
            if (((e.virtualSize = (o + h) * n), (e.virtualSize = Math.ceil(e.virtualSize / S) - h), e.params.cssMode || (e.wrapperEl.style[e.getDirectionLabel("width")] = `${e.virtualSize + h}px`), y)) {
                const b = [];
                for (let z = 0; z < w.length; z += 1) {
                    let $ = w[z];
                    g && ($ = Math.floor($)), w[z] < e.virtualSize + w[0] && b.push($);
                }
                w.splice(0, w.length), w.push(...b);
            }
        },
        m = () => {
            c = e.params.grid && e.params.grid.rows > 1;
        },
        l = () => {
            const { params: o, el: w } = e,
                y = o.grid && o.grid.rows > 1;
            c && !y
                ? (w.classList.remove(`${o.containerModifierClass}grid`, `${o.containerModifierClass}grid-column`), (d = 1), e.emitContainerClasses())
                : !c && y && (w.classList.add(`${o.containerModifierClass}grid`), o.grid.fill === "column" && w.classList.add(`${o.containerModifierClass}grid-column`), e.emitContainerClasses()),
                (c = y);
        };
    i("init", m), i("update", l), (e.grid = { initSlides: u, unsetSlides: f, updateSlide: p, updateWrapperSize: v });
}
function Xs(s) {
    const e = this,
        { params: t, slidesEl: i } = e;
    t.loop && e.loopDestroy();
    const n = (r) => {
        if (typeof r == "string") {
            const d = document.createElement("div");
            (d.innerHTML = r), i.append(d.children[0]), (d.innerHTML = "");
        } else i.append(r);
    };
    if (typeof s == "object" && "length" in s) for (let r = 0; r < s.length; r += 1) s[r] && n(s[r]);
    else n(s);
    e.recalcSlides(), t.loop && e.loopCreate(), (!t.observer || e.isElement) && e.update();
}
function Ys(s) {
    const e = this,
        { params: t, activeIndex: i, slidesEl: n } = e;
    t.loop && e.loopDestroy();
    let r = i + 1;
    const d = (c) => {
        if (typeof c == "string") {
            const a = document.createElement("div");
            (a.innerHTML = c), n.prepend(a.children[0]), (a.innerHTML = "");
        } else n.prepend(c);
    };
    if (typeof s == "object" && "length" in s) {
        for (let c = 0; c < s.length; c += 1) s[c] && d(s[c]);
        r = i + s.length;
    } else d(s);
    e.recalcSlides(), t.loop && e.loopCreate(), (!t.observer || e.isElement) && e.update(), e.slideTo(r, 0, !1);
}
function Ns(s, e) {
    const t = this,
        { params: i, activeIndex: n, slidesEl: r } = t;
    let d = n;
    i.loop && ((d -= t.loopedSlides), t.loopDestroy(), t.recalcSlides());
    const c = t.slides.length;
    if (s <= 0) {
        t.prependSlide(e);
        return;
    }
    if (s >= c) {
        t.appendSlide(e);
        return;
    }
    let a = d > s ? d + 1 : d;
    const u = [];
    for (let f = c - 1; f >= s; f -= 1) {
        const p = t.slides[f];
        p.remove(), u.unshift(p);
    }
    if (typeof e == "object" && "length" in e) {
        for (let f = 0; f < e.length; f += 1) e[f] && r.append(e[f]);
        a = d > s ? d + e.length : d;
    } else r.append(e);
    for (let f = 0; f < u.length; f += 1) r.append(u[f]);
    t.recalcSlides(), i.loop && t.loopCreate(), (!i.observer || t.isElement) && t.update(), i.loop ? t.slideTo(a + t.loopedSlides, 0, !1) : t.slideTo(a, 0, !1);
}
function Fs(s) {
    const e = this,
        { params: t, activeIndex: i } = e;
    let n = i;
    t.loop && ((n -= e.loopedSlides), e.loopDestroy());
    let r = n,
        d;
    if (typeof s == "object" && "length" in s) {
        for (let c = 0; c < s.length; c += 1) (d = s[c]), e.slides[d] && e.slides[d].remove(), d < r && (r -= 1);
        r = Math.max(r, 0);
    } else (d = s), e.slides[d] && e.slides[d].remove(), d < r && (r -= 1), (r = Math.max(r, 0));
    e.recalcSlides(), t.loop && e.loopCreate(), (!t.observer || e.isElement) && e.update(), t.loop ? e.slideTo(r + e.loopedSlides, 0, !1) : e.slideTo(r, 0, !1);
}
function Ws() {
    const s = this,
        e = [];
    for (let t = 0; t < s.slides.length; t += 1) e.push(t);
    s.removeSlide(e);
}
function js(s) {
    let { swiper: e } = s;
    Object.assign(e, { appendSlide: Xs.bind(e), prependSlide: Ys.bind(e), addSlide: Ns.bind(e), removeSlide: Fs.bind(e), removeAllSlides: Ws.bind(e) });
}
function ue(s) {
    const { effect: e, swiper: t, on: i, setTranslate: n, setTransition: r, overwriteParams: d, perspective: c, recreateShadows: a, getEffectParams: u } = s;
    i("beforeInit", () => {
        if (t.params.effect !== e) return;
        t.classNames.push(`${t.params.containerModifierClass}${e}`), c && c() && t.classNames.push(`${t.params.containerModifierClass}3d`);
        const p = d ? d() : {};
        Object.assign(t.params, p), Object.assign(t.originalParams, p);
    }),
        i("setTranslate", () => {
            t.params.effect === e && n();
        }),
        i("setTransition", (p, v) => {
            t.params.effect === e && r(v);
        }),
        i("transitionEnd", () => {
            if (t.params.effect === e && a) {
                if (!u || !u().slideShadows) return;
                t.slides.forEach((p) => {
                    p.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((v) => v.remove());
                }),
                    a();
            }
        });
    let f;
    i("virtualUpdate", () => {
        t.params.effect === e &&
            (t.slides.length || (f = !0),
            requestAnimationFrame(() => {
                f && t.slides && t.slides.length && (n(), (f = !1));
            }));
    });
}
function xe(s, e) {
    const t = ce(e);
    return t !== e && ((t.style.backfaceVisibility = "hidden"), (t.style["-webkit-backface-visibility"] = "hidden")), t;
}
function ze(s) {
    let { swiper: e, duration: t, transformElements: i, allSlides: n } = s;
    const { activeIndex: r } = e,
        d = (c) => (c.parentElement ? c.parentElement : e.slides.find((u) => u.shadowRoot && u.shadowRoot === c.parentNode));
    if (e.params.virtualTranslate && t !== 0) {
        let c = !1,
            a;
        n
            ? (a = i)
            : (a = i.filter((u) => {
                  const f = u.classList.contains("swiper-slide-transform") ? d(u) : u;
                  return e.getSlideIndex(f) === r;
              })),
            a.forEach((u) => {
                be(u, () => {
                    if (c || !e || e.destroyed) return;
                    (c = !0), (e.animating = !1);
                    const f = new window.CustomEvent("transitionend", { bubbles: !0, cancelable: !0 });
                    e.wrapperEl.dispatchEvent(f);
                });
            });
    }
}
function Us(s) {
    let { swiper: e, extendParams: t, on: i } = s;
    t({ fadeEffect: { crossFade: !1 } }),
        ue({
            effect: "fade",
            swiper: e,
            on: i,
            setTranslate: () => {
                const { slides: d } = e,
                    c = e.params.fadeEffect;
                for (let a = 0; a < d.length; a += 1) {
                    const u = e.slides[a];
                    let p = -u.swiperSlideOffset;
                    e.params.virtualTranslate || (p -= e.translate);
                    let v = 0;
                    e.isHorizontal() || ((v = p), (p = 0));
                    const m = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(u.progress), 0) : 1 + Math.min(Math.max(u.progress, -1), 0),
                        l = xe(c, u);
                    (l.style.opacity = m), (l.style.transform = `translate3d(${p}px, ${v}px, 0px)`);
                }
            },
            setTransition: (d) => {
                const c = e.slides.map((a) => ce(a));
                c.forEach((a) => {
                    a.style.transitionDuration = `${d}ms`;
                }),
                    ze({ swiper: e, duration: d, transformElements: c, allSlides: !0 });
            },
            overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !e.params.cssMode }),
        });
}
function Ks(s) {
    let { swiper: e, extendParams: t, on: i } = s;
    t({ cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: 0.94 } });
    const n = (a, u, f) => {
        let p = f ? a.querySelector(".swiper-slide-shadow-left") : a.querySelector(".swiper-slide-shadow-top"),
            v = f ? a.querySelector(".swiper-slide-shadow-right") : a.querySelector(".swiper-slide-shadow-bottom");
        p || ((p = Z("div", `swiper-slide-shadow-cube swiper-slide-shadow-${f ? "left" : "top"}`.split(" "))), a.append(p)),
            v || ((v = Z("div", `swiper-slide-shadow-cube swiper-slide-shadow-${f ? "right" : "bottom"}`.split(" "))), a.append(v)),
            p && (p.style.opacity = Math.max(-u, 0)),
            v && (v.style.opacity = Math.max(u, 0));
    };
    ue({
        effect: "cube",
        swiper: e,
        on: i,
        setTranslate: () => {
            const { el: a, wrapperEl: u, slides: f, width: p, height: v, rtlTranslate: m, size: l, browser: o } = e,
                w = Ae(e),
                y = e.params.cubeEffect,
                g = e.isHorizontal(),
                h = e.virtual && e.params.virtual.enabled;
            let S = 0,
                b;
            y.shadow &&
                (g
                    ? ((b = e.wrapperEl.querySelector(".swiper-cube-shadow")), b || ((b = Z("div", "swiper-cube-shadow")), e.wrapperEl.append(b)), (b.style.height = `${p}px`))
                    : ((b = a.querySelector(".swiper-cube-shadow")), b || ((b = Z("div", "swiper-cube-shadow")), a.append(b))));
            for (let $ = 0; $ < f.length; $ += 1) {
                const O = f[$];
                let P = $;
                h && (P = parseInt(O.getAttribute("data-swiper-slide-index"), 10));
                let L = P * 90,
                    A = Math.floor(L / 360);
                m && ((L = -L), (A = Math.floor(-L / 360)));
                const M = Math.max(Math.min(O.progress, 1), -1);
                let E = 0,
                    x = 0,
                    D = 0;
                P % 4 === 0 ? ((E = -A * 4 * l), (D = 0)) : (P - 1) % 4 === 0 ? ((E = 0), (D = -A * 4 * l)) : (P - 2) % 4 === 0 ? ((E = l + A * 4 * l), (D = l)) : (P - 3) % 4 === 0 && ((E = -l), (D = 3 * l + l * 4 * A)),
                    m && (E = -E),
                    g || ((x = E), (E = 0));
                const q = `rotateX(${w(g ? 0 : -L)}deg) rotateY(${w(g ? L : 0)}deg) translate3d(${E}px, ${x}px, ${D}px)`;
                M <= 1 && M > -1 && ((S = P * 90 + M * 90), m && (S = -P * 90 - M * 90)), (O.style.transform = q), y.slideShadows && n(O, M, g);
            }
            if (((u.style.transformOrigin = `50% 50% -${l / 2}px`), (u.style["-webkit-transform-origin"] = `50% 50% -${l / 2}px`), y.shadow))
                if (g) b.style.transform = `translate3d(0px, ${p / 2 + y.shadowOffset}px, ${-p / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${y.shadowScale})`;
                else {
                    const $ = Math.abs(S) - Math.floor(Math.abs(S) / 90) * 90,
                        O = 1.5 - (Math.sin(($ * 2 * Math.PI) / 360) / 2 + Math.cos(($ * 2 * Math.PI) / 360) / 2),
                        P = y.shadowScale,
                        L = y.shadowScale / O,
                        A = y.shadowOffset;
                    b.style.transform = `scale3d(${P}, 1, ${L}) translate3d(0px, ${v / 2 + A}px, ${-v / 2 / L}px) rotateX(-89.99deg)`;
                }
            const z = (o.isSafari || o.isWebView) && o.needPerspectiveFix ? -l / 2 : 0;
            (u.style.transform = `translate3d(0px,0,${z}px) rotateX(${w(e.isHorizontal() ? 0 : S)}deg) rotateY(${w(e.isHorizontal() ? -S : 0)}deg)`), u.style.setProperty("--swiper-cube-translate-z", `${z}px`);
        },
        setTransition: (a) => {
            const { el: u, slides: f } = e;
            if (
                (f.forEach((p) => {
                    (p.style.transitionDuration = `${a}ms`),
                        p.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((v) => {
                            v.style.transitionDuration = `${a}ms`;
                        });
                }),
                e.params.cubeEffect.shadow && !e.isHorizontal())
            ) {
                const p = u.querySelector(".swiper-cube-shadow");
                p && (p.style.transitionDuration = `${a}ms`);
            }
        },
        recreateShadows: () => {
            const a = e.isHorizontal();
            e.slides.forEach((u) => {
                const f = Math.max(Math.min(u.progress, 1), -1);
                n(u, f, a);
            });
        },
        getEffectParams: () => e.params.cubeEffect,
        perspective: () => !0,
        overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: !0, resistanceRatio: 0, spaceBetween: 0, centeredSlides: !1, virtualTranslate: !0 }),
    });
}
function fe(s, e, t) {
    const i = `swiper-slide-shadow${t ? `-${t}` : ""}${s ? ` swiper-slide-shadow-${s}` : ""}`,
        n = ce(e);
    let r = n.querySelector(`.${i.split(" ").join(".")}`);
    return r || ((r = Z("div", i.split(" "))), n.append(r)), r;
}
function Zs(s) {
    let { swiper: e, extendParams: t, on: i } = s;
    t({ flipEffect: { slideShadows: !0, limitRotation: !0 } });
    const n = (a, u) => {
        let f = e.isHorizontal() ? a.querySelector(".swiper-slide-shadow-left") : a.querySelector(".swiper-slide-shadow-top"),
            p = e.isHorizontal() ? a.querySelector(".swiper-slide-shadow-right") : a.querySelector(".swiper-slide-shadow-bottom");
        f || (f = fe("flip", a, e.isHorizontal() ? "left" : "top")), p || (p = fe("flip", a, e.isHorizontal() ? "right" : "bottom")), f && (f.style.opacity = Math.max(-u, 0)), p && (p.style.opacity = Math.max(u, 0));
    };
    ue({
        effect: "flip",
        swiper: e,
        on: i,
        setTranslate: () => {
            const { slides: a, rtlTranslate: u } = e,
                f = e.params.flipEffect,
                p = Ae(e);
            for (let v = 0; v < a.length; v += 1) {
                const m = a[v];
                let l = m.progress;
                e.params.flipEffect.limitRotation && (l = Math.max(Math.min(m.progress, 1), -1));
                const o = m.swiperSlideOffset;
                let y = -180 * l,
                    g = 0,
                    h = e.params.cssMode ? -o - e.translate : -o,
                    S = 0;
                e.isHorizontal() ? u && (y = -y) : ((S = h), (h = 0), (g = -y), (y = 0)), (m.style.zIndex = -Math.abs(Math.round(l)) + a.length), f.slideShadows && n(m, l);
                const b = `translate3d(${h}px, ${S}px, 0px) rotateX(${p(g)}deg) rotateY(${p(y)}deg)`,
                    z = xe(f, m);
                z.style.transform = b;
            }
        },
        setTransition: (a) => {
            const u = e.slides.map((f) => ce(f));
            u.forEach((f) => {
                (f.style.transitionDuration = `${a}ms`),
                    f.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((p) => {
                        p.style.transitionDuration = `${a}ms`;
                    });
            }),
                ze({ swiper: e, duration: a, transformElements: u });
        },
        recreateShadows: () => {
            e.params.flipEffect,
                e.slides.forEach((a) => {
                    let u = a.progress;
                    e.params.flipEffect.limitRotation && (u = Math.max(Math.min(a.progress, 1), -1)), n(a, u);
                });
        },
        getEffectParams: () => e.params.flipEffect,
        perspective: () => !0,
        overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !e.params.cssMode }),
    });
}
function Qs(s) {
    let { swiper: e, extendParams: t, on: i } = s;
    t({ coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: !0 } }),
        ue({
            effect: "coverflow",
            swiper: e,
            on: i,
            setTranslate: () => {
                const { width: d, height: c, slides: a, slidesSizesGrid: u } = e,
                    f = e.params.coverflowEffect,
                    p = e.isHorizontal(),
                    v = e.translate,
                    m = p ? -v + d / 2 : -v + c / 2,
                    l = p ? f.rotate : -f.rotate,
                    o = f.depth,
                    w = Ae(e);
                for (let y = 0, g = a.length; y < g; y += 1) {
                    const h = a[y],
                        S = u[y],
                        b = h.swiperSlideOffset,
                        z = (m - b - S / 2) / S,
                        $ = typeof f.modifier == "function" ? f.modifier(z) : z * f.modifier;
                    let O = p ? l * $ : 0,
                        P = p ? 0 : l * $,
                        L = -o * Math.abs($),
                        A = f.stretch;
                    typeof A == "string" && A.indexOf("%") !== -1 && (A = (parseFloat(f.stretch) / 100) * S);
                    let M = p ? 0 : A * $,
                        E = p ? A * $ : 0,
                        x = 1 - (1 - f.scale) * Math.abs($);
                    Math.abs(E) < 0.001 && (E = 0), Math.abs(M) < 0.001 && (M = 0), Math.abs(L) < 0.001 && (L = 0), Math.abs(O) < 0.001 && (O = 0), Math.abs(P) < 0.001 && (P = 0), Math.abs(x) < 0.001 && (x = 0);
                    const D = `translate3d(${E}px,${M}px,${L}px)  rotateX(${w(P)}deg) rotateY(${w(O)}deg) scale(${x})`,
                        q = xe(f, h);
                    if (((q.style.transform = D), (h.style.zIndex = -Math.abs(Math.round($)) + 1), f.slideShadows)) {
                        let C = p ? h.querySelector(".swiper-slide-shadow-left") : h.querySelector(".swiper-slide-shadow-top"),
                            I = p ? h.querySelector(".swiper-slide-shadow-right") : h.querySelector(".swiper-slide-shadow-bottom");
                        C || (C = fe("coverflow", h, p ? "left" : "top")), I || (I = fe("coverflow", h, p ? "right" : "bottom")), C && (C.style.opacity = $ > 0 ? $ : 0), I && (I.style.opacity = -$ > 0 ? -$ : 0);
                    }
                }
            },
            setTransition: (d) => {
                e.slides
                    .map((a) => ce(a))
                    .forEach((a) => {
                        (a.style.transitionDuration = `${d}ms`),
                            a.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((u) => {
                                u.style.transitionDuration = `${d}ms`;
                            });
                    });
            },
            perspective: () => !0,
            overwriteParams: () => ({ watchSlidesProgress: !0 }),
        });
}
function Js(s) {
    let { swiper: e, extendParams: t, on: i } = s;
    t({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: !1,
            progressMultiplier: 1,
            perspective: !0,
            prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
            next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
        },
    });
    const n = (c) => (typeof c == "string" ? c : `${c}px`);
    ue({
        effect: "creative",
        swiper: e,
        on: i,
        setTranslate: () => {
            const { slides: c, wrapperEl: a, slidesSizesGrid: u } = e,
                f = e.params.creativeEffect,
                { progressMultiplier: p } = f,
                v = e.params.centeredSlides,
                m = Ae(e);
            if (v) {
                const l = u[0] / 2 - e.params.slidesOffsetBefore || 0;
                a.style.transform = `translateX(calc(50% - ${l}px))`;
            }
            for (let l = 0; l < c.length; l += 1) {
                const o = c[l],
                    w = o.progress,
                    y = Math.min(Math.max(o.progress, -f.limitProgress), f.limitProgress);
                let g = y;
                v || (g = Math.min(Math.max(o.originalProgress, -f.limitProgress), f.limitProgress));
                const h = o.swiperSlideOffset,
                    S = [e.params.cssMode ? -h - e.translate : -h, 0, 0],
                    b = [0, 0, 0];
                let z = !1;
                e.isHorizontal() || ((S[1] = S[0]), (S[0] = 0));
                let $ = { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 };
                y < 0 ? (($ = f.next), (z = !0)) : y > 0 && (($ = f.prev), (z = !0)),
                    S.forEach((x, D) => {
                        S[D] = `calc(${x}px + (${n($.translate[D])} * ${Math.abs(y * p)}))`;
                    }),
                    b.forEach((x, D) => {
                        let q = $.rotate[D] * Math.abs(y * p);
                        b[D] = q;
                    }),
                    (o.style.zIndex = -Math.abs(Math.round(w)) + c.length);
                const O = S.join(", "),
                    P = `rotateX(${m(b[0])}deg) rotateY(${m(b[1])}deg) rotateZ(${m(b[2])}deg)`,
                    L = g < 0 ? `scale(${1 + (1 - $.scale) * g * p})` : `scale(${1 - (1 - $.scale) * g * p})`,
                    A = g < 0 ? 1 + (1 - $.opacity) * g * p : 1 - (1 - $.opacity) * g * p,
                    M = `translate3d(${O}) ${P} ${L}`;
                if ((z && $.shadow) || !z) {
                    let x = o.querySelector(".swiper-slide-shadow");
                    if ((!x && $.shadow && (x = fe("creative", o)), x)) {
                        const D = f.shadowPerProgress ? y * (1 / f.limitProgress) : y;
                        x.style.opacity = Math.min(Math.max(Math.abs(D), 0), 1);
                    }
                }
                const E = xe(f, o);
                (E.style.transform = M), (E.style.opacity = A), $.origin && (E.style.transformOrigin = $.origin);
            }
        },
        setTransition: (c) => {
            const a = e.slides.map((u) => ce(u));
            a.forEach((u) => {
                (u.style.transitionDuration = `${c}ms`),
                    u.querySelectorAll(".swiper-slide-shadow").forEach((f) => {
                        f.style.transitionDuration = `${c}ms`;
                    });
            }),
                ze({ swiper: e, duration: c, transformElements: a, allSlides: !0 });
        },
        perspective: () => e.params.creativeEffect.perspective,
        overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !e.params.cssMode }),
    });
}
function ei(s) {
    let { swiper: e, extendParams: t, on: i } = s;
    t({ cardsEffect: { slideShadows: !0, rotate: !0, perSlideRotate: 2, perSlideOffset: 8 } }),
        ue({
            effect: "cards",
            swiper: e,
            on: i,
            setTranslate: () => {
                const { slides: d, activeIndex: c, rtlTranslate: a } = e,
                    u = e.params.cardsEffect,
                    { startTranslate: f, isTouched: p } = e.touchEventsData,
                    v = a ? -e.translate : e.translate;
                for (let m = 0; m < d.length; m += 1) {
                    const l = d[m],
                        o = l.progress,
                        w = Math.min(Math.max(o, -4), 4);
                    let y = l.swiperSlideOffset;
                    e.params.centeredSlides && !e.params.cssMode && (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (y -= d[0].swiperSlideOffset);
                    let g = e.params.cssMode ? -y - e.translate : -y,
                        h = 0;
                    const S = -100 * Math.abs(w);
                    let b = 1,
                        z = -u.perSlideRotate * w,
                        $ = u.perSlideOffset - Math.abs(w) * 0.75;
                    const O = e.virtual && e.params.virtual.enabled ? e.virtual.from + m : m,
                        P = (O === c || O === c - 1) && w > 0 && w < 1 && (p || e.params.cssMode) && v < f,
                        L = (O === c || O === c + 1) && w < 0 && w > -1 && (p || e.params.cssMode) && v > f;
                    if (P || L) {
                        const x = (1 - Math.abs((Math.abs(w) - 0.5) / 0.5)) ** 0.5;
                        (z += -28 * w * x), (b += -0.5 * x), ($ += 96 * x), (h = `${-25 * x * Math.abs(w)}%`);
                    }
                    if ((w < 0 ? (g = `calc(${g}px ${a ? "-" : "+"} (${$ * Math.abs(w)}%))`) : w > 0 ? (g = `calc(${g}px ${a ? "-" : "+"} (-${$ * Math.abs(w)}%))`) : (g = `${g}px`), !e.isHorizontal())) {
                        const x = h;
                        (h = g), (g = x);
                    }
                    const A = w < 0 ? `${1 + (1 - b) * w}` : `${1 - (1 - b) * w}`,
                        M = `
        translate3d(${g}, ${h}, ${S}px)
        rotateZ(${u.rotate ? (a ? -z : z) : 0}deg)
        scale(${A})
      `;
                    if (u.slideShadows) {
                        let x = l.querySelector(".swiper-slide-shadow");
                        x || (x = fe("cards", l)), x && (x.style.opacity = Math.min(Math.max((Math.abs(w) - 0.5) / 0.5, 0), 1));
                    }
                    l.style.zIndex = -Math.abs(Math.round(o)) + d.length;
                    const E = xe(u, l);
                    E.style.transform = M;
                }
            },
            setTransition: (d) => {
                const c = e.slides.map((a) => ce(a));
                c.forEach((a) => {
                    (a.style.transitionDuration = `${d}ms`),
                        a.querySelectorAll(".swiper-slide-shadow").forEach((u) => {
                            u.style.transitionDuration = `${d}ms`;
                        });
                }),
                    ze({ swiper: e, duration: d, transformElements: c });
            },
            perspective: () => !0,
            overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !e.params.cssMode }),
        });
}
const ti = [Ps, Ls, Is, As, zs, Os, Ds, $s, ks, Bs, Hs, qs, _s, Gs, Vs, Rs, js, Us, Ks, Zs, Qs, Js, ei];
Y.use(ti);
function si() {
    const s = ".communitySwiper",
        e = ".marqueeSwiper",
        t = ".reviewsSwiper",
        i = ".specialSwiper",
        n = ".previewSwiper",
        r = ".timelineSwiper",
        d = ".detailsSwiper";
    if (document.querySelector(s)) {
        let p = function () {
            const m = document.querySelector(".community .c-grid"),
                l = document.querySelector(".community__carousel");
            return (m && l && m.getBoundingClientRect().left + Number.parseInt(window.getComputedStyle(m).paddingLeft, 10)) || 0;
        };
        var c = p;
        const v = new Y(s, { loop: !0, slidesPerView: "auto", speed: 1e3, spaceBetween: 38, slidesOffsetBefore: p(), breakpoints: { 320: { spaceBetween: 8 }, 768: { spaceBetween: 38 } } });
        window.addEventListener("resize", () => {
            v && v.params && ((v.params.slidesOffsetBefore = p()), v.update());
        }),
            p();
    }
    if (document.querySelector(n)) {
        let p = function () {
            const m = document.querySelector(".preview .c-grid"),
                l = document.querySelector(".preview__carousel");
            return (m && l && m.getBoundingClientRect().left + Number.parseInt(window.getComputedStyle(m).paddingLeft, 10)) || 0;
        };
        var a = p;
        const v = new Y(n, {
            loop: !1,
            slidesPerView: "auto",
            speed: 1e3,
            spaceBetween: 38,
            slidesOffsetBefore: p(),
            slidesOffsetAfter: p(),
            navigation: { nextEl: ".preview__carousel .special__navigation--next", prevEl: ".preview__carousel .special__navigation--prev" },
            pagination: { el: document.querySelector(n + " .swiper-pagination"), clickable: !0 },
            breakpoints: { 320: { slidesPerView: 1, slidesOffsetBefore: 0, slidesOffsetAfter: 0 }, 1280: { slidesPerView: "auto", slidesOffsetBefore: p(), slidesOffsetAfter: p() } },
        });
        window.addEventListener("resize", () => {
            v && v.params && ((v.params.slidesOffsetBefore = p()), (v.params.slidesOffsetAfter = p()), v.update());
        }),
            p();
    }
    if (document.querySelector(e))
        for (const p of document.querySelectorAll(e)) new Y(p, { loop: !0, spaceBetween: 32, speed: 5e3, autoplay: { delay: 0, disableOnInteraction: !0 }, loopedSlides: 4, slidesPerView: "auto", allowTouchMove: !1 });
    if (
        (document.querySelector(t) && new Y(t, { speed: 1e3, effect: "cards", grabCursor: !0, pagination: { el: document.querySelector(t + " .swiper-pagination"), clickable: !0 } }),
        document.querySelector(i) &&
            new Y(i, {
                speed: 1e3,
                slidesPerView: "4",
                spaceBetween: 38,
                navigation: { nextEl: ".special__carousel .special__navigation--next", prevEl: ".special__carousel .special__navigation--prev" },
                pagination: { el: document.querySelector(i + " .swiper-pagination"), clickable: !0 },
                breakpoints: { 320: { slidesPerView: "2", spaceBetween: 10 }, 768: { slidesPerView: "3", spaceBetween: 20 }, 1280: { slidesPerView: "4", spaceBetween: 38 } },
            }),
        document.querySelector(d) && new Y(d, { speed: 1e3, slidesPerView: "auto", spaceBetween: 16, slidesOffsetBefore: 16, slidesOffsetAfter: 16, pagination: { el: document.querySelector(d + " .swiper-pagination"), clickable: !0 } }),
        document.querySelector(".categories__carousel"))
    ) {
        let p = function () {
            const v = document.querySelector(".categories .c-grid"),
                m = document.querySelector(".categories__carousel");
            return (v && m && v.getBoundingClientRect().left + Number.parseInt(window.getComputedStyle(v).paddingLeft, 10)) || 0;
        };
        var u = p;
        for (const [v, m] of document.querySelectorAll(".categories__carousel").entries()) {
            let l = `categoriesSwiper + ${v}`;
            (l = new Y(m.querySelector(".swiper"), {
                speed: 1e3,
                slidesPerView: "auto",
                spaceBetween: 38,
                navigation: { nextEl: m.querySelector(" .special__navigation--next"), prevEl: m.querySelector(" .special__navigation--prev") },
                slidesOffsetBefore: p(),
                slidesOffsetAfter: 16,
                pagination: { el: m.querySelector(" .swiper-pagination"), clickable: !0 },
                breakpoints: { 320: { spaceBetween: 10 }, 768: { spaceBetween: 38 } },
            })),
                window.addEventListener("resize", () => {
                    l && l.params && ((l.params.slidesOffsetBefore = p()), l.update());
                }),
                p();
        }
    }
    if (
        (document.querySelector(r) &&
            new Y(r, {
                speed: 1e3,
                slidesPerView: "auto",
                spaceBetween: 60,
                centeredSlides: !0,
                pagination: { el: document.querySelector(".timeline .swiper-pagination"), clickable: !0 },
                breakpoints: { 320: { spaceBetween: 10, slidesPerView: 1 }, 768: { spaceBetween: 30, slidesPerView: "auto" }, 1024: { spaceBetween: 60, slidesPerView: "auto" } },
            }),
        document.querySelector(".promisesSwiper"))
    ) {
        let v = function () {
            window.innerWidth <= 767
                ? p || (p = new Y(".promisesSwiper", { slidesPerView: "auto", spaceBetween: 12, pagination: { el: document.querySelector(".promisesSwiper .swiper-pagination"), clickable: !0 } }))
                : p && (p.destroy(!0, !0), (p = null));
        };
        var f = v;
        let p = null;
        v(), window.addEventListener("resize", v);
    }
}
function ii() {
    if (!document.querySelector(".details__part a")) return;
    const s = document.querySelectorAll(".details__part a");
    for (const e of s)
        e.addEventListener("click", (t) => {
            t.preventDefault();
            const i = t.currentTarget;
            for (const n of s) n.classList.remove("is-active");
            i.classList.add("is-active");
        });
}
function ri() {
    if (document.querySelector(".rank__dropdown")) {
        const s = document.querySelectorAll(".rank__dropdown-toggle");
        for (const e of s)
            e.addEventListener("click", (t) => {
                const n = e.parentNode.querySelector(".rank__dropdown");
                t.currentTarget.classList.toggle("is-active"), n.classList.toggle("is-open");
            });
    }
}
/* sandy commented this -- function ni() {
    if (!document.querySelector(".header__dropdown")) return;
    const s = document.querySelector(".header__dropdown-toggle"),
        e = document.querySelector(".header__toggle"),
        t = document.querySelector(".header__dropdown");
    s.addEventListener("click", (i) => {
        i.preventDefault(), i.currentTarget.classList.toggle("is-active"), document.body.classList.toggle("is-hideScroll"), t.classList.toggle("is-open");
    }),
        e.addEventListener("click", (i) => {
            i.preventDefault(), i.currentTarget.classList.toggle("is-active"), document.body.classList.toggle("is-hideScroll"), t.classList.toggle("is-open");
        });
} */
function ai() {
   /* const s = document.querySelector(".header__location-toggle"),
        e = document.querySelector(".header__location-close"),
        t = document.querySelector(".header__location-dropdown");
    s.addEventListener("click", (i) => {
        i.preventDefault(), i.currentTarget.classList.toggle("is-active"), document.body.classList.toggle("is-hideScroll"), t.classList.toggle("is-open");
    }),
        e.addEventListener("click", (i) => {
            i.preventDefault(), i.currentTarget.classList.remove("is-active"), document.body.classList.remove("is-hideScroll"), t.classList.remove("is-open");
        });*/
}
function li() {
    if (!document.querySelector(".products__filters nav")) return;
    const s = document.querySelector(".products__filters nav"),
        e = s.querySelectorAll("a"),
        t = document.querySelector(".products__filters .active-background");
    function i(r) {
        if (!r) return;
        const d = r.getBoundingClientRect(),
            c = s.getBoundingClientRect();
        (t.style.width = `${d.width}px`), (t.style.transform = `translateX(${d.left - c.left}px)`), t.classList.add("is-active");
    }
    let n = s.querySelector(".active");
    n && i(n);
    for (const [r, d] of e.entries())
        d.addEventListener("click", (c) => {
            c.preventDefault();
            for (const a of e) a.classList.remove("active");
            d.classList.add("active");
            for (const a of t.classList) a.startsWith("is-") && t.classList.remove(a);
            t.classList.add(`is-${r}`), i(d), (n = d);
        });
    window.addEventListener("resize", () => {
        i(n);
    });
}
function oi() {
    const s = document.querySelector("#progress-bar");
    if (!s) return;
    function e() {
        requestAnimationFrame(() => {
            const t = document.body.scrollHeight - window.innerHeight,
                i = (window.scrollY / t) * 100;
            s.style.width = `${i}%`;
        });
    }
    e(), window.addEventListener("scroll", e), window.addEventListener("resize", e);
}
function di() {
    const s = document.querySelectorAll(".more__nav a"),
        e = document.querySelector("header"),
        t = [];
    if (s.length === 0 || !e) return;
    for (const r of s) {
        const d = r.getAttribute("href").slice(1),
            c = document.getElementById(d);
        c && t.push({ section: c, link: r });
    }
    function i() {
        e.offsetHeight;
        const r = window.scrollY + 20;
        for (const { section: d, link: c } of t) {
            const a = d.offsetTop - 20,
                u = a + d.offsetHeight;
            r >= a && r < u ? c.classList.add("is-active") : c.classList.remove("is-active");
        }
    }
    function n(r) {
        r.preventDefault();
        const d = this.getAttribute("href").slice(1),
            c = document.getElementById(d);
        if (c) {
            e.offsetHeight;
            const a = c.offsetTop - 20;
            window.scrollTo({ top: a, behavior: "smooth" });
        }
    }
    window.addEventListener("scroll", i), i();
    for (const r of s) r.addEventListener("click", n);
}
function ci() {
    const s = document.querySelectorAll(".menu-link");
    document.getElementById("header"),
        document.getElementById("alert"),
        s.forEach((e) => {
            e.addEventListener("click", (t) => {
                t.preventDefault();
                const i = e.getAttribute("href").substring(1),
                    n = document.getElementById(i);
                if (n) {
                    const r = n.offsetTop;
                    window.scrollTo({ top: r, behavior: "smooth" });
                }
            });
        });
}
function fi() {
    const s = document.querySelector(".details__sticky"),
        e = document.querySelector("#details");
    if (!s || !e) return;
    function t() {
        const i = e.getBoundingClientRect();
        i.top <= window.innerHeight / 2 && i.bottom >= window.innerHeight / 2 ? s.classList.add("is-visible") : s.classList.remove("is-visible");
    }
    window.addEventListener("scroll", t), window.addEventListener("resize", t), t();
}
document.addEventListener("DOMContentLoaded", () => {
    (() => {
        const e = document.querySelectorAll("a");
        for (const [t, i] of e.entries())
            i.addEventListener("click", (n) => {
                i.getAttribute("href") === "#" && n.preventDefault();
            });
    })(),
        lt(),
        si(),
        ot(),
        ci(),
        ai(),
        ni(),
        ii(),
        oi(),
        di(),
        ri(),
        fi(),
        setTimeout(() => li(), 300);
});
